var _style, _g, _g2, _polygon, _path, _polygon2, _polygon3, _g3, _g4, _g5, _g6, _g7, _path2, _path3, _path4, _path5, _path6, _path7, _g8, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _g9, _g0, _g1, _g10, _polygon4, _polygon5, _polygon6, _defs, _g11, _polygon7, _defs2, _defs3, _defs4, _g12, _path110, _g13, _path111, _path112, _path113, _path114, _polygon8, _g14, _g15, _polygon9, _polygon0, _path115, _path116, _path117, _g16, _g17, _g18, _path118, _polygon1, _path119, _path120, _g19, _path121, _path122, _g20, _ellipse, _path123, _g21, _path124, _path125, _g22, _path126, _path127, _g23, _ellipse2, _path128, _g24, _g25, _path129, _g26, _defs5, _path130, _g27, _polygon10, _path131, _path132, _path133, _g28, _g29, _g30, _g31, _g32, _g33, _g34;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentMethodsLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000065787702027170853380000001604267821868711059_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 960 729.7",
    style: {
      enableBackground: "new 0 0 960 729.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.4;}\r\n\t.st1{fill:#485654;}\r\n\t.st2{fill:#E0E0E0;}\r\n\t.st3{opacity:0.8;fill:#E0E0E0;enable-background:new    ;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{fill:#D3D1D3;}\r\n\t.st6{opacity:0.2;fill:#7D8589;enable-background:new    ;}\r\n\t.st7{opacity:0.6;fill:#D7B18F;enable-background:new    ;}\r\n\t.st8{fill:#D7B18F;}\r\n\t.st9{fill:#7D8589;}\r\n\t.st10{fill:#747678;}\r\n\t.st11{fill:#FFE89B;}\r\n\t.st12{fill:#CDA349;}\r\n\t.st13{fill:#E9E9EA;}\r\n\t.st14{fill:#D4D8D3;}\r\n\t.st15{fill:#375D4C;}\r\n\t.st16{fill:#A3A5A8;}\r\n\t.st17{opacity:0.5;fill:#485654;enable-background:new    ;}\r\n\t.st18{opacity:0.6;fill:#485654;enable-background:new    ;}\r\n\t.st19{opacity:0.7;}\r\n\t.st20{fill:#B4B9BB;}\r\n\t.st21{fill:#637E77;}\r\n\t.st22{fill:#C4C6C8;}\r\n\t.st23{opacity:0.5;fill:url(#SVGID_1_);enable-background:new    ;}\r\n\t.st24{opacity:0.5;}\r\n\t.st25{fill:url(#SVGID_00000117646822674724323230000017400447183279536542_);}\r\n\t.st26{opacity:0.3;fill:#485654;enable-background:new    ;}\r\n\t.st27{fill:url(#SVGID_00000168109901588573238560000017130188808760025517_);}\r\n\t.st28{fill:url(#SVGID_00000125568713006900342310000002627876227379742865_);}\r\n\t.st29{opacity:0.2;fill:url(#SVGID_00000031180415352352353670000013129584115618948528_);enable-background:new    ;}\r\n\t.st30{fill:url(#SVGID_00000046320889820728755860000007660827484030494634_);}\r\n\t.st31{opacity:0.6;fill:#CDA349;enable-background:new    ;}\r\n\t.st32{fill:url(#SVGID_00000102511793369775157460000001274481857155538305_);}\r\n\t.st33{opacity:0.2;fill:url(#SVGID_00000047755494544736645150000004519050436731684260_);enable-background:new    ;}\r\n\t.st34{fill:url(#SVGID_00000065785034085172957040000002975066553844633224_);}\r\n\t.st35{fill:url(#SVGID_00000155140744091925750470000016787088542224579457_);}\r\n\t.st36{opacity:0.2;fill:url(#SVGID_00000111178888770280433020000016987588571923797681_);enable-background:new    ;}\r\n\t.st37{fill:url(#SVGID_00000135692651260302013140000005726678730799678125_);}\r\n\t.st38{fill:url(#SVGID_00000111879658332227318390000000571329737148214697_);}\r\n\t.st39{opacity:0.2;fill:url(#SVGID_00000124129099305558838320000017834810971022772111_);enable-background:new    ;}\r\n\t.st40{fill:url(#SVGID_00000129167899770483303530000001681698539727358631_);}\r\n\t.st41{fill:url(#SVGID_00000130613926724382388260000008692116274071644853_);}\r\n\t.st42{opacity:0.2;fill:url(#SVGID_00000172408069817654311980000017492308516041224366_);enable-background:new    ;}\r\n\t.st43{fill:url(#SVGID_00000080886272505077837680000011015885380016828567_);}\r\n\t.st44{fill:url(#SVGID_00000055682530922882642570000005806764943733371316_);}\r\n\t.st45{opacity:0.2;fill:url(#SVGID_00000059296918812111735810000005253756710892427964_);enable-background:new    ;}\r\n\t.st46{fill:url(#SVGID_00000176024610390401273280000008047403644730854297_);}\r\n\t.st47{fill:url(#SVGID_00000070096963982795361870000011419211966295918258_);}\r\n\t.st48{opacity:0.2;fill:url(#SVGID_00000049224311294487434990000008339903291529407363_);enable-background:new    ;}\r\n\t.st49{fill:url(#SVGID_00000016075287731660159300000001012994426569090994_);}\r\n\t.st50{fill:url(#SVGID_00000083062740558001826010000001729467537113142178_);}\r\n\t.st51{opacity:0.2;fill:url(#SVGID_00000119825422689083902770000009017607721232702106_);enable-background:new    ;}\r\n\t.st52{fill:url(#SVGID_00000027573299351595155480000012561915489220560026_);}\r\n\t.st53{fill:url(#SVGID_00000111153765446171319390000012380213102802211768_);}\r\n\t.st54{opacity:0.2;fill:url(#SVGID_00000021827849836659556970000000259015715000198275_);enable-background:new    ;}\r\n\t.st55{fill:url(#SVGID_00000149352905016374821490000009852564010485764507_);}\r\n\t.st56{fill:url(#SVGID_00000108309150091826499550000007859275611047449779_);}\r\n\t.st57{opacity:0.2;fill:url(#SVGID_00000034795535931980984790000014367452849155107748_);enable-background:new    ;}\r\n\t.st58{fill:url(#SVGID_00000153680178403760265880000007696362531729193131_);}\r\n\t.st59{fill:url(#SVGID_00000014626094652303439360000014273903436866364318_);}\r\n\t.st60{opacity:0.2;fill:url(#SVGID_00000072252476975855859760000008736822722696811162_);enable-background:new    ;}\r\n\t.st61{fill:url(#SVGID_00000181062084557817303620000007394437423142889620_);}\r\n\t.st62{fill:url(#SVGID_00000143614587391022524380000017397987284513994900_);}\r\n\t.st63{opacity:0.2;fill:url(#SVGID_00000059271142072495337620000002060541387887375531_);enable-background:new    ;}\r\n\t.st64{fill:url(#SVGID_00000088131000446196469340000005268339765946437009_);}\r\n\t.st65{fill:url(#SVGID_00000173145084537018347710000014402318480435184056_);}\r\n\t.st66{opacity:0.2;fill:url(#SVGID_00000018233717159889362510000000404246913721500841_);enable-background:new    ;}\r\n\t.st67{fill:url(#SVGID_00000106854845743466949450000017086321475393562253_);}\r\n\t.st68{fill:url(#SVGID_00000161628836359636951020000002576813726878895537_);}\r\n\t.st69{opacity:0.2;fill:url(#SVGID_00000178193443192284122800000005142981221108064678_);enable-background:new    ;}\r\n\t.st70{fill:url(#SVGID_00000070117637046366734230000006744535038944822946_);}\r\n\t.st71{fill:url(#SVGID_00000038393685742589506610000008846503396867790777_);}\r\n\t.st72{opacity:0.2;fill:url(#SVGID_00000168819589857856839750000012950178430955598220_);enable-background:new    ;}\r\n\t.st73{fill:url(#SVGID_00000020358017460626298040000014705801909605842323_);}\r\n\t.st74{fill:url(#SVGID_00000022529331483679602860000014746275922125279142_);}\r\n\t.st75{opacity:0.2;fill:url(#SVGID_00000148647459889505572980000018165436173568041136_);enable-background:new    ;}\r\n\t.st76{fill:url(#SVGID_00000171715770631003946920000007148839877069472687_);}\r\n\t.st77{fill:url(#SVGID_00000147912529769850447240000004971629161905797260_);}\r\n\t.st78{opacity:0.2;fill:url(#SVGID_00000041979531366926740450000000100297665624831384_);enable-background:new    ;}\r\n\t.st79{fill:url(#SVGID_00000018216459593719946210000006484079108344178865_);}\r\n\t.st80{fill:url(#SVGID_00000003784037146535002590000013439633974681025207_);}\r\n\t.st81{opacity:0.2;fill:url(#SVGID_00000170986702687386555830000012536176830986902921_);enable-background:new    ;}\r\n\t.st82{fill:url(#SVGID_00000180344770413471817540000016264685196122041250_);}\r\n\t.st83{fill:url(#SVGID_00000136373617074079913220000014516825226958873987_);}\r\n\t.st84{opacity:0.2;fill:url(#SVGID_00000005232791450261104280000017945565595519715774_);enable-background:new    ;}\r\n\t.st85{fill:url(#SVGID_00000045620570431706493220000008145432359717001381_);}\r\n\t.st86{fill:url(#SVGID_00000152256690047684252270000010976677822360368316_);}\r\n\t.st87{opacity:0.2;fill:url(#SVGID_00000056393655432843428360000009808768128444638854_);enable-background:new    ;}\r\n\t.st88{fill:url(#SVGID_00000076589248584376525030000017091726344015814544_);}\r\n\t.st89{fill:url(#SVGID_00000016753779239922276690000010679473170218302619_);}\r\n\t.st90{opacity:0.2;fill:url(#SVGID_00000036216718886267654870000015558435923960328370_);enable-background:new    ;}\r\n\t.st91{fill:url(#SVGID_00000021109828339768499770000016058428117228495027_);}\r\n\t.st92{fill:url(#SVGID_00000143604815377438386420000000867390957163112093_);}\r\n\t.st93{opacity:0.2;fill:url(#SVGID_00000070823789438015936700000005804291196312296349_);enable-background:new    ;}\r\n\t.st94{fill:url(#SVGID_00000168115003683601151760000001392894975535298698_);}\r\n\t.st95{fill:url(#SVGID_00000154396097343959263380000017686723538218194331_);}\r\n\t.st96{opacity:0.2;fill:url(#SVGID_00000153682159464858019320000005070282558187626167_);enable-background:new    ;}\r\n\t.st97{fill:url(#SVGID_00000173866833865120440190000017210277057492491967_);}\r\n\t.st98{fill:url(#SVGID_00000087404448416236027500000005669927688274173072_);}\r\n\t.st99{opacity:0.2;fill:url(#SVGID_00000166657299273805490980000016871433209975434886_);enable-background:new    ;}\r\n\t.st100{fill:url(#SVGID_00000035526474035055252350000004550738762881735557_);}\r\n\t.st101{fill:url(#SVGID_00000042004012325927218010000000972199412624189104_);}\r\n\t.st102{opacity:0.2;fill:url(#SVGID_00000145770766045596234740000013360598703177686453_);enable-background:new    ;}\r\n\t.st103{fill:url(#SVGID_00000068648332099288971560000013331210192052251010_);}\r\n\t.st104{fill:url(#SVGID_00000003801556799323245830000000280086478940693676_);}\r\n\t.st105{opacity:0.2;fill:url(#SVGID_00000027601085759832963080000002050678882254323847_);enable-background:new    ;}\r\n\t.st106{fill:url(#SVGID_00000132084416074115849590000005930256981405462913_);}\r\n\t.st107{fill:url(#SVGID_00000023977930209099394930000006802288469582747043_);}\r\n\t.st108{opacity:0.2;fill:url(#SVGID_00000130618634720777620410000000095284451702309537_);enable-background:new    ;}\r\n\t.st109{fill:url(#SVGID_00000172436568523251387240000004034898697787087543_);}\r\n\t.st110{fill:url(#SVGID_00000020371100611692597910000008463931119373629354_);}\r\n\t.st111{opacity:0.2;fill:url(#SVGID_00000040558381934350694880000012803843073178730418_);enable-background:new    ;}\r\n\t.st112{fill:url(#SVGID_00000178901367929692499980000007665770172575695280_);}\r\n\t.st113{fill:url(#SVGID_00000150808132217047031860000017971221794356757170_);}\r\n\t.st114{opacity:0.2;fill:url(#SVGID_00000147184223920988678740000017235333820623942292_);enable-background:new    ;}\r\n\t.st115{fill:url(#SVGID_00000041280740475232725000000001532518062509745551_);}\r\n\t.st116{fill:url(#SVGID_00000132802338833730223230000001184059544872887737_);}\r\n\t.st117{opacity:0.2;fill:url(#SVGID_00000150073691110398822290000002384316125394334647_);enable-background:new    ;}\r\n\t.st118{fill:url(#SVGID_00000036967819647104755530000005176266528324593793_);}\r\n\t.st119{fill:url(#SVGID_00000121972530230325539520000016060602675859544201_);}\r\n\t.st120{opacity:0.2;fill:url(#SVGID_00000031915438059818878150000018398646548017794946_);enable-background:new    ;}\r\n\t.st121{fill:url(#SVGID_00000101801983368203559030000017223115233822259630_);}\r\n\t.st122{fill:url(#SVGID_00000005952302696312896450000012058233250440883377_);}\r\n\t.st123{opacity:0.2;fill:url(#SVGID_00000168834479951448926760000005552123035283813043_);enable-background:new    ;}\r\n\t.st124{fill:url(#SVGID_00000144304004833779824850000007187838697838236077_);}\r\n\t.st125{fill:url(#SVGID_00000105393908617411806110000011346063266155065999_);}\r\n\t.st126{opacity:0.2;fill:url(#SVGID_00000090987802846480282980000006326426415940375702_);enable-background:new    ;}\r\n\t.st127{fill:url(#SVGID_00000015326481743494417850000017198148009780860055_);}\r\n\t.st128{fill:url(#SVGID_00000121237829867636701990000011549703909997756544_);}\r\n\t.st129{opacity:0.2;fill:url(#SVGID_00000138535589838583395360000018245129380592402610_);enable-background:new    ;}\r\n\t.st130{fill:url(#SVGID_00000010268526892753644970000013287885347050630057_);}\r\n\t.st131{fill:url(#SVGID_00000109715300372004346660000008590754868553234819_);}\r\n\t.st132{opacity:0.2;fill:url(#SVGID_00000096771045685418896420000010401936541861442689_);enable-background:new    ;}\r\n\t.st133{fill:url(#SVGID_00000113318659623281660410000011591133483187748530_);}\r\n\t.st134{fill:url(#SVGID_00000019679004594487568270000010616023952377993117_);}\r\n\t.st135{opacity:0.2;fill:url(#SVGID_00000022554722004242320850000000600304844976934301_);enable-background:new    ;}\r\n\t.st136{fill:url(#SVGID_00000134233497775112361030000009968837000097605050_);}\r\n\t.st137{fill:url(#SVGID_00000003821777313800084280000000983902343700265376_);}\r\n\t.st138{opacity:0.2;fill:url(#SVGID_00000176743314427022252660000007955987225415450780_);enable-background:new    ;}\r\n\t.st139{fill:url(#SVGID_00000114762102472445297920000017005562400915656634_);}\r\n\t.st140{fill:url(#SVGID_00000041265133920522605980000000331254595600504709_);}\r\n\t.st141{opacity:0.2;fill:url(#SVGID_00000166640031885424405210000007145369977704416394_);enable-background:new    ;}\r\n\t.st142{fill:url(#SVGID_00000119827942709497555300000012597433019397900468_);}\r\n\t.st143{fill:url(#SVGID_00000155129888866155320530000005621179077248547481_);}\r\n\t.st144{opacity:0.2;fill:url(#SVGID_00000046313236401492386260000015854544260394674325_);enable-background:new    ;}\r\n\t.st145{fill:url(#SVGID_00000098917624848631173490000004933562019201358263_);}\r\n\t.st146{fill:url(#SVGID_00000173870988292902331670000002228933564333876870_);}\r\n\t.st147{opacity:0.2;fill:url(#SVGID_00000056407174724374428740000016234663043463670930_);enable-background:new    ;}\r\n\t.st148{fill:url(#SVGID_00000029744758014198546190000013147469875659108749_);}\r\n\t.st149{fill:url(#SVGID_00000021814302343826237890000002030641229120844200_);}\r\n\t.st150{opacity:0.2;fill:url(#SVGID_00000095299525859073431610000002055763939918086570_);enable-background:new    ;}\r\n\t.st151{fill:url(#SVGID_00000018933137439629408560000018033399479598204860_);}\r\n\t.st152{fill:url(#SVGID_00000096755412924717289410000007150897949349521292_);}\r\n\t.st153{opacity:0.2;fill:url(#SVGID_00000021834782929103015860000005311128771112282288_);enable-background:new    ;}\r\n\t.st154{fill:url(#SVGID_00000098196711884664894940000000144998528672219819_);}\r\n\t.st155{fill:url(#SVGID_00000122707501836688699910000001231713803242074036_);}\r\n\t.st156{opacity:0.2;fill:url(#SVGID_00000123431880401062983560000016573887898717022883_);enable-background:new    ;}\r\n\t.st157{fill:url(#SVGID_00000011714154845748610820000007030063026706222465_);}\r\n\t.st158{fill:url(#SVGID_00000084524566767387586420000003433501725736417430_);}\r\n\t.st159{opacity:0.2;fill:url(#SVGID_00000049209268731888334380000012130961310237886640_);enable-background:new    ;}\r\n\t.st160{fill:url(#SVGID_00000109019216618222599510000012275353560468968091_);}\r\n\t.st161{fill:url(#SVGID_00000137842566316170491870000003962577533799856044_);}\r\n\t.st162{opacity:0.2;fill:url(#SVGID_00000009574988519392198080000014123950320922931082_);enable-background:new    ;}\r\n\t.st163{fill:url(#SVGID_00000139276743390617365020000014304795987315493006_);}\r\n\t.st164{fill:url(#SVGID_00000062151934040370871990000013853259451047512740_);}\r\n\t.st165{opacity:0.2;fill:url(#SVGID_00000006709432205483311590000014520202582733290684_);enable-background:new    ;}\r\n\t.st166{fill:url(#SVGID_00000010291225639183212140000011253004018885412263_);}\r\n\t.st167{fill:url(#SVGID_00000116229355398336882050000017646214018705947533_);}\r\n\t.st168{opacity:0.2;fill:url(#SVGID_00000052804110065561820080000017561829785483569841_);enable-background:new    ;}\r\n\t.st169{fill:url(#SVGID_00000163764302301850226450000001298986967211786372_);}\r\n\t.st170{fill:url(#SVGID_00000130611420684729092740000017486314108865444254_);}\r\n\t.st171{opacity:0.2;fill:url(#SVGID_00000122694540310387865870000018262300267063222199_);enable-background:new    ;}\r\n\t.st172{fill:url(#SVGID_00000008852488544180944460000010763637119094086054_);}\r\n\t.st173{fill:url(#SVGID_00000140004474800472308090000002387978758368597152_);}\r\n\t.st174{opacity:0.2;fill:url(#SVGID_00000078758115796020004720000012547194261110629291_);enable-background:new    ;}\r\n\t.st175{fill:url(#SVGID_00000150811597680633297720000000633236502978661565_);}\r\n\t.st176{fill:url(#SVGID_00000072266155385381709490000002675260218644455356_);}\r\n\t.st177{opacity:0.2;fill:url(#SVGID_00000152946135195429574080000016743950530017144491_);enable-background:new    ;}\r\n\t.st178{fill:url(#SVGID_00000119840534322538999870000009560182100330689713_);}\r\n\t.st179{fill:url(#SVGID_00000083060633896430580670000003585646833370533548_);}\r\n\t.st180{opacity:0.2;fill:url(#SVGID_00000129188749677071119380000014390949129350902163_);enable-background:new    ;}\r\n\t.st181{fill:url(#SVGID_00000091698853065379185660000010141212568063709576_);}\r\n\t.st182{fill:url(#SVGID_00000011744989221162734880000013409298282783109281_);}\r\n\t.st183{opacity:0.2;fill:url(#SVGID_00000119089900661699772810000002792146937742690447_);enable-background:new    ;}\r\n\t.st184{fill:url(#SVGID_00000078019925713788331990000015514153203589016755_);}\r\n\t.st185{enable-background:new    ;}\r\n\t.st186{fill:#497775;}\r\n\t.st187{opacity:0.4;fill:#497775;enable-background:new    ;}\r\n\t.st188{fill:#989498;}\r\n\t.st189{fill:#FBCC34;}\r\n\t.st190{fill:#A16733;}\r\n\t.st191{fill:#B96E2B;}\r\n\t.st192{fill:#B0ACB0;}\r\n\t.st193{fill:#D2D5D4;}\r\n\t.st194{fill:#E6E7E8;}\r\n\t.st195{opacity:0.9;fill:#B0ACB0;enable-background:new    ;}\r\n\t.st196{fill:url(#SVGID_00000065045169654599318350000000124083169543677866_);}\r\n\t.st197{opacity:0.8;fill:#1E1E1E;enable-background:new    ;}\r\n\t.st198{clip-path:url(#SVGID_00000012469131493306514120000003200858374427505814_);}\r\n\t.st199{clip-path:url(#SVGID_00000000222709379002950550000016616912119180489402_);}\r\n\t.st200{fill:url(#SVGID_00000060735631205404365080000003285741837160077184_);}\r\n\t.st201{fill:url(#SVGID_00000176738819455299689980000016796473308698473898_);}\r\n\t.st202{clip-path:url(#SVGID_00000173138598150565354040000013214004711232502405_);}\r\n\t\r\n\t\t.st203{opacity:0.7;clip-path:url(#SVGID_00000139973040219516475380000017230415461414994304_);fill:#858E8D;enable-background:new    ;}\r\n\t.st204{fill:#5D5E61;}\r\n\t.st205{opacity:0.7;fill:#1E1E1E;enable-background:new    ;}\r\n\t.st206{opacity:0.7;fill:#9EA0A4;enable-background:new    ;}\r\n\t.st207{fill:#6C301E;}\r\n\t.st208{opacity:0.5;fill:#6C301E;enable-background:new    ;}\r\n\t.st209{fill:#9EA0A4;}\r\n\t.st210{opacity:0.8;fill:#B2B6BA;enable-background:new    ;}\r\n\t.st211{fill:url(#SVGID_00000037659512309327131460000001766658048582750120_);}\r\n\t.st212{fill:#B3B4B4;}\r\n\t.st213{fill:url(#SVGID_00000180342376018873784470000007017765965301017788_);}\r\n\t.st214{fill:url(#SVGID_00000072269256831428989430000008728646526580108693_);}\r\n\t.st215{opacity:0.9;fill:#E9E9EA;enable-background:new    ;}\r\n\t.st216{fill:#212121;}\r\n\t.st217{opacity:0.1;fill:#D2D5D4;enable-background:new    ;}\r\n\t.st218{opacity:0.2;fill:#D2D5D4;enable-background:new    ;}\r\n\t.st219{fill:#E2C675;}\r\n\t.st220{opacity:0.8;fill:#8C959D;enable-background:new    ;}\r\n\t.st221{fill:#C59E78;}\r\n\t.st222{opacity:0.7;fill:#747678;enable-background:new    ;}\r\n\t.st223{fill:url(#SVGID_00000129171916642904128610000012331763144051329429_);}\r\n\t.st224{opacity:0.2;fill:url(#SVGID_00000056405569868894111110000007346364726067998395_);enable-background:new    ;}\r\n\t.st225{fill:url(#SVGID_00000040571615877610065650000009592615689706957735_);}\r\n\t.st226{opacity:0.2;fill:url(#SVGID_00000107582454651194398470000012003584101799232934_);enable-background:new    ;}\r\n\t.st227{fill:url(#SVGID_00000104700166020892431030000005973615962487641784_);}\r\n\t.st228{opacity:0.2;fill:url(#SVGID_00000031926349308921825250000017153199895469935750_);enable-background:new    ;}\r\n\t.st229{fill:url(#SVGID_00000145049012290282577460000001471319401042604727_);}\r\n\t.st230{opacity:0.2;fill:url(#SVGID_00000049195930676262084220000010520337353544784318_);enable-background:new    ;}\r\n\t.st231{opacity:0.6;fill:url(#SVGID_00000085967622294771363590000013645168846664542860_);enable-background:new    ;}\r\n\t.st232{fill:url(#SVGID_00000057138201667425978000000012110879388810044823_);}\r\n\t.st233{opacity:0.2;fill:url(#SVGID_00000163064311799318081750000006910036711842645686_);enable-background:new    ;}\r\n\t.st234{opacity:0.6;}\r\n\t.st235{fill:#F4E6D0;}\r\n\t.st236{fill:#B2B3B7;}\r\n\t.st237{fill:url(#SVGID_00000004547941884527466090000012299191557984459703_);}\r\n\t.st238{clip-path:url(#SVGID_00000046319275844812814640000018300805799863308735_);}\r\n\t.st239{opacity:0.6;fill:#E9E9EA;enable-background:new    ;}\r\n\t.st240{opacity:0.7;fill:#151718;enable-background:new    ;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "_x32_"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.2,96.9c2.3,4.9-2.7,9.9-11.2,11.2c-8.4,1.4-17.1-1.6-19.4-6.5c-2.3-4.9,2.7-9.9,11.2-11.2 C253.2,89.2,261.9,92,264.2,96.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M282.6,213.5c2.3,4.9-2.7,9.9-11.2,11.2c-8.4,1.4-17.1-1.6-19.4-6.5c-2.3-4.9,2.7-9.9,11.2-11.2 C271.7,205.8,280.3,208.7,282.6,213.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.5,242.2c2.3,4.9-2.7,9.9-11.2,11.2c-8.4,1.4-17.1-1.6-19.4-6.5c-2.3-4.9,2.7-9.9,11.2-11.2 C135.5,234.4,144.2,237.4,146.5,242.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M433.7,208.2c4.6,9.9-5.6,19.9-22.6,22.6c-17.1,2.6-34.5-3.3-39.1-13c-4.6-9.9,5.6-19.9,22.6-22.6 C411.6,192.6,429.2,198.5,433.7,208.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M188.6,556.8c2.3,4.9-2.7,9.9-11.2,11.2c-8.4,1.4-17.1-1.6-19.4-6.5c-2.3-4.9,2.7-9.9,11.2-11.2 C177.8,549.1,186.4,552,188.6,556.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M366.6,710.1c2.3,4.9-2.7,9.9-11.2,11.2c-8.4,1.4-17.1-1.6-19.4-6.5c-2.3-4.9,2.7-9.9,11.2-11.2 C355.6,702.4,364.3,705.3,366.6,710.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M435.9,560.9c2.3,4.9-2.7,9.9-11.2,11.2c-8.4,1.4-17.1-1.6-19.4-6.5c-2.3-4.9,2.7-9.9,11.2-11.2 C424.9,553,433.6,556,435.9,560.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M704.3,479c2.3,4.9-2.7,9.9-11.2,11.2c-8.4,1.4-17.1-1.6-19.4-6.5c-2.3-4.9,2.7-9.9,11.2-11.2 C693.5,471.1,702.1,474.1,704.3,479z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M667.1,429.3c2.3,4.9-2.7,9.9-11.2,11.2c-8.4,1.4-17.1-1.6-19.4-6.5c-2.3-4.9,2.7-9.9,11.2-11.2 C656.2,421.4,664.9,424.4,667.1,429.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M734.2,282.2c2.3,4.9-2.7,9.9-11.2,11.2c-8.4,1.4-17.1-1.6-19.4-6.5c-2.3-4.9,2.7-9.9,11.2-11.2 C723.3,274.3,731.9,277.3,734.2,282.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M637.4,242.5c2.3,4.9-2.7,9.9-11.2,11.2c-8.4,1.4-17.1-1.6-19.4-6.5c-2.3-4.9,2.7-9.9,11.2-11.2 C626.4,234.7,635.1,237.6,637.4,242.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M562.9,225.7c2.3,4.9-2.7,9.9-11.2,11.2c-8.4,1.4-17.1-1.6-19.4-6.5c-2.3-4.9,2.7-9.9,11.2-11.2 C552,218,560.8,220.8,562.9,225.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M566.9,207.7c2.3,4.9-2.7,9.9-11.2,11.2c-8.4,1.4-17.1-1.6-19.4-6.5c-2.3-4.9,2.7-9.9,11.2-11.2 C555.9,199.8,564.5,202.8,566.9,207.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M914.5,286.7c-0.9-2.2-3.3-3.9-6.1-5.1c-3.8-3-10.3-4.3-16.8-3.4c-8.4,1.4-13.4,6.4-11.2,11.2 c0.9,2.2,3.3,3.9,6.1,5.1c3.8,3,10.3,4.3,16.8,3.4C911.6,296.4,916.7,291.4,914.5,286.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M702.7,671.7c2.3,4.9-2.7,9.9-11.2,11.2c-8.4,1.4-17.1-1.6-19.4-6.5c-2.3-4.9,2.7-9.9,11.2-11.2 C691.7,663.8,700.4,666.8,702.7,671.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M686.8,719.3c2.3,4.9-2.7,9.9-11.2,11.2c-8.4,1.4-17.1-1.6-19.4-6.5c-2.3-4.9,2.7-9.9,11.2-11.2 C675.9,711.6,684.5,714.5,686.8,719.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M775.3,717.2c2.3,4.9-2.7,9.9-11.2,11.2c-8.4,1.4-17.1-1.6-19.4-6.5c-2.3-4.9,2.7-9.9,11.2-11.2 C764.3,709.5,773.1,712.3,775.3,717.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M892.4,517c-1.2,0.1-2.3,0.3-3.5,0.3c-0.1,0-6.6,0-6.8,0c-7,0-13.4-2.7-15.3-6.8c-2.3-4.9,2.7-9.9,11.2-11.2 c1.1-0.1,2.2-0.3,3.1-0.3c0.3,0,6.6,0,6.9,0C895.3,499,900.9,515.7,892.4,517z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M802.4,517.7c-1.2,0.1-2.3,0.3-3.5,0.3c-0.1,0-6.6,0-6.8,0c-7,0-13.4-2.7-15.3-6.8 c-2.3-4.9,2.7-9.9,11.2-11.2c1.1-0.1,2.2-0.3,3.1-0.3c0.3,0,6.6,0,6.9,0C805.2,499.7,810.9,516.3,802.4,517.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M586.2,531c-1.2,0.1-2.3,0.8-3.5,0.9c-0.1,0-6.6,0-6.8,0c-7,0-13.4-2.7-15.3-6.8c-2.3-4.9,2.7-9.9,11.2-11.2 c1.1-0.1,2.2-0.3,3.1-0.3c0.3,0,6.6,0,6.9,0C588.9,513.5,594.6,529.6,586.2,531z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.4,543.3c-1.2,0.1-2.3,0.8-3.5,0.9c-0.1,0-6.6,0-6.8,0c-7,0-13.4-2.7-15.3-6.8c-2.3-4.9,2.7-9.9,11.2-11.2 c1.1-0.1,2.2-0.3,3.1-0.3c0.3,0,6.6,0,6.9,0C73.1,525.8,78.8,541.9,70.4,543.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92.3,531.1c-1.2,0.1-2.3,0.8-3.5,0.9c-0.1,0-6.6,0-6.8,0c-7,0-13.4-2.7-15.3-6.8c-2.3-4.9,2.7-9.9,11.2-11.2 c1.1-0.1,2.2-0.3,3.1-0.3c0.3,0,6.6,0,6.9,0C95,513.6,100.7,529.9,92.3,531.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.8,528.4c-1.2,0.1-2.3,0.8-3.5,0.9c-0.1,0-6.6,0-6.8,0c-7,0-13.4-2.7-15.3-6.8c-2.3-4.9,2.7-9.9,11.2-11.2 c1.1-0.1,2.2-0.3,3.1-0.3c0.3,0,6.6,0,6.9,0C55.5,510.9,61.2,527,52.8,528.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M397.5,215.1c-3.5,0.5-6.9,2.6-10.4,2.6c-0.5,0-19.4,0-19.9,0c-20.6,0-39.4-7.9-45-19.9 c-6.6-14.4,8.1-29.1,32.9-32.9c3.1-0.5,6.2-0.8,9.3-0.8c0.7,0,19.6,0,20.3,0C405.5,163.8,422.3,211.2,397.5,215.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M788.8,503.6c-1.2,0.1-2.3,0.3-3.5,0.3c-0.1,0-6.6,0-6.8,0c-7,0-13.4-2.7-15.3-6.8 c-2.3-4.9,2.7-9.9,11.2-11.2c1.1-0.1,2.2-0.3,3.1-0.3c0.3,0,6.6,0,6.9,0C791.5,485.5,797.2,502.3,788.8,503.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M756.9,246.2c-1.2,0.1-2.3,0.3-3.5,0.3c-0.1,0-6.6,0-6.8,0c-7,0-13.4-2.7-15.3-6.8 c-2.3-4.9,2.7-9.9,11.2-11.2c1.1-0.1,2.2-0.3,3.1-0.3c0.3,0,6.6,0,6.9,0C759.6,228.2,765.3,244.9,756.9,246.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M651.6-47c-1.2,0.1-2.3,0.3-3.5,0.3c-0.1,0-6.6,0-6.8,0c-7,0-13.4-2.7-15.3-6.8c-2.3-4.9,2.7-9.9,11.2-11.2 c1.1-0.1,2.2-0.3,3.1-0.3c0.3,0,6.6,0,6.9,0C654.5-65.2,660.2-48.4,651.6-47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M555.7,77.7c-1.2,0.1-2.3,0.3-3.5,0.3c-0.1,0-12.7,0-12.9,0c-7,0-13.4-2.7-15.3-6.8 c-2.3-4.9,2.7-9.9,11.2-11.2c1.1-0.1,2.2-0.3,3.1-0.3c0.3,0,12.9,0,13,0C558.6,59.5,564.3,76.3,555.7,77.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M327.3,733c2.3,4.9-2.7,9.9-11.2,11.2c-8.4,1.4-17.1-1.6-19.4-6.5c-2.3-4.9,2.7-9.9,11.2-11.2 C316.3,725.2,325,728.1,327.3,733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267,78.6c2.3,4.9-2.7,9.9-11.2,11.2c-8.4,1.4-17.1-1.6-19.4-6.5c-2.3-4.9,2.7-9.9,11.2-11.2 C256,70.9,264.7,73.8,267,78.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "65.8,702.4 108.7,727.1 132.7,727.1 151.6,652.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-3.7,680.5 46.5,709.5 70.6,709.5 82.2,630.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "304.9,124.9 435.9,200.6 464.6,200.6 390.8,75.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M777.4,623.9l72.3,41.8c2,1.2,2.3,3,0.5,4.1l-45.4,26.1c-1.8,1.1-5,0.9-7-0.3l-72.3-42c-2-1.2-2.3-3-0.5-4.1 l45.4-26.1C772.3,622.5,775.4,622.6,777.4,623.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M378.5,680.6l79.2,45.6c3.1,1.8,9.8,2,12.7,0.3l115.7-67c3.1-1.8,3-4.7,0-6.5l-80.8-45.9 c-3.1-1.8-8.1-1.8-11.1,0l-115.7,67C375.4,675.9,375.4,678.9,378.5,680.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M861.8,633.8l-86.4-52.5l-31,17.9c-3.1,1.8-3.1,6.2,0,8l98.7,57c2.2,1.2,4.7,1.9,7.3,1.9H872L861.8,633.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "66.2,366.2 10.1,398.6 37.2,414.2 160.9,414.2 176.8,366.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "274.5,521.5 278.5,516.9 274.6,502.1 238.8,490.3 212.2,505.6 264.2,535.7 271.3,535.7 273.8,537.1  278.5,537.1 277.2,527.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M432.8,470.7c0-0.1,0-0.3-0.1-0.4l-0.1-0.1l-0.1-0.1l0,0l0,0l0,0l0,0c0,0-0.1,0-0.1-0.1 c-0.4-0.3-0.8-0.4-1.2-0.5c-0.1,0-0.1,0-0.3-0.1c-0.4-0.1-0.9-0.3-1.4-0.4c-0.1,0-0.3,0-0.4,0c-0.4-0.1-0.9-0.1-1.4-0.1 c-0.1,0-0.3,0-0.4,0c-0.5,0-1.1,0-1.6,0c-0.1,0-0.3,0-0.4,0c-0.8,0-1.5,0.1-1.6,0.1c-0.8,0.1-3.4,0.4-5.1,1.4h-0.1l0,0 c-0.7,0.4-58.8,34-94.1,56.2c-16.3,10.2-17.7,11.8-23,15.7c0.1,0,0.3-0.1,0.4-0.1c-0.4,0.1-0.8,0.4-0.5,0.7 c-4.9,4.2-2.4,3,3.4,0.5c1.2-0.1,4.1-1.6,5.3-2.3l0,0c6.8-3,13.8-6.8,21.1-10.7c9.2-5,18.8-10.3,38.6-21.5 c28.6-16.3,62-35.9,62.6-36.3l0,0l0.1-0.1c0.5-0.3,0.7-0.7,0.8-0.9C432.8,471,432.8,470.8,432.8,470.7 C432.8,470.8,432.8,470.7,432.8,470.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M517.1,359.3H416.7c-2.7,0-5.3,0.7-7.7,2l-65.1,37.5c-2.3,1.4-1.4,4.9,1.4,4.9h121.5c1.2,0,2.3-0.3,3.3-0.9 l45.5-26.3l6-7.6L517.1,359.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "506.1,380.1 492.8,380.4 474.8,398.7 500.3,398.7 507.3,388.2  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_x31__6_"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "169.4,652.3 70.6,709.3 19.6,679.8 19.6,655.7 169.4,628.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M169.4,644.2v0.8l-98.7,57l-0.1-0.1l-50.9-29.5v-0.8l51.1,29.5L169.4,644.2z M70.6,698.5L19.6,669v0.8 l50.9,29.5l0.1,0.1l98.7-57v-0.8L70.6,698.5z M70.6,703.9l-51.1-29.5v0.8l50.9,29.5l0.1,0.1l98.7-57V647L70.6,703.9z  M169.4,649.6l-98.7,57l-51.1-29.5v0.8l50.9,29.5l0.1,0.1l98.7-57V649.6z M70.6,695.8l-51.1-29.5v0.8l50.9,29.5l0.1,0.1 l98.7-57v-0.8L70.6,695.8z M70.6,687.7l-51.1-29.5v0.8l50.9,29.5l0.1,0.1l98.7-57v-0.8L70.6,687.7z M70.6,690.4l-51.1-29.5v0.8 l50.9,29.5l0.1,0.1l98.7-57v-0.8L70.6,690.4z M70.6,693.1l-51.1-29.5v0.8l50.9,29.5l0.1,0.1l98.7-57v-0.8L70.6,693.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "66.3,644.2 19.6,655.7 19.6,679.8 70.6,709.3 70.6,685.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "169.4,628.2 70.6,685.2 19.6,655.7 118.3,598.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "169.4,628.2 70.6,685.2 19.6,655.7 118.2,598.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "148.8,640.1 98.4,669.2 47.2,639.7 104.4,606.7 127,619.7 120.2,623.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M77.6,627.1l-14.6,29.4l-0.3-0.1L77.3,627L77.6,627.1z M74.4,625.4l-14.6,29.4l0.3,0.1l14.6-29.4 L74.4,625.4z M80.1,628.6l-14.5,29.5l0.3,0.1l14.6-29.4L80.1,628.6z M83.1,630.2l-14.6,29.4l0.3,0.1l14.6-29.4L83.1,630.2z  M70.2,626.4L57,653.1l0.3,0.1L70.6,626L70.2,626.4z M85.9,632l-14.6,29.4l0.3,0.1l14.6-29.4L85.9,632z M59.9,632.4l-8.7,17.5 l0.3,0.1l8.8-17.9L59.9,632.4z M44.4,641.3l-1.8,3.5l0.3,0.1l2-3.9L44.4,641.3z M49.7,638.4l-4.1,8.1l0.3,0.1l4.3-8.7 L49.7,638.4z M54.8,635.4l-6.4,12.9l0.3,0.1l6.5-13.3L54.8,635.4z M65.1,629.4l-11,22.1l0.3,0.1l11.1-22.5L65.1,629.4z  M88.8,633.6L74.2,663l0.3,0.1l14.6-29.4L88.8,633.6z M120.2,651.8l-3.3,6.6l0.5-0.3l3.1-6.2L120.2,651.8z M114.5,648.5 l-7.9,16l0.5-0.3l7.6-15.6L114.5,648.5z M111.7,646.9l-10.2,20.6l0.5-0.3l10-20.2L111.7,646.9z M123.2,653.4l-0.9,2l0.5-0.3 l0.8-1.6L123.2,653.4z M117.4,650.1l-5.6,11.4l0.5-0.3l5.4-10.8L117.4,650.1z M108.8,645.1l-12.5,25.2l0.5-0.3l12.3-24.8 L108.8,645.1z M97.3,638.5l-14.6,29.4L83,668l14.6-29.4L97.3,638.5z M94.5,636.9l-14.6,29.4l0.3,0.1L94.8,637L94.5,636.9z  M91.6,635.2L77,664.6l0.3,0.1l14.6-29.4L91.6,635.2z M103.1,641.9l-14.6,29.4l0.3,0.1l14.6-29.4L103.1,641.9z M100.2,640.3 l-14.6,29.4l0.3,0.1l14.6-29.4L100.2,640.3z M106,643.5L91.4,673l0.3,0.1l0,0l14.5-29.4L106,643.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "136.5,614.3 102.6,633.9 80,620.8 113.8,601.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "166.4,630 131.2,650.3 123.9,646.1 155.7,627.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M88.9,626.2L88.9,626.2c-9.3,5.4-9.3,14.2,0,19.6c9.3,5.4,24.5,5.4,33.9,0l0,0L88.9,626.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "131.6,650 130.2,650.8 79.2,621.3 80.5,620.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "45.7,651.6 31.6,659.8 24.5,655.7 38.5,647.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M94.6,620.8c-0.9,0.5-1.6,1.4-1.6,2h-0.1l-2.8-2.2c-0.4-0.3-0.3-0.4,0-0.5l4.3-2.6l-0.8-0.9h-0.3 l-5.8,3.4v0.1l5.6,3.7l0.7-0.1c-0.1-0.9,0.3-1.6,1.2-2.2c1.1-0.7,3.3-0.9,5.6,0.4c1.8,1.1,2.4,2.3,0.9,3.1 c-1.2,0.7-2.7,0.5-4.1,0.1c-0.4-0.1-0.7-0.1-0.9,0c-0.4,0.1-0.5,0.7,0,1.1c0.8,0.4,3.3,0.4,5.6-0.8c2.8-1.6,2.4-3.4,0.3-4.7 C99.5,619.4,96.6,619.7,94.6,620.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M99.4,612.9c-2.8,1.6-1.4,3.8,2.2,5.8c3.5,2,7.2,3,10,1.2c2.8-1.6,1.4-3.8-2.2-5.8 C105.9,612.1,102.2,611.3,99.4,612.9z M110.9,619.7c-1.6,0.9-4.7-0.3-7.6-1.9c-2.8-1.6-5-3.4-3.4-4.3 c1.6-0.9,4.7,0.3,7.6,1.9C110.5,616.8,112.5,618.6,110.9,619.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M108.7,607.6c-2.8,1.6-1.4,3.8,2.2,5.8c3.5,2,7.2,3,10,1.2c2.8-1.6,1.4-3.8-2.2-5.8 C115.2,606.8,111.5,605.9,108.7,607.6z M120.2,614.3c-1.6,0.9-4.7-0.3-7.6-1.9c-2.8-1.6-5-3.4-3.4-4.3s4.7,0.3,7.6,1.9 C119.8,611.5,121.8,613.3,120.2,614.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M68.1,676.1c-0.7,0.4-1.1,0.9-1.1,1.4l0,0l-2-1.5c-0.3-0.1-0.3-0.3,0-0.4l3-1.8l-0.5-0.7h-0.1l-4.1,2.3 v0.1L67,678l0.4-0.1c-0.1-0.7,0.1-1.1,0.8-1.5c0.8-0.4,2.2-0.5,3.8,0.3c1.2,0.7,1.6,1.6,0.7,2.2c-0.8,0.5-1.9,0.4-2.8,0.1 c-0.3-0.1-0.4-0.1-0.7,0c-0.3,0.1-0.4,0.5,0,0.7c0.5,0.3,2.2,0.3,3.8-0.5c2-1.2,1.8-2.4,0.1-3.3 C71.5,675.2,69.4,675.2,68.1,676.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M71.3,670.7c-2,1.2-0.9,2.6,1.5,3.9c2.4,1.4,4.9,2,6.9,0.8c2-1.2,0.9-2.6-1.5-3.9 C75.8,670.2,73.4,669.5,71.3,670.7z M79.3,675.3c-1.1,0.7-3.3-0.1-5.3-1.4c-2-1.1-3.4-2.3-2.3-3c1.1-0.7,3.3,0.1,5.3,1.4 C78.9,673.4,80.4,674.7,79.3,675.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M77.7,666.9c-2,1.2-0.9,2.6,1.5,3.9c2.4,1.4,4.9,2,6.9,0.8c2-1.2,0.9-2.6-1.5-3.9 C82.2,666.4,79.7,665.9,77.7,666.9z M85.7,671.5c-1.1,0.7-3.3-0.1-5.3-1.4c-2-1.1-3.4-2.3-2.3-3c1.1-0.7,3.3,0.1,5.3,1.4 C85.4,669.6,86.8,670.9,85.7,671.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M128.7,607.6l-1.6,3.3l-0.5-0.1l1.6-3.3L128.7,607.6z M129.8,608.4l-1.6,3.3l0.5,0.1l1.6-3.3 L129.8,608.4z M131.6,609.5l-1.6,3.3l0.5,0.1l1.6-3.3L131.6,609.5z M133.3,610.5l-1.6,3.3l0.5,0.1l1.6-3.3L133.3,610.5z  M135,611.4l-1.6,3.3l0.5,0.1l1.6-3.3L135,611.4z M136.7,612.5l-1.6,3.3l0.5,0.1l1.6-3.3L136.7,612.5z M138.5,613.4l-1.6,3.3 l0.5,0.1l1.6-3.3L138.5,613.4z M140.3,614.4l-1.6,3.3l0.5,0.1l1.6-3.3L140.3,614.4z M141.9,615.5l-1.6,3.3l0.5,0.1l1.6-3.3 L141.9,615.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M31.6,652.2c-1.6,0.9-1.6,2.6,0,3.5c1.6,0.9,4.5,0.9,6.1,0c1.6-0.9,1.6-2.6,0-3.5 C36.1,651.1,33.4,651.1,31.6,652.2z M37.3,655.4c-1.5,0.8-3.8,0.8-5.3,0c-1.5-0.8-1.5-2.2,0-3.1c1.5-0.8,3.8-0.8,5.3,0 C38.8,653.1,38.8,654.6,37.3,655.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M77.6,625.1l2.2,0.4l1.9-0.8v1.4l1.9,0.8l-2.2,0.4l-0.7,1.2l-1.4-1.1H77l1.4-1.1L77.6,625.1z  M70.6,634.2l-1.4,1.1h2.3l1.4,1.1l0.7-1.2l2.2-0.4l-1.9-0.8v-1.4l-1.9,0.8l-2.2-0.4L70.6,634.2z M70.6,642.8l-1.4,1.1h2.3 l1.4,1.1l0.7-1.2l2.2-0.4l-1.9-0.8v-1.4L72,642l-2.2-0.4L70.6,642.8z M78.4,650.5l-1.4,1.1h2.3l1.4,1.1l0.7-1.2l2.2-0.4 l-1.9-0.8v-1.4l-1.9,0.8l-2.2-0.4L78.4,650.5z M91.8,655l-1.4,1.1h2.3l1.4,1.1l0.7-1.2l2.2-0.4l-1.9-0.8v-1.4l-1.9,0.8 l-2.2-0.4L91.8,655z M106.7,655l-1.4,1.1h2.3l1.4,1.1l0.7-1.2l2.2-0.4l-1.9-0.8v-1.4l-1.9,0.8l-2.2-0.4L106.7,655z  M120.1,650.5l-1.4,1.1h2.3l1.4,1.1l0.7-1.2l2.2-0.4l-1.9-0.8v-1.4l-1.9,0.8l-2.2-0.4L120.1,650.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "83.8,618.6 59.8,632.4 111,662.1 135,648.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "135,672.2 111,686 111,662.1 135,648.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "132.3,649.7 81.1,620.2 84.1,618.5 135.2,648 135.2,672.1 132.3,673.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "110.5,662.3 59.3,632.7 62.2,631 113.6,660.6 113.6,684.5 110.5,686.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "132.3,649.7 135.2,648 135.2,672.1 132.3,673.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "110.5,662.3 113.6,660.6 113.6,684.5 110.5,686.3  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "235.2,667.9 132.7,727.1 91.1,703.1 91.1,681.7 235.2,646.5  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M235.2,660.7v0.7l-102.5,59.2l-0.1-0.1l-41.4-24v-0.7l41.6,24.1L235.2,660.7z M132.7,717.4l-41.6-24.1 v0.7l41.4,24l0.1,0.1l102.5-59.2v-0.7L132.7,717.4z M132.7,722.2l-41.6-24.1v0.7l41.4,24l0.1,0.1l102.5-59.2V663L132.7,722.2z  M235.2,665.4l-102.5,59.2l-41.6-24.1v0.7l41.4,24l0.1,0.1l102.5-59.2L235.2,665.4L235.2,665.4z M132.7,715l-41.6-24.1v0.7 l41.4,24l0.1,0.1l102.5-59.2v-0.7L132.7,715z M132.7,707.8l-41.6-24v0.7l41.4,24l0.1,0.1l102.5-59.2v-0.8L132.7,707.8z  M132.7,710.3l-41.6-24.1v0.7l41.4,24l0.1,0.1l102.5-59.2v-0.7L132.7,710.3z M132.7,712.7l-41.6-24.1v0.7l41.4,24l0.1,0.1 l102.5-59.2v-0.7L132.7,712.7z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "132.7,671.5 91.1,681.7 91.1,703.1 132.7,727.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "235.2,646.5 132.7,705.7 91.1,681.7 193.6,622.5  "
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M132.9,704c-0.1,0.1-0.3,0.1-0.4,0l-38.5-22.2c-0.1-0.1-0.1-0.1,0-0.3l99.3-57.3 c0.1-0.1,0.3-0.1,0.4,0l38.5,22.2c0.1,0.1,0.1,0.1,0,0.3L132.9,704z M102.9,682c-1.4,0.8-1.4,2,0,2.7l24.6,14.2 c1.2,0.7,3.4,0.7,4.7,0l91.1-52.7c1.4-0.8,1.4-2,0-2.7l-24.6-14.2c-1.2-0.7-3.4-0.7-4.7,0L102.9,682z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.6,624.3l38.5,22.2l-99.3,57.3l-38.5-22.2L193.6,624.3L193.6,624.3z M132.4,699l91.1-52.7 c1.5-0.8,1.5-2.2,0-3l-24.6-14.2c-1.4-0.8-3.7-0.8-5.1,0l-91.1,52.7c-1.5,0.8-1.5,2.2,0,3l24.6,14.2 C128.7,699.8,131,699.8,132.4,699L132.4,699z M193.1,624l-99.3,57.3c-0.3,0.1-0.3,0.4,0,0.5l38.5,22.2 c0.3,0.1,0.7,0.1,0.9,0l99.3-57.3c0.3-0.1,0.3-0.4,0-0.5L194,624C193.7,623.9,193.3,623.9,193.1,624L193.1,624z M132,698.8 c-1.2,0.7-3.1,0.7-4.2,0l-24.6-14.2c-1.2-0.7-1.1-1.8,0-2.4l91.1-52.7c1.2-0.7,3.1-0.7,4.2,0l24.6,14.2 c1.2,0.7,1.1,1.8,0,2.4L132,698.8L132,698.8z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M182.2,634.6L182.2,634.6l-3.3-1.8c-0.3-0.1-0.7-0.1-0.9,0l-0.3,0.1c-0.1,0.1-0.1,0.1-0.1,0.3 c0,0.1,0,0.1-0.1,0.3c-0.1,0.1-0.3,0.3-0.4,0.4c-0.3,0.1-0.3,0.4,0,0.5l0.4,0.3c0.3,0.1,0.7,0.1,0.9,0l0,0l1.8,1.1 l-0.1,0.1c-0.3,0.1-0.3,0.4,0,0.5l0.4,0.3c0.3,0.1,0.7,0.1,0.9,0l2.2-1.2c0.3-0.1,0.3-0.4,0-0.5l-0.4-0.3 C182.9,634.4,182.5,634.4,182.2,634.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M187.5,629c-0.4-0.1-0.8-0.3-1.2-0.3c-0.4,0-0.8,0-1.1,0.1c-0.3,0.1-0.7,0.3-0.9,0.4 c-0.3,0.1-0.5,0.3-0.7,0.5c-0.1,0.3-0.3,0.4-0.1,0.7c0,0.1,0,0.3,0.1,0.4c-0.3,0-0.4-0.1-0.7-0.1c-0.4,0-0.8,0-1.1,0.1 c-0.3,0.1-0.7,0.3-0.9,0.4c-0.3,0.1-0.5,0.3-0.7,0.5s-0.3,0.4-0.1,0.7c0,0.3,0.1,0.4,0.4,0.7c0.3,0.3,0.5,0.4,0.9,0.7 c0.4,0.3,0.8,0.4,1.2,0.5c0.4,0.1,0.8,0.3,1.2,0.3s0.8,0,1.1-0.1c0.3-0.1,0.7-0.3,0.9-0.4s0.5-0.3,0.7-0.5 c0.1-0.3,0.3-0.4,0.3-0.7c0-0.1,0-0.3-0.1-0.4c0.3,0,0.4,0.1,0.7,0.1c0.4,0,0.8,0,1.1-0.1c0.3-0.1,0.7-0.3,0.9-0.4 c0.3-0.1,0.5-0.3,0.7-0.5s0.3-0.4,0.3-0.7c0-0.3-0.1-0.4-0.4-0.7c-0.3-0.3-0.5-0.4-0.9-0.7 C188.6,629.3,187.9,629.1,187.5,629z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M182.1,635.1l0.5-0.3l0.4,0.3l-2.2,1.2l-0.4-0.3l0.7-0.4l-2.7-1.5l-0.5,0.3l-0.4-0.3 c0.3-0.1,0.4-0.3,0.5-0.4s0.3-0.3,0.3-0.5l0.3-0.1L182.1,635.1z M183.7,631.3c0.4,0.1,0.7,0.3,1.1,0.5s0.7,0.4,0.8,0.7 s0.3,0.4,0.3,0.5c0,0.1,0,0.3-0.1,0.5c-0.1,0.1-0.3,0.3-0.5,0.4c-0.3,0.1-0.4,0.3-0.7,0.3c-0.3,0.1-0.5,0.1-0.8,0.1 s-0.5-0.1-0.9-0.1c-0.4-0.1-0.7-0.3-1.1-0.5s-0.7-0.4-0.8-0.7c-0.1-0.1-0.3-0.4-0.3-0.5c0-0.1,0-0.3,0.1-0.4 c0.1-0.1,0.3-0.3,0.5-0.4c0.3-0.1,0.4-0.3,0.7-0.3c0.3-0.1,0.5-0.1,0.8-0.1C183.1,631,183.5,631.2,183.7,631.3z  M183.7,632.4c-0.4-0.3-0.7-0.4-0.8-0.4c-0.3-0.1-0.4-0.1-0.5-0.3c-0.1,0-0.3,0-0.3,0c-0.1,0-0.1,0-0.1,0s-0.1,0-0.1,0.1 c0,0,0,0.1,0.1,0.1c0.1,0.1,0.3,0.1,0.4,0.3c0.1,0.1,0.4,0.3,0.8,0.5c0.4,0.1,0.7,0.4,0.8,0.4c0.3,0.1,0.4,0.1,0.5,0.3 c0.1,0,0.3,0,0.3,0c0.1,0,0.1,0,0.1,0s0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1c-0.1-0.1-0.3-0.1-0.4-0.3 C184.3,632.8,184,632.7,183.7,632.4z M188.2,629.8c0.4,0.3,0.7,0.4,0.8,0.7c0.1,0.1,0.3,0.4,0.3,0.5c0,0.1,0,0.3-0.1,0.5 c-0.1,0.1-0.3,0.3-0.5,0.4c-0.3,0.1-0.4,0.3-0.7,0.3c-0.3,0.1-0.5,0.1-0.8,0.1s-0.5-0.1-0.9-0.1c-0.4-0.1-0.7-0.3-1.1-0.5 s-0.7-0.4-0.8-0.7c-0.1-0.1-0.3-0.4-0.3-0.5c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.3-0.3,0.5-0.4c0.3-0.1,0.4-0.3,0.7-0.3 c0.3-0.1,0.5-0.1,0.8-0.1c0.3,0,0.7,0.1,0.9,0.1C187.5,629.4,187.8,629.6,188.2,629.8z M187.1,630.5 c-0.4-0.3-0.7-0.4-0.8-0.4c-0.3-0.1-0.4-0.1-0.5-0.3c-0.1,0-0.3,0-0.3,0c-0.1,0-0.1,0-0.1,0s-0.1,0-0.1,0.1 c0,0,0,0.1,0.1,0.1c0.1,0.1,0.3,0.1,0.4,0.3c0.1,0.1,0.4,0.3,0.8,0.5c0.4,0.1,0.7,0.4,0.8,0.4c0.3,0.1,0.4,0.1,0.5,0.3 c0.1,0,0.3,0,0.3,0c0.1,0,0.1,0,0.1,0s0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1c-0.1-0.1-0.3-0.1-0.4-0.3 C187.7,630.9,187.4,630.6,187.1,630.5z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M197.5,655.6l-0.3,0.1l-7.4-4.3c-0.5-0.4-1.6-0.4-2.2,0l-0.7,0.4c-0.3,0.1-0.4,0.4-0.4,0.7 s-0.1,0.5-0.4,0.7c-0.3,0.3-0.7,0.5-1.1,0.8c-0.5,0.4-0.5,0.9,0,1.2l1.1,0.7c0.5,0.4,1.6,0.4,2.2,0h0.1l4.3,2.4l-0.4,0.3 c-0.5,0.4-0.5,0.9,0,1.2l0.9,0.5c0.5,0.4,1.6,0.4,2.2,0l5.3-3.1c0.5-0.4,0.5-0.9,0-1.2l-0.9-0.5 C199,655.2,198.1,655.2,197.5,655.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M209.9,642.2c-0.9-0.3-2-0.5-2.8-0.5c-0.9,0-1.9,0-2.7,0.3s-1.5,0.5-2.2,0.9s-1.2,0.8-1.5,1.2 c-0.4,0.5-0.5,1.1-0.5,1.6c0,0.3,0.1,0.5,0.4,0.9c-0.5-0.1-1.1-0.1-1.6-0.1c-0.9,0-1.9,0-2.7,0.3 c-0.8,0.3-1.5,0.5-2.2,0.9c-0.7,0.4-1.2,0.8-1.5,1.2c-0.4,0.5-0.5,1.1-0.5,1.6c0.1,0.5,0.4,1.1,0.9,1.6 c0.5,0.5,1.4,1.1,2.3,1.8c1.1,0.7,2,1.1,3,1.4c0.9,0.3,1.9,0.5,2.8,0.5c0.9,0,1.9,0,2.7-0.3c0.8-0.3,1.5-0.5,2.2-0.8 c0.7-0.4,1.2-0.8,1.5-1.2c0.4-0.5,0.5-1.1,0.5-1.6c0-0.3-0.1-0.5-0.3-0.9c0.5,0.1,1.1,0.1,1.5,0.1c0.9,0,1.9,0,2.7-0.3 c0.8-0.3,1.5-0.5,2.2-0.8c0.7-0.4,1.2-0.8,1.5-1.2c0.4-0.5,0.5-1.1,0.5-1.6c-0.1-0.5-0.4-1.1-0.9-1.6 c-0.5-0.5-1.4-1.1-2.3-1.8C211.8,643,210.8,642.4,209.9,642.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M197.1,656.8l1.4-0.8l0.9,0.5l-5.3,3.1l-0.9-0.5l1.5-0.8l-6.4-3.7l-1.1,0.7l-1.1-0.7 c0.5-0.3,1.1-0.7,1.4-1.1c0.4-0.4,0.5-0.8,0.5-1.1l0.7-0.4L197.1,656.8z M200.9,647.6c0.8,0.3,1.6,0.7,2.6,1.2 c0.9,0.5,1.6,1.1,2,1.5s0.7,0.9,0.8,1.4c0,0.4,0,0.8-0.4,1.1c-0.3,0.4-0.7,0.7-1.2,0.9s-1.1,0.5-1.8,0.7 c-0.5,0.1-1.2,0.3-1.9,0.1c-0.7,0-1.5-0.1-2.3-0.4c-0.8-0.3-1.6-0.7-2.6-1.2c-0.9-0.5-1.6-1.1-2-1.5s-0.7-0.9-0.8-1.4 c0-0.4,0-0.8,0.3-1.1c0.3-0.4,0.7-0.7,1.2-0.9s1.1-0.5,1.8-0.7c0.5-0.1,1.2-0.3,2-0.3C199.3,647.2,200.1,647.3,200.9,647.6 z M200.8,650.3c-0.8-0.5-1.5-0.8-2-1.1c-0.5-0.3-0.9-0.4-1.4-0.5c-0.4-0.1-0.5-0.1-0.8-0.1c-0.1,0-0.4,0-0.4,0.1 c-0.1,0-0.1,0.1-0.3,0.3c0,0.1,0,0.3,0.3,0.4c0.1,0.1,0.5,0.4,0.9,0.8c0.4,0.3,1.1,0.7,1.9,1.2c0.8,0.5,1.5,0.8,2,1.1 s0.9,0.4,1.4,0.5s0.5,0.1,0.8,0.1c0.1,0,0.3,0,0.4-0.1c0.1-0.1,0.1-0.1,0.3-0.3c0-0.1,0-0.3-0.3-0.4 c-0.1-0.1-0.5-0.4-0.9-0.8C202.3,651.2,201.6,650.8,200.8,650.3z M211.6,644c0.9,0.5,1.6,1.1,2,1.5s0.7,0.9,0.8,1.4 c0,0.4,0,0.8-0.4,1.1c-0.3,0.4-0.7,0.7-1.2,0.9s-1.1,0.5-1.8,0.7c-0.5,0.1-1.2,0.3-1.9,0.1c-0.7,0-1.5-0.1-2.3-0.4 c-0.8-0.3-1.6-0.7-2.6-1.2c-0.9-0.5-1.6-1.1-2-1.5c-0.4-0.4-0.7-0.9-0.8-1.4c0-0.4,0-0.8,0.3-1.1c0.3-0.4,0.7-0.7,1.2-0.9 s1.1-0.5,1.8-0.7c0.5-0.1,1.2-0.3,2-0.3c0.7,0,1.5,0.1,2.3,0.4C209.9,643.1,210.7,643.5,211.6,644z M208.9,645.7 c-0.8-0.5-1.5-0.8-2-1.1s-0.9-0.4-1.4-0.5s-0.5-0.1-0.8-0.1c-0.1,0-0.4,0-0.4,0.1c-0.1,0-0.1,0.1-0.3,0.3 c0,0.1,0,0.3,0.3,0.4c0.1,0.1,0.5,0.4,0.9,0.8c0.4,0.3,1.1,0.7,1.9,1.2c0.8,0.5,1.5,0.8,2,1.1s0.9,0.4,1.4,0.5 c0.4,0.1,0.5,0.1,0.8,0.1c0.1,0,0.3,0,0.4-0.1c0.1-0.1,0.1-0.1,0.3-0.3c0-0.1,0-0.3-0.3-0.4c-0.1-0.1-0.5-0.4-0.9-0.8 C210.4,646.5,209.7,646.1,208.9,645.7z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M107.1,678L107.1,678l-3.3-1.8c-0.3-0.1-0.7-0.1-0.9,0l-0.3,0.1c-0.1,0.1-0.1,0.1-0.1,0.3 c0,0.1,0,0.1-0.1,0.3c-0.1,0.1-0.3,0.3-0.4,0.4c-0.3,0.1-0.3,0.4,0,0.5l0.4,0.3c0.3,0.1,0.7,0.1,0.9,0l0,0l1.8,1.1 l-0.1,0.1c-0.3,0.1-0.3,0.4,0,0.5l0.4,0.3c0.3,0.1,0.7,0.1,0.9,0l2.2-1.2c0.3-0.1,0.3-0.4,0-0.5l-0.4-0.3 C107.8,677.9,107.3,677.9,107.1,678z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M112.2,672.5c-0.4-0.1-0.8-0.3-1.2-0.3s-0.8,0-1.1,0.1c-0.3,0.1-0.7,0.3-0.9,0.4 c-0.3,0.1-0.5,0.3-0.7,0.5c-0.1,0.3-0.3,0.4-0.1,0.7c0,0.1,0,0.3,0.1,0.4c-0.3,0-0.4-0.1-0.7-0.1c-0.4,0-0.8,0-1.1,0.1 c-0.3,0.1-0.7,0.3-0.9,0.4c-0.3,0.1-0.5,0.3-0.7,0.5c-0.1,0.3-0.3,0.4-0.1,0.7c0,0.3,0.1,0.4,0.4,0.7 c0.3,0.3,0.5,0.4,0.9,0.7c0.4,0.3,0.8,0.4,1.2,0.5c0.4,0.1,0.8,0.3,1.2,0.3s0.8,0,1.1-0.1c0.3-0.1,0.7-0.3,0.9-0.4 c0.3-0.1,0.5-0.3,0.7-0.5c0.1-0.3,0.3-0.4,0.3-0.7c0-0.1,0-0.3-0.1-0.4c0.3,0,0.4,0.1,0.7,0.1c0.4,0,0.8,0,1.1-0.1 c0.3-0.1,0.7-0.3,0.9-0.4c0.3-0.1,0.5-0.3,0.7-0.5c0.1-0.3,0.3-0.4,0.3-0.7s-0.1-0.4-0.4-0.7c-0.3-0.3-0.5-0.4-0.9-0.7 C113,672.8,112.6,672.6,112.2,672.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M106.9,678.6l0.5-0.3l0.4,0.3l-2.2,1.2l-0.4-0.3l0.7-0.4l-2.7-1.5l-0.5,0.3l-0.4-0.3 c0.3-0.1,0.4-0.3,0.5-0.4c0.1-0.1,0.3-0.3,0.3-0.5l0.3-0.1L106.9,678.6z M108.4,674.7c0.4,0.1,0.7,0.3,1.1,0.5 s0.7,0.4,0.8,0.7c0.1,0.1,0.3,0.4,0.3,0.5c0,0.1,0,0.3-0.1,0.5c-0.1,0.1-0.3,0.3-0.5,0.4c-0.3,0.1-0.4,0.3-0.7,0.3 c-0.3,0.1-0.5,0.1-0.8,0.1c-0.3,0-0.5-0.1-0.9-0.1c-0.4-0.1-0.7-0.3-1.1-0.5c-0.4-0.3-0.7-0.4-0.8-0.7 c-0.1-0.1-0.3-0.4-0.3-0.5c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.3-0.3,0.5-0.4c0.3-0.1,0.4-0.3,0.7-0.3c0.3-0.1,0.5-0.1,0.8-0.1 C107.9,674.5,108.2,674.7,108.4,674.7z M108.4,675.9c-0.4-0.3-0.7-0.4-0.8-0.4c-0.3-0.1-0.4-0.1-0.5-0.3 c-0.1,0-0.3,0-0.3,0c-0.1,0-0.1,0-0.1,0s-0.1,0-0.1,0.1c0,0,0,0.1,0.1,0.1c0.1,0.1,0.3,0.1,0.4,0.3 c0.1,0.1,0.4,0.3,0.8,0.5c0.4,0.1,0.7,0.4,0.8,0.4c0.3,0.1,0.4,0.1,0.5,0.3c0.1,0,0.3,0,0.3,0c0.1,0,0.1,0,0.1,0 s0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1c-0.1-0.1-0.3-0.1-0.4-0.3C109.1,676.3,108.8,676.1,108.4,675.9z M113,673.3 c0.4,0.3,0.7,0.4,0.8,0.7c0.1,0.1,0.3,0.4,0.3,0.5c0,0.1,0,0.3-0.1,0.5c-0.1,0.1-0.3,0.3-0.5,0.4c-0.3,0.1-0.4,0.3-0.7,0.3 c-0.3,0.1-0.5,0.1-0.8,0.1c-0.3,0-0.5-0.1-0.9-0.1c-0.4-0.1-0.7-0.3-1.1-0.5s-0.7-0.4-0.8-0.7c-0.1-0.1-0.3-0.4-0.3-0.5 c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.3-0.3,0.5-0.4c0.3-0.1,0.4-0.3,0.7-0.3c0.3-0.1,0.5-0.1,0.8-0.1c0.3,0,0.7,0.1,0.9,0.1 C112.2,672.9,112.6,673,113,673.3z M111.8,674c-0.4-0.3-0.7-0.4-0.8-0.4c-0.3-0.1-0.4-0.1-0.5-0.3c-0.1,0-0.3,0-0.3,0 c-0.1,0-0.1,0-0.1,0s-0.1,0-0.1,0.1c0,0,0,0.1,0.1,0.1c0.1,0.1,0.3,0.1,0.4,0.3c0.1,0.1,0.4,0.3,0.8,0.5 c0.4,0.1,0.7,0.4,0.8,0.4c0.3,0.1,0.4,0.1,0.5,0.3c0.1,0,0.3,0,0.3,0c0.1,0,0.1,0,0.1,0s0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1 c-0.1-0.1-0.3-0.1-0.4-0.3C112.5,674.2,112.2,674.1,111.8,674z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M141.1,697.7L141.1,697.7l-3.3-1.8c-0.3-0.1-0.7-0.1-0.9,0l-0.3,0.1c-0.1,0.1-0.1,0.1-0.1,0.3 c0,0.1,0,0.1-0.1,0.3c-0.1,0.1-0.3,0.3-0.4,0.4c-0.3,0.1-0.3,0.4,0,0.5l0.4,0.3c0.3,0.1,0.7,0.1,0.9,0l0,0l1.8,1.1 l-0.1,0.1c-0.3,0.1-0.3,0.4,0,0.5l0.4,0.3c0.3,0.1,0.7,0.1,0.9,0l2.2-1.2c0.3-0.1,0.3-0.4,0-0.5l-0.4-0.3 C141.7,697.5,141.3,697.5,141.1,697.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M146.3,692.1c-0.4-0.1-0.8-0.3-1.2-0.3s-0.8,0-1.1,0.1c-0.3,0.1-0.7,0.3-0.9,0.4s-0.5,0.3-0.7,0.5 s-0.3,0.4-0.1,0.7c0,0.1,0,0.3,0.1,0.4c-0.3,0-0.4-0.1-0.7-0.1c-0.4,0-0.8,0-1.1,0.1c-0.3,0.1-0.7,0.3-0.9,0.4 c-0.3,0.1-0.5,0.3-0.7,0.5c-0.1,0.3-0.3,0.4-0.1,0.7c0,0.3,0.1,0.4,0.4,0.7c0.3,0.3,0.5,0.4,0.9,0.7 c0.4,0.3,0.8,0.4,1.2,0.5c0.4,0.1,0.8,0.3,1.2,0.3s0.8,0,1.1-0.1c0.3-0.1,0.7-0.3,0.9-0.4c0.3-0.1,0.5-0.3,0.7-0.5 s0.3-0.4,0.3-0.7c0-0.1,0-0.3-0.1-0.4c0.3,0,0.4,0.1,0.7,0.1c0.4,0,0.8,0,1.1-0.1c0.3-0.1,0.7-0.3,0.9-0.4 c0.3-0.1,0.5-0.3,0.7-0.5c0.1-0.3,0.3-0.4,0.3-0.7c0-0.3-0.1-0.4-0.4-0.7c-0.3-0.3-0.5-0.4-0.9-0.7 C147.2,692.5,146.8,692.3,146.3,692.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M140.9,698.2l0.5-0.3l0.4,0.3l-2.2,1.2l-0.4-0.3l0.7-0.4l-2.7-1.5l-0.5,0.3l-0.4-0.3 c0.3-0.1,0.4-0.3,0.5-0.4c0.1-0.1,0.3-0.3,0.3-0.5l0.3-0.1L140.9,698.2z M142.6,694.4c0.4,0.1,0.7,0.3,1.1,0.5 s0.7,0.4,0.8,0.7c0.1,0.1,0.3,0.4,0.3,0.5c0,0.1,0,0.3-0.1,0.5c-0.1,0.1-0.3,0.3-0.5,0.4c-0.3,0.1-0.4,0.3-0.7,0.3 c-0.3,0.1-0.5,0.1-0.8,0.1s-0.5-0.1-0.9-0.1c-0.3-0.1-0.7-0.3-1.1-0.5s-0.7-0.4-0.8-0.7c-0.1-0.1-0.3-0.4-0.3-0.5 s0-0.3,0.1-0.4c0.1-0.1,0.3-0.3,0.5-0.4c0.3-0.1,0.4-0.3,0.7-0.3c0.3-0.1,0.5-0.1,0.8-0.1 C141.9,694.2,142.3,694.3,142.6,694.4z M142.6,695.5c-0.4-0.3-0.7-0.4-0.8-0.4c-0.3-0.1-0.4-0.1-0.5-0.3 c-0.1,0-0.3,0-0.3,0c-0.1,0-0.1,0-0.1,0s-0.1,0-0.1,0.1c0,0,0,0.1,0.1,0.1c0.1,0.1,0.3,0.1,0.4,0.3 c0.1,0.1,0.4,0.3,0.8,0.5c0.4,0.1,0.7,0.4,0.8,0.4c0.3,0.1,0.4,0.1,0.5,0.3c0.1,0,0.3,0,0.3,0c0.1,0,0.1,0,0.1,0 s0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1c-0.1-0.1-0.3-0.1-0.4-0.3C143.1,695.9,142.8,695.8,142.6,695.5z M147,692.9 c0.4,0.3,0.7,0.4,0.8,0.7c0.1,0.1,0.3,0.4,0.3,0.5c0,0.1,0,0.3-0.1,0.5c-0.1,0.1-0.3,0.3-0.5,0.4c-0.3,0.1-0.4,0.3-0.7,0.3 c-0.3,0.1-0.5,0.1-0.8,0.1c-0.3,0-0.5-0.1-0.9-0.1c-0.4-0.1-0.7-0.3-1.1-0.5s-0.7-0.4-0.8-0.7c-0.1-0.1-0.3-0.4-0.3-0.5 c0-0.1,0-0.3,0.1-0.4s0.3-0.3,0.5-0.4c0.3-0.1,0.4-0.3,0.7-0.3c0.3-0.1,0.5-0.1,0.8-0.1s0.7,0.1,0.9,0.1 C146.2,692.5,146.6,692.7,147,692.9z M145.9,693.6c-0.4-0.3-0.7-0.4-0.8-0.4c-0.3-0.1-0.4-0.1-0.5-0.3c-0.1,0-0.3,0-0.3,0 c-0.1,0-0.1,0-0.1,0s-0.1,0-0.1,0.1c0,0,0,0.1,0.1,0.1c0.1,0.1,0.3,0.1,0.4,0.3c0.1,0.1,0.4,0.3,0.8,0.5 c0.4,0.1,0.7,0.4,0.8,0.4c0.3,0.1,0.4,0.1,0.5,0.3c0.1,0,0.3,0,0.3,0c0.1,0,0.1,0,0.1,0s0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1 c-0.1-0.1-0.3-0.1-0.4-0.3C146.5,694,146.2,693.7,145.9,693.6z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 177.0212,
    y1: 223.7517,
    x2: 177.0212,
    y2: 248.0803,
    gradientTransform: "matrix(0.7071 -0.7071 -0.7071 -0.7071 236.8348 941.0643)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4C6C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7232,
    style: {
      stopColor: "#81908B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#637E77"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M192.3,640c2.2,1.2,2.2,3.3,0,4.5c-2.2,1.2-5.7,1.2-7.9,0c-2.2-1.2-2.2-3.3,0-4.5 C186.6,638.8,190.1,638.8,192.3,640z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st24"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158723207986867070110000016627888010160843183_",
    gradientUnits: "userSpaceOnUse",
    x1: 106.6359,
    y1: 187.3916,
    x2: 106.6359,
    y2: 265.7573,
    gradientTransform: "matrix(0.7071 -0.7071 -0.7071 -0.7071 236.8348 941.0643)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4C6C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7232,
    style: {
      stopColor: "#81908B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#637E77"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158723207986867070110000016627888010160843183_)"
    },
    d: "M142.4,676 c6.9,4.1,6.9,10.6,0,14.5c-6.9,4.1-18.3,4.1-25.2,0c-6.9-4.1-6.9-10.6,0-14.5C124.1,672.1,135.5,672.1,142.4,676z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M142.8,690.9c-7.2,4.2-19,4.2-26.1,0c-7.2-4.2-7.2-11,0-15c7.2-4.2,19-4.2,26.1,0 C150.1,679.9,150.1,686.7,142.8,690.9z M117.6,676.3c-6.6,3.9-6.6,10.2,0,14.1c6.6,3.9,17.6,3.9,24.2,0 c6.6-3.9,6.6-10.2,0-14.1C135.2,672.5,124.4,672.5,117.6,676.3z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M135.5,676.4c-0.5-0.1-0.8-0.1-1.2-0.1c-0.7,0.1-1.1,0.4-1.2,0.7c0,0.1,0,0.4,0.3,0.7s0.5,0.5,1.1,0.8 c0.4,0.3,1.1,0.7,2,1.2c0.8,0.5,1.5,0.8,2.2,1.1c0.5,0.3,1.1,0.4,1.5,0.5c0.5,0.1,0.8,0.3,1.2,0.1c0.3,0,0.5-0.1,0.8-0.3 c0.3-0.1,0.4-0.3,0.4-0.4s0-0.4-0.3-0.7s-0.5-0.5-1.1-0.8c-0.4-0.3-1.1-0.7-1.9-1.2c-0.8-0.5-1.6-0.8-2.2-1.1 C136.3,676.7,135.9,676.5,135.5,676.4z M140.5,679.7c0.4,0.3,0.8,0.5,0.9,0.8c0.1,0.1,0.3,0.4,0.3,0.4 c0,0.3-0.3,0.4-0.7,0.4c-0.1,0-0.4,0-0.8-0.1c-0.4-0.1-0.8-0.3-1.4-0.5c-0.5-0.3-1.2-0.7-2-1.1c-0.8-0.5-1.5-0.9-1.9-1.2 s-0.8-0.5-0.9-0.8c-0.1-0.1-0.3-0.4-0.3-0.4c0-0.1,0.1-0.1,0.3-0.3c0.1,0,0.3-0.1,0.4-0.1c0.1,0,0.4,0,0.8,0.1 c0.4,0.1,0.8,0.3,1.4,0.5c0.5,0.3,1.2,0.7,2,1.1C139.4,678.9,140.1,679.3,140.5,679.7z M138.9,675.5 c-0.8-0.3-1.6-0.4-2.4-0.4c-0.8,0-1.5,0-2.2,0.3c-1.2,0.4-2.4,1.1-3.1,1.8c-0.3,0.4-0.4,0.8-0.4,1.2c0,0.4,0.3,0.9,0.8,1.4 c0.4,0.5,1.2,0.9,2.2,1.6c0.9,0.5,1.9,0.9,2.7,1.2c0.8,0.3,1.6,0.4,2.4,0.4c0.8,0,1.5,0,2.2-0.3c0.7-0.1,1.2-0.4,1.8-0.7 s0.9-0.7,1.4-1.1c0.3-0.4,0.4-0.8,0.4-1.2c0-0.4-0.3-0.9-0.8-1.4c-0.4-0.5-1.2-0.9-2.2-1.6 C140.7,676.1,139.7,675.7,138.9,675.5z M143.2,678.4c0.4,0.4,0.7,0.8,0.7,1.2s0,0.7-0.3,1.1c-0.5,0.7-1.6,1.4-2.8,1.6 c-0.5,0.1-1.2,0.3-1.8,0.1c-0.7,0-1.4-0.1-2.2-0.4c-0.8-0.3-1.6-0.7-2.6-1.2c-0.9-0.5-1.6-1.1-2-1.5 c-0.4-0.4-0.7-0.8-0.7-1.2c0-0.4,0-0.7,0.3-1.1c0.3-0.3,0.7-0.7,1.2-0.9s1.1-0.5,1.6-0.7c0.5-0.1,1.2-0.3,1.8-0.1 c0.7,0,1.4,0.1,2.2,0.4c0.8,0.3,1.6,0.7,2.6,1.2C142.2,677.5,142.8,678,143.2,678.4z M127.9,688.7l-1.1,0.7l-8.3-4.7 c-0.1-0.1-0.3-0.1-0.4,0l-0.7,0.4l-0.1,0.1c0,0.3-0.1,0.7-0.5,1.1c-0.3,0.4-0.8,0.7-1.4,1.1c-0.1,0.1-0.1,0.1,0,0.3l1.1,0.7 c0.1,0.1,0.3,0.1,0.4,0l0.9-0.5l6,3.4l-1.2,0.7c-0.1,0.1-0.1,0.1,0,0.3l0.9,0.5c0.1,0.1,0.3,0.1,0.4,0l5.3-3.1 c0.1-0.1,0.1-0.1,0-0.3l-0.9-0.5C128.3,688.6,128.1,688.6,127.9,688.7z M128.7,689.4l-4.9,2.8l-0.5-0.3l1.2-0.7 c0.1-0.1,0.1-0.1,0-0.3l-6.4-3.7c-0.1-0.1-0.3-0.1-0.4,0l-0.9,0.5l-0.7-0.4c0.5-0.3,0.9-0.7,1.2-0.9 c0.4-0.4,0.5-0.8,0.5-1.1l0.4-0.3l8.3,4.7c0.1,0.1,0.3,0.1,0.4,0l1.1-0.7L128.7,689.4z M128.5,679.7c-0.8,0-1.5,0-2.2,0.3 c-1.2,0.4-2.4,1.1-3.1,1.8c-0.3,0.4-0.4,0.8-0.4,1.2c0,0.4,0.3,0.9,0.8,1.4c0.4,0.5,1.2,0.9,2.2,1.6 c0.9,0.5,1.9,0.9,2.7,1.2c0.8,0.3,1.6,0.4,2.4,0.4c0.8,0,1.5,0,2.2-0.3c0.7-0.1,1.2-0.4,1.8-0.7s0.9-0.7,1.4-1.1 c0.3-0.4,0.4-0.8,0.4-1.2c0-0.4-0.3-0.9-0.8-1.4c-0.4-0.5-1.2-0.9-2.2-1.6c-0.9-0.5-1.9-0.9-2.7-1.2 C130,679.9,129.2,679.7,128.5,679.7z M135.1,683.2c0.4,0.4,0.7,0.8,0.7,1.2c0,0.4,0,0.7-0.3,1.1c-0.5,0.7-1.6,1.4-2.8,1.6 c-0.5,0.1-1.2,0.3-1.8,0.1c-0.7,0-1.4-0.1-2.2-0.4c-0.8-0.3-1.6-0.7-2.6-1.2c-0.9-0.5-1.6-1.1-2-1.5 c-0.4-0.4-0.7-0.8-0.7-1.2s0-0.7,0.3-1.1c0.3-0.3,0.7-0.7,1.2-0.9c0.5-0.3,1.1-0.5,1.6-0.7c0.5-0.1,1.2-0.3,1.8-0.1 c0.7,0,1.4,0.1,2.2,0.4s1.6,0.7,2.6,1.2C134,682.2,134.7,682.6,135.1,683.2z M127.3,681.3c-0.4-0.1-0.7-0.1-0.9-0.1 c-0.5,0-0.8,0.3-0.9,0.5c0,0.1,0,0.3,0.3,0.5c0.1,0.3,0.5,0.5,0.9,0.8c0.4,0.3,1.1,0.7,2,1.2c0.8,0.5,1.5,0.8,2,1.1 s1.1,0.4,1.4,0.5c0.4,0.1,0.7,0.1,0.9,0.1s0.4-0.1,0.7-0.1c0.1-0.1,0.3-0.3,0.3-0.4c0-0.1,0-0.4-0.3-0.5 c-0.1-0.3-0.5-0.4-0.9-0.8c-0.4-0.3-1.1-0.7-1.9-1.2c-0.8-0.5-1.5-0.8-2.2-1.1C128.1,681.6,127.7,681.4,127.3,681.3z  M132.3,684.4c0.4,0.3,0.8,0.5,0.9,0.7c0.3,0.3,0.3,0.3,0.1,0.4c0,0.1-0.1,0.3-0.4,0.3c0,0-0.3,0-0.5-0.1 c-0.3-0.1-0.8-0.3-1.2-0.5c-0.5-0.3-1.2-0.7-2-1.1c-0.8-0.5-1.5-0.9-1.9-1.2s-0.7-0.5-0.9-0.7c-0.3-0.3-0.3-0.3-0.1-0.3 c0,0,0-0.1,0.1-0.1s0.1-0.1,0.3-0.1c0,0,0.1,0,0.5,0.1c0.3,0.1,0.8,0.3,1.2,0.5c0.5,0.3,1.2,0.7,2,1.1 C131.2,683.7,131.7,684.1,132.3,684.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M107.2,684.3l-0.3,0.1l-1.6-2l0.3-0.1l3.7,0.9l-0.8,0.5l-0.5-0.1l-0.8,0.5L107.2,684.3z M106.3,683 l0.5,0.7l0.7-0.4L106.3,683z M108.7,680.6l-0.8,0.4l0.7,0.4h0.1c0.3-0.1,0.5-0.3,0.8-0.3c0.3,0,0.5,0.1,0.8,0.3 c0.3,0.1,0.4,0.4,0.4,0.5c0,0.1-0.1,0.4-0.5,0.5c-0.1,0.1-0.4,0.1-0.5,0.3c-0.1,0-0.4,0.1-0.7,0.1l-0.1-0.3 c0.1,0,0.3,0,0.4,0c0.1,0,0.3-0.1,0.4-0.1c0,0,0.1,0,0.1-0.1v-0.1c0,0,0-0.1-0.1-0.1c0,0-0.1-0.1-0.3-0.1 c-0.1,0-0.3-0.1-0.3-0.1c-0.1,0-0.1,0-0.3,0c-0.1,0-0.1,0-0.3,0s-0.1,0-0.3,0.1l-0.1,0.1l-0.1,0.1l-1.4-0.8l1.5-0.8 L108.7,680.6z M112.4,681.2l-0.5-0.4l-0.8,0.5l-0.4-0.1l-0.8-1.6l0.8-0.4l1.8,0.9l0.3-0.1l0.3,0.1l-0.3,0.1l0.5,0.4 L112.4,681.2z M111.5,680.7l-1.2-0.7l0.5,1.1L111.5,680.7z M113,678l-0.8,0.4l0.7,0.4h0.1c0.3-0.1,0.5-0.3,0.8-0.3 c0.3,0,0.5,0.1,0.8,0.3c0.3,0.1,0.4,0.4,0.4,0.5s-0.1,0.4-0.5,0.5c-0.1,0.1-0.4,0.1-0.5,0.3c-0.1,0-0.4,0.1-0.7,0.1 l-0.1-0.3c0.1,0,0.3,0,0.4,0c0.1,0,0.3-0.1,0.4-0.1c0,0,0.1,0,0.1-0.1v-0.1c0,0,0-0.1-0.1-0.1s-0.1-0.1-0.3-0.1 c-0.1,0-0.3-0.1-0.3-0.1c-0.1,0-0.1,0-0.3,0c-0.1,0-0.1,0-0.3,0s-0.1,0-0.3,0.1l-0.1,0.1l-0.1,0.1l-1.4-0.8l1.5-0.8L113,678 z M114.1,677.1c0.1,0,0.3-0.1,0.3-0.1c0.1,0,0.3-0.1,0.4-0.1c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0.1c0.1,0,0.1,0.1,0.1,0.1 v0.1v0.1v0.1c0.3-0.1,0.4-0.1,0.7-0.1c0.3,0,0.4,0.1,0.7,0.1c0.3,0.1,0.4,0.4,0.4,0.5c0,0.1-0.3,0.4-0.5,0.5 c-0.1,0.1-0.3,0.1-0.4,0.3c-0.1,0-0.3,0.1-0.4,0.1c-0.1,0-0.3,0-0.4,0c-0.1,0-0.3-0.1-0.4-0.1c-0.3-0.1-0.4-0.3-0.4-0.4 c0-0.1,0-0.3,0.1-0.4c-0.1,0-0.3,0.1-0.5,0.1c-0.1,0-0.3,0-0.4-0.1c-0.1-0.1-0.1-0.1-0.3-0.3c0-0.1,0-0.1,0-0.3 c0-0.1,0.1-0.1,0.1-0.3C114,677.2,114.1,677.1,114.1,677.1z M115.5,677.9c0,0-0.1,0.1,0,0.1c0,0.1,0.1,0.1,0.4,0.3 c0.3,0.1,0.4,0.3,0.5,0.3c0.1,0,0.3,0,0.3,0s0,0,0-0.1c0,0,0-0.1-0.1-0.1l-0.1-0.1c0,0-0.1-0.1-0.3-0.1 c-0.1-0.1-0.4-0.1-0.4-0.3C115.6,677.8,115.6,677.8,115.5,677.9z M114.4,677.2C114.4,677.2,114.4,677.4,114.4,677.2 c0,0.1,0.1,0.3,0.3,0.3c0.3,0.1,0.4,0.1,0.5,0.1c0.1,0,0-0.1-0.1-0.3s-0.3-0.1-0.4-0.1C114.5,677.2,114.5,677.2,114.4,677.2 z M117.6,676.7c-0.3-0.1-0.4-0.3-0.5-0.4c-0.1-0.1-0.1-0.3-0.3-0.4c0-0.1,0-0.3,0.1-0.3c0.1-0.1,0.1-0.1,0.3-0.3 c0.1-0.1,0.3-0.1,0.4-0.1c0.1,0,0.4,0,0.5,0c0.1,0,0.4,0,0.7,0.1c0.3,0.1,0.4,0.1,0.7,0.3c0.3,0.1,0.4,0.3,0.5,0.4 c0.1,0.1,0.1,0.3,0.3,0.4c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.1,0.1-0.3,0.3c-0.1,0.1-0.3,0.1-0.4,0.1c-0.1,0-0.4,0-0.5,0 c-0.1,0-0.4,0-0.7-0.1C118.2,677,117.9,676.8,117.6,676.7z M118.5,676.1c0.3,0.1,0.4,0.3,0.5,0.3c0.1,0.1,0.3,0.1,0.4,0.1 c0.1,0,0.1,0,0.3,0h0.1c0,0,0,0,0-0.1v-0.1c0,0-0.1-0.1-0.3-0.3c-0.1-0.1-0.3-0.1-0.5-0.3c-0.3-0.1-0.4-0.3-0.5-0.3 c-0.1-0.1-0.3-0.1-0.4-0.1c-0.1,0-0.1,0-0.3,0h-0.1c0,0,0,0,0,0.1v0.1c0,0,0.1,0.1,0.3,0.3C118,676,118.2,676,118.5,676.1z  M119.9,675.3c-0.3-0.1-0.4-0.3-0.5-0.4c-0.1-0.1-0.1-0.3-0.3-0.4c0-0.1,0-0.3,0.1-0.3c0.1-0.1,0.1-0.1,0.3-0.3 c0.1-0.1,0.3-0.1,0.4-0.1c0.1,0,0.4,0,0.5,0s0.4,0,0.7,0.1c0.3,0.1,0.4,0.1,0.7,0.3c0.3,0.1,0.4,0.3,0.5,0.4 c0.1,0.1,0.1,0.3,0.3,0.4c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.1,0.1-0.3,0.3c-0.1,0.1-0.3,0.1-0.4,0.1c-0.1,0-0.4,0-0.5,0 s-0.4,0-0.7-0.1C120.3,675.6,120.1,675.5,119.9,675.3z M120.6,674.9c0.3,0.1,0.4,0.3,0.5,0.3c0.1,0.1,0.3,0.1,0.4,0.1 c0.1,0,0.1,0,0.3,0h0.1c0,0,0,0,0-0.1v-0.1c0,0-0.1-0.1-0.3-0.3c-0.1-0.1-0.3-0.1-0.5-0.3c-0.3-0.1-0.4-0.3-0.5-0.3 c-0.1-0.1-0.3-0.1-0.4-0.1c-0.1,0-0.1,0-0.3,0h-0.1c0,0,0,0,0,0.1v0.1c0,0,0.1,0.1,0.3,0.3 C120.2,674.7,120.3,674.8,120.6,674.9z M122.1,674.1c-0.3-0.1-0.4-0.3-0.5-0.4c-0.1-0.1-0.1-0.3-0.3-0.4 c0-0.1,0-0.3,0.1-0.3c0.1-0.1,0.1-0.1,0.3-0.3c0.1-0.1,0.3-0.1,0.4-0.1c0.1,0,0.4,0,0.5,0s0.4,0,0.7,0.1 c0.3,0.1,0.4,0.1,0.7,0.3c0.3,0.1,0.4,0.3,0.5,0.4c0.1,0.1,0.1,0.3,0.3,0.4c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.1,0.1-0.3,0.3 c-0.1,0.1-0.3,0.1-0.4,0.1c-0.1,0-0.4,0-0.5,0s-0.4,0-0.7-0.1C122.5,674.2,122.4,674.2,122.1,674.1z M122.8,673.7 c0.3,0.1,0.4,0.3,0.5,0.3c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0.1,0,0.3,0h0.1c0,0,0,0,0-0.1v-0.1c0,0-0.1-0.1-0.3-0.3 s-0.3-0.1-0.5-0.3c-0.3-0.1-0.4-0.3-0.5-0.3c-0.1-0.1-0.3-0.1-0.4-0.1c-0.1,0-0.1,0-0.3,0H122c0,0,0,0,0,0.1v0.1 c0,0,0.1,0.1,0.3,0.3C122.4,673.4,122.6,673.6,122.8,673.7z M125.1,671.1l-0.8,0.5l0.7,0.4h0.1c0.3-0.1,0.5-0.3,0.8-0.3 c0.3,0,0.5,0.1,0.8,0.3c0.3,0.1,0.4,0.4,0.4,0.5c0,0.1-0.1,0.4-0.5,0.5c-0.1,0.1-0.4,0.1-0.5,0.3c-0.1,0-0.4,0.1-0.7,0.1 l-0.1-0.3c0.1,0,0.3,0,0.4,0c0.1,0,0.3-0.1,0.4-0.1c0,0,0.1,0,0.1-0.1v-0.1c0,0,0-0.1-0.1-0.1s-0.1-0.1-0.3-0.1 c-0.1,0-0.3-0.1-0.3-0.1c-0.1,0-0.1,0-0.3,0c-0.1,0-0.1,0-0.3,0s-0.1,0-0.3,0.1l-0.1,0.1l-0.1,0.1l-1.4-0.8l1.5-0.8 L125.1,671.1z M127.4,671c-0.3-0.1-0.4-0.3-0.5-0.4c-0.1-0.1-0.1-0.3-0.3-0.4c0-0.1,0-0.3,0.1-0.3c0.1-0.1,0.1-0.1,0.3-0.3 c0.1-0.1,0.3-0.1,0.4-0.1c0.1,0,0.4,0,0.5,0c0.1,0,0.4,0,0.7,0.1s0.4,0.1,0.7,0.3c0.3,0.1,0.4,0.3,0.5,0.4 c0.1,0.1,0.1,0.3,0.3,0.4c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.1,0.1-0.3,0.3s-0.3,0.1-0.4,0.1c-0.1,0-0.4,0-0.5,0 s-0.4,0-0.7-0.1C127.9,671.3,127.7,671.1,127.4,671z M128.2,670.6c0.3,0.1,0.4,0.3,0.5,0.3c0.1,0.1,0.3,0.1,0.4,0.1 c0.1,0,0.1,0,0.3,0h0.1c0,0,0,0,0-0.1v-0.1c0,0-0.1-0.1-0.3-0.3c-0.1-0.1-0.3-0.1-0.5-0.3c-0.3-0.1-0.4-0.3-0.5-0.3 c-0.1-0.1-0.3-0.1-0.4-0.1c-0.1,0-0.1,0-0.3,0h-0.1c0,0,0,0,0,0.1v0.1c0,0,0.1,0.1,0.3,0.3 C127.8,670.3,127.9,670.5,128.2,670.6z M129.7,669.8c-0.3-0.1-0.4-0.3-0.5-0.4c-0.1-0.1-0.1-0.3-0.3-0.4 c0-0.1,0-0.3,0.1-0.3c0.1-0.1,0.1-0.1,0.3-0.3c0.1-0.1,0.3-0.1,0.4-0.1c0.1,0,0.4,0,0.5,0s0.4,0,0.7,0.1s0.4,0.1,0.7,0.3 c0.3,0.1,0.4,0.3,0.5,0.4c0.1,0.1,0.1,0.3,0.3,0.4c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.1,0.1-0.3,0.3c-0.1,0.1-0.3,0.1-0.4,0.1 c-0.1,0-0.4,0-0.5,0s-0.4,0-0.7-0.1C130.1,670,130,669.9,129.7,669.8z M130.4,669.2c0.3,0.1,0.4,0.3,0.5,0.3 c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0.1,0,0.3,0h0.1c0,0,0,0,0-0.1v-0.1c0,0-0.1-0.1-0.3-0.3c-0.1-0.1-0.3-0.1-0.5-0.3 c-0.3-0.1-0.4-0.3-0.5-0.3c-0.1-0.1-0.3-0.1-0.4-0.1c-0.1,0-0.1,0-0.3,0h-0.1c0,0,0,0,0,0.1v0.1c0,0,0.1,0.1,0.3,0.3 C130,669.1,130.2,669.1,130.4,669.2z M132.3,666.7l0.3,0.1v0.4c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.3,0.1 c0.1,0,0.3,0.1,0.3,0.1c0.1,0.1,0.3,0.1,0.4,0.3c0.1,0.1,0.1,0.3,0.1,0.3c0,0.1,0,0.3-0.1,0.3c-0.1,0.1-0.1,0.3-0.4,0.3 c-0.1,0-0.1,0.1-0.3,0.1s-0.1,0-0.3,0.1c-0.1,0-0.1,0-0.3,0s-0.1,0-0.3,0l-0.1-0.3c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4-0.1 c0.1,0,0.1-0.1,0.1-0.1v-0.1c0,0,0-0.1-0.1-0.1l-0.1-0.1c-0.1,0-0.1-0.1-0.3-0.1s-0.1,0-0.3,0s-0.1,0-0.3,0s-0.1,0-0.3,0.1 H132v-0.9l-1.1,0.7l-0.3-0.1L132.3,666.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127739806396793246630000011064290342284978350_",
    gradientUnits: "userSpaceOnUse",
    x1: 141.5892,
    y1: 272.6512,
    x2: 141.5892,
    y2: 227.0883,
    gradientTransform: "matrix(0.7071 -0.7071 -0.7071 -0.7071 236.8348 941.0643)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4C6C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6452,
    style: {
      stopColor: "#A3A5A8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127739806396793246630000011064290342284978350_)"
    },
    d: "M172.9,658.3 c9.5,5.4,11.9,13,5.3,16.7c-6.5,3.8-19.5,2.4-29-3.1c-9.5-5.4-11.9-13-5.3-16.7C150.5,651.4,163.4,652.7,172.9,658.3z"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M178.4,675.1c-6.6,3.8-19.8,2.4-29.4-3.1c-9.6-5.6-11.9-13.1-5.3-16.9c6.6-3.8,19.8-2.4,29.4,3.1 C182.8,663.5,185.1,671.3,178.4,675.1z M144.2,655.3c-6.4,3.7-3.9,11.1,5.3,16.5c9.3,5.4,22.1,6.8,28.4,3.1 s3.9-11.1-5.3-16.5C163.4,653,150.5,651.6,144.2,655.3z"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M149.1,659.8l-1.5-0.8l0.7-0.4l1.4,0.8c0.4-0.3,0.7-0.4,0.9-0.7c0.3-0.1,0.7-0.3,1.1-0.5l-1.4-0.8 l0.7-0.4l1.5,0.8c1.6-0.7,3.3-1.1,4.7-1.1s2.6,0.3,3.4,0.8c0.5,0.3,0.8,0.7,0.8,0.9c0,0.4-0.1,0.7-0.5,0.8 c-0.4,0.3-0.8,0.3-1.5,0.3c-0.5,0-1.1-0.1-1.5-0.4c-0.7-0.4-0.8-0.8-0.5-1.4c0.1-0.3,0.1-0.4,0.1-0.4c-0.1-0.1-0.7-0.1-1.5,0 c-0.8,0.1-1.8,0.4-2.8,0.8l7.6,4.3c4.3-0.9,7.7-0.8,10.3,0.7c1.2,0.7,1.9,1.5,2.2,2.6c0.3,1.1-0.1,2.2-1.2,3.3l3.3,1.9 l-0.7,0.4l-3.1-1.8c-0.7,0.5-1.4,0.9-1.9,1.2l3,1.8l-0.7,0.4l-3-1.8c-2,0.8-3.8,1.2-5.4,1.1s-3-0.4-3.9-0.9 c-0.5-0.3-0.8-0.7-0.8-1.1c-0.1-0.4,0.1-0.8,0.5-1.1s0.9-0.4,1.5-0.4c0.7,0,1.2,0.1,1.6,0.4c0.4,0.3,0.7,0.5,0.7,0.9 c0,0.3-0.1,0.5-0.5,0.8c0,0-0.1,0-0.3,0.1c-0.1,0-0.3,0.1-0.3,0.1c-0.1,0.1-0.1,0.1,0,0.3c0.3,0.1,1.1,0.3,2.3,0.3 c1.2,0,2.4-0.3,3.8-0.9l-8.9-5.1c-3.9,1.1-7,0.8-9.3-0.4C147.2,663.5,147,661.8,149.1,659.8z M155.8,663.7l-6-3.4 c-1.2,1.4-1.1,2.4,0.4,3.3C151.5,664.2,153.4,664.2,155.8,663.7z M150.4,659.8l6.4,3.7c0.5-0.1,1.5-0.4,2.8-0.8l-7.2-4.2 l-1.1,0.5c-0.1,0.1-0.4,0.3-0.5,0.4C150.7,659.6,150.5,659.8,150.4,659.8z M170.7,669l-7.6-4.3l-3,0.7l8.7,5 c0.3-0.1,0.4-0.1,0.5-0.3C169.6,669.8,170,669.5,170.7,669z M164.1,664.4l7.2,4.1c1.4-1.5,1.1-2.7-0.5-3.8 C169,663.8,166.8,663.7,164.1,664.4z"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "153.5,645.7 133.5,657.2 175.1,681.3 195.1,669.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "195.1,691 175.1,702.7 175.1,681.3 195.1,669.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "192.9,671 151.4,646.9 153.8,645.5 195.5,669.5 195.5,690.9 192.9,692.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "174.7,681.4 133.1,657.5 135.7,656 177.2,680.1 177.2,701.5 174.7,702.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "192.9,671 195.5,669.5 195.5,690.9 192.9,692.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "174.7,681.4 177.2,680.1 177.2,701.5 174.7,702.8  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123423046622725432930000004881571911132767137_",
    gradientUnits: "userSpaceOnUse",
    x1: 639.7102,
    y1: 301.5897,
    x2: 668.122,
    y2: 301.5897,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000123423046622725432930000004881571911132767137_)"
    },
    d: "M659.8,421.4c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C668,425.9,665.3,423,659.8,421.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031916281214479540790000009677636173794662331_",
    gradientUnits: "userSpaceOnUse",
    x1: 640.0501,
    y1: 296.5789,
    x2: 667.8116,
    y2: 296.5789,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000031916281214479540790000009677636173794662331_)",
      enableBackground: "new"
    },
    d: " M641.1,432.4v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C640.3,431.3,640.7,431.8,641.1,432.4z M648.2,436.6v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C648.9,436.7,648.6,436.6,648.2,436.6z M652.4,437.1v3.3c0.3,0,0.7,0,0.9,0v-3.3C653.1,437.1,652.7,437.1,652.4,437.1z  M650.4,436.8v3.1c0.3,0,0.7,0.1,0.9,0.1V437C651.1,437,650.7,437,650.4,436.8z M642.1,433.6v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C642.8,434,642.4,433.9,642.1,433.6z M646.2,435.9v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C646.9,436,646.6,436,646.2,435.9z  M644.2,434.9v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C644.9,435.2,644.5,435.1,644.2,434.9z M654.5,437.1v3.3c0.3,0,0.7,0,0.9,0v-3.3 C655.1,437.1,654.9,437.1,654.5,437.1z M664.8,434.1v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C665.4,433.7,665,433.9,664.8,434.1z  M656.5,437v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C657.2,436.8,656.9,437,656.5,437z M666.8,432.2v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C667.6,431.2,667.2,431.7,666.8,432.2z M662.7,435.4v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C663.4,435.1,663,435.2,662.7,435.4z  M660.7,436.2v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C661.4,435.9,661,436,660.7,436.2z M658.5,436.7v3.1c0.3-0.1,0.7-0.1,0.9-0.3 v-3.1C659.2,436.6,658.9,436.6,658.5,436.7z"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M664,423.2c5.6,3.1,5.6,8.4,0,11.6s-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C649.3,420.1,658.4,419.9,664,423.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080206951878423103490000007766635867252590216_",
    gradientUnits: "userSpaceOnUse",
    x1: 640.973,
    y1: 302.9698,
    x2: 666.824,
    y2: 302.9698,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080206951878423103490000007766635867252590216_)"
    },
    d: "M663,423.7c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1s-5.1-7.6,0-10.6C649.7,420.9,658,420.7,663,423.7z"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M645,424.4c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3c-5-2.8-13.3-2.8-18.3,0.1 c-3.9,2.3-4.7,5.6-2.6,8.3C640.5,429.5,641.5,426.6,645,424.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168808203893479874450000012536952295740768672_",
    gradientUnits: "userSpaceOnUse",
    x1: 534.0771,
    y1: 521.9294,
    x2: 562.4888,
    y2: 521.9294,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168808203893479874450000012536952295740768672_)"
    },
    d: "M554.1,201.1c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C562.4,205.5,559.7,202.7,554.1,201.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000910207715160088180000008552268062480492478_",
    gradientUnits: "userSpaceOnUse",
    x1: 534.4324,
    y1: 516.9186,
    x2: 562.1939,
    y2: 516.9186,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000000910207715160088180000008552268062480492478_)",
      enableBackground: "new"
    },
    d: " M535.4,212v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C534.6,211,535,211.5,535.4,212z M542.7,216.1v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C543.3,216.2,543,216.2,542.7,216.1z M546.8,216.8v3.3c0.3,0,0.7,0,0.9,0v-3.3C547.5,216.8,547.1,216.8,546.8,216.8z  M544.8,216.5v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C545.5,216.6,545,216.6,544.8,216.5z M536.5,213.3v3.1c0.3,0.3,0.7,0.5,0.9,0.8 v-3.1C537.2,213.7,536.8,213.5,536.5,213.3z M540.6,215.6v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C541.3,215.7,541,215.7,540.6,215.6z  M538.5,214.6v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C539.2,214.9,538.8,214.7,538.5,214.6z M548.8,216.8v3.3c0.3,0,0.7,0,0.9,0v-3.3 C549.5,216.8,549.2,216.8,548.8,216.8z M559.1,213.8v3.1c0.4-0.3,0.7-0.5,0.9-0.8V213C559.8,213.4,559.5,213.5,559.1,213.8z  M550.9,216.6v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C551.5,216.5,551.3,216.6,550.9,216.6z M561.2,211.9v3.1c0.4-0.5,0.8-1.2,0.9-1.9 v-3C562,210.8,561.6,211.4,561.2,211.9z M557.1,215v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C557.8,214.6,557.4,214.7,557.1,215z  M555.1,215.8v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C555.7,215.6,555.3,215.7,555.1,215.8z M553,216.4v3.1c0.3-0.1,0.7-0.1,0.9-0.3 v-3.1C553.7,216.2,553.3,216.2,553,216.4z"
  }), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M558.3,202.8c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C543.7,199.7,552.8,199.6,558.3,202.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181068367127207363840000000587111893512403888_",
    gradientUnits: "userSpaceOnUse",
    x1: 535.3552,
    y1: 523.3345,
    x2: 561.2062,
    y2: 523.3345,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181068367127207363840000000587111893512403888_)"
    },
    d: "M557.4,203.4c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C544.1,200.4,552.4,200.4,557.4,203.4z"
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M539.4,204c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3c-5-2.8-13.3-2.8-18.3,0.1 c-3.9,2.3-4.7,5.6-2.6,8.3C534.9,209.2,535.8,206.1,539.4,204z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149374507525623532370000003682988129511817609_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.233,
    y1: 515.8352,
    x2: 283.6449,
    y2: 515.8352,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000149374507525623532370000003682988129511817609_)"
    },
    d: "M275.3,207.2c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C283.5,211.5,280.8,208.6,275.3,207.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026126265774158793490000011044329982782511256_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.5866,
    y1: 510.8244,
    x2: 283.3481,
    y2: 510.8244,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000026126265774158793490000011044329982782511256_)",
      enableBackground: "new"
    },
    d: " M256.6,218.1v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C255.8,217,256.2,217.6,256.6,218.1z M263.9,222.2v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C264.4,222.3,264.2,222.2,263.9,222.2z M268,222.7v3.3c0.3,0,0.7,0,0.9,0v-3.3C268.6,222.9,268.2,222.7,268,222.7z  M265.9,222.6v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C266.6,222.7,266.2,222.6,265.9,222.6z M257.7,219.2v3.1c0.3,0.3,0.7,0.5,0.9,0.8 V220C258.3,219.8,257.9,219.5,257.7,219.2z M261.7,221.5v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C262.4,221.8,262.1,221.6,261.7,221.5 z M259.7,220.6v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C260.4,221,260,220.8,259.7,220.6z M270,222.9v3.3c0.3,0,0.7,0,0.9,0v-3.3 C270.7,222.7,270.4,222.7,270,222.9z M280.3,219.9v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C281,219.3,280.7,219.6,280.3,219.9z  M272,222.7v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C272.7,222.6,272.4,222.6,272,222.7z M282.3,218v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C283.1,216.8,282.7,217.5,282.3,218z M278.3,221v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C278.9,220.7,278.5,220.8,278.3,221z  M276.2,221.8v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C276.9,221.6,276.5,221.6,276.2,221.8z M274.2,222.3v3.1 c0.3-0.1,0.7-0.1,0.9-0.3v-3.1C274.7,222.2,274.5,222.3,274.2,222.3z"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M279.5,208.8c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C264.8,205.7,273.9,205.7,279.5,208.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134220911923396245610000007959652210951316617_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.5096,
    y1: 517.3249,
    x2: 282.3605,
    y2: 517.3249,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134220911923396245610000007959652210951316617_)"
    },
    d: "M278.5,209.3c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C265.3,206.5,273.5,206.5,278.5,209.3z"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M260.5,210.1c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C256,215.1,257,212.2,260.5,210.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065076339341398654250000005690385467860907156_",
    gradientUnits: "userSpaceOnUse",
    x1: -41.7585,
    y1: 540.6183,
    x2: -13.3466,
    y2: 540.6183,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065076339341398654250000005690385467860907156_)"
    },
    d: "M-21.7,182.4c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C-13.5,186.8-16.3,183.9-21.7,182.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085246805909683101430000001611201196085065398_",
    gradientUnits: "userSpaceOnUse",
    x1: -41.4325,
    y1: 535.6075,
    x2: -13.6706,
    y2: 535.6075,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000085246805909683101430000001611201196085065398_)",
      enableBackground: "new"
    },
    d: " M-40.4,193.3v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C-41.2,192.3-40.8,192.8-40.4,193.3z M-33.2,197.4v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C-32.5,197.5-32.8,197.5-33.2,197.4z M-29,197.9v3.3c0.3,0,0.7,0,0.9,0v-3.3C-28.4,198.1-28.8,197.9-29,197.9z  M-31.1,197.8v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C-30.5,197.9-30.8,197.8-31.1,197.8z M-39.3,194.4v3.1c0.3,0.3,0.7,0.5,0.9,0.8 v-3.1C-38.6,195-39,194.7-39.3,194.4z M-35.3,196.7v3.1c0.3,0.1,0.7,0.3,0.9,0.3V197C-34.6,197-34.9,196.9-35.3,196.7z  M-37.3,195.8v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C-36.6,196.2-37,196.1-37.3,195.8z M-27,198.1v3.3c0.3,0,0.7,0,0.9,0v-3.3 C-26.3,197.9-26.7,198.1-27,198.1z M-16.7,195.1v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C-16,194.6-16.4,194.8-16.7,195.1z M-25,197.9 v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C-24.3,197.8-24.6,197.8-25,197.9z M-14.7,193.2v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C-13.9,192-14.3,192.7-14.7,193.2z M-18.7,196.2v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C-18.1,195.9-18.5,196.1-18.7,196.2z  M-20.8,197v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C-20.1,196.9-20.5,196.9-20.8,197z M-22.9,197.5v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1 C-22.3,197.4-22.5,197.5-22.9,197.5z"
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M-17.5,184c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C-32.1,180.9-23.1,180.9-17.5,184z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176028527531034493800000014304345165900212366_",
    gradientUnits: "userSpaceOnUse",
    x1: -40.5093,
    y1: 542.108,
    x2: -14.6583,
    y2: 542.108,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176028527531034493800000014304345165900212366_)"
    },
    d: "M-18.5,184.5c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C-31.7,181.7-23.5,181.7-18.5,184.5z"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M-36.5,185.4c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C-40.9,190.4-40,187.4-36.5,185.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109027481366956300410000007714038817787068556_",
    gradientUnits: "userSpaceOnUse",
    x1: 605.0409,
    y1: 487.3955,
    x2: 633.4526,
    y2: 487.3955,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109027481366956300410000007714038817787068556_)"
    },
    d: "M625.1,235.6c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C633.3,239.9,630.6,237.1,625.1,235.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170996472290824435070000014996673707598070420_",
    gradientUnits: "userSpaceOnUse",
    x1: 605.3807,
    y1: 482.4525,
    x2: 633.1422,
    y2: 482.4525,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000170996472290824435070000014996673707598070420_)",
      enableBackground: "new"
    },
    d: " M606.4,246.6v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C605.6,245.3,606,246,606.4,246.6z M613.6,250.6v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C614.2,250.8,614,250.6,613.6,250.6z M617.8,251.2v3.3c0.3,0,0.7,0,0.9,0v-3.3C618.4,251.2,618,251.2,617.8,251.2z M615.7,250.9 v3.1c0.3,0,0.7,0.1,0.9,0.1V251C616.4,251,616,251,615.7,250.9z M607.5,247.7v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C608.2,248.1,607.7,247.9,607.5,247.7z M611.5,250v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C612.2,250.2,611.9,250.1,611.5,250z  M609.5,249v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C610.2,249.4,609.8,249.1,609.5,249z M619.8,251.2v3.3c0.3,0,0.7,0,0.9,0v-3.3 C620.5,251.2,620.2,251.2,619.8,251.2z M630.1,248.2v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C630.8,247.8,630.4,248.1,630.1,248.2z  M621.8,251v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C622.5,251,622.2,251,621.8,251z M632.1,246.4v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C632.9,245.2,632.5,245.8,632.1,246.4z M628.1,249.4v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C628.7,249.1,628.3,249.3,628.1,249.4z  M626,250.2v3.1c0.3-0.1,0.7-0.3,0.9-0.3V250C626.7,250,626.3,250.1,626,250.2z M623.9,250.8v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1 C624.5,250.6,624.3,250.6,623.9,250.8z"
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M629.3,237.2c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C614.7,234.1,623.7,234.1,629.3,237.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000154413475234703132400000016547685895201185204_",
    gradientUnits: "userSpaceOnUse",
    x1: 606.3036,
    y1: 488.9111,
    x2: 632.1545,
    y2: 488.9111,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000154413475234703132400000016547685895201185204_)"
    },
    d: "M628.3,237.8c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1s-5.1-7.6,0-10.6C615.1,234.9,623.3,234.8,628.3,237.8z"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M610.3,238.4c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C605.9,243.6,606.8,240.6,610.3,238.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021114631834116961320000017889432205551464637_",
    gradientUnits: "userSpaceOnUse",
    x1: 876.0303,
    y1: 224.8025,
    x2: 904.4422,
    y2: 224.8025,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021114631834116961320000017889432205551464637_)"
    },
    d: "M896.1,498.2c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C904.3,502.7,901.6,499.8,896.1,498.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142871659593815387700000004467488923460058772_",
    gradientUnits: "userSpaceOnUse",
    x1: 876.4077,
    y1: 219.7918,
    x2: 904.1692,
    y2: 219.7918,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000142871659593815387700000004467488923460058772_)",
      enableBackground: "new"
    },
    d: " M877.4,509.2v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C876.6,508.1,877,508.6,877.4,509.2z M884.7,513.2v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C885.4,513.4,885,513.4,884.7,513.2z M888.8,513.9v3.3c0.3,0,0.7,0,0.9,0v-3.3C889.4,513.9,889.2,513.9,888.8,513.9z  M886.7,513.6v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C887.4,513.8,887,513.8,886.7,513.6z M878.5,510.4v3.1c0.3,0.3,0.7,0.5,0.9,0.8 v-3.1C879.1,510.8,878.7,510.7,878.5,510.4z M882.7,512.7v3.1c0.3,0.1,0.7,0.3,0.9,0.3V513C883.2,512.8,882.9,512.8,882.7,512.7 z M880.5,511.7v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C881.2,512,880.9,511.9,880.5,511.7z M890.8,513.9v3.3c0.3,0,0.7,0,0.9,0v-3.3 C891.5,513.9,891.2,513.9,890.8,513.9z M901.1,510.9v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C901.8,510.5,901.5,510.7,901.1,510.9z  M893,513.8v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C893.5,513.6,893.2,513.8,893,513.8z M903.1,509v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C903.9,507.9,903.7,508.5,903.1,509z M899.1,512.1v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C899.7,511.9,899.5,512,899.1,512.1z  M897,513v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C897.7,512.7,897.3,512.8,897,513z M895,513.5v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1 C895.7,513.4,895.3,513.4,895,513.5z"
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M900.3,500c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C885.8,496.8,894.7,496.7,900.3,500z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000128446587453327255730000006928651576014959548_",
    gradientUnits: "userSpaceOnUse",
    x1: 877.3306,
    y1: 226.2076,
    x2: 903.1815,
    y2: 226.2076,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000128446587453327255730000006928651576014959548_)"
    },
    d: "M899.3,500.5c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C886.2,497.5,894.3,497.5,899.3,500.5z"
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M881.3,501.2c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C876.8,506.3,877.8,503.3,881.3,501.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155114426858899796390000015795325946981773500_",
    gradientUnits: "userSpaceOnUse",
    x1: 875.7594,
    y1: 228.5945,
    x2: 904.1711,
    y2: 228.5945,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155114426858899796390000015795325946981773500_)"
    },
    d: "M895.8,494.4c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C904.1,498.9,901.2,496,895.8,494.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060709146994927809750000014660777058842117818_",
    gradientUnits: "userSpaceOnUse",
    x1: 876.0923,
    y1: 223.5838,
    x2: 903.8538,
    y2: 223.5838,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000060709146994927809750000014660777058842117818_)",
      enableBackground: "new"
    },
    d: " M877.1,505.4v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C876.3,504.3,876.7,504.8,877.1,505.4z M884.3,509.4v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C885,509.6,884.7,509.6,884.3,509.4z M888.5,510.1v3.3c0.3,0,0.7,0,0.9,0v-3.3C889.2,510.1,888.8,510.1,888.5,510.1z  M886.5,509.8v3.1c0.3,0,0.7,0.1,0.9,0.1V510C887,510,886.7,509.8,886.5,509.8z M878.2,506.6v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C878.9,507,878.5,506.7,878.2,506.6z M882.3,508.9v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C882.9,509,882.7,509,882.3,508.9z  M880.2,507.9v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C880.9,508.2,880.5,508.1,880.2,507.9z M890.5,510.1v3.3c0.3,0,0.7,0,0.9,0v-3.3 C891.2,510.1,890.8,510.1,890.5,510.1z M900.8,507.1v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C901.5,506.7,901.1,506.9,900.8,507.1z  M892.6,510v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C893.2,509.8,893,510,892.6,510z M902.8,505.2v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C903.7,504.2,903.3,504.7,902.8,505.2z M898.8,508.3v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C899.5,507.9,899.1,508.1,898.8,508.3z  M896.8,509v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C897.4,508.9,897,509,896.8,509z M894.6,509.6v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1 C895.3,509.4,895,509.6,894.6,509.6z"
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M900,496.2c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C885.4,492.9,894.4,492.9,900,496.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173856435685481262940000012102680628644028093_",
    gradientUnits: "userSpaceOnUse",
    x1: 877.0155,
    y1: 230.0842,
    x2: 902.8661,
    y2: 230.0842,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173856435685481262940000012102680628644028093_)"
    },
    d: "M899.1,496.6c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C885.8,493.7,894,493.7,899.1,496.6z"
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M881,497.4c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3c-5-2.8-13.3-2.8-18.3,0.1 c-3.9,2.3-4.7,5.6-2.6,8.3C876.6,502.5,877.5,499.4,881,497.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023263650477370338630000010822718827106401417_",
    gradientUnits: "userSpaceOnUse",
    x1: 567.571,
    y1: 210.041,
    x2: 595.9828,
    y2: 210.041,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023263650477370338630000010822718827106401417_)"
    },
    d: "M587.7,513c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C595.8,517.4,593.1,514.6,587.7,513z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093178655692015755010000004711788877943490701_",
    gradientUnits: "userSpaceOnUse",
    x1: 567.9338,
    y1: 205.0303,
    x2: 595.6955,
    y2: 205.0303,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000093178655692015755010000004711788877943490701_)",
      enableBackground: "new"
    },
    d: " M568.9,523.9v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C568.2,522.8,568.5,523.4,568.9,523.9z M576.2,528v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C576.9,528.1,576.5,528.1,576.2,528z M580.3,528.7v3.3c0.3,0,0.7,0,0.9,0v-3.3C580.9,528.7,580.7,528.7,580.3,528.7z  M578.2,528.4v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C578.9,528.5,578.6,528.5,578.2,528.4z M570,525.1v3.1c0.3,0.3,0.7,0.5,0.9,0.8 V526C570.6,525.5,570.2,525.4,570,525.1z M574.2,527.4v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C574.8,527.6,574.4,527.6,574.2,527.4z  M572,526.5v3.1c0.3,0.1,0.7,0.3,0.9,0.5V527C572.7,526.8,572.4,526.6,572,526.5z M582.3,528.7v3.3c0.3,0,0.7,0,0.9,0v-3.3 C583,528.7,582.7,528.7,582.3,528.7z M592.6,525.7v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C593.4,525.3,593,525.4,592.6,525.7z  M584.5,528.5v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C585.1,528.4,584.7,528.5,584.5,528.5z M594.6,523.8v3.1c0.4-0.5,0.8-1.2,0.9-1.9 v-3C595.4,522.7,595.2,523.2,594.6,523.8z M590.6,526.9v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C591.2,526.6,591,526.8,590.6,526.9z  M588.5,527.7v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C589.2,527.4,588.8,527.6,588.5,527.7z M586.5,528.3v3.1 c0.3-0.1,0.7-0.1,0.9-0.3V528C587.2,528.1,586.8,528.1,586.5,528.3z"
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M591.8,514.7c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C577.3,511.6,586.2,511.5,591.8,514.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031204091204458318280000013478795331599806345_",
    gradientUnits: "userSpaceOnUse",
    x1: 568.845,
    y1: 211.4461,
    x2: 594.6959,
    y2: 211.4461,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031204091204458318280000013478795331599806345_)"
    },
    d: "M590.8,515.3c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C577.7,512.3,585.8,512.3,590.8,515.3z"
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M572.8,515.9c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C568.3,521.1,569.3,518.1,572.8,515.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000038404536532426715610000002339337794328437946_",
    gradientUnits: "userSpaceOnUse",
    x1: 567.2568,
    y1: 213.833,
    x2: 595.6686,
    y2: 213.833,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000038404536532426715610000002339337794328437946_)"
    },
    d: "M587.3,509.2c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C595.6,513.6,592.9,510.8,587.3,509.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131333038527078879360000009437066314605163136_",
    gradientUnits: "userSpaceOnUse",
    x1: 567.6066,
    y1: 208.8222,
    x2: 595.3683,
    y2: 208.8222,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000131333038527078879360000009437066314605163136_)",
      enableBackground: "new"
    },
    d: " M568.6,520.1v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C567.8,519,568.2,519.6,568.6,520.1z M575.9,524.2v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C576.5,524.3,576.2,524.3,575.9,524.2z M580,524.9v3.3c0.3,0,0.7,0,0.9,0v-3.3C580.7,524.9,580.3,524.9,580,524.9z  M578,524.6v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C578.6,524.7,578.2,524.6,578,524.6z M569.7,521.3v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C570.4,521.8,570,521.5,569.7,521.3z M573.8,523.7v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C574.4,523.8,574.2,523.8,573.8,523.7z  M571.7,522.7v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C572.4,523,572,522.8,571.7,522.7z M582,524.9v3.3c0.3,0,0.7,0,0.9,0v-3.3 C582.7,524.9,582.4,524.9,582,524.9z M592.3,521.9v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C593,521.5,592.7,521.6,592.3,521.9z  M584,524.7v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C584.7,524.6,584.5,524.7,584,524.7z M594.3,520v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C595.2,518.9,594.7,519.5,594.3,520z M590.3,523.1v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C591,522.7,590.6,522.8,590.3,523.1z  M588.2,523.8v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C588.9,523.7,588.5,523.8,588.2,523.8z M586.2,524.3v3.1 c0.3-0.1,0.7-0.1,0.9-0.3v-3.1C586.8,524.2,586.5,524.3,586.2,524.3z"
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M591.5,510.9c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C576.9,507.7,585.9,507.7,591.5,510.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000064339648539772831380000003682679548613335728_",
    gradientUnits: "userSpaceOnUse",
    x1: 568.5297,
    y1: 215.3227,
    x2: 594.3806,
    y2: 215.3227,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000064339648539772831380000003682679548613335728_)"
    },
    d: "M590.6,511.3c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C577.3,508.5,585.5,508.5,590.6,511.3z"
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M572.5,512.1c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C568.1,517.3,569,514.2,572.5,512.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036213614665914869860000014618307355534122165_",
    gradientUnits: "userSpaceOnUse",
    x1: 408.3217,
    y1: 170.0901,
    x2: 436.7337,
    y2: 170.0901,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036213614665914869860000014618307355534122165_)"
    },
    d: "M428.4,552.9c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C436.6,557.2,433.9,554.4,428.4,552.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001635549999739218160000002844058595765799615_",
    gradientUnits: "userSpaceOnUse",
    x1: 408.6717,
    y1: 165.2147,
    x2: 436.4342,
    y2: 165.2147,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000001635549999739218160000002844058595765799615_)",
      enableBackground: "new"
    },
    d: " M409.6,563.9v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C408.9,562.7,409.2,563.3,409.6,563.9z M416.9,567.9v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C417.6,568.1,417.2,567.9,416.9,567.9z M421,568.5v3.3c0.3,0,0.7,0,0.9,0v-3.3C421.7,568.5,421.4,568.5,421,568.5z  M419,568.2v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C419.6,568.3,419.4,568.3,419,568.2z M410.7,565v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C411.4,565.4,411,565.2,410.7,565z M414.9,567.3v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C415.6,567.5,415.2,567.4,414.9,567.3z  M412.9,566.3v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C413.4,566.6,413.1,566.4,412.9,566.3z M423.2,568.5v3.3c0.3,0,0.7,0,0.9,0v-3.3 C423.7,568.5,423.4,568.5,423.2,568.5z M433.3,565.5v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C434.1,565.1,433.7,565.4,433.3,565.5z  M425.2,568.3v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C425.9,568.3,425.5,568.3,425.2,568.3z M435.5,563.6v3.1c0.4-0.5,0.8-1.2,0.9-1.9 v-3C436.2,562.5,435.9,563.1,435.5,563.6z M431.3,566.7v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C432,566.4,431.7,566.6,431.3,566.7z  M429.3,567.5v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C429.9,567.3,429.7,567.4,429.3,567.5z M427.2,568.1v3.1 c0.3-0.1,0.7-0.1,0.9-0.3v-3.1C427.9,567.9,427.5,567.9,427.2,568.1z"
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M432.5,554.5c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C418,551.4,427,551.3,432.5,554.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155120635268778761040000008393971417270892203_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.6026,
    y1: 171.6056,
    x2: 435.4536,
    y2: 171.6056,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155120635268778761040000008393971417270892203_)"
    },
    d: "M431.7,555.1c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C418.4,552.2,426.5,552.1,431.7,555.1z"
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M413.5,555.7c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C409.1,560.9,410,557.9,413.5,555.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169556777648298913840000011758591682374045870_",
    gradientUnits: "userSpaceOnUse",
    x1: 113.4409,
    y1: 487.531,
    x2: 141.8528,
    y2: 487.531,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000169556777648298913840000011758591682374045870_)"
    },
    d: "M133.5,235.5c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C141.7,239.9,139,237.1,133.5,235.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000014634405845977234970000006635881257817146498_",
    gradientUnits: "userSpaceOnUse",
    x1: 113.7953,
    y1: 482.5202,
    x2: 141.5569,
    y2: 482.5202,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000014634405845977234970000006635881257817146498_)",
      enableBackground: "new"
    },
    d: " M114.8,246.4v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C114,245.3,114.4,245.9,114.8,246.4z M122.1,250.5v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C122.6,250.6,122.4,250.6,122.1,250.5z M126.2,251.2v3.3c0.3,0,0.7,0,0.9,0v-3.3C126.8,251.2,126.4,251.2,126.2,251.2z  M124.1,250.9v3.1c0.3,0,0.7,0.1,0.9,0.1V251C124.8,251,124.4,251,124.1,250.9z M115.9,247.7v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C116.6,248.1,116.1,247.9,115.9,247.7z M119.9,250v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C120.6,250.1,120.3,250.1,119.9,250z  M117.9,249v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C118.6,249.3,118.2,249.1,117.9,249z M128.2,251.2v3.3c0.3,0,0.7,0,0.9,0v-3.3 C128.9,251.2,128.6,251.2,128.2,251.2z M138.5,248.2v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C139.2,247.8,138.9,247.9,138.5,248.2z  M130.2,251v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C130.9,250.9,130.6,251,130.2,251z M140.5,246.3v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C141.3,245.2,140.9,245.8,140.5,246.3z M136.5,249.4v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C137.1,249,136.7,249.1,136.5,249.4z  M134.4,250.2v3.1c0.3-0.1,0.7-0.3,0.9-0.3V250C135.1,250,134.7,250.1,134.4,250.2z M132.4,250.8v3.1c0.3-0.1,0.7-0.1,0.9-0.3 v-3.1C132.9,250.6,132.7,250.6,132.4,250.8z"
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M137.7,237.2c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C123.1,234,132.1,234,137.7,237.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065069378465463085140000000941146488474870715_",
    gradientUnits: "userSpaceOnUse",
    x1: 114.7185,
    y1: 489.0207,
    x2: 140.5694,
    y2: 489.0207,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065069378465463085140000000941146488474870715_)"
    },
    d: "M136.7,237.6c5,2.8,5.1,7.6,0,10.6 s-13.3,3-18.3,0.1s-5.1-7.6,0-10.6C123.5,234.8,131.7,234.8,136.7,237.6z"
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M118.7,238.4c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C114.3,243.6,115.2,240.5,118.7,238.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000128483003603559113210000007175733437282652566_",
    gradientUnits: "userSpaceOnUse",
    x1: 161.7567,
    y1: 174.1529,
    x2: 190.1685,
    y2: 174.1529,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000128483003603559113210000007175733437282652566_)"
    },
    d: "M181.8,548.8c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C190.1,553.2,187.2,550.3,181.8,548.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120517988873249983190000001557434053702432419_",
    gradientUnits: "userSpaceOnUse",
    x1: 162.1078,
    y1: 169.2098,
    x2: 189.8694,
    y2: 169.2098,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000120517988873249983190000001557434053702432419_)",
      enableBackground: "new"
    },
    d: " M163.1,559.8v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C162.3,558.6,162.7,559.3,163.1,559.8z M170.3,563.9v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C171,564,170.7,563.9,170.3,563.9z M174.5,564.4v3.3c0.3,0,0.7,0,0.9,0v-3.3C175.2,564.4,174.8,564.4,174.5,564.4z  M172.5,564.3v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C173,564.3,172.8,564.3,172.5,564.3z M164.2,560.9v3.1c0.3,0.3,0.7,0.5,0.9,0.8 v-3.1C164.9,561.4,164.5,561.2,164.2,560.9z M168.3,563.2v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C169,563.5,168.6,563.3,168.3,563.2z  M166.3,562.2v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C166.9,562.7,166.5,562.5,166.3,562.2z M176.5,564.4v3.3c0.3,0,0.7,0,0.9,0v-3.3 C177.2,564.4,176.8,564.4,176.5,564.4z M186.8,561.4v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C187.5,561,187.1,561.3,186.8,561.4z  M178.6,564.3v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C179.3,564.3,179,564.3,178.6,564.3z M188.9,559.7v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C189.7,558.5,189.3,559,188.9,559.7z M184.8,562.7v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C185.5,562.4,185.1,562.5,184.8,562.7z  M182.6,563.5v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C183.3,563.3,183.1,563.3,182.6,563.5z M180.6,564v3.1c0.3-0.1,0.7-0.1,0.9-0.3 v-3.1C181.3,563.9,181,563.9,180.6,564z"
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M186,550.5c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C171.4,547.4,180.5,547.4,186,550.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095332001970019793140000002039924294704350619_",
    gradientUnits: "userSpaceOnUse",
    x1: 163.0308,
    y1: 175.6426,
    x2: 188.8816,
    y2: 175.6426,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000095332001970019793140000002039924294704350619_)"
    },
    d: "M185.1,551c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C171.8,548.2,180.1,548.2,185.1,551z"
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M167.1,551.7c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C162.6,556.8,163.5,553.9,167.1,551.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111914152431443218430000003234090992525344897_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.7492,
    y1: 212.0724,
    x2: 70.1613,
    y2: 212.0724,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111914152431443218430000003234090992525344897_)"
    },
    d: "M61.8,510.9c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C70.1,515.3,67.3,512.4,61.8,510.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080901981795202987210000005641889229579901868_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.1002,
    y1: 207.1294,
    x2: 69.8618,
    y2: 207.1294,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000080901981795202987210000005641889229579901868_)",
      enableBackground: "new"
    },
    d: " M43.2,521.9v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C42.3,520.8,42.6,521.3,43.2,521.9z M50.3,526v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C51,526.1,50.7,526,50.3,526z M54.5,526.5v3.3c0.3,0,0.7,0,0.9,0v-3.3C55.1,526.5,54.8,526.5,54.5,526.5z M52.4,526.4v3.1 c0.3,0,0.7,0.1,0.9,0.1v-3.1C53,526.5,52.8,526.4,52.4,526.4z M44.2,523v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C44.8,523.5,44.5,523.2,44.2,523z M48.3,525.3v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C49,525.5,48.6,525.4,48.3,525.3z M46.3,524.3 v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C46.9,524.7,46.5,524.6,46.3,524.3z M56.6,526.5v3.3c0.3,0,0.7,0,0.9,0v-3.3 C57.2,526.5,56.8,526.5,56.6,526.5z M66.9,523.5v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C67.5,523.1,67.1,523.4,66.9,523.5z  M58.6,526.5v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C59.3,526.4,58.9,526.4,58.6,526.5z M68.9,521.8v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C69.7,520.5,69.3,521.2,68.9,521.8z M64.8,524.7v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C65.5,524.5,65.1,524.6,64.8,524.7z  M62.7,525.5v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C63.3,525.4,63.1,525.4,62.7,525.5z M60.6,526.1v3.1c0.3-0.1,0.7-0.1,0.9-0.3 v-3.1C61.3,526,61,526.1,60.6,526.1z"
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M65.9,512.5c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C51.4,509.4,60.4,509.4,65.9,512.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123405796694309342100000015285450744233535657_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.0017,
    y1: 213.5621,
    x2: 68.8526,
    y2: 213.5621,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000123405796694309342100000015285450744233535657_)"
    },
    d: "M65.1,513.1c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C51.8,510.2,59.9,510.2,65.1,513.1z"
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M47.1,513.9c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C42.5,518.9,43.4,515.9,47.1,513.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028305789747610513630000006598202471703184004_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.6976,
    y1: 216.8124,
    x2: 70.1095,
    y2: 216.8124,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000028305789747610513630000006598202471703184004_)"
    },
    d: "M61.7,506.2c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C70,510.7,67.3,507.7,61.7,506.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000064333598214197391400000012497451515524779193_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.0709,
    y1: 211.8016,
    x2: 69.8327,
    y2: 211.8016,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000064333598214197391400000012497451515524779193_)",
      enableBackground: "new"
    },
    d: " M43,517.2v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C42.2,516.1,42.6,516.6,43,517.2z M50.3,521.2v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C51,521.3,50.6,521.3,50.3,521.2z M54.4,521.8v3.3c0.3,0,0.7,0,0.9,0v-3.3C55.1,521.9,54.8,521.8,54.4,521.8z M52.4,521.6v3.1 c0.3,0,0.7,0.1,0.9,0.1v-3.1C53,521.8,52.6,521.6,52.4,521.6z M44.1,518.2v3.1c0.3,0.3,0.7,0.5,0.9,0.8V519 C44.8,518.8,44.4,518.5,44.1,518.2z M48.3,520.5v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C49,520.8,48.6,520.7,48.3,520.5z  M46.1,519.6v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C46.8,520,46.5,519.9,46.1,519.6z M56.4,521.9v3.3c0.3,0,0.7,0,0.9,0v-3.3 C57.1,521.8,56.8,521.9,56.4,521.9z M66.7,518.9v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C67.5,518.4,67.1,518.6,66.7,518.9z  M58.6,521.8v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C59.1,521.6,58.9,521.6,58.6,521.8z M68.7,517v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C69.6,515.8,69.3,516.5,68.7,517z M64.7,520v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C65.4,519.7,65.1,519.9,64.7,520z M62.7,520.8 v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C63.3,520.7,62.9,520.7,62.7,520.8z M60.6,521.3v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1 C61.3,521.2,60.9,521.3,60.6,521.3z"
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M65.9,507.8c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C51.4,504.7,60.4,504.7,65.9,507.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024718990700652273680000012307724818025971888_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.9716,
    y1: 218.3021,
    x2: 68.8225,
    y2: 218.3021,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000024718990700652273680000012307724818025971888_)"
    },
    d: "M65,508.3c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C51.8,505.5,59.9,505.5,65,508.3z"
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M46.9,509.2c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C42.5,514.2,43.4,511.2,46.9,509.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052788412867466287900000007113449803993361305_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.7235,
    y1: 220.6043,
    x2: 70.1352,
    y2: 220.6043,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052788412867466287900000007113449803993361305_)"
    },
    d: "M61.8,502.4c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C70,506.9,67.3,504,61.8,502.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098204952589773293000000010573492165123353531_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.0709,
    y1: 215.5936,
    x2: 69.8334,
    y2: 215.5936,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000098204952589773293000000010573492165123353531_)",
      enableBackground: "new"
    },
    d: " M43,513.4v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C42.3,512.3,42.6,512.8,43,513.4z M50.3,517.4v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C51,517.6,50.6,517.6,50.3,517.4z M54.4,518.1v3.3c0.3,0,0.7,0,0.9,0v-3.3C55.1,518.1,54.8,518.1,54.4,518.1z M52.4,517.8v3.1 c0.3,0,0.7,0.1,0.9,0.1V518C53,518,52.8,518,52.4,517.8z M44.1,514.6v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C44.8,515,44.4,514.8,44.1,514.6z M48.3,516.9v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C49,517,48.6,517,48.3,516.9z M46.3,515.9v3.1 c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C46.8,516.2,46.5,516.1,46.3,515.9z M56.6,518.1v3.3c0.3,0,0.7,0,0.9,0v-3.3 C57.2,518.1,56.8,518.1,56.6,518.1z M66.7,515.1v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C67.5,514.7,67.1,514.8,66.7,515.1z  M58.6,518v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C59.3,517.8,58.9,518,58.6,518z M68.9,513.2v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C69.6,512.1,69.3,512.7,68.9,513.2z M64.7,516.3v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C65.4,516.1,65.1,516.2,64.7,516.3z  M62.7,517.2v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C63.3,516.9,63.1,517,62.7,517.2z M60.6,517.7v3.1c0.3-0.1,0.7-0.1,0.9-0.3 v-3.1C61.3,517.6,60.9,517.6,60.6,517.7z"
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M65.9,504.2c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C51.4,501,60.4,500.9,65.9,504.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036218884255690569370000012332017263593971600_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.0017,
    y1: 221.9844,
    x2: 68.8527,
    y2: 221.9844,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036218884255690569370000012332017263593971600_)"
    },
    d: "M65.1,504.7c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C51.8,501.8,59.9,501.7,65.1,504.7z"
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M46.9,505.4c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C42.5,510.5,43.4,507.5,46.9,505.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090984039284927495520000017477978802399979439_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.7492,
    y1: 224.2609,
    x2: 70.1613,
    y2: 224.2609,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090984039284927495520000017477978802399979439_)"
    },
    d: "M61.8,498.7c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C70.1,503.2,67.3,500.2,61.8,498.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100362233567187692260000004589072776928151995_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.1002,
    y1: 219.2501,
    x2: 69.8618,
    y2: 219.2501,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000100362233567187692260000004589072776928151995_)",
      enableBackground: "new"
    },
    d: " M43.2,509.7v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C42.3,508.6,42.6,509.2,43.2,509.7z M50.3,513.8v3.1c0.3,0.1,0.7,0.1,0.9,0.3V514 C51,513.9,50.7,513.9,50.3,513.8z M54.5,514.3v3.3c0.3,0,0.7,0,0.9,0v-3.3C55.1,514.4,54.8,514.3,54.5,514.3z M52.4,514.2v3.1 c0.3,0,0.7,0.1,0.9,0.1v-3.1C53,514.3,52.8,514.2,52.4,514.2z M44.2,510.8v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C44.8,511.3,44.5,511.1,44.2,510.8z M48.3,513.1v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C49,513.4,48.6,513.2,48.3,513.1z  M46.3,512.1v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C46.9,512.5,46.5,512.4,46.3,512.1z M56.6,514.4v3.3c0.3,0,0.7,0,0.9,0v-3.3 C57.2,514.3,56.8,514.4,56.6,514.4z M66.9,511.5v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C67.5,510.9,67.1,511.2,66.9,511.5z  M58.6,514.3v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C59.3,514.2,58.9,514.2,58.6,514.3z M68.9,509.6v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C69.7,508.3,69.3,509,68.9,509.6z M64.8,512.5v3.1c0.4-0.1,0.7-0.3,0.9-0.5V512C65.5,512.3,65.1,512.4,64.8,512.5z  M62.7,513.4v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C63.3,513.2,63.1,513.2,62.7,513.4z M60.6,513.9v3.1c0.3-0.1,0.7-0.1,0.9-0.3 v-3.1C61.3,513.8,61,513.9,60.6,513.9z"
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M65.9,500.4c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C51.4,497.2,60.4,497.2,65.9,500.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020396098704151052060000001883581985186813584_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.0017,
    y1: 225.7506,
    x2: 68.8526,
    y2: 225.7506,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000020396098704151052060000001883581985186813584_)"
    },
    d: "M65.1,500.9c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C51.8,498.1,59.9,498.1,65.1,500.9z"
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M47.1,501.7c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C42.5,506.7,43.4,503.7,47.1,501.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026872948267242994080000000219534910401846455_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.9587,
    y1: 227.9174,
    x2: 71.3706,
    y2: 227.9174,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026872948267242994080000000219534910401846455_)"
    },
    d: "M63.1,495.1c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C71.3,499.4,68.5,496.6,63.1,495.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039121100494531428700000005470873586859117231_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.3095,
    y1: 222.9744,
    x2: 71.0713,
    y2: 222.9744,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000039121100494531428700000005470873586859117231_)",
      enableBackground: "new"
    },
    d: " M44.4,506v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C43.6,505,43.8,505.5,44.4,506z M51.6,510.1v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C52.2,510.2,52,510.1,51.6,510.1z M55.7,510.7v3.3c0.3,0,0.7,0,0.9,0v-3.3C56.3,510.7,56,510.7,55.7,510.7z M53.6,510.5v3.1 c0.3,0,0.7,0.1,0.9,0.1v-3.1C54.3,510.5,54,510.5,53.6,510.5z M45.3,507.1v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C46,507.7,45.7,507.4,45.3,507.1z M49.5,509.4v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C50.2,509.7,49.8,509.6,49.5,509.4z  M47.5,508.5v3.1c0.3,0.1,0.7,0.3,0.9,0.5V509C48.2,508.9,47.8,508.8,47.5,508.5z M57.8,510.7v3.3c0.3,0,0.7,0,0.9,0v-3.3 C58.5,510.7,58.1,510.7,57.8,510.7z M68.1,507.7v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C68.7,507.3,68.3,507.5,68.1,507.7z  M59.8,510.7v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C60.5,510.5,60.1,510.5,59.8,510.7z M70.1,505.9v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C70.9,504.7,70.5,505.2,70.1,505.9z M65.9,508.9v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C66.6,508.6,66.3,508.8,65.9,508.9z  M63.9,509.7v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C64.6,509.6,64.3,509.6,63.9,509.7z M61.8,510.2v3.1c0.3-0.1,0.7-0.1,0.9-0.3 V510C62.5,510.1,62.2,510.1,61.8,510.2z"
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M67.1,496.7c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C52.6,493.6,61.6,493.6,67.1,496.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013165068757038763050000012113121374974142337_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.2206,
    y1: 229.4071,
    x2: 70.0716,
    y2: 229.4071,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013165068757038763050000012113121374974142337_)"
    },
    d: "M66.3,497.2c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C53,494.4,61.2,494.4,66.3,497.2z"
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M48.3,498.1c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C43.7,503.1,44.6,500.1,48.3,498.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016034572658007569700000003622180450125158792_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.6645,
    y1: 231.7093,
    x2: 70.0764,
    y2: 231.7093,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016034572658007569700000003622180450125158792_)"
    },
    d: "M61.7,491.3c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C70,495.8,67.3,492.8,61.7,491.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075843847852865157030000017067072858872475569_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.0356,
    y1: 226.6986,
    x2: 69.7972,
    y2: 226.6986,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000075843847852865157030000017067072858872475569_)",
      enableBackground: "new"
    },
    d: " M43,502.3v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C42.2,501.2,42.6,501.7,43,502.3z M50.3,506.3v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C51,506.5,50.6,506.5,50.3,506.3z M54.4,506.9v3.3c0.3,0,0.7,0,0.9,0v-3.3C55.1,507,54.8,506.9,54.4,506.9z M52.4,506.7v3.1 c0.3,0,0.7,0.1,0.9,0.1v-3.1C53,506.9,52.6,506.7,52.4,506.7z M44.1,503.3v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C44.8,503.9,44.4,503.6,44.1,503.3z M48.2,505.6v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C48.8,505.9,48.6,505.8,48.2,505.6z  M46.1,504.7v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C46.8,505.1,46.5,505,46.1,504.7z M56.4,507v3.3c0.3,0,0.7,0,0.9,0V507 C57.1,506.9,56.8,507,56.4,507z M66.7,504v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C67.4,503.5,67.1,503.7,66.7,504z M58.5,506.9v3.1 c0.3,0,0.7-0.1,0.9-0.1v-3.1C59.1,506.7,58.9,506.7,58.5,506.9z M68.7,502.1v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C69.6,500.9,69.3,501.6,68.7,502.1z M64.7,505.1v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C65.4,504.8,65.1,505,64.7,505.1z  M62.7,505.9v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C63.3,505.8,62.9,505.8,62.7,505.9z M60.6,506.5v3.1c0.3-0.1,0.7-0.1,0.9-0.3 v-3.1C61.3,506.3,60.9,506.5,60.6,506.5z"
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M65.9,492.9c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C51.4,489.8,60.4,489.8,65.9,492.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041277452888904476400000002813871842921785500_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.9586,
    y1: 233.1991,
    x2: 68.8096,
    y2: 233.1991,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000041277452888904476400000002813871842921785500_)"
    },
    d: "M65,493.5c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C51.8,490.6,59.9,490.6,65,493.5z"
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M46.9,494.3c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C42.5,499.3,43.4,496.3,46.9,494.3z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087386481584093841730000002148235542069727375_",
    gradientUnits: "userSpaceOnUse",
    x1: 73.8962,
    y1: 209.9055,
    x2: 102.3079,
    y2: 209.9055,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000087386481584093841730000002148235542069727375_)"
    },
    d: "M93.9,513.1c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C102.2,517.6,99.5,514.6,93.9,513.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078753670036362530280000001647049445121509269_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.2638,
    y1: 204.8948,
    x2: 102.0253,
    y2: 204.8948,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000078753670036362530280000001647049445121509269_)",
      enableBackground: "new"
    },
    d: " M75.3,524.1v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C74.4,523,74.8,523.5,75.3,524.1z M82.6,528.1v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C83.2,528.3,82.8,528.3,82.6,528.1z M86.6,528.8v3.3c0.3,0,0.7,0,0.9,0v-3.3C87.3,528.8,87,528.8,86.6,528.8z M84.6,528.5v3.1 c0.3,0,0.7,0.1,0.9,0.1v-3.1C85.3,528.7,84.9,528.5,84.6,528.5z M76.3,525.3v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C77,525.7,76.6,525.4,76.3,525.3z M80.4,527.6v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C81.1,527.7,80.8,527.7,80.4,527.6z  M78.4,526.6v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C79,526.9,78.8,526.8,78.4,526.6z M88.7,528.8v3.3c0.3,0,0.7,0,0.9,0v-3.3 C89.3,528.8,89.1,528.8,88.7,528.8z M99,525.8v3.1c0.4-0.3,0.7-0.5,0.9-0.8V525C99.6,525.3,99.4,525.5,99,525.8z M90.7,528.7 v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C91.4,528.5,91.1,528.7,90.7,528.7z M101,523.9v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C101.8,522.8,101.5,523.4,101,523.9z M96.9,526.9v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C97.6,526.6,97.2,526.8,96.9,526.9z  M94.9,527.7v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C95.6,527.6,95.2,527.7,94.9,527.7z M92.9,528.3v3.1c0.3-0.1,0.7-0.1,0.9-0.3 V528C93.5,528.1,93.1,528.3,92.9,528.3z"
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M98.1,514.8c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C83.6,511.6,92.6,511.6,98.1,514.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023242509083112032160000000320083078282709923_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.1867,
    y1: 211.3953,
    x2: 101.0375,
    y2: 211.3953,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023242509083112032160000000320083078282709923_)"
    },
    d: "M97.2,515.3c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C84.1,512.4,92.2,512.4,97.2,515.3z"
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M79.2,516.1c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C74.7,521.1,75.7,518.1,79.2,516.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024686915754960403250000008573581599277856686_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.6258,
    y1: 214.6455,
    x2: 101.0377,
    y2: 214.6455,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000024686915754960403250000008573581599277856686_)"
    },
    d: "M92.7,508.3c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C101,512.8,98.1,510,92.7,508.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168796918710392434160000009193633639190404277_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.9766,
    y1: 209.6348,
    x2: 100.7385,
    y2: 209.6348,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000168796918710392434160000009193633639190404277_)",
      enableBackground: "new"
    },
    d: " M74,519.3v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C73.2,518.2,73.5,518.8,74,519.3z M81.2,523.4v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C81.9,523.5,81.6,523.5,81.2,523.4z M85.4,524.1v3.3c0.3,0,0.7,0,0.9,0v-3.3C85.9,524.1,85.7,524.1,85.4,524.1z M83.2,523.8 v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C83.9,523.9,83.6,523.9,83.2,523.8z M75,520.5v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C75.7,520.9,75.4,520.8,75,520.5z M79.2,522.8v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C79.9,523,79.4,523,79.2,522.8z M77.1,521.9 v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C77.8,522.2,77.4,522,77.1,521.9z M87.4,524.1v3.3c0.3,0,0.7,0,0.9,0v-3.3 C88.1,524.1,87.7,524.1,87.4,524.1z M97.7,521.1v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C98.4,520.7,98,520.8,97.7,521.1z  M89.5,523.9v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C90.1,523.8,89.7,523.9,89.5,523.9z M99.8,519.2v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C100.6,518.1,100.2,518.6,99.8,519.2z M95.6,522.3v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C96.4,521.9,96,522,95.6,522.3z  M93.5,523.1v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C94.2,522.8,93.9,523,93.5,523.1z M91.5,523.7v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1 C92.2,523.5,91.9,523.5,91.5,523.7z"
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M96.8,510.1c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C82.3,506.9,91.2,506.9,96.8,510.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177468564121462449580000012196469989335828667_",
    gradientUnits: "userSpaceOnUse",
    x1: 73.8791,
    y1: 216.1353,
    x2: 99.7301,
    y2: 216.1353,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000177468564121462449580000012196469989335828667_)"
    },
    d: "M96,510.5c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C82.7,507.7,90.8,507.7,96,510.5z"
  }), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M78,511.3c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3c-5-2.8-13.3-2.8-18.3,0.1 c-3.9,2.3-4.7,5.6-2.6,8.3C73.4,516.5,74.3,513.4,78,511.3z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137114195867477923660000012192326107424297608_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.6773,
    y1: 218.302,
    x2: 101.0891,
    y2: 218.302,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137114195867477923660000012192326107424297608_)"
    },
    d: "M92.7,504.7c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C101,509,98.1,506.2,92.7,504.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150803818035925456180000000676277100682491306_",
    gradientUnits: "userSpaceOnUse",
    x1: 73.0026,
    y1: 213.359,
    x2: 100.7642,
    y2: 213.359,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000150803818035925456180000000676277100682491306_)",
      enableBackground: "new"
    },
    d: " M74,515.7v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C73.2,514.6,73.6,515.1,74,515.7z M81.2,519.7v3.1c0.3,0.1,0.7,0.1,0.9,0.3V520 C81.9,519.9,81.6,519.7,81.2,519.7z M85.4,520.3v3.3c0.3,0,0.7,0,0.9,0v-3.3C86.1,520.3,85.7,520.3,85.4,520.3z M83.4,520.1 v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C83.9,520.3,83.6,520.1,83.4,520.1z M75.1,516.7v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C75.8,517.3,75.4,517,75.1,516.7z M79.2,519v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C79.9,519.3,79.6,519.2,79.2,519z M77.1,518.1 v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C77.8,518.5,77.4,518.4,77.1,518.1z M87.4,520.3v3.3c0.3,0,0.7,0,0.9,0v-3.3 C88.1,520.3,87.7,520.3,87.4,520.3z M97.7,517.3v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C98.4,516.9,98,517.2,97.7,517.3z  M89.5,520.3v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C90.1,520.1,89.9,520.1,89.5,520.3z M99.8,515.5v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C100.6,514.3,100.2,515,99.8,515.5z M95.7,518.5v3.1c0.4-0.1,0.7-0.3,0.9-0.5V518C96.4,518.2,96,518.4,95.7,518.5z M93.7,519.3 v3.1c0.3-0.1,0.7-0.3,0.9-0.3V519C94.3,519.2,93.9,519.2,93.7,519.3z M91.5,519.9v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1 C92.2,519.7,91.9,519.7,91.5,519.9z"
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M96.9,506.3c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C82.3,503.2,91.4,503.2,96.9,506.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132054724781773442350000016854879720169012158_",
    gradientUnits: "userSpaceOnUse",
    x1: 73.9256,
    y1: 219.7918,
    x2: 99.7765,
    y2: 219.7918,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132054724781773442350000016854879720169012158_)"
    },
    d: "M96,506.9c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C82.7,504,91,504,96,506.9z"
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M78,507.7c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3c-5-2.8-13.3-2.8-18.3,0.1 c-3.9,2.3-4.7,5.6-2.6,8.3C73.5,512.7,74.4,509.7,78,507.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018210382578706371820000012587931741798425487_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.4038,
    y1: 197.7171,
    x2: 80.8157,
    y2: 197.7171,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018210382578706371820000012587931741798425487_)"
    },
    d: "M72.5,525.3c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C80.7,529.6,78,526.8,72.5,525.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054262238628956724720000018309277634169120432_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.7696,
    y1: 192.7741,
    x2: 80.5311,
    y2: 192.7741,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000054262238628956724720000018309277634169120432_)",
      enableBackground: "new"
    },
    d: " M53.7,536.2v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C52.9,535,53.3,535.7,53.7,536.2z M61,540.3v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C61.7,540.4,61.3,540.3,61,540.3z M65.1,540.9v3.3c0.3,0,0.7,0,0.9,0v-3.3C65.8,540.9,65.5,540.9,65.1,540.9z M63.1,540.7v3.1 c0.3,0,0.7,0.1,0.9,0.1v-3.1C63.7,540.7,63.5,540.7,63.1,540.7z M54.8,537.3v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C55.5,537.9,55.1,537.6,54.8,537.3z M59,539.6v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C59.7,539.9,59.3,539.8,59,539.6z M56.8,538.7 v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C57.5,539.1,57.2,538.8,56.8,538.7z M67.1,540.9v3.3c0.3,0,0.7,0,0.9,0v-3.3 C67.8,540.9,67.5,540.9,67.1,540.9z M77.4,537.9v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C78.2,537.5,77.8,537.7,77.4,537.9z  M69.3,540.7v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C70,540.7,69.6,540.7,69.3,540.7z M79.4,536.1v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C80.3,534.9,80,535.4,79.4,536.1z M75.4,539.1v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C76.1,538.8,75.8,539,75.4,539.1z M73.4,539.9 v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C74,539.8,73.6,539.8,73.4,539.9z M71.3,540.4v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1 C72,540.3,71.6,540.3,71.3,540.4z"
  }), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M76.6,526.9c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 S71.1,523.8,76.6,526.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150802842980107479980000001410356432670077111_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.6779,
    y1: 199.2069,
    x2: 79.5286,
    y2: 199.2069,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150802842980107479980000001410356432670077111_)"
    },
    d: "M75.7,527.4c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6S70.6,524.6,75.7,527.4z"
  }), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M57.6,528.1c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C53.2,533.3,54.1,530.3,57.6,528.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112603360941096782360000002972082849204881074_",
    gradientUnits: "userSpaceOnUse",
    x1: 51.8883,
    y1: 201.5091,
    x2: 80.3004,
    y2: 201.5091,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000112603360941096782360000002972082849204881074_)"
    },
    d: "M72,521.5c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C80.3,526,77.4,523,72,521.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031194326743727101660000003748357273150192795_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.2393,
    y1: 196.4984,
    x2: 80.0013,
    y2: 196.4984,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000031194326743727101660000003748357273150192795_)",
      enableBackground: "new"
    },
    d: " M53.3,532.5v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C52.5,531.4,52.8,531.9,53.3,532.5z M60.5,536.5v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C61.2,536.7,60.8,536.7,60.5,536.5z M64.6,537.2v3.3c0.3,0,0.7,0,0.9,0v-3.3C65.2,537.2,65,537.2,64.6,537.2z M62.5,536.9v3.1 c0.3,0,0.7,0.1,0.9,0.1v-3.1C63.2,537.1,62.9,536.9,62.5,536.9z M54.3,533.7v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C54.9,534.1,54.7,533.8,54.3,533.7z M58.5,536v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C59.1,536.1,58.7,536.1,58.5,536z M56.4,535 v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C57,535.3,56.7,535.2,56.4,535z M66.7,537.2v3.3c0.3,0,0.7,0,0.9,0v-3.3 C67.4,537.2,67,537.2,66.7,537.2z M77,534.2v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C77.7,533.7,77.3,533.9,77,534.2z M68.7,537.1 v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C69.4,536.9,69,537.1,68.7,537.1z M79,532.3v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C79.7,531.2,79.4,531.8,79,532.3z M74.8,535.3v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C75.5,535,75.3,535.2,74.8,535.3z M72.8,536.1 v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C73.5,536,73.2,536.1,72.8,536.1z M70.8,536.7v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1 C71.5,536.5,71.2,536.7,70.8,536.7z"
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M76.1,523.2c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C61.6,520,70.5,520,76.1,523.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139261895151253915730000013786327380946576563_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.1588,
    y1: 202.9988,
    x2: 79.0097,
    y2: 202.9988,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000139261895151253915730000013786327380946576563_)"
    },
    d: "M75.3,523.7c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C62,520.8,70.1,520.8,75.3,523.7z"
  }), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M57.2,524.5c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C52.6,529.5,53.6,526.5,57.2,524.5z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102529889329574944260000009092215788100433809_",
    gradientUnits: "userSpaceOnUse",
    x1: 539.4942,
    y1: 663.3152,
    x2: 567.906,
    y2: 663.3152,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000102529889329574944260000009092215788100433809_)"
    },
    d: "M559.5,59.7c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C567.8,64,565,61.2,559.5,59.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125576389359662979730000000877384596574969784_",
    gradientUnits: "userSpaceOnUse",
    x1: 539.8284,
    y1: 658.3721,
    x2: 567.59,
    y2: 658.3721,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000125576389359662979730000000877384596574969784_)",
      enableBackground: "new"
    },
    d: " M540.8,70.6v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C540,69.4,540.4,70.1,540.8,70.6z M548,74.7v3.1c0.3,0.1,0.7,0.1,0.9,0.3V75 C548.7,74.8,548.4,74.7,548,74.7z M552.2,75.3v3.3c0.3,0,0.7,0,0.9,0v-3.3C552.9,75.3,552.5,75.3,552.2,75.3z M550.2,75.1v3.1 c0.3,0,0.7,0.1,0.9,0.1v-3.1C550.9,75.1,550.5,75.1,550.2,75.1z M541.9,71.7v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C542.6,72.3,542.2,72,541.9,71.7z M546,74v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C546.7,74.3,546.4,74.2,546,74z M544,73.1v3.1 c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C544.6,73.5,544.2,73.4,544,73.1z M554.3,75.3v3.3c0.3,0,0.7,0,0.9,0v-3.3 C554.9,75.3,554.5,75.3,554.3,75.3z M564.5,72.3v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C565.2,71.9,564.8,72.1,564.5,72.3z  M556.3,75.1v3.1c0.3,0,0.7-0.1,0.9-0.1V75C557,75.1,556.7,75.1,556.3,75.1z M566.6,70.5v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C567.4,69.3,567,69.8,566.6,70.5z M562.5,73.5v3.1c0.4-0.1,0.7-0.3,0.9-0.5V73C563.2,73.2,562.8,73.4,562.5,73.5z M560.5,74.3 v3.1c0.3-0.1,0.7-0.3,0.9-0.3V74C561.2,74.2,560.8,74.2,560.5,74.3z M558.3,74.8V78c0.3-0.1,0.7-0.1,0.9-0.3v-3.1 C559,74.7,558.7,74.7,558.3,74.8z"
  }), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M563.7,61.3c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C549.1,58.2,558.2,58.2,563.7,61.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060722842759711305490000013912420985564301993_",
    gradientUnits: "userSpaceOnUse",
    x1: 540.7515,
    y1: 664.8049,
    x2: 566.6023,
    y2: 664.8049,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060722842759711305490000013912420985564301993_)"
    },
    d: "M562.8,61.8c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C549.5,59,557.8,59,562.8,61.8z"
  }), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M544.8,62.5c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C540.3,67.7,541.3,64.7,544.8,62.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168827125975875746380000002400848352284169888_",
    gradientUnits: "userSpaceOnUse",
    x1: 539.4257,
    y1: 668.0552,
    x2: 567.8376,
    y2: 668.0552,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168827125975875746380000002400848352284169888_)"
    },
    d: "M559.5,54.9c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C567.8,59.3,565,56.4,559.5,54.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025432260084955549870000010656162005600549302_",
    gradientUnits: "userSpaceOnUse",
    x1: 539.7766,
    y1: 663.0443,
    x2: 567.5381,
    y2: 663.0443,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000025432260084955549870000010656162005600549302_)",
      enableBackground: "new"
    },
    d: " M540.8,65.9V69c-0.4-0.5-0.8-1.2-0.9-1.8v-3C540,64.8,540.3,65.4,540.8,65.9z M548,70v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C548.7,70.1,548.3,70,548,70z M552.1,70.5v3.3c0.3,0,0.7,0,0.9,0v-3.3C552.8,70.6,552.5,70.5,552.1,70.5z M550.1,70.4v3.1 c0.3,0,0.7,0.1,0.9,0.1v-3.1C550.7,70.5,550.5,70.4,550.1,70.4z M541.8,67v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C542.5,67.5,542.2,67.3,541.8,67z M546,69.3v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C546.7,69.6,546.3,69.4,546,69.3z M544,68.3v3.1 c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C544.5,68.8,544.2,68.6,544,68.3z M554.3,70.6v3.3c0.3,0,0.7,0,0.9,0v-3.3 C554.9,70.5,554.5,70.5,554.3,70.6z M564.5,67.7v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C565.2,67.1,564.8,67.4,564.5,67.7z  M556.3,70.5v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C557,70.4,556.6,70.4,556.3,70.5z M566.6,65.8v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C567.3,64.6,567,65.2,566.6,65.8z M562.4,68.8v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C563.1,68.5,562.8,68.6,562.4,68.8z  M560.3,69.6v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C561,69.4,560.8,69.4,560.3,69.6z M558.3,70.1v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1 C559,70,558.7,70.1,558.3,70.1z"
  }), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M563.6,56.6c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C549.1,53.4,558,53.4,563.6,56.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005955984953065736940000011897664942629749634_",
    gradientUnits: "userSpaceOnUse",
    x1: 540.6959,
    y1: 669.5449,
    x2: 566.5469,
    y2: 669.5449,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005955984953065736940000011897664942629749634_)"
    },
    d: "M562.8,57.1c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C549.5,54.3,557.6,54.3,562.8,57.1z"
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M544.8,57.9c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C540.2,62.9,541.1,59.9,544.8,57.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116913893952682596230000014323397801044245914_",
    gradientUnits: "userSpaceOnUse",
    x1: 539.4517,
    y1: 671.8471,
    x2: 567.8633,
    y2: 671.8471,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116913893952682596230000014323397801044245914_)"
    },
    d: "M559.5,51.1c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C567.8,55.6,565,52.8,559.5,51.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000117671560805064387620000008706687735338542247_",
    gradientUnits: "userSpaceOnUse",
    x1: 539.8026,
    y1: 666.8363,
    x2: 567.5641,
    y2: 666.8363,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000117671560805064387620000008706687735338542247_)",
      enableBackground: "new"
    },
    d: " M540.8,62.1v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C540,61,540.3,61.6,540.8,62.1z M548,66.2v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C548.7,66.3,548.4,66.3,548,66.2z M552.2,66.9v3.3c0.3,0,0.7,0,0.9,0v-3.3C552.9,66.9,552.5,66.9,552.2,66.9z M550.1,66.6v3.1 c0.3,0,0.7,0.1,0.9,0.1v-3.1C550.7,66.7,550.5,66.7,550.1,66.6z M541.9,63.3v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C542.5,63.7,542.2,63.6,541.9,63.3z M546,65.6v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C546.7,65.8,546.3,65.8,546,65.6z M544,64.7 v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C544.6,65,544.2,64.8,544,64.7z M554.3,66.9v3.3c0.3,0,0.7,0,0.9,0v-3.3 C554.9,66.9,554.5,66.9,554.3,66.9z M564.5,63.9V67c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C565.2,63.5,564.8,63.6,564.5,63.9z  M556.3,66.7v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C557,66.6,556.7,66.7,556.3,66.7z M566.6,62v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C567.4,60.9,567,61.4,566.6,62z M562.5,65.1v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C563.2,64.7,562.8,64.8,562.5,65.1z M560.3,65.9 V69c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C561,65.6,560.8,65.8,560.3,65.9z M558.3,66.5v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1 C559,66.3,558.7,66.3,558.3,66.5z"
  }), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M563.6,52.9c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C549.1,49.7,558,49.7,563.6,52.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016062519471376117310000010312350050351027375_",
    gradientUnits: "userSpaceOnUse",
    x1: 540.7256,
    y1: 673.2521,
    x2: 566.5765,
    y2: 673.2521,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016062519471376117310000010312350050351027375_)"
    },
    d: "M562.8,53.4c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C549.5,50.5,557.6,50.5,562.8,53.4z"
  }), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M544.8,54.1c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C540.2,59.3,541.1,56.2,544.8,54.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032648042520181452980000001153089454145255828_",
    gradientUnits: "userSpaceOnUse",
    x1: 539.4942,
    y1: 675.5037,
    x2: 567.906,
    y2: 675.5037,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000032648042520181452980000001153089454145255828_)"
    },
    d: "M559.5,47.5c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C567.8,51.8,565,49,559.5,47.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124141810577096148220000006178869054700986038_",
    gradientUnits: "userSpaceOnUse",
    x1: 539.8284,
    y1: 670.4929,
    x2: 567.59,
    y2: 670.4929,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000124141810577096148220000006178869054700986038_)",
      enableBackground: "new"
    },
    d: " M540.8,58.5v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C540,57.4,540.4,57.9,540.8,58.5z M548,62.5v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C548.7,62.7,548.4,62.5,548,62.5z M552.2,63.1v3.3c0.3,0,0.7,0,0.9,0v-3.3C552.9,63.2,552.5,63.1,552.2,63.1z M550.2,62.9V66 c0.3,0,0.7,0.1,0.9,0.1v-3.1C550.9,63.1,550.5,62.9,550.2,62.9z M541.9,59.5v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C542.6,60.1,542.2,59.8,541.9,59.5z M546,61.8V65c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C546.7,62.1,546.4,62,546,61.8z M544,60.9V64 c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C544.6,61.3,544.2,61.2,544,60.9z M554.3,63.2v3.3c0.3,0,0.7,0,0.9,0v-3.3 C554.9,63.1,554.5,63.1,554.3,63.2z M564.5,60.1v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C565.2,59.7,564.8,59.9,564.5,60.1z  M556.3,63.1v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C557,62.9,556.7,62.9,556.3,63.1z M566.6,58.3v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C567.4,57.1,567,57.8,566.6,58.3z M562.5,61.3v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C563.2,61,562.8,61.2,562.5,61.3z M560.5,62.1 v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C561.2,62,560.8,62,560.5,62.1z M558.3,62.7v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1 C559,62.5,558.7,62.7,558.3,62.7z"
  }), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M563.7,49.1c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C549.1,46,558.2,46,563.7,49.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052064124095156929300000016843547590161570694_",
    gradientUnits: "userSpaceOnUse",
    x1: 540.7515,
    y1: 676.9933,
    x2: 566.6023,
    y2: 676.9933,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052064124095156929300000016843547590161570694_)"
    },
    d: "M562.8,49.7c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C549.5,46.8,557.8,46.8,562.8,49.7z"
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M544.8,50.5c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C540.3,55.5,541.3,52.5,544.8,50.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066474246441067687590000012765312418039056769_",
    gradientUnits: "userSpaceOnUse",
    x1: 540.7131,
    y1: 679.1602,
    x2: 569.1249,
    y2: 679.1602,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066474246441067687590000012765312418039056769_)"
    },
    d: "M560.8,43.8c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C569,48.2,566.2,45.3,560.8,43.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058575788960172214460000003051158232501140649_",
    gradientUnits: "userSpaceOnUse",
    x1: 541.0377,
    y1: 674.217,
    x2: 568.7993,
    y2: 674.217,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000058575788960172214460000003051158232501140649_)",
      enableBackground: "new"
    },
    d: " M542.1,54.8v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C541.3,53.6,541.7,54.3,542.1,54.8z M549.2,58.9V62c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C549.9,59,549.7,58.9,549.2,58.9z M553.4,59.4v3.3c0.3,0,0.7,0,0.9,0v-3.3C554.1,59.4,553.7,59.4,553.4,59.4z M551.4,59.1v3.1 c0.3,0,0.7,0.1,0.9,0.1v-3.1C552,59.3,551.7,59.3,551.4,59.1z M543.2,55.9V59c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C543.8,56.3,543.4,56.2,543.2,55.9z M547.2,58.2v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C547.9,58.5,547.6,58.3,547.2,58.2z  M545.2,57.2v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C545.9,57.5,545.5,57.4,545.2,57.2z M555.5,59.4v3.3c0.3,0,0.7,0,0.9,0v-3.3 C556.2,59.4,555.7,59.4,555.5,59.4z M565.8,56.4v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C566.4,56,566,56.3,565.8,56.4z M557.5,59.3 v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C558.2,59.3,557.9,59.3,557.5,59.3z M567.8,54.7v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C568.6,53.4,568.2,54,567.8,54.7z M563.7,57.6v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C564.4,57.4,564,57.5,563.7,57.6z M561.7,58.5 v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C562.4,58.2,562,58.3,561.7,58.5z M559.5,59v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1 C560.2,58.9,559.9,58.9,559.5,59z"
  }), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M565,45.5c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C550.3,42.3,559.4,42.3,565,45.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153702814837227589410000016082487932224582047_",
    gradientUnits: "userSpaceOnUse",
    x1: 541.9607,
    y1: 680.6757,
    x2: 567.8117,
    y2: 680.6757,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000153702814837227589410000016082487932224582047_)"
    },
    d: "M564,46c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C550.7,43.2,559,43,564,46z"
  }), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M546,46.7c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3c-5-2.8-13.3-2.8-18.3,0.1 c-3.9,2.3-4.7,5.6-2.6,8.3C541.5,51.8,542.5,48.8,546,46.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129187712197325424790000018121200312625707433_",
    gradientUnits: "userSpaceOnUse",
    x1: 539.4127,
    y1: 682.9521,
    x2: 567.8246,
    y2: 682.9521,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129187712197325424790000018121200312625707433_)"
    },
    d: "M559.5,40c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C567.7,44.4,565,41.5,559.5,40z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085950775580469483030000005458423040441658524_",
    gradientUnits: "userSpaceOnUse",
    x1: 539.7651,
    y1: 678.009,
    x2: 567.5276,
    y2: 678.009,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000085950775580469483030000005458423040441658524_)",
      enableBackground: "new"
    },
    d: " M540.7,51v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C540,49.9,540.3,50.5,540.7,51z M548,55.1v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C548.7,55.2,548.3,55.1,548,55.1z M552.1,55.6v3.3c0.3,0,0.7,0,0.9,0v-3.3C552.8,55.6,552.5,55.6,552.1,55.6z M550.1,55.5v3.1 c0.3,0,0.7,0.1,0.9,0.1v-3.1C550.7,55.5,550.5,55.5,550.1,55.5z M541.8,52.1v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C542.5,52.6,542.1,52.4,541.8,52.1z M546,54.4v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C546.7,54.7,546.3,54.5,546,54.4z M544,53.4 v3.1c0.3,0.1,0.7,0.3,0.9,0.5V54C544.5,53.9,544.2,53.7,544,53.4z M554.3,55.6v3.3c0.3,0,0.7,0,0.9,0v-3.3 C554.8,55.6,554.5,55.6,554.3,55.6z M564.4,52.6v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C565.2,52.2,564.8,52.5,564.4,52.6z  M556.3,55.6v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C557,55.5,556.6,55.5,556.3,55.6z M566.6,50.9V54c0.4-0.5,0.8-1.2,0.9-1.9v-3 C567.3,49.7,567,50.3,566.6,50.9z M562.4,53.9V57c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C563.1,53.6,562.8,53.7,562.4,53.9z M560.3,54.7 v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C561,54.5,560.8,54.5,560.3,54.7z M558.3,55.2v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1 C559,55.1,558.6,55.1,558.3,55.2z"
  }), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M563.6,41.7c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1s-5.6-8.4,0-11.6 C549.1,38.6,558,38.6,563.6,41.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095318302049462420180000018177554857312387241_",
    gradientUnits: "userSpaceOnUse",
    x1: 540.6959,
    y1: 684.4418,
    x2: 566.5469,
    y2: 684.4418,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000095318302049462420180000018177554857312387241_)"
    },
    d: "M562.8,42.2c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1s-5.1-7.6,0-10.6C549.5,39.4,557.6,39.4,562.8,42.2z"
  }), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M544.6,43c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3c-5-2.8-13.3-2.8-18.3,0.1 c-3.9,2.3-4.7,5.6-2.6,8.3C540.2,48,541.1,45.1,544.6,43z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000166667934094942193330000005297055495461461398_",
    gradientUnits: "userSpaceOnUse",
    x1: 735.5925,
    y1: 494.3023,
    x2: 764.0045,
    y2: 494.3023,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000166667934094942193330000005297055495461461398_)"
    },
    d: "M755.6,228.7c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C763.9,233.2,761.2,230.2,755.6,228.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160192174027767939630000004442624931943727543_",
    gradientUnits: "userSpaceOnUse",
    x1: 735.967,
    y1: 489.2915,
    x2: 763.7288,
    y2: 489.2915,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000160192174027767939630000004442624931943727543_)",
      enableBackground: "new"
    },
    d: " M736.9,239.7v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C736.1,238.6,736.5,239.1,736.9,239.7z M744.3,243.7v3.1c0.3,0.1,0.7,0.1,0.9,0.3 V244C744.9,243.9,744.5,243.9,744.3,243.7z M748.3,244.4v3.3c0.3,0,0.7,0,0.9,0v-3.3C749,244.4,748.7,244.4,748.3,244.4z  M746.3,244.1v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C747,244.3,746.6,244.1,746.3,244.1z M738,240.9v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C738.7,241.3,738.3,241,738,240.9z M742.2,243.2v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C742.8,243.3,742.5,243.3,742.2,243.2z  M740.1,242.2v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C740.7,242.5,740.5,242.4,740.1,242.2z M750.4,244.4v3.3c0.3,0,0.7,0,0.9,0v-3.3 C751,244.4,750.8,244.4,750.4,244.4z M760.6,241.4v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C761.3,241,761.1,241.2,760.6,241.4z  M752.5,244.3v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C753.1,244.1,752.8,244.3,752.5,244.3z M762.7,239.5v3.1c0.4-0.5,0.8-1.2,0.9-1.9 v-3C763.5,238.4,763.2,239,762.7,239.5z M758.6,242.6v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C759.3,242.2,759,242.4,758.6,242.6z  M756.6,243.3v3.1c0.3-0.1,0.7-0.3,0.9-0.3V243C757.3,243.2,756.9,243.3,756.6,243.3z M754.6,243.9v3.1c0.3-0.1,0.7-0.1,0.9-0.3 v-3.1C755.2,243.7,754.8,243.9,754.6,243.9z"
  }), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M759.8,230.5c5.6,3.1,5.6,8.4,0,11.6s-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C745.3,227.2,754.3,227.2,759.8,230.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112596745756720217020000017317329929982396604_",
    gradientUnits: "userSpaceOnUse",
    x1: 736.8903,
    y1: 495.792,
    x2: 762.7411,
    y2: 495.792,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000112596745756720217020000017317329929982396604_)"
    },
    d: "M758.9,230.9c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1s-5.1-7.6,0-10.6C745.7,228,753.9,228,758.9,230.9z"
  }), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M740.9,231.7c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C736.4,236.7,737.4,233.7,740.9,231.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142857679063270113920000004214871217537162680_",
    gradientUnits: "userSpaceOnUse",
    x1: 734.3293,
    y1: 499.0423,
    x2: 762.7411,
    y2: 499.0423,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142857679063270113920000004214871217537162680_)"
    },
    d: "M754.4,224c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C762.7,228.4,759.8,225.6,754.4,224z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078027315059031632470000016551399224685205947_",
    gradientUnits: "userSpaceOnUse",
    x1: 734.6804,
    y1: 494.0315,
    x2: 762.4418,
    y2: 494.0315,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000078027315059031632470000016551399224685205947_)",
      enableBackground: "new"
    },
    d: " M735.7,234.9v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C734.9,233.8,735.2,234.4,735.7,234.9z M742.9,239v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C743.6,239.1,743.3,239.1,742.9,239z M747.1,239.7v3.3c0.3,0,0.7,0,0.9,0v-3.3C747.8,239.7,747.4,239.7,747.1,239.7z  M744.9,239.4v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C745.6,239.5,745.3,239.5,744.9,239.4z M736.8,236.1v3.1c0.3,0.3,0.7,0.5,0.9,0.8 V237C737.4,236.5,737.1,236.4,736.8,236.1z M740.9,238.4v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C741.6,238.6,741.1,238.6,740.9,238.4 z M738.8,237.5v3.1c0.3,0.1,0.7,0.3,0.9,0.5V238C739.5,237.8,739.1,237.6,738.8,237.5z M749.1,239.7v3.3c0.3,0,0.7,0,0.9,0v-3.3 C749.8,239.7,749.4,239.7,749.1,239.7z M759.4,236.7v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C760.1,236.3,759.7,236.4,759.4,236.7z  M751.2,239.5v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C751.8,239.4,751.6,239.5,751.2,239.5z M761.5,234.8v3.1c0.4-0.5,0.8-1.2,0.9-1.9 v-3C762.3,233.7,761.9,234.2,761.5,234.8z M757.4,237.9v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C758.1,237.5,757.7,237.8,757.4,237.9z  M755.2,238.7v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C755.9,238.4,755.6,238.6,755.2,238.7z M753.2,239.3v3.1 c0.3-0.1,0.7-0.1,0.9-0.3V239C753.9,239.1,753.6,239.1,753.2,239.3z"
  }), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M758.5,225.7c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1s-5.6-8.4,0-11.6 C744,222.6,752.9,222.5,758.5,225.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086679389927905782730000002801261165778059951_",
    gradientUnits: "userSpaceOnUse",
    x1: 735.6033,
    y1: 500.4473,
    x2: 761.4542,
    y2: 500.4473,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000086679389927905782730000002801261165778059951_)"
    },
    d: "M757.7,226.3c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1s-5.1-7.6,0-10.6C744.4,223.3,752.5,223.3,757.7,226.3z"
  }), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M739.7,226.9c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C735.1,232.1,736,229.1,739.7,226.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066503741857117816910000009670742702707456413_",
    gradientUnits: "userSpaceOnUse",
    x1: 734.3737,
    y1: 502.6988,
    x2: 762.7857,
    y2: 502.6988,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066503741857117816910000009670742702707456413_)"
    },
    d: "M754.4,220.3c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C762.7,224.6,759.8,221.8,754.4,220.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013912972812557327360000007925591588109730484_",
    gradientUnits: "userSpaceOnUse",
    x1: 734.7061,
    y1: 497.688,
    x2: 762.4677,
    y2: 497.688,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000013912972812557327360000007925591588109730484_)",
      enableBackground: "new"
    },
    d: " M735.7,231.3v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C734.9,230.2,735.3,230.7,735.7,231.3z M742.9,235.3v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C743.6,235.5,743.3,235.3,742.9,235.3z M747.1,235.9v3.3c0.3,0,0.7,0,0.9,0v-3.3C747.8,236,747.4,235.9,747.1,235.9z  M745.1,235.7v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C745.6,235.9,745.3,235.7,745.1,235.7z M736.8,232.3v3.1c0.3,0.3,0.7,0.5,0.9,0.8 v-3.1C737.5,232.9,737.1,232.6,736.8,232.3z M740.9,234.7v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1 C741.6,234.9,741.3,234.8,740.9,234.7z M738.8,233.7v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C739.5,234.1,739.1,234,738.8,233.7z  M749.1,236v3.3c0.3,0,0.7,0,0.9,0V236C749.8,235.9,749.4,235.9,749.1,236z M759.4,233v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1 C760.1,232.5,759.7,232.8,759.4,233z M751.2,235.9v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C751.8,235.7,751.6,235.7,751.2,235.9z  M761.5,231.1v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3C762.3,229.9,761.9,230.6,761.5,231.1z M757.4,234.1v3.1c0.4-0.1,0.7-0.3,0.9-0.5 v-3.1C758.1,233.8,757.7,234,757.4,234.1z M755.4,234.9v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C756,234.8,755.6,234.8,755.4,234.9z  M753.2,235.5v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1C753.9,235.3,753.6,235.5,753.2,235.5z"
  }), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M758.6,221.9c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C744,218.8,753.1,218.8,758.6,221.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131357619142583821890000011860580554373632179_",
    gradientUnits: "userSpaceOnUse",
    x1: 735.6292,
    y1: 504.1885,
    x2: 761.4802,
    y2: 504.1885,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000131357619142583821890000011860580554373632179_)"
    },
    d: "M757.7,222.5c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C744.4,219.6,752.7,219.6,757.7,222.5z"
  }), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M739.7,223.3c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C735.2,228.3,736.1,225.3,739.7,223.3z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075149523874354549830000013025416122820706463_",
    gradientUnits: "userSpaceOnUse",
    x1: 285.29,
    y1: 336.0051,
    x2: 313.702,
    y2: 336.0051,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075149523874354549830000013025416122820706463_)"
    },
    d: "M305.4,387c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C313.7,391.3,310.8,388.5,305.4,387z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000068646942969465983940000012538453388419289234_",
    gradientUnits: "userSpaceOnUse",
    x1: 285.641,
    y1: 331.1297,
    x2: 313.4029,
    y2: 331.1297,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000068646942969465983940000012538453388419289234_)",
      enableBackground: "new"
    },
    d: " M286.7,398v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C285.9,396.7,286.2,397.3,286.7,398z M293.9,402v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C294.6,402.2,294.3,402,293.9,402z M298.1,402.6v3.3c0.3,0,0.7,0,0.9,0v-3.3C298.6,402.6,298.3,402.6,298.1,402.6z M295.9,402.3 v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C296.6,402.4,296.3,402.4,295.9,402.3z M287.7,399v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C288.3,399.4,288.1,399.3,287.7,399z M291.8,401.3v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C292.5,401.5,292.1,401.5,291.8,401.3z  M289.8,400.4v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C290.5,400.7,290.1,400.5,289.8,400.4z M300.1,402.6v3.3c0.3,0,0.7,0,0.9,0v-3.3 C300.8,402.6,300.4,402.6,300.1,402.6z M310.4,399.6v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C311.1,399.2,310.7,399.3,310.4,399.6z  M302.1,402.4v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C302.8,402.3,302.4,402.4,302.1,402.4z M312.4,397.7v3.1c0.4-0.5,0.8-1.2,0.9-1.9 v-3C313.2,396.6,312.8,397.1,312.4,397.7z M308.2,400.8v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C308.9,400.5,308.6,400.7,308.2,400.8z  M306.2,401.6v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C306.9,401.3,306.6,401.5,306.2,401.6z M304.2,402.2v3.1 c0.3-0.1,0.7-0.1,0.9-0.3v-3.1C304.8,402,304.6,402,304.2,402.2z"
  }), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M309.5,388.6c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C295,385.5,303.9,385.4,309.5,388.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000167384720493493724540000013194826099280126399_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.5502,
    y1: 337.5206,
    x2: 312.4012,
    y2: 337.5206,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000167384720493493724540000013194826099280126399_)"
    },
    d: "M308.6,389.2c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1s-5.1-7.6,0-10.6C295.4,386.3,303.5,386.2,308.6,389.2z"
  }), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M290.6,389.8c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C286,395,287,392,290.6,389.8z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114782848898906042740000003332384988308269203_",
    gradientUnits: "userSpaceOnUse",
    x1: 280.3377,
    y1: 341.1513,
    x2: 308.7496,
    y2: 341.1513,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114782848898906042740000003332384988308269203_)"
    },
    d: "M300.4,381.8c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C308.6,386.3,305.9,383.3,300.4,381.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124134374159751952920000000767872333987263896_",
    gradientUnits: "userSpaceOnUse",
    x1: 280.6761,
    y1: 336.1405,
    x2: 308.438,
    y2: 336.1405,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000124134374159751952920000000767872333987263896_)",
      enableBackground: "new"
    },
    d: " M281.7,392.8v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C280.9,391.7,281.3,392.3,281.7,392.8z M288.9,396.9v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C289.5,397,289.3,397,288.9,396.9z M293.1,397.6v3.3c0.3,0,0.7,0,0.9,0v-3.3C293.7,397.6,293.3,397.6,293.1,397.6z  M291,397.3v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C291.7,397.4,291.3,397.3,291,397.3z M282.8,394v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C283.5,394.4,283,394.2,282.8,394z M286.8,396.3v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C287.5,396.5,287.2,396.5,286.8,396.3z  M284.8,395.4v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C285.5,395.7,285.1,395.5,284.8,395.4z M295.1,397.6v3.3c0.3,0,0.7,0,0.9,0v-3.3 C295.8,397.6,295.5,397.6,295.1,397.6z M305.4,394.6v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C306.1,394.2,305.7,394.3,305.4,394.6z  M297.1,397.4v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C297.8,397.3,297.5,397.4,297.1,397.4z M307.4,392.7v3.1c0.4-0.5,0.8-1.2,0.9-1.9 v-3C308.2,391.6,307.8,392.1,307.4,392.7z M303.4,395.8v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C304,395.4,303.6,395.5,303.4,395.8z  M301.3,396.5v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C302,396.3,301.6,396.5,301.3,396.5z M299.2,397v3.1c0.3-0.1,0.7-0.1,0.9-0.3 v-3.1C299.8,396.9,299.6,397,299.2,397z"
  }), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M304.6,383.6c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C290,380.4,299,380.4,304.6,383.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000138545348943102896360000001680157767137064099_",
    gradientUnits: "userSpaceOnUse",
    x1: 281.5992,
    y1: 342.641,
    x2: 307.4502,
    y2: 342.641,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000138545348943102896360000001680157767137064099_)"
    },
    d: "M303.6,384c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C290.4,381.2,298.6,381.2,303.6,384z"
  }), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M285.6,384.8c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C281.2,389.8,282.1,386.9,285.6,384.8z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156571880525428481870000000940126534064647322_",
    gradientUnits: "userSpaceOnUse",
    x1: 550.132,
    y1: 648.96,
    x2: 578.5436,
    y2: 648.96,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000156571880525428481870000000940126534064647322_)"
    },
    d: "M570.2,74c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C578.5,78.4,575.7,75.5,570.2,74z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122700747178950829190000015002679799776514433_",
    gradientUnits: "userSpaceOnUse",
    x1: 550.4829,
    y1: 644.0845,
    x2: 578.2446,
    y2: 644.0845,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000122700747178950829190000015002679799776514433_)",
      enableBackground: "new"
    },
    d: " M551.5,85v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C550.7,83.8,551,84.5,551.5,85z M558.7,89.1v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C559.4,89.2,559.1,89.1,558.7,89.1z M562.9,89.6v3.3c0.3,0,0.7,0,0.9,0v-3.3C563.5,89.6,563.2,89.6,562.9,89.6z M560.8,89.3v3.1 c0.3,0,0.7,0.1,0.9,0.1v-3.1C561.4,89.5,561.2,89.5,560.8,89.3z M552.5,86.1v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C553.2,86.5,552.9,86.4,552.5,86.1z M556.7,88.4v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C557.4,88.7,557,88.5,556.7,88.4z M554.7,87.4 v3.1c0.3,0.1,0.7,0.3,0.9,0.5V88C555.3,87.7,554.9,87.6,554.7,87.4z M565,89.6v3.3c0.3,0,0.7,0,0.9,0v-3.3 C565.6,89.6,565.2,89.6,565,89.6z M575.2,86.6v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C575.9,86.2,575.5,86.5,575.2,86.6z M567,89.5 v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C567.7,89.5,567.3,89.5,567,89.5z M577.3,84.7v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C578.1,83.6,577.7,84.2,577.3,84.7z M573.1,87.8V91c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C573.8,87.6,573.5,87.7,573.1,87.8z M571,88.7 v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C571.7,88.4,571.5,88.5,571,88.7z M569,89.2v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1 C569.7,89.1,569.4,89.1,569,89.2z"
  }), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M574.3,75.7c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C559.8,72.5,568.7,72.4,574.3,75.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025432494191834032450000006042235821019914682_",
    gradientUnits: "userSpaceOnUse",
    x1: 551.3947,
    y1: 650.4755,
    x2: 577.2457,
    y2: 650.4755,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000025432494191834032450000006042235821019914682_)"
    },
    d: "M573.5,76.2c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C560.2,73.4,568.3,73.2,573.5,76.2z"
  }), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M555.5,76.9c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3c-5-2.8-13.3-2.8-18.3,0.1 c-3.9,2.3-4.7,5.6-2.6,8.3C550.9,82,551.8,79,555.5,76.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116949836715775938440000004615936633637286568_",
    gradientUnits: "userSpaceOnUse",
    x1: 549.6166,
    y1: 652.7519,
    x2: 578.0283,
    y2: 652.7519,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116949836715775938440000004615936633637286568_)"
    },
    d: "M569.7,70.2c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C578,74.7,575.1,71.7,569.7,70.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122699144648379934690000005440811787177350027_",
    gradientUnits: "userSpaceOnUse",
    x1: 549.9675,
    y1: 647.7411,
    x2: 577.729,
    y2: 647.7411,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000122699144648379934690000005440811787177350027_)",
      enableBackground: "new"
    },
    d: " M551,81.2v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C550.2,80.1,550.6,80.7,551,81.2z M558.2,85.3v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C558.9,85.4,558.6,85.4,558.2,85.3z M562.4,85.8v3.3c0.3,0,0.7,0,0.9,0v-3.3C563.1,86,562.7,86,562.4,85.8z M560.3,85.7v3.1 c0.3,0,0.7,0.1,0.9,0.1v-3.1C560.9,85.8,560.6,85.7,560.3,85.7z M552.1,82.3v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C552.6,82.8,552.4,82.6,552.1,82.3z M556.2,84.7v3.1c0.3,0.1,0.7,0.3,0.9,0.3V85C556.8,84.9,556.4,84.7,556.2,84.7z M554.1,83.8 v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C554.8,84.1,554.4,83.9,554.1,83.8z M564.4,86v3.3c0.3,0,0.7,0,0.9,0V86 C565.1,85.8,564.7,86,564.4,86z M574.7,83v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C575.4,82.4,575,82.7,574.7,83z M566.4,85.8v3.1 c0.3,0,0.7-0.1,0.9-0.1v-3.1C567.1,85.7,566.9,85.8,566.4,85.8z M576.7,81.1v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C577.5,80,577.1,80.5,576.7,81.1z M572.7,84.1v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C573.4,83.8,572.9,83.9,572.7,84.1z M570.5,84.9 V88c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C571.2,84.7,570.9,84.7,570.5,84.9z M568.5,85.4v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1 C569.2,85.3,568.9,85.4,568.5,85.4z"
  }), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M573.9,71.9c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C559.3,68.8,568.2,68.8,573.9,71.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049911629382903209880000006315964376116471984_",
    gradientUnits: "userSpaceOnUse",
    x1: 550.8905,
    y1: 654.2416,
    x2: 576.7415,
    y2: 654.2416,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049911629382903209880000006315964376116471984_)"
    },
    d: "M572.9,72.4c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C559.7,69.6,567.9,69.6,572.9,72.4z"
  }), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M554.9,73.2c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3c-5-2.8-13.3-2.8-18.3,0.1 c-3.9,2.3-4.7,5.6-2.6,8.3C550.3,78.2,551.3,75.3,554.9,73.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009573273054671874610000013933010643320850836_",
    gradientUnits: "userSpaceOnUse",
    x1: 773.512,
    y1: 238.0744,
    x2: 801.924,
    y2: 238.0744,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000009573273054671874610000013933010643320850836_)"
    },
    d: "M793.6,484.9c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C801.8,489.4,799.1,486.4,793.6,484.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021809985374279617870000003885231829358856854_",
    gradientUnits: "userSpaceOnUse",
    x1: 773.8706,
    y1: 233.0637,
    x2: 801.6323,
    y2: 233.0637,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000021809985374279617870000003885231829358856854_)",
      enableBackground: "new"
    },
    d: " M774.9,495.9v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C774.1,494.8,774.5,495.3,774.9,495.9z M782.2,500v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C782.7,500.1,782.5,500.1,782.2,500z M786.2,500.5v3.3c0.3,0,0.7,0,0.9,0v-3.3C786.9,500.6,786.5,500.5,786.2,500.5z  M784.2,500.4v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C784.9,500.5,784.5,500.4,784.2,500.4z M775.9,497v3.1c0.3,0.3,0.7,0.5,0.9,0.8 v-3.1C776.6,497.5,776.2,497.2,775.9,497z M780,499.3v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C780.7,499.5,780.4,499.4,780,499.3z  M778,498.3v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C778.7,498.7,778.4,498.6,778,498.3z M788.3,500.6v3.3c0.3,0,0.7,0,0.9,0v-3.3 C789,500.5,788.7,500.6,788.3,500.6z M798.6,497.6v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C799.2,497.1,799,497.4,798.6,497.6z  M790.3,500.5v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C791,500.4,790.7,500.4,790.3,500.5z M800.6,495.8v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C801.4,494.5,801,495.2,800.6,495.8z M796.5,498.7v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C797.2,498.5,796.8,498.6,796.5,498.7z  M794.5,499.5v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C795.2,499.4,794.8,499.4,794.5,499.5z M792.5,500.1v3.1 c0.3-0.1,0.7-0.1,0.9-0.3v-3.1C793.1,500,792.7,500.1,792.5,500.1z"
  }), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M797.8,486.5c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C783.1,483.4,792.2,483.4,797.8,486.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000118366349278298241200000008826615622533479335_",
    gradientUnits: "userSpaceOnUse",
    x1: 774.7936,
    y1: 239.5641,
    x2: 800.6446,
    y2: 239.5641,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000118366349278298241200000008826615622533479335_)"
    },
    d: "M796.8,487.1c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C783.7,484.2,791.8,484.2,796.8,487.1z"
  }), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M778.8,487.9c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C774.3,492.9,775.3,489.9,778.8,487.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000154422506325312656960000007317228932055919268_",
    gradientUnits: "userSpaceOnUse",
    x1: 773.4678,
    y1: 242.8144,
    x2: 801.8796,
    y2: 242.8144,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000154422506325312656960000007317228932055919268_)"
    },
    d: "M793.6,480.2c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C801.8,484.6,799,481.7,793.6,480.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096049546463278122210000013833244061177736100_",
    gradientUnits: "userSpaceOnUse",
    x1: 773.8188,
    y1: 237.8036,
    x2: 801.5805,
    y2: 237.8036,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000096049546463278122210000013833244061177736100_)",
      enableBackground: "new"
    },
    d: " M774.9,491.1v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C774.1,490.1,774.3,490.6,774.9,491.1z M782,495.2v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C782.7,495.3,782.5,495.3,782,495.2z M786.2,495.8v3.3c0.3,0,0.7,0,0.9,0v-3.3C786.9,495.9,786.5,495.9,786.2,495.8z  M784.1,495.6v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C784.8,495.8,784.5,495.6,784.1,495.6z M775.9,492.2v3.1c0.3,0.3,0.7,0.5,0.9,0.8 V493C776.5,492.8,776.2,492.5,775.9,492.2z M780,494.7v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C780.7,494.8,780.3,494.7,780,494.7z  M778,493.7v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C778.7,494,778.3,493.9,778,493.7z M788.3,495.9v3.3c0.3,0,0.7,0,0.9,0v-3.3 C789,495.9,788.5,495.9,788.3,495.9z M798.6,492.9v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C799.2,492.4,798.8,492.6,798.6,492.9z  M790.3,495.8v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C791,495.6,790.7,495.8,790.3,495.8z M800.6,491v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C801.4,489.9,801,490.5,800.6,491z M796.5,494v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C797.2,493.7,796.8,493.9,796.5,494z  M794.4,494.8v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C795,494.7,794.8,494.8,794.4,494.8z M792.3,495.3v3.1c0.3-0.1,0.7-0.1,0.9-0.3 v-3.1C793,495.2,792.7,495.3,792.3,495.3z"
  }), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M797.6,481.8c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C783.1,478.7,792.1,478.7,797.6,481.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000166666318246672772110000014223842411103749046_",
    gradientUnits: "userSpaceOnUse",
    x1: 774.742,
    y1: 244.3041,
    x2: 800.5927,
    y2: 244.3041,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000166666318246672772110000014223842411103749046_)"
    },
    d: "M796.8,482.3c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C783.5,479.5,791.7,479.5,796.8,482.3z"
  }), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M778.8,483.2c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C774.2,488.2,775.1,485.2,778.8,483.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096043470846206115120000001394075926258559887_",
    gradientUnits: "userSpaceOnUse",
    x1: 773.512,
    y1: 246.4708,
    x2: 801.9241,
    y2: 246.4708,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096043470846206115120000001394075926258559887_)"
    },
    d: "M793.6,476.5c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C801.8,480.9,799,478,793.6,476.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016048090004692272670000007017231295937139644_",
    gradientUnits: "userSpaceOnUse",
    x1: 773.8447,
    y1: 241.5955,
    x2: 801.6062,
    y2: 241.5955,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000016048090004692272670000007017231295937139644_)",
      enableBackground: "new"
    },
    d: " M774.9,487.5v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C774.1,486.3,774.5,487,774.9,487.5z M782,491.6v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C782.7,491.7,782.5,491.6,782,491.6z M786.2,492.1v3.3c0.3,0,0.7,0,0.9,0v-3.3C786.9,492.1,786.5,492.1,786.2,492.1z  M784.2,491.8v3.1c0.3,0,0.7,0.1,0.9,0.1V492C784.8,492,784.5,492,784.2,491.8z M775.9,488.6v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C776.6,489,776.2,488.8,775.9,488.6z M780,490.9v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C780.7,491.1,780.4,491,780,490.9z M778,489.9 v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C778.7,490.2,778.3,490.1,778,489.9z M788.3,492.1v3.3c0.3,0,0.7,0,0.9,0v-3.3 C789,492.1,788.5,492.1,788.3,492.1z M798.6,489.1v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C799.2,488.7,798.8,489,798.6,489.1z  M790.3,492v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C791,492,790.7,492,790.3,492z M800.6,487.2v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C801.4,486.1,801,486.7,800.6,487.2z M796.5,490.3v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C797.2,490.1,796.8,490.2,796.5,490.3z  M794.5,491.1v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C795.2,490.9,794.8,491,794.5,491.1z M792.3,491.7v3.1c0.3-0.1,0.7-0.1,0.9-0.3 v-3.1C793,491.6,792.7,491.6,792.3,491.7z"
  }), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M797.8,478.1c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C783.1,475,792.2,474.9,797.8,478.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036972896038816392690000013907649780706102931_",
    gradientUnits: "userSpaceOnUse",
    x1: 774.7677,
    y1: 247.9864,
    x2: 800.6185,
    y2: 247.9864,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036972896038816392690000013907649780706102931_)"
    },
    d: "M796.8,478.7c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C783.5,475.8,791.8,475.7,796.8,478.7z"
  }), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M778.8,479.4c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C774.3,484.5,775.3,481.5,778.8,479.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003815492821410042380000016667870358002333114_",
    gradientUnits: "userSpaceOnUse",
    x1: 773.512,
    y1: 250.2629,
    x2: 801.9239,
    y2: 250.2629,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003815492821410042380000016667870358002333114_)"
    },
    d: "M793.6,472.7c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C801.8,477.2,799.1,474.2,793.6,472.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121980088094905513780000000332459663506742192_",
    gradientUnits: "userSpaceOnUse",
    x1: 773.8706,
    y1: 245.2521,
    x2: 801.6323,
    y2: 245.2521,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000121980088094905513780000000332459663506742192_)",
      enableBackground: "new"
    },
    d: " M774.9,483.7v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C774.1,482.6,774.5,483.2,774.9,483.7z M782.2,487.8v3.1c0.3,0.1,0.7,0.1,0.9,0.3 V488C782.7,487.9,782.5,487.9,782.2,487.8z M786.2,488.3v3.3c0.3,0,0.7,0,0.9,0v-3.3C786.9,488.4,786.5,488.4,786.2,488.3z  M784.2,488.2v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C784.9,488.3,784.5,488.2,784.2,488.2z M775.9,484.8v3.1c0.3,0.3,0.7,0.5,0.9,0.8 v-3.1C776.6,485.3,776.2,485.1,775.9,484.8z M780,487.2v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C780.7,487.4,780.4,487.2,780,487.2z  M778,486.3v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C778.7,486.5,778.4,486.4,778,486.3z M788.3,488.4v3.3c0.3,0,0.7,0,0.9,0v-3.3 C789,488.3,788.7,488.4,788.3,488.4z M798.6,485.5v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C799.2,484.9,799,485.2,798.6,485.5z  M790.3,488.3v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C791,488.2,790.7,488.3,790.3,488.3z M800.6,483.6v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C801.4,482.5,801,483,800.6,483.6z M796.5,486.5v3.1c0.4-0.1,0.7-0.3,0.9-0.5V486C797.2,486.3,796.8,486.4,796.5,486.5z  M794.5,487.4v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C795.2,487.2,794.8,487.2,794.5,487.4z M792.5,487.9v3.1 c0.3-0.1,0.7-0.1,0.9-0.3v-3.1C793.1,487.8,792.7,487.9,792.5,487.9z"
  }), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M797.8,474.4c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C783.1,471.2,792.2,471.2,797.8,474.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047764702381984219220000016327882748636834742_",
    gradientUnits: "userSpaceOnUse",
    x1: 774.7936,
    y1: 251.7526,
    x2: 800.6446,
    y2: 251.7526,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047764702381984219220000016327882748636834742_)"
    },
    d: "M796.8,474.9c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C783.7,472.1,791.8,472.1,796.8,474.9z"
  }), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M778.8,475.7c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C774.3,480.7,775.3,477.7,778.8,475.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000167393693050856143410000007463219199763787947_",
    gradientUnits: "userSpaceOnUse",
    x1: 784.174,
    y1: 223.7191,
    x2: 812.5859,
    y2: 223.7191,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000167393693050856143410000007463219199763787947_)"
    },
    d: "M804.3,499.3c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C812.5,503.6,809.7,500.8,804.3,499.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114033598047174433500000009553272267414694326_",
    gradientUnits: "userSpaceOnUse",
    x1: 784.5248,
    y1: 218.7084,
    x2: 812.2866,
    y2: 218.7084,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000114033598047174433500000009553272267414694326_)",
      enableBackground: "new"
    },
    d: " M785.6,510.2v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C784.8,509.2,785.2,509.7,785.6,510.2z M792.7,514.3v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C793.4,514.4,793.1,514.3,792.7,514.3z M796.9,514.8v3.3c0.3,0,0.7,0,0.9,0v-3.3C797.6,515,797.2,514.8,796.9,514.8z  M794.8,514.7v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C795.5,514.8,795.2,514.7,794.8,514.7z M786.6,511.3v3.1c0.3,0.3,0.7,0.5,0.9,0.8 v-3.1C787.2,511.9,786.9,511.6,786.6,511.3z M790.7,513.6v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C791.4,513.9,791,513.8,790.7,513.6z  M788.7,512.7v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C789.4,513.1,789,513,788.7,512.7z M799,515v3.3c0.3,0,0.7,0,0.9,0V515 C799.6,514.8,799.2,514.8,799,515z M809.3,512v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C809.9,511.5,809.5,511.7,809.3,512z M801,514.8 v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C801.7,514.7,801.4,514.7,801,514.8z M811.3,510.1v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C812.1,508.9,811.7,509.6,811.3,510.1z M807.2,513.1v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C807.9,512.8,807.5,513,807.2,513.1z  M805.1,513.9v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C805.7,513.8,805.5,513.8,805.1,513.9z M803,514.4v3.1c0.3-0.1,0.7-0.1,0.9-0.3 v-3.1C803.7,514.3,803.4,514.4,803,514.4z"
  }), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M808.3,500.9c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C793.8,497.8,802.8,497.8,808.3,500.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083047090343731419480000015764394335823542413_",
    gradientUnits: "userSpaceOnUse",
    x1: 785.4481,
    y1: 225.2089,
    x2: 811.299,
    y2: 225.2089,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083047090343731419480000015764394335823542413_)"
    },
    d: "M807.5,501.4c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C794.2,498.6,802.5,498.6,807.5,501.4z"
  }), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M789.5,502.3c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C784.9,507.3,785.8,504.3,789.5,502.3z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165944808195688452970000005234857101294984073_",
    gradientUnits: "userSpaceOnUse",
    x1: 783.6691,
    y1: 227.5111,
    x2: 812.0809,
    y2: 227.5111,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165944808195688452970000005234857101294984073_)"
    },
    d: "M803.7,495.5c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C812,500,809.3,497.1,803.7,495.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000068669483251827685950000001882760076635744174_",
    gradientUnits: "userSpaceOnUse",
    x1: 784.0096,
    y1: 222.5003,
    x2: 811.7712,
    y2: 222.5003,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000068669483251827685950000001882760076635744174_)",
      enableBackground: "new"
    },
    d: " M785,506.5v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C784.2,505.4,784.6,505.9,785,506.5z M792.2,510.5v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C792.9,510.7,792.6,510.7,792.2,510.5z M796.4,511.2v3.3c0.3,0,0.7,0,0.9,0v-3.3C797.1,511.2,796.7,511.2,796.4,511.2z  M794.4,510.9v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C795,511.1,794.6,511.1,794.4,510.9z M786.1,507.7v3.1c0.3,0.3,0.7,0.5,0.9,0.8 v-3.1C786.8,508.1,786.4,507.9,786.1,507.7z M790.2,510v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C790.8,510.1,790.6,510.1,790.2,510z  M788.1,509v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C788.8,509.3,788.4,509.2,788.1,509z M798.4,511.2v3.3c0.3,0,0.7,0,0.9,0v-3.3 C799.1,511.2,798.8,511.2,798.4,511.2z M808.7,508.2v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C809.4,507.8,809,507.9,808.7,508.2z  M800.5,511.1v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C801.1,510.9,800.9,511.1,800.5,511.1z M810.8,506.3v3.1c0.4-0.5,0.8-1.2,0.9-1.9 v-3C811.6,505.2,811.2,505.8,810.8,506.3z M806.7,509.4v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C807.4,509,807,509.2,806.7,509.4z  M804.7,510.2v3.1c0.3-0.1,0.7-0.3,0.9-0.3V510C805.3,510,804.9,510.1,804.7,510.2z M802.5,510.8v3.1c0.3-0.1,0.7-0.1,0.9-0.3 v-3.1C803.2,510.7,802.9,510.7,802.5,510.8z"
  }), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M807.9,497.2c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C793.3,494,802.4,494,807.9,497.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039854644557396065880000013970701465111101313_",
    gradientUnits: "userSpaceOnUse",
    x1: 784.9327,
    y1: 228.9162,
    x2: 810.7836,
    y2: 228.9162,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039854644557396065880000013970701465111101313_)"
    },
    d: "M807,497.8c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C793.7,494.8,802,494.8,807,497.8z"
  }), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M789,498.5c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3c-5-2.8-13.3-2.8-18.3,0.1 c-3.9,2.3-4.7,5.6-2.6,8.3C784.5,503.6,785.4,500.5,789,498.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150819467869078361910000017016952404222914207_",
    gradientUnits: "userSpaceOnUse",
    x1: 676.8171,
    y1: 251.8879,
    x2: 705.2291,
    y2: 251.8879,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150819467869078361910000017016952404222914207_)"
    },
    d: "M696.9,471.1c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C705.1,475.4,702.4,472.6,696.9,471.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010992034805851181810000011160981659625736341_",
    gradientUnits: "userSpaceOnUse",
    x1: 677.1541,
    y1: 247.0126,
    x2: 704.9157,
    y2: 247.0126,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000010992034805851181810000011160981659625736341_)",
      enableBackground: "new"
    },
    d: " M678.2,481.9v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C677.4,480.9,677.8,481.4,678.2,481.9z M685.3,486.1v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C686,486.3,685.8,486.1,685.3,486.1z M689.5,486.7v3.3c0.3,0,0.7,0,0.9,0v-3.3C690.2,486.7,689.8,486.7,689.5,486.7z  M687.5,486.4v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C688.2,486.5,687.8,486.5,687.5,486.4z M679.3,483.2v3.1c0.3,0.3,0.7,0.5,0.9,0.8 V484C679.9,483.6,679.5,483.4,679.3,483.2z M683.3,485.5v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C684,485.6,683.7,485.6,683.3,485.5z  M681.3,484.5v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C682,484.8,681.6,484.6,681.3,484.5z M691.6,486.7v3.3c0.3,0,0.7,0,0.9,0v-3.3 C692.3,486.7,692,486.7,691.6,486.7z M701.9,483.7v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C702.5,483.3,702.1,483.4,701.9,483.7z  M693.6,486.5v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C694.3,486.4,694,486.5,693.6,486.5z M703.9,481.8v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C704.7,480.7,704.3,481.3,703.9,481.8z M699.8,484.9v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C700.5,484.6,700.1,484.8,699.8,484.9z  M697.8,485.7v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C698.5,485.5,698.1,485.6,697.8,485.7z M695.6,486.3v3.1 c0.3-0.1,0.7-0.1,0.9-0.3V486C696.3,486.1,696,486.1,695.6,486.3z"
  }), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M701.1,472.7c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C686.4,469.6,695.5,469.5,701.1,472.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000113347118218295327980000004893062422072678310_",
    gradientUnits: "userSpaceOnUse",
    x1: 678.0772,
    y1: 253.4035,
    x2: 703.9282,
    y2: 253.4035,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000113347118218295327980000004893062422072678310_)"
    },
    d: "M700.1,473.3c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C686.8,470.4,695.1,470.3,700.1,473.3z"
  }), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M682.1,474c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3c-5-2.8-13.3-2.8-18.3,0.1 c-3.9,2.3-4.7,5.6-2.6,8.3C677.6,479.1,678.6,476.1,682.1,474z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036947632836781291090000009237064038550120850_",
    gradientUnits: "userSpaceOnUse",
    x1: 707.3867,
    y1: 448.528,
    x2: 735.7986,
    y2: 448.528,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036947632836781291090000009237064038550120850_)"
    },
    d: "M727.5,274.5c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C735.7,278.9,732.9,276.1,727.5,274.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163073459072462140810000009295663293523312063_",
    gradientUnits: "userSpaceOnUse",
    x1: 707.7378,
    y1: 443.5172,
    x2: 735.4995,
    y2: 443.5172,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000163073459072462140810000009295663293523312063_)",
      enableBackground: "new"
    },
    d: " M708.8,285.4v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C708,284.4,708.4,284.9,708.8,285.4z M716,289.6v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C716.6,289.8,716.4,289.6,716,289.6z M720.2,290.2v3.3c0.3,0,0.7,0,0.9,0v-3.3C720.8,290.2,720.4,290.2,720.2,290.2z M718,289.9 v3.1c0.3,0,0.7,0.1,0.9,0.1V290C718.7,290,718.4,290,718,289.9z M709.9,286.7v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C710.4,287.1,710.1,286.9,709.9,286.7z M713.9,289v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C714.6,289.1,714.2,289.1,713.9,289z  M711.9,288v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C712.6,288.3,712.2,288.1,711.9,288z M722.2,290.2v3.3c0.3,0,0.7,0,0.9,0v-3.3 C722.9,290.2,722.5,290.2,722.2,290.2z M732.5,287.2v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C733.2,286.8,732.7,286.9,732.5,287.2z  M724.2,290v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C724.9,289.9,724.6,290,724.2,290z M734.5,285.3v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C735.3,284.2,734.9,284.8,734.5,285.3z M730.4,288.4v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C731.1,288.1,730.7,288.3,730.4,288.4z  M728.3,289.2v3.1c0.3-0.1,0.7-0.3,0.9-0.3V289C729,289,728.7,289.1,728.3,289.2z M726.2,289.8v3.1c0.3-0.1,0.7-0.1,0.9-0.3 v-3.1C726.9,289.6,726.7,289.6,726.2,289.8z"
  }), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M731.5,276.2c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1s-5.6-8.4,0-11.6S726,273,731.5,276.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083080666782744319550000010275704710957553075_",
    gradientUnits: "userSpaceOnUse",
    x1: 708.6607,
    y1: 449.9081,
    x2: 734.5117,
    y2: 449.9081,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083080666782744319550000010275704710957553075_)"
    },
    d: "M730.7,276.8c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C717.4,273.9,725.7,273.8,730.7,276.8z"
  }), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M712.7,277.4c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C708.1,282.6,709,279.6,712.7,277.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177477914012099632260000003746046931589300371_",
    gradientUnits: "userSpaceOnUse",
    x1: 675.423,
    y1: 59.1753,
    x2: 703.8348,
    y2: 59.1753,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000177477914012099632260000003746046931589300371_)"
    },
    d: "M695.5,663.8c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C703.8,668.3,700.9,665.3,695.5,663.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101074102430904481590000000016957326332926097_",
    gradientUnits: "userSpaceOnUse",
    x1: 675.7739,
    y1: 54.1646,
    x2: 703.5357,
    y2: 54.1646,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000101074102430904481590000000016957326332926097_)",
      enableBackground: "new"
    },
    d: " M676.8,674.8v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C676,673.7,676.3,674.2,676.8,674.8z M684,678.9v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C684.7,679,684.4,679,684,678.9z M688.2,679.5v3.3c0.3,0,0.7,0,0.9,0v-3.3C688.9,679.5,688.5,679.5,688.2,679.5z M686,679.3v3.1 c0.3,0,0.7,0.1,0.9,0.1v-3.1C686.7,679.4,686.4,679.3,686,679.3z M677.9,676v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C678.4,676.4,678.2,676.1,677.9,676z M682,678.3v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C682.6,678.4,682.2,678.4,682,678.3z  M679.9,677.4v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C680.6,677.6,680.2,677.5,679.9,677.4z M690.2,679.5v3.3c0.3,0,0.7,0,0.9,0v-3.3 C690.9,679.5,690.5,679.5,690.2,679.5z M700.5,676.5v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C701.2,676.1,700.8,676.3,700.5,676.5z  M692.3,679.4v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C692.9,679.3,692.7,679.4,692.3,679.4z M702.5,674.7v3.1c0.4-0.5,0.8-1.2,0.9-1.9 v-3C703.4,673.6,703,674.1,702.5,674.7z M698.5,677.8v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C699.2,677.4,698.8,677.5,698.5,677.8z  M696.3,678.4v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C697,678.3,696.7,678.4,696.3,678.4z M694.3,679v3.1c0.3-0.1,0.7-0.1,0.9-0.3 v-3.1C695,678.9,694.7,679,694.3,679z"
  }), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M699.6,665.6c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C685.1,662.3,694,662.3,699.6,665.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125568531029376147300000015751068658322119059_",
    gradientUnits: "userSpaceOnUse",
    x1: 676.6971,
    y1: 60.6651,
    x2: 702.548,
    y2: 60.6651,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000125568531029376147300000015751068658322119059_)"
    },
    d: "M698.8,666c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C685.5,663.1,693.7,663.1,698.8,666z"
  }), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M680.7,666.8c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C676.1,671.8,677.1,668.8,680.7,666.8z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036951762051168838480000013959626804918485423_",
    gradientUnits: "userSpaceOnUse",
    x1: 659.0129,
    y1: 10.9634,
    x2: 687.4249,
    y2: 10.9634,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036951762051168838480000013959626804918485423_)"
    },
    d: "M679.1,712c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C687.4,716.5,684.5,713.5,679.1,712z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013179298599455437500000005208455752345183418_",
    gradientUnits: "userSpaceOnUse",
    x1: 659.3639,
    y1: 5.9526,
    x2: 687.1256,
    y2: 5.9526,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000013179298599455437500000005208455752345183418_)",
      enableBackground: "new"
    },
    d: " M660.4,723v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C659.6,721.9,659.9,722.5,660.4,723z M667.6,727.1v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C668.3,727.2,668,727.2,667.6,727.1z M671.7,727.6v3.3c0.3,0,0.7,0,0.9,0v-3.3C672.3,727.7,672.1,727.6,671.7,727.6z  M669.6,727.5v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C670.3,727.6,670,727.5,669.6,727.5z M661.4,724.1v3.1c0.3,0.3,0.7,0.5,0.9,0.8 v-3.1C662.1,724.6,661.8,724.4,661.4,724.1z M665.6,726.4v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1 C666.3,726.7,665.8,726.5,665.6,726.4z M663.5,725.6v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C664.2,725.8,663.8,725.7,663.5,725.6z  M673.8,727.7v3.3c0.3,0,0.7,0,0.9,0v-3.3C674.5,727.6,674.1,727.7,673.8,727.7z M684.1,724.8v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1 C684.8,724.2,684.4,724.5,684.1,724.8z M675.9,727.6v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C676.5,727.5,676.1,727.5,675.9,727.6z  M686.2,722.9v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3C687,721.6,686.6,722.3,686.2,722.9z M682,725.8v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1 C682.6,725.6,682.4,725.7,682,725.8z M679.9,726.7v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C680.6,726.5,680.3,726.5,679.9,726.7z  M677.9,727.2v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1C678.6,727.1,678.3,727.2,677.9,727.2z"
  }), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M683.2,713.7c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C668.7,710.5,677.6,710.5,683.2,713.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023242619982981641040000003446454341468087464_",
    gradientUnits: "userSpaceOnUse",
    x1: 660.278,
    y1: 12.4531,
    x2: 686.1289,
    y2: 12.4531,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023242619982981641040000003446454341468087464_)"
    },
    d: "M682.4,714.2c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C669.1,711.4,677.2,711.4,682.4,714.2z"
  }), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M664.4,715c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3c-5-2.8-13.3-2.8-18.3,0.1 c-3.9,2.3-4.7,5.6-2.6,8.3C659.8,720,660.7,717,664.4,715z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024002467511368313040000002663685843114186681_",
    gradientUnits: "userSpaceOnUse",
    x1: 748.3731,
    y1: 13.6719,
    x2: 776.785,
    y2: 13.6719,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000024002467511368313040000002663685843114186681_)"
    },
    d: "M768.5,709.3c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C776.6,713.8,773.9,710.8,768.5,709.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054241441992897381680000002416251393652201356_",
    gradientUnits: "userSpaceOnUse",
    x1: 748.7288,
    y1: 8.6611,
    x2: 776.4915,
    y2: 8.6611,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000054241441992897381680000002416251393652201356_)",
      enableBackground: "new"
    },
    d: " M749.7,720.3v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C749,719.2,749.3,719.8,749.7,720.3z M757,724.4v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C757.7,724.5,757.3,724.5,757,724.4z M761.1,724.9v3.3c0.3,0,0.7,0,0.9,0v-3.3C761.7,725,761.5,725,761.1,724.9z M759,724.8v3.1 c0.3,0,0.7,0.1,0.9,0.1v-3.1C759.7,724.9,759.4,724.8,759,724.8z M750.8,721.4v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C751.4,721.9,751,721.6,750.8,721.4z M755,723.7v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C755.6,723.9,755.2,723.8,755,723.7z  M752.8,722.9v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C753.5,723.1,753.2,723,752.8,722.9z M763.2,725v3.3c0.3,0,0.7,0,0.9,0V725 C763.8,724.9,763.5,725,763.2,725z M773.4,722.1v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C774.2,721.5,773.8,721.8,773.4,722.1z  M765.3,724.9v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C765.9,724.8,765.5,724.9,765.3,724.9z M775.5,720.2v3.1c0.4-0.5,0.8-1.2,0.9-1.9 v-3C776.2,718.9,775.9,719.6,775.5,720.2z M771.3,723.1v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C772,722.9,771.8,723,771.3,723.1z  M769.3,723.9v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C770,723.8,769.7,723.8,769.3,723.9z M767.3,724.5v3.1c0.3-0.1,0.7-0.1,0.9-0.3 v-3.1C768,724.4,767.6,724.5,767.3,724.5z"
  }), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M772.6,710.9c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 S767,707.8,772.6,710.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000164504679259525230180000003264245024714216374_",
    gradientUnits: "userSpaceOnUse",
    x1: 749.6597,
    y1: 15.1616,
    x2: 775.5106,
    y2: 15.1616,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000164504679259525230180000003264245024714216374_)"
    },
    d: "M771.8,711.5c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C758.5,708.6,766.6,708.6,771.8,711.5z"
  }), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M753.6,712.3c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C749.1,717.3,750.1,714.3,753.6,712.3z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067198341229703879200000000574398531403772863_",
    gradientUnits: "userSpaceOnUse",
    x1: 530.9623,
    y1: 503.7822,
    x2: 559.3743,
    y2: 503.7822,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067198341229703879200000000574398531403772863_)"
    },
    d: "M551,219.2c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C559.3,223.7,556.6,220.8,551,219.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101095394841827428740000012593201883227650972_",
    gradientUnits: "userSpaceOnUse",
    x1: 531.304,
    y1: 498.7714,
    x2: 559.0656,
    y2: 498.7714,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000101095394841827428740000012593201883227650972_)",
      enableBackground: "new"
    },
    d: " M532.3,230.2v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C531.5,229.1,531.9,229.6,532.3,230.2z M539.5,234.2v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C540.2,234.4,539.9,234.4,539.5,234.2z M543.7,234.9v3.3c0.3,0,0.7,0,0.9,0v-3.3C544.4,234.9,544,234.9,543.7,234.9z  M541.7,234.7v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C542.3,234.8,541.9,234.8,541.7,234.7z M533.4,231.4v3.1c0.3,0.3,0.7,0.5,0.9,0.8 v-3.1C534.1,231.8,533.7,231.7,533.4,231.4z M537.5,233.7v3.1c0.3,0.1,0.7,0.3,0.9,0.3V234C538.1,233.8,537.9,233.8,537.5,233.7 z M535.4,232.8v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C536.1,233,535.7,232.9,535.4,232.8z M545.7,234.9v3.3c0.3,0,0.7,0,0.9,0v-3.3 C546.4,234.9,546.1,234.9,545.7,234.9z M556,231.9v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C556.7,231.5,556.3,231.7,556,231.9z  M547.8,234.8v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C548.4,234.7,548.2,234.8,547.8,234.8z M558,230v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C558.9,229,558.5,229.5,558,230z M554,233.2v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C554.7,232.8,554.3,233,554,233.2z M552,234v3.1 c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C552.6,233.7,552.2,233.8,552,234z M549.8,234.5v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1 C550.5,234.4,550.2,234.4,549.8,234.5z"
  }), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M555.2,221c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1s-5.6-8.4,0-11.6 C540.6,217.9,549.7,217.7,555.2,221z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173877422393518119660000000982837244536382138_",
    gradientUnits: "userSpaceOnUse",
    x1: 532.2272,
    y1: 505.1873,
    x2: 558.0781,
    y2: 505.1873,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173877422393518119660000000982837244536382138_)"
    },
    d: "M554.3,221.5c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C541,218.5,549.2,218.5,554.3,221.5z"
  }), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M536.2,222.2c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C531.8,227.3,532.7,224.2,536.2,222.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078728751467650370240000014949898691820527279_",
    gradientUnits: "userSpaceOnUse",
    x1: 339.2467,
    y1: 20.8495,
    x2: 367.6586,
    y2: 20.8495,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078728751467650370240000014949898691820527279_)"
    },
    d: "M359.4,702.1c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C367.5,706.6,364.8,703.6,359.4,702.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000040544533724063174830000007144237885234037393_",
    gradientUnits: "userSpaceOnUse",
    x1: 339.6039,
    y1: 15.8388,
    x2: 367.3665,
    y2: 15.8388,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000040544533724063174830000007144237885234037393_)",
      enableBackground: "new"
    },
    d: " M340.6,713.1v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C339.9,712,340.1,712.6,340.6,713.1z M347.9,717.2v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C348.5,717.3,348.1,717.2,347.9,717.2z M351.9,717.7v3.3c0.3,0,0.7,0,0.9,0v-3.3C352.6,717.9,352.3,717.7,351.9,717.7z  M349.9,717.6v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C350.6,717.7,350.3,717.6,349.9,717.6z M341.6,714.2v3.1c0.3,0.3,0.7,0.5,0.9,0.8 V715C342.3,714.7,341.9,714.5,341.6,714.2z M345.8,716.5v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C346.5,716.8,346.1,716.6,345.8,716.5 z M343.7,715.6v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C344.3,716,344.1,715.8,343.7,715.6z M354.1,717.9v3.3c0.3,0,0.7,0,0.9,0v-3.3 C354.6,717.7,354.4,717.7,354.1,717.9z M364.3,714.9v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C365.1,714.3,364.7,714.6,364.3,714.9z  M356.1,717.7v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C356.8,717.6,356.4,717.6,356.1,717.7z M366.4,713v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C367.1,711.8,366.8,712.4,366.4,713z M362.2,716v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C362.9,715.7,362.6,715.8,362.2,716z  M360.2,716.8v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C360.9,716.6,360.6,716.6,360.2,716.8z M358.2,717.3v3.1 c0.3-0.1,0.7-0.1,0.9-0.3V717C358.8,717.2,358.4,717.3,358.2,717.3z"
  }), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M363.4,703.8c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C348.9,700.7,357.9,700.7,363.4,703.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132080900335254596540000002624574290892908958_",
    gradientUnits: "userSpaceOnUse",
    x1: 340.5349,
    y1: 22.3393,
    x2: 366.3858,
    y2: 22.3393,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132080900335254596540000002624574290892908958_)"
    },
    d: "M362.6,704.3c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C349.4,701.5,357.5,701.5,362.6,704.3z"
  }), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M344.5,705.1c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3 c-5-2.8-13.3-2.8-18.3,0.1c-3.9,2.3-4.7,5.6-2.6,8.3C340,710.1,341,707.2,344.5,705.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124879285381382866970000013963808522944279180_",
    gradientUnits: "userSpaceOnUse",
    x1: 299.7216,
    y1: -2.0377,
    x2: 328.1336,
    y2: -2.0377,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124879285381382866970000013963808522944279180_)"
    },
    d: "M319.8,725c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C328.1,729.4,325.2,726.5,319.8,725z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083050081397940269980000003159753186779132858_",
    gradientUnits: "userSpaceOnUse",
    x1: 300.0727,
    y1: -7.0484,
    x2: 327.8343,
    y2: -7.0484,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000083050081397940269980000003159753186779132858_)",
      enableBackground: "new"
    },
    d: " M301.1,736v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C300.3,734.9,300.6,735.5,301.1,736z M308.3,740.1v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C309,740.2,308.6,740.1,308.3,740.1z M312.4,740.6v3.3c0.3,0,0.7,0,0.9,0v-3.3C313.1,740.7,312.8,740.6,312.4,740.6z  M310.4,740.5v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C311,740.6,310.8,740.5,310.4,740.5z M302.1,737.1v3.1c0.3,0.3,0.7,0.5,0.9,0.8 v-3.1C302.8,737.6,302.5,737.4,302.1,737.1z M306.3,739.4v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C307,739.7,306.6,739.5,306.3,739.4z  M304.3,738.4v3.1c0.3,0.1,0.7,0.3,0.9,0.5V739C304.9,738.8,304.5,738.7,304.3,738.4z M314.5,740.7v3.3c0.3,0,0.7,0,0.9,0v-3.3 C315.2,740.6,314.8,740.6,314.5,740.7z M324.8,737.8v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C325.5,737.2,325.1,737.5,324.8,737.8z  M316.6,740.6v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C317.3,740.5,316.9,740.5,316.6,740.6z M326.9,735.9v3.1c0.4-0.5,0.8-1.2,0.9-1.9 v-3C327.6,734.6,327.3,735.3,326.9,735.9z M322.7,738.8v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C323.4,738.6,323.1,738.7,322.7,738.8z  M320.6,739.7v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C321.3,739.5,321.1,739.5,320.6,739.7z M318.6,740.2v3.1 c0.3-0.1,0.7-0.1,0.9-0.3v-3.1C319.3,740.1,319,740.2,318.6,740.2z"
  }), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M323.9,726.7c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C309.4,723.5,318.3,723.5,323.9,726.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000144333499983120214290000010589703436532661691_",
    gradientUnits: "userSpaceOnUse",
    x1: 300.9901,
    y1: -0.5479,
    x2: 326.8411,
    y2: -0.5479,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000144333499983120214290000010589703436532661691_)"
    },
    d: "M323.1,727.2c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C309.8,724.4,317.9,724.4,323.1,727.2z"
  }), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M305.1,728c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3c-5-2.8-13.3-2.8-18.3,0.1 c-3.9,2.3-4.7,5.6-2.6,8.3C300.5,733,301.4,730,305.1,728z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000094586422911906247630000007310056754607638938_",
    gradientUnits: "userSpaceOnUse",
    x1: 234.0545,
    y1: 650.8559,
    x2: 262.4662,
    y2: 650.8559,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000094586422911906247630000007310056754607638938_)"
    },
    d: "M254.1,72.1c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C262.4,76.6,259.6,73.8,254.1,72.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016767144000549616280000014386004733656632746_",
    gradientUnits: "userSpaceOnUse",
    x1: 234.4055,
    y1: 645.8451,
    x2: 262.1671,
    y2: 645.8451,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000016767144000549616280000014386004733656632746_)",
      enableBackground: "new"
    },
    d: " M235.5,83.1v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C234.6,82,234.9,82.6,235.5,83.1z M242.6,87.2v3.1c0.3,0.1,0.7,0.1,0.9,0.3v-3.1 C243.3,87.3,243,87.3,242.6,87.2z M246.8,87.8v3.3c0.3,0,0.7,0,0.9,0v-3.3C247.4,87.8,247.1,87.8,246.8,87.8z M244.7,87.6v3.1 c0.3,0,0.7,0.1,0.9,0.1v-3.1C245.3,87.7,245.1,87.7,244.7,87.6z M236.4,84.3v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C237.1,84.7,236.8,84.6,236.4,84.3z M240.6,86.6v3.1c0.3,0.1,0.7,0.3,0.9,0.3v-3.1C241.3,86.8,240.9,86.8,240.6,86.6z  M238.6,85.7v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C239.3,86,238.8,85.8,238.6,85.7z M248.9,87.8v3.3c0.3,0,0.7,0,0.9,0v-3.3 C249.5,87.8,249.1,87.8,248.9,87.8z M259.2,84.9V88c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C259.8,84.5,259.4,84.6,259.2,84.9z  M250.9,87.7v3.1c0.3,0,0.7-0.1,0.9-0.1v-3.1C251.6,87.6,251.2,87.7,250.9,87.7z M261.2,83v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C262,81.9,261.6,82.4,261.2,83z M257,86.1v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C257.8,85.7,257.4,86,257,86.1z M255,86.9V90 c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C255.6,86.6,255.4,86.8,255,86.9z M252.9,87.4v3.1c0.3-0.1,0.7-0.1,0.9-0.3v-3.1 C253.6,87.3,253.3,87.3,252.9,87.4z"
  }), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M258.2,73.9c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6 C243.7,70.8,252.7,70.6,258.2,73.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001664773443856618640000007009704621667580033_",
    gradientUnits: "userSpaceOnUse",
    x1: 235.3081,
    y1: 652.261,
    x2: 261.1589,
    y2: 652.261,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001664773443856618640000007009704621667580033_)"
    },
    d: "M257.4,74.4c5,2.8,5.1,7.6,0,10.6 c-5,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C244.1,71.5,252.3,71.5,257.4,74.4z"
  }), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M239.4,75.1c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3c-5-2.8-13.3-2.8-18.3,0.1 c-3.9,2.3-4.7,5.6-2.6,8.3C234.8,80.3,235.7,77.1,239.4,75.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114795953666066368340000017736765362819192720_",
    gradientUnits: "userSpaceOnUse",
    x1: 230.9264,
    y1: 632.7087,
    x2: 259.3383,
    y2: 632.7087,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114795953666066368340000017736765362819192720_)"
    },
    d: "M251,90.3c-3.8-1.1-8-1.1-11.8,0 c-5.4,1.6-8.3,4.5-8.3,7.4c0,1.1,0,2.2,0,3.3c0.1,3,2.8,5.8,8.3,7.3c3.8,1.1,8,1.1,11.8,0c5.4-1.6,8.3-4.5,8.3-7.4 c0-1.1,0-2.2,0-3.3C259.3,94.8,256.5,91.9,251,90.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160190412485399653830000002385142557136940689_",
    gradientUnits: "userSpaceOnUse",
    x1: 231.2773,
    y1: 627.6979,
    x2: 259.0388,
    y2: 627.6979,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000160190412485399653830000002385142557136940689_)",
      enableBackground: "new"
    },
    d: " M232.3,101.3v3.1c-0.4-0.5-0.8-1.2-0.9-1.8v-3C231.5,100.2,231.8,100.7,232.3,101.3z M239.5,105.3v3.1c0.3,0.1,0.7,0.1,0.9,0.3 v-3.1C240.2,105.5,239.8,105.5,239.5,105.3z M243.6,106v3.3c0.3,0,0.7,0,0.9,0V106C244.3,106,244,106,243.6,106z M241.6,105.7 v3.1c0.3,0,0.7,0.1,0.9,0.1v-3.1C242.2,105.9,242,105.9,241.6,105.7z M233.3,102.5v3.1c0.3,0.3,0.7,0.5,0.9,0.8v-3.1 C234,102.9,233.7,102.7,233.3,102.5z M237.5,104.8v3.1c0.3,0.1,0.7,0.3,0.9,0.3V105C238.2,104.9,237.8,104.9,237.5,104.8z  M235.5,103.8v3.1c0.3,0.1,0.7,0.3,0.9,0.5v-3.1C236.1,104.1,235.7,104,235.5,103.8z M245.8,106v3.3c0.3,0,0.7,0,0.9,0V106 C246.4,106,246,106,245.8,106z M256,103v3.1c0.4-0.3,0.7-0.5,0.9-0.8v-3.1C256.7,102.6,256.3,102.7,256,103z M247.8,105.9v3.1 c0.3,0,0.7-0.1,0.9-0.1v-3.1C248.5,105.7,248.1,105.9,247.8,105.9z M258.1,101.1v3.1c0.4-0.5,0.8-1.2,0.9-1.9v-3 C258.8,100,258.5,100.6,258.1,101.1z M253.9,104.2v3.1c0.4-0.1,0.7-0.3,0.9-0.5v-3.1C254.6,103.8,254.3,104.1,253.9,104.2z  M251.8,105v3.1c0.3-0.1,0.7-0.3,0.9-0.3v-3.1C252.5,104.8,252.3,104.9,251.8,105z M249.8,105.6v3.1c0.3-0.1,0.7-0.1,0.9-0.3 v-3.1C250.5,105.5,250.2,105.5,249.8,105.6z"
  }), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M255.1,92c5.6,3.1,5.6,8.4,0,11.6c-5.6,3.3-14.5,3.3-20,0.1c-5.6-3.1-5.6-8.4,0-11.6S249.5,88.8,255.1,92z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159440670803600280970000007361664095611531949_",
    gradientUnits: "userSpaceOnUse",
    x1: 232.1933,
    y1: 634.1138,
    x2: 258.0442,
    y2: 634.1138,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE89B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000159440670803600280970000007361664095611531949_)"
    },
    d: "M254.3,92.6c5,2.8,5.1,7.6,0,10.6 c-5.1,3-13.3,3-18.3,0.1c-5-2.8-5.1-7.6,0-10.6C241,89.6,249.1,89.6,254.3,92.6z"
  }), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M236.3,93.3c4.9-2.8,12.9-2.8,17.7-0.1c3.5,2,4.6,5,3,7.6c2-2.7,1.2-6.1-2.7-8.3c-5-2.8-13.3-2.8-18.3,0.1 c-3.9,2.3-4.7,5.6-2.6,8.3C231.7,98.4,232.6,95.3,236.3,93.3z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "_x33__2_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M940.2,611.7c-0.7-1.5-1.6-3-2.7-4.2c-0.9-1.1-1.9-1.9-3-2.6c-16-9.2-82.5-47.7-95.9-55.4 c-1.9-1.1-3.7-1.2-4.9-0.5l-4.5,2.8c1.2-0.7,3-0.7,4.9,0.5c13.4,7.7,79.9,46,95.9,55.4c1.1,0.7,2,1.5,3,2.6 c1.1,1.2,2,2.7,2.7,4.2c0.8,1.8,1.2,3.5,1.2,5.1l4.5-2.8C941.4,615.2,940.9,613.3,940.2,611.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M937.5,607.5l-4.5,2.8c1.1,1.2,2,2.7,2.7,4.2l4.5-2.8C939.5,610.2,938.6,608.7,937.5,607.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.1,607.8c-16-9.2-82.5-47.7-95.9-55.4c-3.8-2.2-6.9-0.4-6.9,3.9v6.2c0,4.3,3,9.6,6.8,11.8 c16.1,9.3,82.6,47.7,96,55.4l6.9-3.9v-6.2C937,615.2,933.9,609.9,930.1,607.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M875.8,654.9v6.2c0,2.2-0.8,3.7-2,4.5l58.4-33.9c1.2-0.7,2-2.3,2-4.5V621L875.8,654.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M932.9,615.9c-0.7-1.5-1.6-3-2.7-4.2c-0.9-1.1-1.9-1.9-3-2.6c-16-9.2-94.5-54.6-107.8-62.3 c-1.9-1.1-3.7-1.2-4.9-0.5l-58.4,33.9c1.2-0.7,3-0.7,4.9,0.5c13.4,7.7,91.8,53.1,107.8,62.3c1.1,0.7,2,1.5,3,2.6 c1.1,1.2,2,2.7,2.7,4.2c0.8,1.8,1.2,3.5,1.2,5.1l58.4-33.9C934.1,619.3,933.7,617.5,932.9,615.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M930.3,611.7L872,645.5c1.1,1.2,2,2.7,2.7,4.2l58.4-33.9C932.2,614.4,931.4,612.9,930.3,611.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869,643.1c3.8,2.2,6.8,7.4,6.8,11.8v6.2c0,4.3-3.1,6.1-6.9,3.9c-13.4-7.7-91.8-53.1-107.8-62.3 c-3.8-2.2-6.8-7.4-6.8-11.8v-6.2c0-4.3,3.1-6.1,6.9-3.9C774.5,588.5,853,633.9,869,643.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st186",
    points: "863.2,578.2 816.4,605.2 781.2,584.7 828,557.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st187",
    points: "828,560.4 861,579.4 863.2,578.2 828,557.8 781.2,584.7 783.4,586.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M877.7,592.9l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-0.8-0.5-1.2-1.1-1.2-1.8v1.5 c0,0.7,0.4,1.2,1.2,1.8l3,1.8c1.6,0.9,4.3,0.9,6,0l4.9-2.8c0.8-0.5,1.2-1.1,1.2-1.8v-1.5 C878.9,591.8,878.5,592.3,877.7,592.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M877.7,589.3c1.6,0.9,1.6,2.6,0,3.5l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-1.6-0.9-1.6-2.6,0-3.5 l4.9-2.8c1.6-0.9,4.3-0.9,6,0L877.7,589.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M861.5,602.2l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-0.8-0.5-1.2-1.1-1.2-1.8v1.5 c0,0.7,0.4,1.2,1.2,1.8l3,1.8c1.6,0.9,4.3,0.9,6,0l4.9-2.8c0.8-0.5,1.2-1.1,1.2-1.8v-1.5 C862.8,601.1,862.4,601.7,861.5,602.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M861.5,598.7c1.6,0.9,1.6,2.6,0,3.5l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-1.6-0.9-1.6-2.6,0-3.5 l4.9-2.8c1.6-0.9,4.3-0.9,6,0L861.5,598.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M845.4,611.5l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-0.8-0.5-1.2-1.1-1.2-1.8v1.5 c0,0.7,0.4,1.2,1.2,1.8l3,1.8c1.6,0.9,4.3,0.9,6,0l4.9-2.8c0.8-0.5,1.2-1.1,1.2-1.8v-1.5C846.6,610.5,846.2,611,845.4,611.5 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M845.4,608c1.6,0.9,1.6,2.6,0,3.5l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-1.6-0.9-1.6-2.6,0-3.5 l4.9-2.8c1.6-0.9,4.3-0.9,6,0L845.4,608z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M888.9,599.4l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-0.8-0.5-1.2-1.1-1.2-1.8v1.5 c0,0.7,0.4,1.2,1.2,1.8l3,1.8c1.6,0.9,4.3,0.9,6,0l4.9-2.8c0.8-0.5,1.2-1.1,1.2-1.8v-1.5 C890.1,598.3,889.7,598.8,888.9,599.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M888.9,595.8c1.6,0.9,1.6,2.6,0,3.5l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-1.6-0.9-1.6-2.6,0-3.5 l4.9-2.8c1.6-0.9,4.3-0.9,6,0L888.9,595.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M872.8,608.7l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-0.8-0.5-1.2-1.1-1.2-1.8v1.5 c0,0.7,0.4,1.2,1.2,1.8l3,1.8c1.6,0.9,4.3,0.9,6,0l4.9-2.8c0.8-0.5,1.2-1.1,1.2-1.8v-1.5C874,607.5,873.6,608.2,872.8,608.7 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M872.8,605.2c1.6,0.9,1.6,2.6,0,3.5l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-1.6-0.9-1.6-2.6,0-3.5 l4.9-2.8c1.6-0.9,4.3-0.9,6,0L872.8,605.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M856.7,618l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-0.8-0.5-1.2-1.1-1.2-1.8v1.5 c0,0.7,0.4,1.2,1.2,1.8l3,1.8c1.6,0.9,4.3,0.9,6,0l4.9-2.8c0.8-0.5,1.2-1.1,1.2-1.8v-1.5C857.9,617,857.5,617.5,856.7,618z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M856.7,614.5c1.6,0.9,1.6,2.6,0,3.5l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-1.6-0.9-1.6-2.6,0-3.5 l4.9-2.8c1.6-0.9,4.3-0.9,6,0L856.7,614.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M900.1,605.9l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-0.8-0.5-1.2-1.1-1.2-1.8v1.5 c0,0.7,0.4,1.2,1.2,1.8l3,1.8c1.6,0.9,4.3,0.9,6,0l4.9-2.8c0.8-0.5,1.2-1.1,1.2-1.8v-1.5 C901.4,604.8,900.9,605.3,900.1,605.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M900.1,602.3c1.6,0.9,1.6,2.6,0,3.5l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-1.6-0.9-1.6-2.6,0-3.5 l4.9-2.8c1.6-0.9,4.3-0.9,6,0L900.1,602.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M884,615.2l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-0.8-0.5-1.2-1.1-1.2-1.8v1.5 c0,0.7,0.4,1.2,1.2,1.8l3,1.8c1.6,0.9,4.3,0.9,6,0l4.9-2.8c0.8-0.5,1.2-1.1,1.2-1.8v-1.5C885.2,614,884.8,614.7,884,615.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M884,611.7c1.6,0.9,1.6,2.6,0,3.5l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-1.6-0.9-1.6-2.6,0-3.5 l4.9-2.8c1.6-0.9,4.3-0.9,6,0L884,611.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M867.9,624.5l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-0.8-0.5-1.2-1.1-1.2-1.8v1.5 c0,0.7,0.4,1.2,1.2,1.8l3,1.8c1.6,0.9,4.3,0.9,6,0l4.9-2.8c0.8-0.5,1.2-1.1,1.2-1.8v-1.5C869.1,623.5,868.7,624,867.9,624.5 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M867.9,621c1.6,0.9,1.6,2.6,0,3.5l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-1.6-0.9-1.6-2.6,0-3.5 l4.9-2.8c1.6-0.9,4.3-0.9,6,0L867.9,621z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M911.4,612.4l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-0.8-0.5-1.2-1.1-1.2-1.8v1.5 c0,0.7,0.4,1.2,1.2,1.8l3,1.8c1.6,0.9,4.3,0.9,6,0l4.9-2.8c0.8-0.5,1.2-1.1,1.2-1.8v-1.5 C912.6,611.1,912.2,611.8,911.4,612.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M911.4,608.8c1.6,0.9,1.6,2.6,0,3.5l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-1.6-0.9-1.6-2.6,0-3.5 l4.9-2.8c1.6-0.9,4.3-0.9,6,0L911.4,608.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "M895.3,621.6l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-0.8-0.5-1.2-1.1-1.2-1.8v1.5 c0,0.7,0.4,1.2,1.2,1.8l3,1.8c1.6,0.9,4.3,0.9,6,0l4.9-2.8c0.8-0.5,1.2-1.1,1.2-1.8v-1.5 C896.5,620.5,896.1,621.2,895.3,621.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M895.3,618.2c1.6,0.9,1.6,2.6,0,3.5l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-1.6-0.9-1.6-2.6,0-3.5 l4.9-2.8c1.6-0.9,4.3-0.9,6,0L895.3,618.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st190",
    d: "M879.1,631l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-0.8-0.5-1.2-1.1-1.2-1.8v1.5 c0,0.7,0.4,1.2,1.2,1.8l3,1.8c1.6,0.9,4.3,0.9,6,0l4.9-2.8c0.8-0.5,1.2-1.1,1.2-1.8v-1.5C880.4,629.8,880,630.5,879.1,631z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st191",
    d: "M879.1,627.5c1.6,0.9,1.6,2.6,0,3.5l-4.9,2.8c-1.6,0.9-4.3,0.9-6,0l-3-1.8c-1.6-0.9-1.6-2.6,0-3.5 l4.9-2.8c1.6-0.9,4.3-0.9,6,0L879.1,627.5z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M829.7,604.4c0.8,0.5,0.8,1.4,0,1.8l-2.6,1.5c-0.8,0.5-2.3,0.5-3.1,0l-1.5-0.9c-0.8-0.5-0.8-1.4,0-1.8 l2.6-1.5c0.8-0.5,2.3-0.5,3.1,0L829.7,604.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M830.4,606.4v-1.1c0,0.3-0.3,0.7-0.7,0.9l-2.6,1.5c-0.8,0.5-2.3,0.5-3.1,0l-1.5-0.9 c-0.4-0.3-0.7-0.5-0.7-0.9v1.1c0,0.3,0.3,0.7,0.7,0.9l1.5,0.9c0.8,0.5,2.3,0.5,3.1,0l2.6-1.5 C830.1,607.1,830.4,606.8,830.4,606.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M842.3,597.2c0.8,0.5,0.8,1.4,0,1.8l-2.6,1.5c-0.8,0.5-2.3,0.5-3.1,0l-1.5-0.9c-0.8-0.5-0.8-1.4,0-1.8 l2.6-1.5c0.8-0.5,2.3-0.5,3.1,0L842.3,597.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M842.9,599.2v-1.1c0,0.3-0.3,0.7-0.7,0.9l-2.6,1.5c-0.8,0.5-2.3,0.5-3.1,0l-1.5-0.9 c-0.4-0.3-0.7-0.5-0.7-0.9v1.1c0,0.3,0.3,0.7,0.7,0.9l1.5,0.9c0.8,0.5,2.3,0.5,3.1,0l2.6-1.5 C842.7,599.9,842.9,599.5,842.9,599.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M854.8,590c0.8,0.5,0.8,1.4,0,1.8l-2.6,1.5c-0.8,0.5-2.3,0.5-3.1,0l-1.5-0.9c-0.8-0.5-0.8-1.4,0-1.8 l2.6-1.5c0.8-0.5,2.3-0.5,3.1,0L854.8,590z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M855.4,592V591c0,0.3-0.3,0.7-0.7,0.9l-2.6,1.5c-0.8,0.5-2.3,0.5-3.1,0l-1.5-0.9 c-0.4-0.3-0.7-0.5-0.7-0.9v1.1c0,0.3,0.3,0.7,0.7,0.9l1.5,0.9c0.8,0.5,2.3,0.5,3.1,0l2.6-1.5 C855.2,592.6,855.4,592.3,855.4,592z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M867.2,582.7c0.8,0.5,0.8,1.4,0,1.8l-2.6,1.5c-0.8,0.5-2.3,0.5-3.1,0L860,585c-0.8-0.5-0.8-1.4,0-1.8 l2.6-1.5c0.8-0.5,2.3-0.5,3.1,0L867.2,582.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M867.9,584.7v-1.1c0,0.3-0.3,0.7-0.7,0.9l-2.6,1.5c-0.8,0.5-2.3,0.5-3.1,0l-1.5-0.9 c-0.4-0.3-0.7-0.5-0.7-0.9v1.1c0,0.3,0.3,0.7,0.7,0.9l1.5,0.9c0.8,0.5,2.3,0.5,3.1,0l2.6-1.5 C867.8,585.4,867.9,585.1,867.9,584.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "927.9,627.7 883.5,653.3 883.5,656 927.9,630.4  "
  }), /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M928.2,634.3l-37.5,21.8c-1.9,1.1-5,1.1-7,0v0.9c1.9,1.1,5.1,1.1,7,0l37.5-21.8c0.9-0.5,1.5-1.2,1.5-2 v-0.9C929.5,632.9,929.1,633.8,928.2,634.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M928,630.2c1.9,1.1,1.9,3,0,4.1l-37.5,21.8c-1.9,1.1-5,1.1-7,0L928,630.2z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M932.2,622.1v6.2c0,2.2-0.8,3.7-2,4.5l9.2-5.3c1.2-0.7,2-2.3,2-4.5v-6.2L932.2,622.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_x39__1_"
  }, _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube_5_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Cube_face_-_left_308_",
    points: "126,277.1 149.8,290.9 149.8,411.2 126,397.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Cube_face_-_right_314_",
    className: "st1",
    points: "194,385.7 149.8,411.2 149.8,290.9 194,265.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Cube_face_-_top_308_",
    className: "st1",
    points: "149.8,290.9 126,277.1 170.1,251.7 194,265.3  "
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube_4_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Cube_face_-_left_240_",
    className: "st192",
    points: "149.8,411.2 160.1,417.2 160.1,342 149.8,335.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Cube_face_-_right_246_",
    className: "st193",
    points: "208.4,389.3 160.1,417.2 160.1,342 208.4,314.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Cube_face_-_top_240_",
    className: "st194",
    points: "160.1,342 149.8,335.9 198.2,308 208.4,314.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st195",
    points: "207.2,313.3 198.2,308 149.8,335.9 158.9,341.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_x34__2_"
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "_x35__1_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st193",
    points: "153.2,258.6 201.4,230.7 208.3,310.6 160.1,338.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st194",
    points: "143.2,252.7 191.2,224.8 201.4,230.7 153.2,258.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st192",
    points: "150.1,332.8 160.1,338.6 153.2,258.6 143.2,252.7 143.2,252.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st186",
    points: "197.3,237.7 158.9,260.1 162,297.6 200.6,275.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st192",
    points: "197.3,237.7 196.5,238.1 199.6,274.7 162,296.6 162,297.6 200.6,275.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st194",
    points: "199.6,274.7 162,296.6 162,297.6 200.6,275.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st194",
    d: "M166.1,268.2c1.6-0.9,3.3-1.5,3.5,0.8v0.3c0.1,0.8-0.3,1.6-0.8,2.3c0.8-0.1,1.4,0.3,1.4,1.2v0.3 c0.1,2.3-1.5,3.8-3.1,4.7l-3.4,2l-0.8-9.6L166.1,268.2z M165,270.6l0.1,2.2l1.2-0.7c0.5-0.3,1.1-0.8,1.1-1.6v-0.1 c0-0.8-0.7-0.7-1.2-0.3L165,270.6z M165.4,274.4l0.1,2.3l1.4-0.8c0.5-0.3,1.2-0.9,1.1-1.8V274c-0.1-0.8-0.7-0.7-1.4-0.4 L165.4,274.4z M175.7,262.6l3.3,8.1l-2.2,1.4l-0.7-1.8l-2.4,1.5l-0.3,2.3l-2.3,1.4l1.8-11.1L175.7,262.6z M173.9,269.8l1.6-0.9 l-1.1-3.1L173.9,269.8z M187.3,266l-2.2,1.2l-3.8-4.1l0.3,1.9l0.3,4.1l-2,1.1l-0.8-9.6l2.2-1.2l3.8,4.1l-0.3-1.9l-0.3-4.1 l2-1.1L187.3,266z M190.3,258.2l2.2-5.1l2.6-1.5l-2.4,5.4l3.3,4.1l-2.3,1.4l-2.2-2.8l-0.8,1.6l0.3,2.7l-2,1.2l-0.8-9.6l2-1.2 L190.3,258.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013151416916101501680000007662002028715934645_",
    gradientUnits: "userSpaceOnUse",
    x1: 176.7131,
    y1: 439.9308,
    x2: 191.8047,
    y2: 413.7913,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D4D8D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#D2D5D4"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000013151416916101501680000007662002028715934645_)"
    },
    points: "167.7,297.3 200.7,278.2  200.7,312.9 167.8,332.1  "
  }), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st194",
    points: "165,295.8 198,276.6 200.7,278.2 167.7,297.3  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st192",
    points: "167.7,297.3 167.8,332.1 165,295.8  "
  }))), /*#__PURE__*/React.createElement("g", null, _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "185.7,312.5 169.4,321.8 169.4,324.5 185.7,315.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000147907231644254046620000001796540810096355983_",
    points: "186.4,312.1 186.4,316 169.4,325.9  169.4,321.8  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000145772096798499918710000003118104636349272228_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147907231644254046620000001796540810096355983_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000145772096798499918710000003118104636349272228_)"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st192",
    points: "186.4,312.1 184.2,310.7 184.2,314.8 186.4,316  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st194",
    points: "186.4,316 169.4,325.9 167.3,324.5 184.2,314.8  "
  })))))))), /*#__PURE__*/React.createElement("g", null, _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "198.4,294.1 187.5,300.4 187.6,303.1 198.4,296.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000152223525696709860670000014293700049310594733_",
    points: "199.1,293.6 199.2,297.6 187.6,304.3  187.5,300.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000182513926166858223030000011428292076700331191_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152223525696709860670000014293700049310594733_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182513926166858223030000011428292076700331191_)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142891522838672853020000014882844752331692460_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.9669,
    y1: 438.4141,
    x2: 197.2862,
    y2: 435.5033,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#858E8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#858E8D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000142891522838672853020000014882844752331692460_)"
    },
    points: "199.1,293.6  197.1,292.4 197.1,296.4 199.2,297.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103232987521884890780000009238994745237469605_",
    gradientUnits: "userSpaceOnUse",
    x1: 191.7933,
    y1: 432.5755,
    x2: 192.8394,
    y2: 430.7636,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#497775"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#637E77"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000103232987521884890780000009238994745237469605_)"
    },
    points: "199.2,297.6  187.6,304.3 185.4,303.1 197.1,296.4  "
  }))))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000052080202059483470340000002814833837967656607_",
    points: "199.1,293.6 199.2,297.6 187.6,304.3  187.5,300.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000066502431248907563800000011702670214474390712_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052080202059483470340000002814833837967656607_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000066502431248907563800000011702670214474390712_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000062178454721379287480000011572122090396807586_",
    points: "199.2,297.6 187.6,304.3 185.4,303.1  197.1,296.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000046302268790702617340000011238034426367806395_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000062178454721379287480000011572122090396807586_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      clipPath: "url(#SVGID_00000046302268790702617340000011238034426367806395_)",
      fill: "#858E8D",
      enableBackground: "new"
    },
    d: " M199.2,295.7l-13.4,7.7v-0.1L199.2,295.7L199.2,295.7z M199.6,295.8l-13.4,7.7v0.1L199.6,295.8L199.6,295.8z M200.2,296.1 l-13.4,7.7v0.1L200.2,296.1L200.2,296.1z M200.6,296.5l-13.4,7.7v0.1L200.6,296.5L200.6,296.5z"
  })))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st204",
    d: "M187.5,292c0-1.9,1.4-4.1,2.8-5l6.4-3.7c0.4-0.3,0.8-0.4,1.1-0.4c0.8,0,1.2,0.7,1.2,1.8v4.9l-11.6,6.8 L187.5,292z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st205",
    points: "197.9,287.8 188.8,293.1 188.8,292.4 197.9,287.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st197",
    points: "197.7,287.7 197.7,287.3 188.8,292.4 188.8,292.8  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st206",
    d: "M198,284.6c0,0.3-0.3,0.7-0.5,0.9c-0.3,0.1-0.5,0.1-0.5-0.3c0-0.3,0.3-0.7,0.5-0.9 C197.7,284.2,198,284.3,198,284.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M197.9,284.6c0,0.3-0.3,0.5-0.4,0.7c-0.3,0.1-0.4,0-0.4-0.1c0-0.3,0.3-0.5,0.4-0.7 S197.9,284.3,197.9,284.6z"
  })))))), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M152.6,371.4v-42.3l-2.8-1.6v43.1C150.8,370.8,151.7,371.1,152.6,371.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_x31_4_1_"
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube_2_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Cube_face_-_left_478_",
    className: "st207",
    points: "278.5,534.9 222.3,502.4 222.3,504.7 278.5,537.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Cube_face_-_right_484_",
    className: "st190",
    points: "405.4,463.8 278.5,537.1 278.5,534.9 405.4,461.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Cube_face_-_top_478_",
    className: "st190",
    points: "278.5,534.9 222.3,502.4 349.2,429.3 405.4,461.6  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st208",
    points: "273,531.6 278.9,531.6 344.9,447.8 291.7,462.4 222.3,502.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "227.2,501.8 227.2,494.8 348.9,431.6 400.7,454.3 400.7,461.4 278.8,531.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st209",
    points: "227.2,501.8 227.2,494.8 348.9,431.6 291.3,478.1 278.7,506 278.8,531.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st194",
    points: "227.2,494.8 348.9,424.5 400.7,454.3 278.8,524.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st210",
    points: "390,454.6 278.9,518.6 238,495.1 349.1,431  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M390.5,454.6L278.8,519l-41.4-24l111.7-64.5L390.5,454.6z M278.9,518.4l110.5-63.8l-40.4-23.3 l-110.5,63.8L278.9,518.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M327.7,460.9l-56.7,32.8c-0.1,0.1-0.4,0.1-0.7,0c-0.1-0.1-0.1-0.3,0-0.4l56.7-32.8 c0.1-0.1,0.4-0.1,0.7,0C327.8,460.7,327.8,460.8,327.7,460.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M335.7,465.4l-72.7,42c-0.1,0.1-0.4,0.1-0.7,0c-0.1-0.1-0.1-0.3,0-0.4l72.7-42c0.1-0.1,0.4-0.1,0.7,0 C335.8,465.1,335.8,465.3,335.7,465.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M384,453.8l-48.2,27.9c-0.1,0.1-0.4,0.1-0.7,0c-0.1-0.1-0.1-0.3,0-0.4l48.2-27.9 c0.1-0.1,0.4-0.1,0.7,0C384.3,453.5,384.3,453.6,384,453.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M318.9,489.8l-43.2,24.9c-0.1,0.1-0.4,0.1-0.7,0c-0.1-0.1-0.1-0.3,0-0.4l43.2-24.9 c0.1-0.1,0.4-0.1,0.7,0C319.2,489.5,319.2,489.8,318.9,489.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M354.4,436.8l-43.5,25.1c-0.1,0.1-0.4,0.1-0.7,0c-0.1-0.1-0.1-0.3,0-0.4l43.5-25.1 c0.1-0.1,0.4-0.1,0.7,0C354.5,436.6,354.5,436.7,354.4,436.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M371.3,446.1l-30.5,17.6l-11.1-6.4l30.5-17.6L371.3,446.1z M340.7,463l29.3-16.9l-9.9-5.7l-29.3,16.9 L340.7,463z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M300.2,465.8l0.8-0.5c0.1-0.1,0.3-0.1,0.5-0.1c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0.1 c0.1,0,0.3,0.1,0.4,0.1c0.1,0.1,0.3,0.3,0.4,0.3c0,0.1,0.1,0.1,0.1,0.3c0,0.1,0,0.1-0.1,0.3c-0.1,0.1-0.1,0.1-0.3,0.3 l-0.8,0.5L300.2,465.8z M301.1,465.7l1.1,0.5l0.1-0.1c0.1-0.1,0.1-0.1,0.3-0.1v-0.1c0,0-0.1-0.1-0.3-0.3 c-0.1-0.1-0.4-0.1-0.5-0.1s-0.3,0-0.4,0.1L301.1,465.7z M304.8,465l-0.7,0.4l0.3,0.3l-0.5,0.4l-1.2-1.5l0.7-0.4l2.6,0.7 l-0.5,0.4L304.8,465z M304.3,464.7l-0.9-0.3l0.4,0.5L304.3,464.7z M303.9,463.7l1.8-1.1l0.4,0.3l-0.5,0.4l1.4,0.8l-0.5,0.3 l-1.4-0.8l-0.5,0.4L303.9,463.7z M305.9,462.6l1.5-0.9l0.4,0.3l-0.9,0.5l0.3,0.1l0.9-0.5l0.4,0.3l-0.9,0.5l0.4,0.3l0.9-0.5 l0.4,0.3l-1.6,0.9L305.9,462.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M250.8,500.8l0.9-0.5c0.3-0.1,0.4-0.1,0.7-0.1s0.4,0,0.5,0.1c0.1,0.1,0.3,0.3,0.3,0.4 c0,0.1-0.1,0.3-0.4,0.4l-0.3,0.1l0.7,0.4l-0.5,0.3L250.8,500.8z M252.1,500.9l0.1-0.1c0.1,0,0.1-0.1,0.1-0.1s0-0.1-0.1-0.1 c0,0-0.1,0-0.3,0s-0.1,0-0.3,0.1l-0.1,0.1L252.1,500.9z M255.1,500l-0.7,0.4l0.3,0.3l-0.5,0.4l-1.2-1.5l0.7-0.4l2.6,0.7 l-0.5,0.4L255.1,500z M254.6,499.8l-0.9-0.3l0.4,0.5L254.6,499.8z M254,498.9l0.7-0.4l0.9,0.1l-0.3-0.5l0.7-0.4l0.4,1.1 l0.8,0.4l-0.5,0.3l-0.8-0.4L254,498.9z M257,497.1l1.8-1.1l0.4,0.3l-0.5,0.4l1.4,0.8l-0.5,0.3l-1.4-0.8l-0.5,0.4L257,497.1z  M259.8,496.6c-0.3-0.1-0.4-0.4-0.4-0.5c0-0.1,0.1-0.4,0.4-0.5c0.3-0.1,0.7-0.3,0.9-0.3s0.7,0.1,0.9,0.3 c0.3,0.1,0.4,0.3,0.4,0.4c0,0.1,0.1,0.3,0,0.4c0,0.1-0.1,0.3-0.4,0.4c-0.3,0.1-0.4,0.3-0.7,0.3s-0.4,0-0.7,0 C260.2,496.8,260.1,496.7,259.8,496.6z M260.4,496.3c0.1,0.1,0.4,0.1,0.5,0.1s0.3,0,0.4-0.1c0.1-0.1,0.1-0.1,0.1-0.3 c0-0.1-0.1-0.1-0.3-0.3c-0.1-0.1-0.4-0.1-0.5-0.1s-0.3,0-0.4,0.1c-0.1,0-0.1,0.1-0.1,0.3C260.1,496,260.2,496.2,260.4,496.3 z M261.9,494.3l1.8-1.1l0.4,0.3l-0.5,0.4l1.4,0.8l-0.5,0.3l-1.4-0.8l-0.5,0.4L261.9,494.3z M263.9,493.2l0.5-0.3l0.7,0.4 l0.7-0.4l-0.7-0.4l0.5-0.3l1.9,1.1l-0.5,0.3l-0.8-0.4l-0.7,0.4l0.8,0.4l-0.5,0.3L263.9,493.2z M266.1,491.8l1.5-0.9l0.4,0.3 l-0.9,0.5l0.3,0.1l0.9-0.5l0.4,0.3l-0.9,0.5l0.4,0.3l0.9-0.5l0.4,0.3l-1.6,0.9L266.1,491.8z M254.3,502.8 c-0.3-0.1-0.4-0.4-0.4-0.5c0-0.1,0.1-0.4,0.4-0.5c0.3-0.1,0.7-0.3,0.9-0.3c0.3,0,0.7,0.1,0.9,0.3c0.3,0.1,0.4,0.3,0.4,0.4 s0.1,0.3,0,0.4c0,0.1-0.1,0.3-0.4,0.4c-0.3,0.1-0.4,0.3-0.7,0.3c-0.3,0-0.4,0-0.7,0C254.8,503.1,254.6,502.9,254.3,502.8z  M255,502.5c0.1,0.1,0.4,0.1,0.5,0.1s0.3,0,0.4-0.1c0.1-0.1,0.1-0.1,0.1-0.3c0-0.1-0.1-0.1-0.3-0.3 c-0.1-0.1-0.4-0.1-0.5-0.1s-0.3,0-0.4,0.1c-0.1,0-0.1,0.1-0.1,0.3C254.6,502.3,254.7,502.4,255,502.5z M257.5,502.1 l-1.9-1.1l0.9-0.5c0.1-0.1,0.3-0.1,0.4-0.3c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0.1c0.1,0,0.1,0.1,0.3,0.1c0,0.1,0,0.1,0,0.3 c0,0,0,0.1-0.1,0.1c0.1,0,0.1,0,0.3,0h0.1c0.1,0,0.1,0,0.1,0l0.8,0.1l-0.7,0.4l-0.9-0.1c-0.1,0-0.1,0-0.3,0s-0.1,0-0.1,0 l0,0l0.8,0.4L257.5,502.1z M257,501l0.3-0.1c0,0,0.1,0,0.1-0.1c0,0,0,0,0-0.1c0,0,0,0-0.1-0.1h-0.1c-0.1,0-0.1,0-0.3,0.1 l-0.3,0.1L257,501z M257.7,499.8l0.8-0.5c0.1-0.1,0.3-0.1,0.5-0.1c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0.1 c0.1,0,0.3,0.1,0.4,0.1c0.1,0.1,0.3,0.3,0.4,0.3c0.1,0,0.1,0.1,0.1,0.3c0,0.1,0,0.1-0.1,0.3c-0.1,0.1-0.1,0.1-0.3,0.3 l-0.8,0.5L257.7,499.8z M258.8,499.7l1.1,0.5l0.1-0.1c0.1-0.1,0.1-0.1,0.3-0.1v-0.1c0,0-0.1-0.1-0.3-0.3 c-0.1-0.1-0.4-0.1-0.5-0.1s-0.3,0-0.4,0.1L258.8,499.7z M259.7,498.6l1.5-0.9l0.4,0.3l-0.9,0.5l0.3,0.1l0.9-0.5l0.4,0.3 l-0.9,0.5l0.4,0.3l0.9-0.5l0.4,0.3l-1.6,0.9L259.7,498.6z M263.5,498.6l-1.9-1.1l0.9-0.5c0.1-0.1,0.3-0.1,0.4-0.3 c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0.1c0.1,0,0.1,0.1,0.3,0.1c0,0.1,0,0.1,0,0.3c0,0,0,0.1-0.1,0.1c0.1,0,0.1,0,0.3,0h0.1 c0.1,0,0.1,0,0.1,0l0.8,0.1l-0.7,0.4l-0.9-0.1c-0.1,0-0.1,0-0.3,0s-0.1,0-0.1,0l0,0l0.8,0.4L263.5,498.6z M263,497.6 l0.3-0.1c0,0,0.1,0,0.1-0.1c0,0,0,0,0-0.1c0,0,0,0-0.1-0.1h-0.1c-0.1,0-0.1,0-0.3,0.1l-0.3,0.1L263,497.6z M265.4,496.4 c-0.3-0.1-0.4-0.4-0.4-0.5c0-0.1,0.1-0.4,0.4-0.5c0.3-0.1,0.7-0.3,0.9-0.3s0.7,0.1,0.9,0.3c0.3,0.1,0.4,0.3,0.4,0.4 s0.1,0.3,0,0.4c0,0.1-0.1,0.3-0.4,0.4c-0.3,0.1-0.4,0.3-0.7,0.3s-0.4,0-0.7,0C265.8,496.7,265.7,496.6,265.4,496.4z  M265.9,496.2c0.1,0.1,0.4,0.1,0.5,0.1c0.1,0,0.3,0,0.4-0.1c0.1-0.1,0.1-0.1,0.1-0.3c0-0.1-0.1-0.1-0.3-0.3 c-0.1-0.1-0.4-0.1-0.5-0.1s-0.3,0-0.4,0.1c-0.1,0-0.1,0.1-0.1,0.3C265.7,495.9,265.8,496,265.9,496.2z M266.7,494.5l1.5-0.8 l0.4,0.3l-0.8,0.5l0.3,0.1l0.7-0.4l0.4,0.3l-0.7,0.4l0.8,0.4l-0.5,0.3L266.7,494.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M341.8,464.3l0.8-0.5c0.1-0.1,0.3-0.1,0.5-0.1c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0.1 c0.1,0,0.3,0.1,0.4,0.1c0.1,0.1,0.3,0.3,0.4,0.3c0,0.1,0.1,0.1,0.1,0.3c0,0.1,0,0.1-0.1,0.3c-0.1,0.1-0.1,0.1-0.3,0.3 l-0.8,0.5L341.8,464.3z M342.9,464.3l1.1,0.5l0.1-0.1c0.1-0.1,0.1-0.1,0.3-0.1v-0.1c0,0-0.1-0.1-0.3-0.3 c-0.1-0.1-0.4-0.1-0.5-0.1s-0.3,0-0.4,0.1L342.9,464.3z M344.8,463.8c-0.3-0.1-0.4-0.4-0.4-0.5c0-0.1,0.1-0.4,0.4-0.5 c0.3-0.1,0.7-0.3,0.9-0.3s0.7,0.1,0.9,0.3c0.3,0.1,0.4,0.3,0.4,0.4c0,0.1,0.1,0.3,0,0.4c0,0.1-0.1,0.3-0.4,0.4 c-0.3,0.1-0.4,0.3-0.7,0.3s-0.4,0-0.7,0C345.2,463.9,344.9,463.9,344.8,463.8z M345.3,463.4c0.1,0.1,0.4,0.1,0.5,0.1 s0.3,0,0.4-0.1c0.1-0.1,0.1-0.1,0.1-0.3c0-0.1-0.1-0.1-0.3-0.3c-0.1-0.1-0.4-0.1-0.5-0.1s-0.3,0-0.4,0.1 c-0.1,0-0.1,0.1-0.1,0.3C345,463.3,345.2,463.4,345.3,463.4z M346.1,461.9l0.5-0.3l1.4,0.8l0.9-0.5l0.4,0.3l-1.5,0.8 L346.1,461.9z M347.9,460.9l0.5-0.3l1.4,0.8l0.9-0.5l0.4,0.3l-1.5,0.8L347.9,460.9z M352.3,460.1l-0.7,0.4l0.3,0.3l-0.5,0.4 l-1.2-1.5l0.7-0.4l2.6,0.7l-0.5,0.4L352.3,460.1z M351.8,460l-0.9-0.3l0.4,0.5L351.8,460z M353.4,459.9l-1.9-1.1l0.9-0.5 c0.1-0.1,0.3-0.1,0.4-0.3c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0.1c0.1,0,0.1,0.1,0.3,0.1c0,0.1,0,0.1,0,0.3 c0,0,0,0.1-0.1,0.1c0.1,0,0.1,0,0.3,0h0.1c0.1,0,0.1,0,0.1,0l0.8,0.1l-0.7,0.4l-0.9-0.1c-0.1,0-0.1,0-0.3,0s-0.1,0-0.1,0 l0,0l0.8,0.4L353.4,459.9z M353,458.8l0.3-0.1c0,0,0.1,0,0.1-0.1c0,0,0,0,0-0.1c0,0,0,0-0.1-0.1h-0.1c-0.1,0-0.1,0-0.3,0.1 l-0.3,0.1L353,458.8z M354.8,458.4l0.5-0.4c0.1,0,0.1,0.1,0.3,0.1s0.3,0,0.4-0.1c0.1,0,0.1-0.1,0.1-0.1v-0.1H356 c-0.1,0-0.3,0-0.4,0.1c-0.3,0.1-0.5,0.1-0.8,0.1s-0.4,0-0.5-0.1c-0.1,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1,0-0.3 c0-0.1,0.1-0.1,0.4-0.3c0.3-0.1,0.4-0.3,0.7-0.3s0.4,0,0.7,0.1l-0.5,0.3c-0.1,0-0.1,0-0.3,0s-0.1,0-0.3,0.1l-0.1,0.1 c0,0,0,0,0,0.1h0.1c0,0,0.1,0,0.3-0.1c0.3-0.1,0.5-0.1,0.7-0.3c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0.1 c0.1,0.1,0.1,0.1,0.3,0.3c0,0.1,0,0.1,0,0.3c0,0.1-0.1,0.1-0.4,0.3c-0.3,0.1-0.5,0.3-0.8,0.3 C355.2,458.5,355,458.4,354.8,458.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M343.3,434.7c0.1,0,0.1,0.1,0.1,0.1s0,0.1-0.1,0.1l-0.9,0.5c-0.1,0-0.1,0-0.3,0s-0.1,0-0.3,0l-3-1.8 c-0.1,0-0.1-0.1-0.1-0.1s0-0.1,0.1-0.1l0.8-0.5c0.1,0,0.1,0,0.3,0s0.1,0,0.3,0l0.8,0.4l-0.3,0.1l-0.7-0.4l-0.8,0.4l1.4,0.7 l0.8-0.5c0.1,0,0.1,0,0.3,0s0.1,0,0.3,0L343.3,434.7z M342.9,434.8l-1.4-0.8l-0.8,0.4l1.4,0.8L342.9,434.8z M345.2,433.6 c0.1,0,0.1,0.1,0.1,0.1s0,0.1-0.1,0.1l-0.8,0.5c-0.1,0-0.1,0-0.3,0s-0.1,0-0.3,0L343,434l0.3-0.1l0.7,0.4l0.8-0.4l-1.4-0.7 l-0.8,0.5c-0.1,0-0.1,0-0.3,0s-0.1,0-0.3,0l-1.5-0.8c-0.1,0-0.1-0.1-0.1-0.1s0-0.1,0.1-0.1l0.9-0.5c0.1,0,0.1,0,0.3,0 s0.1,0,0.3,0L345.2,433.6z M343.3,432.8l-1.4-0.8l-0.8,0.4l1.4,0.8L343.3,432.8z M346.5,433.1l-0.3,0.1l-2.4-2.3l-0.7,0.4 l0.5,0.3l-0.3,0.1l-0.8-0.4l1.4-0.8l0.1,0.1L346.5,433.1z M348.8,431.4c0.1,0,0.1,0.1,0.1,0.1s0,0.1-0.1,0.1l-0.9,0.5 c-0.1,0-0.1,0-0.3,0s-0.1,0-0.3,0l-1.1-0.7c-0.1,0-0.1-0.1-0.1-0.1l0.1-0.3l-0.5,0.1c-0.1,0-0.3,0-0.3,0l-0.9-0.5 c-0.1,0-0.1-0.1-0.1-0.1s0-0.1,0.1-0.1l0.9-0.5c0.1,0,0.1,0,0.3,0s0.1,0,0.3,0l0.9,0.5c0.1,0,0.1,0.1,0.1,0.1l-0.1,0.3h0.5 c0.1,0,0.3,0,0.4,0L348.8,431.4z M348.4,431.6l-1.2-0.7l-0.7,0.1l-0.1,0.4l1.2,0.7L348.4,431.6z M346.5,430.5l-0.9-0.5 l-0.8,0.4l0.9,0.5l0.7-0.1L346.5,430.5z M280.2,516.6C280.3,516.6,280.3,516.7,280.2,516.6c0.1,0.1,0,0.3,0,0.3l-0.8,0.5 c0,0-0.1,0-0.3,0s-0.1,0-0.3,0l-2.8-1.6l-0.1-0.1c0,0,0-0.1,0.1-0.1l0.8-0.5c0,0,0.1,0,0.3,0s0.1,0,0.3,0L280.2,516.6z  M279.9,516.7l-2.7-1.6l-0.8,0.4l2.7,1.6L279.9,516.7z M282,515.5C282,515.5,282,515.7,282,515.5c0.1,0.1,0,0.3,0,0.3 l-0.8,0.5c0,0-0.1,0-0.3,0c-0.1,0-0.1,0-0.3,0l-2.8-1.6l-0.1-0.1c0,0,0-0.1,0.1-0.1l0.8-0.5c0,0,0.1,0,0.3,0 c0.1,0,0.1,0,0.3,0L282,515.5z M281.6,515.7l-2.7-1.6l-0.8,0.4l2.7,1.6L281.6,515.7z M283.8,514.4 C283.9,514.6,283.9,514.6,283.8,514.4c0.1,0.1,0,0.3,0,0.3l-0.8,0.5c0,0-0.1,0-0.3,0s-0.1,0-0.3,0l-2.8-1.6l-0.1-0.1 c0,0,0-0.1,0.1-0.1l0.8-0.5c0,0,0.1,0,0.3,0s0.1,0,0.3,0L283.8,514.4z M283.5,514.6l-2.7-1.6l-0.8,0.4l2.7,1.6L283.5,514.6z  M285.7,513.4C285.7,513.5,285.8,513.5,285.7,513.4c0.1,0.1,0,0.3,0,0.3l-0.8,0.5c0,0-0.1,0-0.3,0s-0.1,0-0.3,0l-2.8-1.6 l-0.1-0.1c0,0,0-0.1,0.1-0.1l0.8-0.5c0,0,0.1,0,0.3,0s0.1,0,0.3,0L285.7,513.4z M285.4,513.6l-2.7-1.6l-0.8,0.4l2.7,1.6 L285.4,513.6z M287.5,512.4C287.6,512.4,287.6,512.4,287.5,512.4c0.1,0.1,0,0.3,0,0.3l-0.8,0.5c-0.1,0-0.1,0-0.3,0 s-0.1,0-0.3,0l-1.1-0.7c-0.1,0-0.1-0.1-0.1-0.1l0.1-0.3h-0.5c-0.1,0-0.3,0-0.3,0l-0.9-0.5l-0.1-0.1c0,0,0-0.1,0.1-0.1 l0.8-0.5c0,0,0.1,0,0.3,0s0.1,0,0.3,0l0.9,0.5c0.1,0,0.1,0.1,0.1,0.1l-0.1,0.3h0.5c0.1,0,0.3,0,0.3,0L287.5,512.4z  M287.2,512.5l-1.1-0.7l-0.7,0.1l-0.1,0.4l1.1,0.7L287.2,512.5z M285.4,511.5l-0.9-0.5l-0.7,0.4l0.9,0.5l0.5-0.1 L285.4,511.5z M288.7,510.9l-0.3,0.1l0.8,0.5l-0.3,0.1l-0.8-0.5l-0.9,0.5l-0.1-0.1l-1.5-1.8l0.3-0.1l0,0l1.4,1.6l0.5-0.4 l-1.2-0.7l0.3-0.1l1.2,0.7l0.3-0.1L288.7,510.9z M291,510.4C291,510.4,291.1,510.5,291,510.4c0.1,0.1,0.1,0.3,0,0.3 l-0.8,0.5c0,0-0.1,0-0.3,0s-0.1,0-0.3,0l-2.8-1.6l-0.1-0.1c0,0,0-0.1,0.1-0.1l0.8-0.4c0.1,0,0.1,0,0.3,0s0.1,0,0.3,0 l0.7,0.4l-0.3,0.1l-0.7-0.4l-0.7,0.4l1.2,0.7l0.8-0.4c0.1,0,0.1,0,0.3,0s0.1,0,0.3,0L291,510.4z M290.7,510.5l-1.2-0.7 l-0.7,0.4l1.2,0.7L290.7,510.5z M292.7,509.3C292.9,509.3,292.9,509.4,292.7,509.3c0.1,0.1,0,0.3,0,0.3l-0.8,0.5 c-0.1,0-0.1,0-0.3,0s-0.1,0-0.3,0l-1.1-0.7c-0.1,0-0.1-0.1-0.1-0.1l0.1-0.3h-0.5c-0.1,0-0.3,0-0.3,0l-0.9-0.5l-0.1-0.1 c0,0,0-0.1,0.1-0.1l0.8-0.5c0,0,0.1,0,0.3,0s0.1,0,0.3,0l0.9,0.5c0.1,0,0.1,0.1,0.1,0.1l-0.1,0.3h0.5c0.1,0,0.3,0,0.3,0 L292.7,509.3z M292.5,509.4l-1.1-0.7l-0.7,0.1l-0.1,0.4l1.1,0.7L292.5,509.4z M290.7,508.5l-0.9-0.5l-0.7,0.4l0.9,0.5 l0.5-0.1L290.7,508.5z M294.5,508.3C294.6,508.3,294.6,508.3,294.5,508.3c0.1,0.1,0.1,0.3,0,0.3l-0.8,0.4 c-0.1,0-0.1,0-0.3,0s-0.1,0-0.3,0l-0.8-0.5l0.3-0.1l0.8,0.4l0.7-0.4l-1.5-0.9l-0.9,0.5l-1.5-0.8l1.2-0.7l0.3,0.1l-0.9,0.5 l0.9,0.5l0.7-0.4c0.1,0,0.1,0,0.3,0s0.1,0,0.3,0L294.5,508.3z M296.4,507.3C296.4,507.3,296.5,507.3,296.4,507.3 c0.1,0.1,0,0.3,0,0.3l-0.8,0.5c0,0-0.1,0-0.3,0s-0.1,0-0.3,0l-2.8-1.6l-0.1-0.1c0,0,0-0.1,0.1-0.1l0.8-0.5c0,0,0.1,0,0.3,0 s0.1,0,0.3,0L296.4,507.3z M296.1,507.4l-2.7-1.6l-0.8,0.4l2.7,1.6L296.1,507.4z M298.3,506.2 C298.3,506.2,298.3,506.3,298.3,506.2c0.1,0.1,0,0.3,0,0.3l-0.8,0.5c0,0-0.1,0-0.3,0s-0.1,0-0.3,0l-2.8-1.6l-0.1-0.1 c0,0,0-0.1,0.1-0.1l0.8-0.5c0,0,0.1,0,0.3,0s0.1,0,0.3,0L298.3,506.2z M297.9,506.3l-2.7-1.6l-0.8,0.4l2.7,1.6L297.9,506.3z  M300.1,505.1C300.2,505.1,300.2,505.2,300.1,505.1c0.1,0.1,0,0.3,0,0.3l-0.8,0.5c0,0-0.1,0-0.3,0s-0.1,0-0.3,0l-2.8-1.6 l-0.1-0.1c0,0,0-0.1,0.1-0.1l0.8-0.5c0,0,0.1,0,0.3,0s0.1,0,0.3,0L300.1,505.1z M299.8,505.2l-2.7-1.6l-0.8,0.4l2.7,1.6 L299.8,505.2z M306.2,501.6C306.2,501.7,306.2,501.7,306.2,501.6c0.1,0.1,0,0.3,0,0.3l-0.8,0.5c0,0-0.1,0-0.3,0 c-0.1,0-0.1,0-0.3,0l-2.8-1.6l-0.1-0.1c0,0,0-0.1,0.1-0.1l0.8-0.5c0,0,0.1,0,0.3,0c0.1,0,0.1,0,0.3,0L306.2,501.6z  M305.7,501.8l-2.7-1.6l-0.8,0.4l2.7,1.6L305.7,501.8z M307.9,500.6C308,500.6,308,500.6,307.9,500.6c0.1,0.1,0,0.3,0,0.3 l-0.8,0.5c0,0-0.1,0-0.3,0s-0.1,0-0.3,0l-2.8-1.6l-0.1-0.1c0,0,0-0.1,0.1-0.1l0.8-0.5c0,0,0.1,0,0.3,0s0.1,0,0.3,0 L307.9,500.6z M307.6,500.8l-2.7-1.6l-0.8,0.4l2.7,1.6L307.6,500.8z M309.8,499.5C309.8,499.5,309.9,499.5,309.8,499.5 c0.1,0.1,0,0.3,0,0.3l-0.8,0.5c0,0-0.1,0-0.3,0s-0.1,0-0.3,0l-2.8-1.6l-0.1-0.1c0,0,0-0.1,0.1-0.1l0.8-0.5c0,0,0.1,0,0.3,0 s0.1,0,0.3,0L309.8,499.5z M309.5,499.7l-2.7-1.6l-0.8,0.4l2.7,1.6L309.5,499.7z M311.7,498.5L311.7,498.5 c0.1,0.1,0,0.3,0,0.3l-0.8,0.5c0,0-0.1,0-0.3,0s-0.1,0-0.3,0l-2.8-1.6l-0.1-0.1c0,0,0-0.1,0.1-0.1l0.8-0.5c0,0,0.1,0,0.3,0 s0.1,0,0.3,0L311.7,498.5z M311.3,498.6l-2.7-1.6l-0.8,0.4l2.7,1.6L311.3,498.6z M316.9,495.5 C316.9,495.5,317,495.5,316.9,495.5c0.1,0.1,0,0.3,0,0.3l-0.8,0.5c0,0-0.1,0-0.3,0s-0.1,0-0.3,0l-2.8-1.6l-0.1-0.1 c0,0,0-0.1,0.1-0.1l0.8-0.5c0,0,0.1,0,0.3,0s0.1,0,0.3,0L316.9,495.5z M316.4,495.6l-2.7-1.6l-0.8,0.4l2.7,1.6L316.4,495.6z  M318.6,494.4C318.7,494.4,318.7,494.4,318.6,494.4c0.1,0.1,0,0.3,0,0.3l-0.8,0.5c0,0-0.1,0-0.3,0s-0.1,0-0.3,0l-2.8-1.6 l-0.1-0.1c0,0,0-0.1,0.1-0.1l0.8-0.5c0,0,0.1,0,0.3,0s0.1,0,0.3,0L318.6,494.4z M318.3,494.5l-2.7-1.6l-0.8,0.4l2.7,1.6 L318.3,494.5z M320.5,493.3C320.6,493.3,320.6,493.5,320.5,493.3c0.1,0.1,0,0.3,0,0.3l-0.8,0.5c0,0-0.1,0-0.3,0 s-0.1,0-0.3,0l-2.8-1.6l-0.1-0.1c0,0,0-0.1,0.1-0.1l0.8-0.5c0,0,0.1,0,0.3,0s0.1,0,0.3,0L320.5,493.3z M320.2,493.5 l-2.7-1.6l-0.8,0.4l2.7,1.6L320.2,493.5z M322.4,492.2C322.4,492.2,322.4,492.4,322.4,492.2c0.1,0.1,0,0.3,0,0.3l-0.8,0.5 c0,0-0.1,0-0.3,0s-0.1,0-0.3,0l-2.8-1.6l-0.1-0.1c0,0,0-0.1,0.1-0.1l0.8-0.5c0,0,0.1,0,0.3,0s0.1,0,0.3,0L322.4,492.2z  M322,492.4l-2.7-1.6l-0.8,0.4l2.7,1.6L322,492.4z M324.3,491.4l-1.4,0.8l-0.1-0.1l-1.1-1.8l-0.8-0.4l-0.7,0.4l0.7,0.4 l-0.3,0.1l-0.8-0.4l-0.1-0.1c0,0,0-0.1,0.1-0.1l0.8-0.4c0.1,0,0.1,0,0.3,0s0.1,0,0.3,0l0.7,0.4c0.1,0,0.1,0.1,0.3,0.3 l0.9,1.5l0.9-0.5H324.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M374.8,450.1c-2.8,2.8-5.1,5.8-6.9,8.9c-0.8,0.8-1.5,1.6-2.3,2.4h-0.1c-0.5,0.4-1.1,0.9-1.5,1.4 c-1.4,1.2-2.6,2.4-3.5,4.2c0.1-1.8,0.7-3,1.6-4.5c0,0,0-0.1-0.1-0.1s-0.3,0-0.3,0c-1.9,1.5-3.7,4.1-4.3,5.7 c0-0.9,0.3-2.3,1.4-3.8c0,0,0-0.1-0.1-0.1c-0.1,0-0.3,0-0.3,0l-5.6,5l-0.1,0.1c0.4-0.5,0.8-1.4,1.1-2h0.1 c0.1,0,0.5,0,0.8-0.3c0.5-0.4,0.7-1.4,0.4-1.6c-0.1-0.1-0.3-0.3-0.5-0.3c0.1-0.5,0.3-0.9,0.3-1.5c0,0,0-0.1-0.1-0.1 s-0.1,0-0.3,0c-0.5,0.5-1.1,1.2-1.5,1.9c-0.1,0-0.1,0-0.3,0.1c-0.1-0.1-0.1-0.3-0.3-0.4c-0.5-0.8-0.8-1.5-1.6-1.5 c-0.5,0-0.8,0.5-0.5,3c0,0,0,0-0.1,0c-0.8,0.5-1.6,0.9-1.9,1.4c-0.3,0.3-0.5,0.7-0.8,0.9c-0.4,0.8,0.4,1.5,1.4,1.6 c0.5,0.1,1.2,0.1,1.9,0c0,0,0,0,0,0.1c0.1,0.8,0.1,1.8-0.4,2.7c-0.5,0.8-1.9,1.5-3.5,1.8c-1.6,0.3-3.4,0.1-4.6-0.4 c-0.1,0-0.3,0-0.3,0c-0.1,0,0,0.1,0,0.1c1.4,0.5,3.1,0.8,5,0.5c1.8-0.3,3.3-0.9,3.8-1.9s0.5-1.9,0.4-2.7c0,0,0-0.1,0-0.3 c0.1-0.1,0.3-0.1,0.4-0.3c0.1,0,0.1,0,0.1,0l5.8-5.3c-0.8,1.5-0.9,3-0.5,3.7c0,0,0.1,0.1,0.3,0.1s0.1,0,0.1-0.1 c0.3-1.2,1.8-3.8,3.5-5.6c-0.8,1.5-1.1,2.8-1.2,4.9l0.1,0.1c0.1,0,0.3,0,0.3-0.1c0.5-1.6,1.6-2.8,2.7-4.1 c-0.1,0.4-0.3,0.8-0.4,1.1c0,0,0,0.1,0.1,0.1s0.3,0,0.3-0.1c1.2-1.8,2.6-3.5,4.2-5.3c-0.5,1.1-1.1,2.3-1.5,3.4 c0,0.1-1.6,4.3-0.3,5c0.1,0.1,0.4,0.1,0.8,0c0.1,0,0.1,0,0.3-0.1c0.7-0.4,0.9-1.8,1.2-3.9c0.3-2.3,0.7-5.1,2.2-7 c0,0,0-0.1-0.1-0.1s-0.3,0-0.3,0c-0.1,0.1-0.4,0.4-0.5,0.5c1.6-2.7,3.8-5.3,6.2-7.7c0,0,0-0.1-0.1-0.1 C375,450.1,374.8,450.1,374.8,450.1z M354.6,465.7c0.1,0.3,0.1,1.1-0.4,1.4c-0.1,0.1-0.3,0.1-0.4,0.1h-0.1 c0.3-0.5,0.4-1.1,0.5-1.5l0,0C354.5,465.7,354.5,465.7,354.6,465.7z M354.2,464.5c0,0.3-0.1,0.5-0.3,0.9 c-0.1,0-0.4,0.1-0.5,0.1C353.6,465.1,353.8,464.7,354.2,464.5z M353.1,466c0.3-0.1,0.5-0.1,0.8-0.3 c-0.1,0.4-0.3,0.8-0.5,1.2c-0.1-0.1-0.4-0.3-0.5-0.5C352.9,466.2,353,466.1,353.1,466z M350.7,464.3L350.7,464.3 c0.4,0,0.8,0.7,1.1,1.4c0.1,0.1,0.1,0.3,0.3,0.4c-0.5,0.3-1.1,0.5-1.5,0.8C350.4,465.3,350.6,464.5,350.7,464.3z  M350.7,470.8c-0.5,0.1-1.2,0.1-1.6,0c-0.8-0.1-1.5-0.7-1.2-1.4c0.1-0.3,0.4-0.7,0.7-0.9s0.9-0.7,1.6-1.2 c0.1,0.8,0.3,1.8,0.4,3C350.7,470.6,350.7,470.7,350.7,470.8z M351.4,470.4c-0.1,0.1-0.1,0.1-0.3,0.1c0-0.1,0-0.1,0-0.3 c-0.3-1.4-0.4-2.4-0.4-3.3c0.5-0.3,1.1-0.5,1.6-0.8l0.1,0.1C351.7,467.7,351.3,469.2,351.4,470.4z M352.6,466.8 c0.1,0.3,0.4,0.4,0.5,0.5c-0.4,0.9-0.9,1.9-1.5,2.6C351.8,468.9,352.2,467.9,352.6,466.8z M363.8,463.7 c0.1-0.1,0.3-0.4,0.4-0.5l0,0C364.1,463.3,364,463.4,363.8,463.7z M367.2,464.6c-0.3,1.9-0.5,3.7-1.2,3.8 c-0.3,0-0.3,0-0.4,0c-0.8-0.4-0.3-3,0.4-4.7c0.5-1.5,1.4-3.1,2.2-4.6c0.1-0.1,0.3-0.3,0.5-0.4 C367.8,460.4,367.5,462.7,367.2,464.6z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M348.3,426.3l-118.6,68.5l49.3,28.4l119.4-68.9l-48.5-28l-0.8-0.4L348.3,426.3z M395.3,454.3 l-116.5,67.2l-46.2-26.7l116.5-67.2L395.3,454.3z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M304.9,536.1c-0.4-0.3-0.8-0.3-1.1,0c-1.1,0.9-0.1,2.8,0.9,3.5c0.5,0.3,0.9,0.3,1.2,0.1 c0.4-0.1,0.5-0.5,0.5-1.1C306.4,537.7,305.7,536.5,304.9,536.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000113311438798893041410000017721869696351495816_",
    gradientUnits: "userSpaceOnUse",
    x1: 366.0804,
    y1: 238.1474,
    x2: 372.5773,
    y2: 226.8946,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1724,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4559,
    style: {
      stopColor: "#485654"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4776,
    style: {
      stopColor: "#485654"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6092,
    style: {
      stopColor: "#485654"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    style: {
      stopColor: "#4E5453"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6684,
    style: {
      stopColor: "#454748"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6926,
    style: {
      stopColor: "#2A292A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000113311438798893041410000017721869696351495816_)"
    },
    d: "M433.2,467.2L433.2,467.2 C433.2,467.2,433.2,467,433.2,467.2C433.2,467,433.2,467,433.2,467.2c0-0.1,0-0.3,0-0.4c0-0.5-0.1-1.1-0.3-1.6 c0-0.1,0-0.1-0.1-0.3c-0.1-0.5-0.4-0.9-0.5-1.4c0-0.1-0.1-0.3-0.1-0.3c-0.3-0.4-0.4-0.7-0.7-1.1c-0.1-0.1-0.1-0.3-0.3-0.3 c-0.3-0.4-0.7-0.7-0.9-0.9c-0.1-0.1-0.1-0.1-0.3-0.3c-0.5-0.4-0.9-0.7-0.9-0.7c-0.5-0.3-2.2-1.1-3.8-0.3h-0.1l0,0 c-0.7,0.4-62.4,36-97.5,59c-11.8,7.7-17.1,11.6-20.3,14.4c0,0-0.3,0.3-0.4,0.4c-0.3,0.3-0.4,0.7-0.4,1.1c0,1.2,0.8,2.6,1.9,3.3 c0.3,0.1,0.7,0.3,1.2,0.1l0,0c0.1,0,0.3-0.1,0.4-0.1c0.1,0,0.1,0,0.3,0c0.5-0.3,1.2-0.5,2.2-0.8c2.8-1.1,7.4-3.3,16.7-8 c8.7-4.5,21.3-11.4,40-21.9c27.4-15.4,62.2-36,62.7-36.4l0,0l0.1-0.1c0.5-0.3,0.8-0.8,1.1-1.2c0.1-0.1,0.1-0.3,0.3-0.5 c0-0.1,0-0.1,0-0.3c0-0.3,0.1-0.5,0.1-0.7c0-0.1,0-0.3,0-0.4C433.2,467.4,433.2,467.3,433.2,467.2L433.2,467.2z"
  }), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st194",
    d: "M308.2,533.7c-0.5-0.3-1.1-0.3-1.4,0l-3,2.4c0.3-0.3,0.7-0.3,1.1,0c0.8,0.4,1.5,1.6,1.5,2.6 c0,0.5-0.1,0.9-0.5,1.1l3.7-1.5c0.4-0.1,0.7-0.7,0.7-1.4C310.1,535.7,309.3,534.2,308.2,533.7z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st212",
    d: "M304.5,536.7c-0.4-0.3-0.7-0.1-0.9,0c-0.7,0.7-2.6,2.4-3,2.8c0.1-0.1,0.3-0.1,0.4,0 c0.3,0.1,0.5,0.5,0.5,0.9c0,0.1-0.1,0.3-0.1,0.4c0.5-0.1,3-0.9,3.9-1.2c0.3-0.1,0.4-0.4,0.4-0.8 C305.7,537.9,305.2,537.1,304.5,536.7z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st212",
    d: "M301,539.5c-0.1-0.1-0.3-0.1-0.4,0c-0.3,0.3-0.5,0.5-0.5,0.7c-0.1,0.4,0.3,0.5,0.3,0.7 c0.3,0.1,0.7,0,1.1-0.1c0.1,0,0.1-0.1,0.1-0.4C301.5,540,301.3,539.6,301,539.5z"
  }))), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "426.1,465.3 386.3,488.3 383.1,486.4 422.9,463.4  "
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "418.2,466.8 415.4,465.3 423,463.7 425.6,465.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "386.1,486 383.3,484.5 383.3,483.8 386.1,485.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st194",
    points: "386.1,485.3 383.3,483.8 415.4,465.3 418.2,466.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "418.2,466.8 425.6,465.1 416.4,470.4 414.8,469.5 386.1,486 386.1,485.3  "
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "_x31_6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M482.3,611.8l10.4-6c0.5-0.3,0.9,0,0.9,0.5v0.3c0,0.5-0.4,1.2-0.9,1.5l-10.4,6c-0.5,0.3-0.9,0-0.9-0.5 v-0.3C481.4,612.8,481.8,612.1,482.3,611.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M480.9,612.5c0-0.1,0.1-0.4,0.3-0.5c0.1-0.1,0.3-0.4,0.5-0.4l10.4-6c0.3-0.1,0.4-0.1,0.7,0l0.7,0.4 c-0.1-0.1-0.4-0.1-0.7,0l-10.4,6c-0.1,0.1-0.4,0.3-0.5,0.4c-0.1,0.1-0.3,0.4-0.3,0.5s-0.1,0.4-0.1,0.5v0.3 c0,0.3,0.1,0.5,0.3,0.5l-0.7-0.4c-0.1-0.1-0.3-0.3-0.3-0.5V613C480.9,612.8,480.9,612.6,480.9,612.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M470.7,617.9c0.1-0.1,0.3-0.4,0.5-0.4l4.9-2.8c0.3-0.1,0.4-0.1,0.7,0l0.7,0.4c-0.1-0.1-0.4-0.1-0.7,0 l-4.9,2.8c-0.1,0.1-0.4,0.3-0.5,0.4c-0.1,0.1-0.3,0.4-0.3,0.5c0,0.1-0.1,0.4-0.1,0.5v0.3c0,0.3,0.1,0.5,0.3,0.5l-0.7-0.4 c-0.1-0.1-0.3-0.3-0.3-0.5V619c0-0.1,0-0.3,0.1-0.5C470.6,618.3,470.6,618,470.7,617.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M471.9,617.8l4.9-2.8c0.5-0.3,0.9,0,0.9,0.5v0.3c0,0.5-0.4,1.2-0.9,1.5l-4.9,2.8 c-0.5,0.3-0.9,0-0.9-0.5v-0.3C471,618.7,471.4,618,471.9,617.8z"
  }))), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "500.5,606.9 392.3,669.6 388.6,667.5 500.5,602.7 588.2,653.3 584.6,655.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152943507482095084180000016959181780444056724_",
    gradientUnits: "userSpaceOnUse",
    x1: 790.5696,
    y1: 95.199,
    x2: 865.4386,
    y2: 95.199,
    gradientTransform: "matrix(-1 0 0 -1 1329.5864 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B0ACB0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B4B9BB"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000152943507482095084180000016959181780444056724_)"
    },
    points: "500.5,606.1 390.5,669.8  388.6,668.6 500.5,603.8 588.2,654.2 586.4,655.4  "
  }), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "588.4,654.1 470.3,722.2 382.4,671.5 500.5,603.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042735611670799806100000000504900389206120869_",
    gradientUnits: "userSpaceOnUse",
    x1: 460.6694,
    y1: 43.4828,
    x2: 480.5053,
    y2: 43.4828,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4274,
    style: {
      stopColor: "#B2B3B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5565,
    style: {
      stopColor: "#D4D8D3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000042735611670799806100000000504900389206120869_)"
    },
    d: "M381.2,672.1c0,1.2,0.8,2.3,2.3,3.3 l79.2,45.6c3.1,1.8,8.1,1.8,11.1,0l115.7-67c1.5-0.9,2.3-2,2.3-3.3v4.1c0,1.2-0.8,2.3-2.3,3.3l-115.7,67c-3.1,1.8-8,1.8-11.1,0 l-79.2-45.6c-1.5-0.9-2.3-2-2.3-3.3V672.1z"
  }), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M383.5,675.3l79.2,45.6c3.1,1.8,8.1,1.8,11.1,0l115.7-67c3.1-1.8,3-4.7,0-6.5l-79.2-45.5 c-3.1-1.8-8.1-1.8-11.1,0l-115.7,67C380.4,670.7,380.4,673.6,383.5,675.3z M388.6,667.5l112-64.7l87.6,50.5l-112,64.7 L388.6,667.5z"
  }))), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M421.3,692.5l1.9-1.1c0.9-0.5,2.6-0.5,3.5,0.1l6.8,3.9c0.4,0.3,0.7,0.4,0.8,0.7c0.4,0.7,0.1,1.4-0.5,1.8 l-1.9,1.1c-0.9,0.5-2.6,0.5-3.5-0.1l-6.8-3.9c-0.4-0.3-0.7-0.4-0.8-0.7C420.5,693.6,420.6,692.9,421.3,692.5z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st215",
    d: "M421.3,693.2l1.9-1.1c0.9-0.5,2.6-0.5,3.5,0.1l6.8,3.9c0.4,0.3,0.7,0.4,0.8,0.7c0,0.1,0.1,0.3,0.1,0.3 c-0.1,0.3-0.3,0.5-0.7,0.8l-1.9,1.1c-0.9,0.5-2.6,0.5-3.5-0.1l-6.8-3.9c-0.4-0.3-0.7-0.4-0.8-0.7c0-0.1-0.1-0.3-0.1-0.3 C420.7,693.6,421,693.3,421.3,693.2z"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st216",
    d: "M545,626.8c0.9,0.5,2.4,0.5,3.4,0c0.9-0.5,0.9-1.4,0-1.9s-2.4-0.5-3.4,0S544.1,626.3,545,626.8z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st217",
    d: "M545.6,626.4c0.5,0.4,1.5,0.3,2.2,0c0.7-0.3,0.5-0.9,0-1.2c-0.5-0.4-1.5-0.4-2.2,0 C545,625.6,545,626.2,545.6,626.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st217",
    d: "M546,626.2c0.3,0.1,0.8,0.1,1.2,0c0.3-0.1,0.3-0.5,0-0.7s-0.8-0.1-1.2,0 C545.7,625.6,545.7,625.9,546,626.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st218",
    d: "M546.5,625.9c0.1,0.1,0.3,0.1,0.4,0c0.1-0.1,0.1-0.1,0-0.3c-0.1-0.1-0.3-0.1-0.4,0 C546.4,625.6,546.4,625.8,546.5,625.9z"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "581.6,653.8 476.7,714.3 402.7,671.7 507.7,611.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st219",
    d: "M450.1,671.9l-23.6,13.5l-8.4-4.9l23.6-13.5c2.3-1.4,6.1-1.4,8.4,0l0,0 C452.4,668.4,452.4,670.6,450.1,671.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M461.6,678.4L438.1,692l-8.4-4.9l23.6-13.5c2.3-1.4,6.1-1.4,8.4,0l0,0 C463.9,675.1,463.9,677.1,461.6,678.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st190",
    d: "M473,685.1l-23.6,13.5l-8.4-4.9l23.6-13.5c2.3-1.4,6.1-1.4,8.4,0l0,0C475.3,681.6,475.3,683.7,473,685.1z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M484.4,691.7l-23.6,13.5l-8.4-4.9l23.6-13.5c2.3-1.4,6.1-1.4,8.4,0l0,0 C486.7,688.2,486.7,690.4,484.4,691.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M495.9,698.2l-23.6,13.5l-8.4-4.9l23.6-13.5c2.3-1.4,6.1-1.4,8.4,0l0,0C498.2,694.8,498.2,697,495.9,698.2 z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st186",
    points: "507.7,611.1 402.7,671.7 395.7,667.6 500.6,607.1  "
  }))), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M457.8,655.7l-0.7-0.4c-4.5-2.6-4.7-4.6-1.5-6.5c3.4-1.9,6.8-1.8,11.2,0.8l0.7,0.4 c4.5,2.6,4.7,4.6,1.4,6.5C465.8,658.4,462.3,658.3,457.8,655.7z M466.9,655.2c1.6-0.9,0.7-2-1.9-3.5l-0.7-0.4 c-2.6-1.5-4.5-2-6.1-1.1l-0.1,0.1c-1.6,0.9-0.7,2,1.9,3.5l0.7,0.4c2.6,1.5,4.5,2,6.2,1.1V655.2z M484.9,647.2l-2.8,1.6l-12.2-2.2 l2.7,1.5l5.4,3.1l-2.6,1.5l-12.9-7.4l2.8-1.6l12.2,2.2l-2.7-1.5l-5.4-3.1l2.6-1.5L484.9,647.2z M486.8,646.1l-12.9-7.4l2.7-1.5 l10.6,6.1l4.7-2.7l2.3,1.4L486.8,646.1z M498.2,639.4l-2.7,1.5l-12.9-7.4l2.7-1.5L498.2,639.4z M509.6,632.9l-2.8,1.6l-12.2-2.2 l2.7,1.5l5.4,3.1l-2.6,1.5l-12.9-7.4l2.8-1.6l12.2,2.2l-2.7-1.5l-5.4-3.1l2.6-1.5L509.6,632.9z M506.5,619.8l2.3,1.4l-5.3,3 l2.8,1.6l4.3-2.6l2.3,1.4l-4.3,2.6l3.1,1.8l5.3-3l2.3,1.4l-7.9,4.6l-12.9-7.4L506.5,619.8z"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "476.5,625.6 428.7,653.3 427.1,652.3 474.9,624.7  "
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st219",
    d: "M481.9,660.8l-0.3-0.1c-1.1-0.7-2.3-0.7-3.4-0.5c0.3-0.5,0.1-1.1-0.8-1.6l-0.3-0.1 c-2.4-1.4-4.6-0.7-6.2,0.3l-3.4,2l10.4,6l3.5-2C483.2,663.7,484.5,662.3,481.9,660.8z M475,661.1l-1.2,0.7l-2.3-1.4l1.2-0.7 c0.5-0.3,1.4-0.5,2.2-0.1l0.1,0.1C476,660.3,475.6,660.8,475,661.1z M479.6,663.5l-1.5,0.8l-2.6-1.5l1.5-0.8 c0.5-0.4,1.5-0.5,2.4,0l0.1,0.1C480.6,662.6,480.2,663.1,479.6,663.5z M480.9,653l-3,1.8l7.9,7.6l2.3-1.4l-1.8-1.6l2.6-1.5 l2.7,0.9l2.3-1.4L480.9,653z M484.8,658l-3-2.7l4.7,1.8L484.8,658z M502.4,652.6l-2.3,1.4l-9.9-1.8l2.2,1.2l4.3,2.6l-2,1.2 l-10.4-6l2.3-1.4l9.8,1.8l-2.2-1.2l-4.3-2.6l2-1.2L502.4,652.6z M499.8,646.8l-1.5-3.8l2.6-1.5l1.2,4.1l9.2,1.9l-2.4,1.4 l-6.1-1.4l0.4,1.2l3,1.8l-2.2,1.2l-10.4-6l2.2-1.2L499.8,646.8z M514.4,645.5l-2.2,1.2l-10.4-6l2.2-1.2L514.4,645.5z  M523.6,640.3l-2.3,1.4l-9.9-1.8l2.2,1.2l4.3,2.6l-2,1.2l-10.4-6l2.3-1.4l9.8,1.8l-2.2-1.2l-4.3-2.6l2-1.2L523.6,640.3z  M520,636.6l-0.5-0.3c-3.7-2-3.8-3.7-1.1-5.3c2.4-1.5,4.9-1.6,7.4-0.1l0.5,0.3l-2.2,1.2c-1.5-0.8-2.6-1.1-3.8-0.4l-0.1,0.1 c-1.5,0.8-0.7,1.8,1.5,2.8l0.5,0.3c2,1.2,3.7,1.6,5.1,0.8l0.1-0.1c0.7-0.4,0.9-0.7,0.9-1.1l-1.6-0.9l-1.4,0.8l-1.9-1.1l3.5-2 l4.6,2.7c-0.1,0.8-0.7,1.8-2.4,2.8C526.4,638.9,523.6,638.8,520,636.6z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st220",
    d: "M533.3,643l-42.1,24.4l-0.5-0.4l42.1-24.4L533.3,643z M534.9,643.9l-49.3,28.4l0.5,0.4l49.3-28.4 L534.9,643.9z M537.1,645.1l-49.3,28.4l0.5,0.4l49.3-28.4L537.1,645.1z M539.2,646.3l-49.3,28.4l0.5,0.4l49.3-28.4L539.2,646.3z  M541.4,647.6L492.1,676l0.5,0.4l49.3-28.4L541.4,647.6z M543.6,648.9l-49.3,28.4l0.5,0.4l49.3-28.4L543.6,648.9z M545.7,650.1 l-49.3,28.4l0.5,0.4l49.3-28.4L545.7,650.1z M547.9,651.4l-49.3,28.4l0.5,0.4l49.3-28.4L547.9,651.4z M550.2,652.7l-49.4,28.4 l0.5,0.4l49.3-28.4L550.2,652.7z M552.4,653.9l-49.3,28.4l0.5,0.4l49.3-28.4L552.4,653.9z M554.5,655.2l-49.3,28.4l0.5,0.4 l49.3-28.4L554.5,655.2z M556.7,656.4l-49.3,28.4l0.5,0.4l49.3-28.4L556.7,656.4z"
  }))), /*#__PURE__*/React.createElement("g", null, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "327.8,123.5 463.6,202 523.6,167.4 523.6,136.5 327.8,92.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "327.8,123.5 463.6,202 463.6,171 327.8,92.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M463.6,191.5l60-34.7v1.1l-59.7,34.5l-0.3,0.1l-136-78.5v-0.9L463.6,191.5z M327.8,109.5v1.1l136,78.5 l0.3-0.1l59.7-34.5v-1.1l-60,34.7L327.8,109.5z M327.8,116.5v1.1l136,78.5l0.3-0.1l59.7-34.5v-1.1l-60,34.7L327.8,116.5z  M327.8,121.1l136,78.5l0.3-0.1l59.7-34.5v-1.1l-60,34.7l-136-78.5L327.8,121.1L327.8,121.1z M327.8,106.2v1.1l136,78.5l0.3-0.1 l59.7-34.5V150l-60,34.7L327.8,106.2z M327.8,95.7v1.1l136,78.5l0.3-0.1l59.7-34.5v-1.1l-60,34.7L327.8,95.7z M327.8,99.3v1.1 l136,78.5l0.3-0.1l59.7-34.5v-1.1l-60,34.7L327.8,99.3z M327.8,102.6v1.1l136,78.5l0.3-0.1l59.7-34.5v-1.1l-60,34.7L327.8,102.6 z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st221",
    points: "470.6,104.9 470.6,107.9 467,104.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "327.8,92.6 463.6,171 523.6,136.5 387.7,58  "
  }), /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M333,92.5c-0.1-0.1-0.1-0.3,0-0.4l53.9-31c0.1-0.1,0.4-0.1,0.7,0l24.9,14.4c0.1,0.1,0.1,0.3,0,0.4 l-53.8,31c-0.1,0.1-0.4,0.1-0.7,0L333,92.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M412.3,75.7l-53.8,31l-25.1-14.4l53.9-31L412.3,75.7L412.3,75.7z M412.8,75.3l-25.6-14.8l-55.1,31.7 l26.3,15.2l0,0L412.8,76C413.2,75.8,413.2,75.6,412.8,75.3L412.8,75.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M418.2,141.6c-0.1-0.1-0.1-0.3,0-0.4l53.9-31c0.1-0.1,0.4-0.1,0.7,0l45.4,26.1c0.1,0.1,0.1,0.3,0,0.4 l-53.8,31c-0.1,0.1-0.4,0.1-0.7,0L418.2,141.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M517.8,136.6l-53.8,31l-45.4-26.1l53.9-31L517.8,136.6L517.8,136.6z M518.4,136.2l-45.9-26.5l-55.3,31.8 l46.6,26.8l0,0l54.4-31.4C518.7,136.8,518.7,136.5,518.4,136.2L518.4,136.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "498.7,145.3 463.6,165.5 426.8,144.2 461.8,124  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "472.3,133.2 470.5,132.3 472.3,131.2 473.9,132.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "473.9,134.2 472.3,133.2 473.9,132.3 475.6,133.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "484.3,140.3 482.7,139.2 484.3,138.3 486.1,139.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "468.7,133.2 467,132.3 468.7,131.2 470.5,132.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "473.9,136.2 472.3,135.3 473.9,134.2 475.6,135.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "477.4,138.3 475.6,137.3 477.4,136.2 479.2,137.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "479.2,139.2 477.4,138.3 479.2,137.3 480.9,138.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "482.7,141.2 480.9,140.3 482.7,139.2 484.3,140.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "484.3,142.3 482.7,141.2 484.3,140.3 486.1,141.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "467,134.2 465.2,133.2 467,132.3 468.7,133.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "472.3,137.3 470.5,136.2 472.3,135.3 473.9,136.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "479.2,141.2 477.4,140.3 479.2,139.2 480.9,140.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "480.9,142.3 479.2,141.2 480.9,140.3 482.7,141.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "482.7,143.3 480.9,142.3 482.7,141.2 484.3,142.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "467,136.2 465.2,135.3 467,134.2 468.7,135.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "472.3,139.2 470.5,138.3 472.3,137.3 473.9,138.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "475.6,141.2 473.9,140.3 475.6,139.2 477.4,140.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "479.2,143.3 477.4,142.3 479.2,141.2 480.9,142.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "480.9,144.2 479.2,143.3 480.9,142.3 482.7,143.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "465.2,137.3 463.6,136.2 465.2,135.3 467,136.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "468.7,139.2 467,138.3 468.7,137.3 470.5,138.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "470.5,140.3 468.7,139.2 470.5,138.3 472.3,139.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "473.9,142.3 472.3,141.2 473.9,140.3 475.6,141.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "475.6,143.3 473.9,142.3 475.6,141.2 477.4,142.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "479.2,145.3 477.4,144.2 479.2,143.3 480.9,144.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "453.2,132.3 451.4,131.2 453.2,130.3 454.9,131.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "454.9,133.2 453.2,132.3 454.9,131.2 456.5,132.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "458.3,135.3 456.5,134.2 458.3,133.2 460.1,134.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "461.8,137.3 460.1,136.2 461.8,135.3 463.6,136.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "467,140.3 465.2,139.2 467,138.3 468.7,139.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "470.5,142.3 468.7,141.2 470.5,140.3 472.3,141.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "473.9,144.2 472.3,143.3 473.9,142.3 475.6,143.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "475.6,145.3 473.9,144.2 475.6,143.3 477.4,144.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "479.2,147.3 477.4,146.2 479.2,145.3 480.9,146.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "484.3,150.3 482.7,149.2 484.3,148.3 486.1,149.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "451.4,133.2 449.6,132.3 451.4,131.2 453.2,132.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "460.1,138.3 458.3,137.3 460.1,136.2 461.8,137.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "461.8,139.2 460.1,138.3 461.8,137.3 463.6,138.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "463.6,140.3 461.8,139.2 463.6,138.3 465.2,139.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "468.7,143.3 467,142.3 468.7,141.2 470.5,142.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "472.3,145.3 470.5,144.2 472.3,143.3 473.9,144.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "473.9,146.2 472.3,145.3 473.9,144.2 475.6,145.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "479.2,149.2 477.4,148.3 479.2,147.3 480.9,148.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "453.2,136.2 451.4,135.3 453.2,134.2 454.8,135.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "454.8,137.3 453.2,136.2 454.8,135.3 456.5,136.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "456.5,138.3 454.8,137.3 456.5,136.2 458.3,137.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "463.6,142.3 461.8,141.2 463.6,140.3 465.2,141.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "467,144.2 465.2,143.3 467,142.3 468.7,143.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "472.3,147.3 470.5,146.2 472.3,145.3 473.9,146.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "473.9,148.3 472.3,147.3 473.9,146.2 475.6,147.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "475.6,149.2 473.9,148.3 475.6,147.3 477.4,148.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "477.4,150.3 475.6,149.2 477.4,148.3 479.2,149.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "479.2,151.3 477.4,150.3 479.2,149.2 480.9,150.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "482.7,153.3 480.9,152.3 482.7,151.3 484.3,152.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "454.8,139.2 453.2,138.3 454.8,137.3 456.5,138.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "456.5,140.3 454.8,139.2 456.5,138.3 458.3,139.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "460.1,142.3 458.3,141.2 460.1,140.3 461.8,141.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "463.6,144.2 461.8,143.3 463.6,142.3 465.2,143.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "465.2,145.3 463.6,144.2 465.2,143.3 467,144.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "468.7,147.3 467,146.2 468.7,145.3 470.5,146.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "470.5,148.3 468.7,147.3 470.5,146.2 472.3,147.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "473.9,150.3 472.3,149.2 473.9,148.3 475.6,149.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "479.2,153.3 477.4,152.3 479.2,151.3 480.9,152.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "446.1,136.2 444.5,135.3 446.1,134.2 447.9,135.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "447.9,137.3 446.1,136.2 447.9,135.3 449.6,136.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "449.6,138.3 447.9,137.3 449.6,136.2 451.4,137.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "451.4,139.2 449.6,138.3 451.4,137.3 453.2,138.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "454.8,141.2 453.2,140.3 454.8,139.2 456.5,140.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "456.5,142.3 454.8,141.2 456.5,140.3 458.3,141.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "458.3,143.3 456.5,142.3 458.3,141.2 460.1,142.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "461.8,145.3 460.1,144.2 461.8,143.3 463.6,144.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "468.7,149.2 467,148.3 468.7,147.3 470.5,148.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "475.6,153.3 473.9,152.3 475.6,151.3 477.4,152.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "444.5,137.3 442.7,136.2 444.5,135.3 446.1,136.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "449.6,140.3 447.9,139.2 449.6,138.3 451.4,139.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "453.2,142.3 451.4,141.2 453.2,140.3 454.8,141.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "454.8,143.3 453.2,142.3 454.8,141.2 456.5,142.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "456.5,144.2 454.8,143.3 456.5,142.3 458.3,143.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "460.1,146.2 458.3,145.3 460.1,144.2 461.8,145.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "463.6,148.3 461.8,147.3 463.6,146.2 465.2,147.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "465.2,149.2 463.6,148.3 465.2,147.3 467,148.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "470.5,152.3 468.7,151.3 470.5,150.3 472.3,151.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "472.3,153.3 470.5,152.3 472.3,151.3 473.9,152.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "473.9,154.2 472.3,153.3 473.9,152.3 475.6,153.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "475.6,155.3 473.9,154.2 475.6,153.3 477.4,154.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "442.7,138.3 441,137.3 442.7,136.2 444.5,137.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "447.9,141.2 446.1,140.3 447.9,139.2 449.6,140.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "449.6,142.3 447.9,141.2 449.6,140.3 451.4,141.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "458.3,147.3 456.5,146.2 458.3,145.3 460.1,146.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "460.1,148.3 458.3,147.3 460.1,146.2 461.8,147.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "470.5,154.2 468.7,153.3 470.5,152.3 472.3,153.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "473.9,156.3 472.3,155.3 473.9,154.2 475.6,155.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "475.6,157.4 473.9,156.3 475.6,155.3 477.4,156.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "441,139.2 439.2,138.3 441,137.3 442.7,138.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "444.5,141.2 442.7,140.3 444.5,139.2 446.1,140.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "446.1,142.3 444.5,141.2 446.1,140.3 447.9,141.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "453.2,146.2 451.4,145.3 453.2,144.2 454.8,145.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "461.8,151.3 460.1,150.3 461.8,149.2 463.6,150.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "467,154.2 465.2,153.3 467,152.3 468.7,153.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "472.3,157.4 470.5,156.3 472.3,155.3 473.9,156.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "473.9,158.3 472.3,157.4 473.9,156.3 475.6,157.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "439.2,140.3 437.4,139.2 439.2,138.3 441,139.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "453.2,148.3 451.4,147.3 453.2,146.2 454.8,147.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "454.8,149.2 453.2,148.3 454.8,147.3 456.5,148.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "456.5,150.3 454.8,149.2 456.5,148.3 458.3,149.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "461.8,153.3 460.1,152.3 461.8,151.3 463.6,152.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "463.6,154.2 461.8,153.3 463.6,152.3 465.2,153.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "470.5,158.3 468.7,157.4 470.5,156.3 472.3,157.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "447.9,147.3 446.1,146.2 447.9,145.3 449.6,146.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "449.6,148.3 447.9,147.3 449.6,146.2 451.4,147.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "454.8,151.3 453.2,150.3 454.8,149.2 456.5,150.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "456.5,152.3 454.8,151.3 456.5,150.3 458.3,151.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "458.3,153.3 456.5,152.3 458.3,151.3 460.1,152.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "461.8,155.3 460.1,154.2 461.8,153.3 463.6,154.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "463.6,156.3 461.8,155.3 463.6,154.2 465.2,155.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "470.5,160.3 468.7,159.3 470.5,158.3 472.3,159.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "446.1,148.3 444.5,147.3 446.1,146.2 447.9,147.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "447.9,149.2 446.1,148.3 447.9,147.3 449.6,148.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "449.6,150.3 447.9,149.2 449.6,148.3 451.4,149.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "454.8,153.3 453.2,152.3 454.8,151.3 456.5,152.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "458.3,155.3 456.5,154.2 458.3,153.3 460.1,154.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "461.8,157.4 460.1,156.3 461.8,155.3 463.6,156.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "463.6,158.3 461.8,157.4 463.6,156.3 465.2,157.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "465.2,159.3 463.6,158.3 465.2,157.4 467,158.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "467,160.3 465.2,159.3 467,158.3 468.7,159.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "468.7,161.3 467,160.3 468.7,159.3 470.5,160.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "447.9,151.3 446.1,150.3 447.9,149.2 449.6,150.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "451.4,153.3 449.6,152.3 451.4,151.3 453.2,152.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "453.2,154.2 451.4,153.3 453.2,152.3 454.8,153.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "458.3,157.4 456.5,156.3 458.3,155.3 460.1,156.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "461.8,159.3 460.1,158.3 461.8,157.4 463.6,158.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "463.6,160.3 461.8,159.3 463.6,158.3 465.2,159.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "441,149.2 439.2,148.3 441,147.3 442.7,148.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "444.5,145.3 442.7,144.2 444.5,143.3 446.1,144.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "442.7,150.3 441,149.2 442.7,148.3 444.5,149.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "446.1,152.3 444.5,151.3 446.1,150.3 447.9,151.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "451.4,155.3 449.6,154.2 451.4,153.3 453.2,154.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "456.5,158.3 454.8,157.4 456.5,156.3 458.3,157.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "460.1,160.3 458.3,159.3 460.1,158.3 461.8,159.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "439.2,150.3 437.4,149.2 439.2,148.3 441,149.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "441,151.3 439.2,150.3 441,149.2 442.7,150.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "444.5,153.3 442.7,152.3 444.5,151.3 446.1,152.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "446.1,154.2 444.5,153.3 446.1,152.3 447.9,153.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "447.9,155.3 446.1,154.2 447.9,153.3 449.6,154.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "451.4,157.4 449.6,156.3 451.4,155.3 453.2,156.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "454.8,159.3 453.2,158.3 454.8,157.4 456.5,158.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "458.3,161.3 456.5,160.3 458.3,159.3 460.1,160.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M435.8,140.3l-6.9,4.1l6.9,4.1l6.9-4.1L435.8,140.3z M435.8,146.9l-4.6-2.7l4.6-2.7l4.6,2.7L435.8,146.9 z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "435.8,142.6 432.8,144.2 435.8,146 438.7,144.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M461.8,125.3l-6.9,4.1l6.9,4.1l6.9-4.1L461.8,125.3z M461.8,131.9l-4.6-2.7l4.6-2.7l4.6,2.7L461.8,131.9 z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "461.8,127.6 459,129.2 461.8,130.9 464.7,129.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M489.6,141.2l-6.9,4.1l6.9,4.1l6.9-4.1L489.6,141.2z M489.6,148l-4.6-2.7l4.6-2.7l4.6,2.7L489.6,148z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "489.6,143.7 486.7,145.3 489.6,146.9 492.4,145.3  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "409.4,75.4 388.3,87.6 366.1,74.7 387.2,62.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "393.4,68.2 392.5,67.6 393.4,67 394.5,67.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "394.5,68.8 393.4,68.2 394.5,67.6 395.6,68.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "400.7,72.4 399.8,71.8 400.7,71.2 401.8,71.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "391.4,68.2 390.3,67.6 391.4,67 392.5,67.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "394.5,70 393.4,69.3 394.5,68.8 395.6,69.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "396.6,71.2 395.6,70.5 396.6,70 397.6,70.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "397.6,71.8 396.6,71.2 397.6,70.5 398.7,71.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "399.8,73 398.7,72.4 399.8,71.8 400.7,72.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "400.7,73.7 399.8,73 400.7,72.4 401.8,73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "390.3,68.8 389.4,68.2 390.3,67.6 391.4,68.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "393.4,70.5 392.5,70 393.4,69.3 394.5,70  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "397.6,73 396.6,72.4 397.6,71.8 398.7,72.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "398.7,73.7 397.6,73 398.7,72.4 399.8,73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "399.8,74.2 398.7,73.7 399.8,73 400.7,73.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "390.3,70 389.4,69.3 390.3,68.8 391.4,69.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "393.4,71.8 392.5,71.2 393.4,70.5 394.5,71.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "395.6,73 394.5,72.4 395.6,71.8 396.6,72.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "397.6,74.2 396.6,73.7 397.6,73 398.7,73.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "398.7,74.7 397.6,74.2 398.7,73.7 399.8,74.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "389.4,70.5 388.3,70 389.4,69.3 390.3,70  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "391.4,71.8 390.3,71.2 391.4,70.5 392.5,71.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "392.5,72.4 391.4,71.8 392.5,71.2 393.4,71.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "394.5,73.7 393.4,73 394.5,72.4 395.6,73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "395.6,74.2 394.5,73.7 395.6,73 396.6,73.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "397.6,75.4 396.6,74.7 397.6,74.2 398.7,74.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "382.1,67.6 381,67 382.1,66.3 383,67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "383,68.2 382.1,67.6 383,67 384.1,67.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "385.2,69.3 384.1,68.8 385.2,68.2 386.1,68.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "387.2,70.5 386.1,70 387.2,69.3 388.3,70  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "390.3,72.4 389.4,71.8 390.3,71.2 391.4,71.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "392.5,73.7 391.4,73 392.5,72.4 393.4,73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "394.5,74.7 393.4,74.2 394.5,73.7 395.6,74.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "395.6,75.4 394.5,74.7 395.6,74.2 396.6,74.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "397.6,76.6 396.6,76 397.6,75.4 398.7,76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "400.7,78.4 399.8,77.9 400.7,77.2 401.8,77.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "381,68.2 379.9,67.6 381,67 382.1,67.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "386.1,71.2 385.2,70.5 386.1,70 387.2,70.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "387.2,71.8 386.1,71.2 387.2,70.5 388.3,71.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "388.3,72.4 387.2,71.8 388.3,71.2 389.4,71.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "391.4,74.2 390.3,73.7 391.4,73 392.5,73.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "393.4,75.4 392.5,74.7 393.4,74.2 394.5,74.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "394.5,76 393.4,75.4 394.5,74.7 395.6,75.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "397.6,77.9 396.6,77.2 397.6,76.6 398.7,77.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "382.1,70 381,69.3 382.1,68.8 383,69.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "383,70.5 382.1,70 383,69.3 384.1,70  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "384.1,71.2 383,70.5 384.1,70 385.2,70.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "388.3,73.7 387.2,73 388.3,72.4 389.4,73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "390.3,74.7 389.4,74.2 390.3,73.7 391.4,74.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "393.4,76.6 392.5,76 393.4,75.4 394.5,76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "394.5,77.2 393.4,76.6 394.5,76 395.6,76.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "395.6,77.9 394.5,77.2 395.6,76.6 396.6,77.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "396.6,78.4 395.6,77.9 396.6,77.2 397.6,77.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "397.6,79.1 396.6,78.4 397.6,77.9 398.7,78.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "399.8,80.3 398.7,79.6 399.8,79.1 400.7,79.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "383,71.8 382.1,71.2 383,70.5 384.1,71.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "384.1,72.4 383,71.8 384.1,71.2 385.2,71.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "386.1,73.7 385.2,73 386.1,72.4 387.2,73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "388.3,74.7 387.2,74.2 388.3,73.7 389.4,74.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "389.4,75.4 388.3,74.7 389.4,74.2 390.3,74.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "391.4,76.6 390.3,76 391.4,75.4 392.5,76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "392.5,77.2 391.4,76.6 392.5,76 393.4,76.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "394.5,78.4 393.4,77.9 394.5,77.2 395.6,77.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "397.6,80.3 396.6,79.6 397.6,79.1 398.7,79.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "377.9,70 376.8,69.3 377.9,68.8 378.8,69.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "378.8,70.5 377.9,70 378.8,69.3 379.9,70  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "379.9,71.2 378.8,70.5 379.9,70 381,70.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "381,71.8 379.9,71.2 381,70.5 382.1,71.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "383,73 382.1,72.4 383,71.8 384.1,72.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "384.1,73.7 383,73 384.1,72.4 385.2,73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "385.2,74.2 384.1,73.7 385.2,73 386.1,73.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "387.2,75.4 386.1,74.7 387.2,74.2 388.3,74.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "391.4,77.9 390.3,77.2 391.4,76.6 392.5,77.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "395.6,80.3 394.5,79.6 395.6,79.1 396.6,79.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "376.8,70.5 375.7,70 376.8,69.3 377.9,70  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "379.9,72.4 378.8,71.8 379.9,71.2 381,71.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "382.1,73.7 381,73 382.1,72.4 383,73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "383,74.2 382.1,73.7 383,73 384.1,73.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "384.1,74.7 383,74.2 384.1,73.7 385.2,74.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "386.1,76 385.2,75.4 386.1,74.7 387.2,75.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "388.3,77.2 387.2,76.6 388.3,76 389.4,76.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "389.4,77.9 388.3,77.2 389.4,76.6 390.3,77.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "392.5,79.6 391.4,79.1 392.5,78.4 393.4,79.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "393.4,80.3 392.5,79.6 393.4,79.1 394.5,79.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "394.5,80.8 393.4,80.3 394.5,79.6 395.6,80.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "395.6,81.4 394.5,80.8 395.6,80.3 396.6,80.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "375.7,71.2 374.7,70.5 375.7,70 376.8,70.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "378.8,73 377.9,72.4 378.8,71.8 379.9,72.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "379.9,73.7 378.8,73 379.9,72.4 381,73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "385.2,76.6 384.1,76 385.2,75.4 386.1,76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "386.1,77.2 385.2,76.6 386.1,76 387.2,76.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "392.5,80.8 391.4,80.3 392.5,79.6 393.4,80.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "394.5,82.1 393.4,81.4 394.5,80.8 395.6,81.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "395.6,82.6 394.5,82.1 395.6,81.4 396.6,82.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "374.7,71.8 373.7,71.2 374.7,70.5 375.7,71.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "376.8,73 375.7,72.4 376.8,71.8 377.9,72.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "377.9,73.7 376.8,73 377.9,72.4 378.8,73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "382.1,76 381,75.4 382.1,74.7 383,75.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "387.2,79.1 386.1,78.4 387.2,77.9 388.3,78.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "390.3,80.8 389.4,80.3 390.3,79.6 391.4,80.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "393.4,82.6 392.5,82.1 393.4,81.4 394.5,82.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "394.5,83.3 393.4,82.6 394.5,82.1 395.6,82.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "373.7,72.4 372.6,71.8 373.7,71.2 374.7,71.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "382.1,77.2 381,76.6 382.1,76 383,76.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "383,77.9 382.1,77.2 383,76.6 384.1,77.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "384.1,78.4 383,77.9 384.1,77.2 385.2,77.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "387.2,80.3 386.1,79.6 387.2,79.1 388.3,79.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "388.3,80.8 387.2,80.3 388.3,79.6 389.4,80.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "392.5,83.3 391.4,82.6 392.5,82.1 393.4,82.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "378.8,76.6 377.9,76 378.8,75.4 379.9,76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "379.9,77.2 378.8,76.6 379.9,76 381,76.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "383,79.1 382.1,78.4 383,77.9 384.1,78.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "384.1,79.6 383,79.1 384.1,78.4 385.2,79.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "385.2,80.3 384.1,79.6 385.2,79.1 386.1,79.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "387.2,81.4 386.1,80.8 387.2,80.3 388.3,80.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "388.3,82.1 387.2,81.4 388.3,80.8 389.4,81.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "392.5,84.5 391.4,83.8 392.5,83.3 393.4,83.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "377.9,77.2 376.8,76.6 377.9,76 378.8,76.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "378.8,77.9 377.9,77.2 378.8,76.6 379.9,77.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "379.9,78.4 378.8,77.9 379.9,77.2 381,77.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "383,80.3 382.1,79.6 383,79.1 384.1,79.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "385.2,81.4 384.1,80.8 385.2,80.3 386.1,80.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "387.2,82.6 386.1,82.1 387.2,81.4 388.3,82.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "388.3,83.3 387.2,82.6 388.3,82.1 389.4,82.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "389.4,83.8 388.3,83.3 389.4,82.6 390.3,83.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "390.3,84.5 389.4,83.8 390.3,83.3 391.4,83.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "391.4,85 390.3,84.5 391.4,83.8 392.5,84.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "378.8,79.1 377.9,78.4 378.8,77.9 379.9,78.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "381,80.3 379.9,79.6 381,79.1 382.1,79.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "382.1,80.8 381,80.3 382.1,79.6 383,80.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "385.2,82.6 384.1,82.1 385.2,81.4 386.1,82.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "387.2,83.8 386.1,83.3 387.2,82.6 388.3,83.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "388.3,84.5 387.2,83.8 388.3,83.3 389.4,83.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "374.7,77.9 373.7,77.2 374.7,76.6 375.7,77.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "376.8,75.4 375.7,74.7 376.8,74.2 377.9,74.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "375.7,78.4 374.7,77.9 375.7,77.2 376.8,77.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "377.9,79.6 376.8,79.1 377.9,78.4 378.8,79.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "381,81.4 379.9,80.8 381,80.3 382.1,80.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "384.1,83.3 383,82.6 384.1,82.1 385.2,82.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "386.1,84.5 385.2,83.8 386.1,83.3 387.2,83.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "373.7,78.4 372.6,77.9 373.7,77.2 374.7,77.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "374.7,79.1 373.7,78.4 374.7,77.9 375.7,78.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "376.8,80.3 375.7,79.6 376.8,79.1 377.9,79.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "377.9,80.8 376.8,80.3 377.9,79.6 378.8,80.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "378.8,81.4 377.9,80.8 378.8,80.3 379.9,80.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "381,82.6 379.9,82.1 381,81.4 382.1,82.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "383,83.8 382.1,83.3 383,82.6 384.1,83.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "385.2,85 384.1,84.5 385.2,83.8 386.1,84.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M371.5,72.4l-4.2,2.4l4.2,2.4l4.2-2.4L371.5,72.4z M371.5,76.4l-2.8-1.6l2.8-1.6l2.8,1.6L371.5,76.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "371.5,73.8 369.9,74.7 371.5,75.8 373.3,74.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M387.2,63.4l-4.2,2.4l4.2,2.4l4.2-2.4L387.2,63.4z M387.2,67.4l-2.8-1.6l2.8-1.6l2.8,1.6L387.2,67.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "387.2,64.7 385.4,65.8 387.2,66.8 389,65.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M403.9,73l-4.2,2.4l4.2,2.4l4.2-2.4L403.9,73z M403.9,77l-2.8-1.6l2.8-1.6l2.8,1.6L403.9,77z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "403.9,74.5 402.2,75.4 403.9,76.4 405.6,75.4  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M431.6,94c-11.2-7.2-29.8-8.1-41.6-2c-11.8,6.1-12.2,16.8-0.9,24s29.8,8.1,41.6,2 C442.3,112,442.9,101.2,431.6,94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M428.5,95.2c-9.8-6.2-25.7-7-36-1.8c-10.2,5.3-10.6,14.5-0.8,20.7c9.8,6.2,25.7,7,36,1.8 C437.9,110.8,438.3,101.4,428.5,95.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st222",
    d: "M408.7,119.6c7.3,0,14.1-1.6,19.1-4.5c5.1-3,7.9-6.8,7.9-11c0-4.1-2.8-7.9-7.7-10.8 c-5-3-11.9-4.6-19.1-4.6c-7.3,0-14.1,1.6-19.1,4.5c-5.1,3-7.9,6.8-7.9,11c0,4.1,2.8,7.9,7.7,10.8 C394.8,117.9,401.6,119.6,408.7,119.6z M408.7,119.3c-6.9,0-13.4-1.6-18.3-4.5c-4.9-2.8-7.6-6.6-7.6-10.7c0-4.1,2.7-8,7.7-10.8 c4.9-2.8,11.4-4.3,18.3-4.3c6.9,0,13.4,1.6,18.3,4.5c4.9,2.8,7.6,6.6,7.6,10.7c0,4.1-2.7,8-7.7,10.8 C422.1,117.8,415.6,119.3,408.7,119.3z M391.4,93.8c9.6-5.6,25.2-5.6,34.8,0.1c9.6,5.7,9.8,14.9,0.1,20.4 c-9.6,5.6-25.2,5.6-34.8-0.1C381.9,108.6,381.8,99.5,391.4,93.8z M401.8,100.9c-1.1-0.7-1.1-1.6,0-2.3c1.1-0.7,2.8-0.7,3.9,0 c0.9,0.5,1.1,1.4,0.4,2l21.3,12.6c0.5-0.4,1.1-0.9,1.6-1.4l-10.8-6.4l-1.9-3.3c-0.8,0-1.6-0.1-2.3-0.4c-1.1-0.7-1.1-1.6,0-2.3 c1.1-0.7,2.8-0.7,3.9,0c1.1,0.7,1.1,1.6,0,2.3c-0.1,0.1-0.3,0.1-0.4,0.1l1.9,3.1l10.4,6.1c5.1-5.4,3.8-12.3-4.1-16.9 c-9.3-5.6-24.5-5.6-33.9-0.1s-9.2,14.4,0.1,19.9c7.6,4.5,19,5.4,27.9,2.7l-10.2-6l-3.5-0.7c-0.1,0.1-0.1,0.1-0.3,0.3 c-1.1,0.7-2.8,0.7-3.9,0c-1.1-0.7-1.1-1.6,0-2.3c1.1-0.7,2.8-0.7,3.9,0c0.7,0.4,0.9,0.8,0.8,1.4l3.8,0.8l10.7,6.4 c0.8-0.3,1.8-0.7,2.4-0.9l-27.1-16.1c-1.1,0.4-2.4,0.3-3.4-0.3c-1.1-0.7-1.1-1.6,0-2.3c1.1-0.7,2.8-0.7,3.9,0 c0.9,0.5,1.1,1.4,0.4,2l26.9,16c0.4-0.3,0.8-0.4,1.4-0.7c0.3-0.1,0.5-0.3,0.8-0.4l-21.4-12.6 C404.3,101.6,402.8,101.4,401.8,100.9L401.8,100.9z M404.8,100.3c0.5-0.3,0.5-0.9,0-1.2c-0.5-0.3-1.5-0.4-2,0 c-0.5,0.3-0.5,0.9,0,1.2C403.3,100.7,404.3,100.7,404.8,100.3L404.8,100.3z M417.1,101.3c0.5-0.3,0.5-0.9,0-1.2 c-0.5-0.3-1.5-0.4-2,0c-0.5,0.3-0.5,0.9,0,1.2C415.5,101.6,416.5,101.6,417.1,101.3L417.1,101.3z M396.3,98.7 c0.5-0.3,0.5-0.9,0-1.2c-0.5-0.3-1.5-0.4-2,0c-0.5,0.3-0.5,0.8,0,1.2C394.8,99.1,395.7,99.1,396.3,98.7L396.3,98.7z  M404.9,109.7c0.5-0.3,0.5-0.8,0-1.2c-0.5-0.3-1.5-0.4-2,0c-0.5,0.4-0.5,0.9,0,1.2C403.5,110,404.4,110.1,404.9,109.7 L404.9,109.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M370.7,97.5c-6.1,3.5-15.8,3.5-21.9,0c-6.1-3.5-6.1-9.2-0.1-12.7c6.1-3.5,15.8-3.5,21.9,0 S376.8,94,370.7,97.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M370.4,97.2c2.8-1.6,4.3-3.8,4.3-6.1s-1.6-4.5-4.5-6.1c-2.8-1.6-6.6-2.6-10.7-2.6s-7.9,0.9-10.7,2.6 c-2.8,1.6-4.3,3.8-4.3,6.1s1.6,4.5,4.5,6.1c2.8,1.6,6.6,2.6,10.7,2.6C363.8,99.8,367.6,98.8,370.4,97.2z M349.6,97.2 c-2.8-1.6-4.3-3.8-4.3-6.1s1.5-4.3,4.2-6c2.7-1.6,6.4-2.4,10.2-2.4c3.8,0,7.4,0.8,10.3,2.4c2.8,1.6,4.3,3.8,4.3,6.1 c0,2.3-1.5,4.3-4.2,6c-2.7,1.6-6.4,2.4-10.2,2.4C355.9,99.7,352.3,98.8,349.6,97.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M369.5,97c-5.4,3.1-14.1,3.3-19.5,0s-5.3-8.3,0-11.5c5.4-3.1,14.1-3.3,19.5,0 C374.9,88.7,374.7,93.7,369.5,97z M363.5,89.4c-0.5,0.3-1.4,0.4-1.9,0.1l-11.9,7c0.1,0.1,0.3,0.1,0.4,0.3 c0.3,0.1,0.5,0.3,0.7,0.4l15-8.9c-0.4-0.4-0.3-0.8,0.3-1.1c0.5-0.4,1.6-0.4,2.2,0c0.5,0.4,0.5,0.9,0,1.2 c-0.5,0.3-1.4,0.4-1.9,0.1l-15,8.8c0.4,0.3,0.9,0.4,1.4,0.5l6-3.5l2.2-0.4c0-0.3,0.1-0.5,0.4-0.8c0.5-0.4,1.6-0.4,2.2,0 c0.5,0.4,0.5,0.9,0,1.2c-0.5,0.4-1.6,0.4-2.2,0l-0.1-0.1l-2,0.4l-5.7,3.4c5,1.5,11.4,0.9,15.6-1.5c5.3-3.1,5.3-8.1,0-11.1 c-5.3-3.1-13.7-3-19,0c-4.3,2.6-5.1,6.5-2.2,9.5l5.8-3.4l1.1-1.8c-0.1,0-0.1-0.1-0.3-0.1c-0.5-0.4-0.5-0.9,0-1.2 c0.5-0.4,1.6-0.4,2.2,0c0.5,0.4,0.5,0.9,0,1.2c-0.4,0.3-0.8,0.3-1.2,0.3l-1.1,1.8l-6,3.8c0.3,0.3,0.5,0.5,0.9,0.8l11.9-7 c-0.4-0.4-0.3-0.8,0.3-1.1c0.5-0.4,1.6-0.4,2.2,0C364.2,88.4,364.2,89,363.5,89.4L363.5,89.4z M361.9,89.1 c0.3,0.1,0.8,0.1,1.2,0c0.3-0.1,0.3-0.5,0-0.7c-0.3-0.1-0.8-0.1-1.2,0C361.6,88.6,361.6,88.8,361.9,89.1L361.9,89.1z  M355.1,89.5c0.3,0.1,0.8,0.1,1.2,0c0.3-0.1,0.3-0.5,0-0.7c-0.3-0.1-0.8-0.1-1.2,0C354.7,89.1,354.7,89.4,355.1,89.5 L355.1,89.5z M366.8,88.2c0.3,0.1,0.8,0.1,1.2,0c0.3-0.1,0.3-0.5,0-0.7c-0.3-0.1-0.8-0.1-1.2,0 C366.4,87.6,366.4,88,366.8,88.2L366.8,88.2z M361.9,94.2c0.3,0.1,0.8,0.1,1.2,0c0.3-0.1,0.3-0.5,0-0.7 c-0.3-0.1-0.8-0.1-1.2,0C361.6,93.8,361.6,94.1,361.9,94.2L361.9,94.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M473.2,118.2l1.5-0.9l-0.7-0.4l-2.4,0.4l-0.1,0.1l0.8,0.4l-0.5,0.3l0.7,0.4l0.5-0.3l0.3,0.1l0.3-0.1 L473.2,118.2z M472.5,117.8l-0.7-0.4l1.8-0.3L472.5,117.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M475.6,119c0-0.1-0.1-0.3-0.4-0.4h-0.1l0.5-0.4l0.7,0.4l0.3-0.1l-1.4-0.8l-1.1,0.7h0.1c0,0,0.1,0,0.1,0.1 l0.1,0.1l0.1,0.1v0.1l-0.1,0.1c-0.1,0-0.1,0.1-0.3,0.1s-0.1,0-0.3,0s-0.1,0-0.1,0h-0.1c-0.1,0-0.1-0.1-0.1-0.1 c0-0.1-0.1-0.1-0.1-0.3h-0.3c0,0.1,0.1,0.3,0.1,0.3c0.1,0.1,0.1,0.1,0.4,0.3c0.3,0.1,0.5,0.3,0.8,0.3s0.5,0,0.8-0.3 C475.5,119.3,475.6,119.2,475.6,119z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M471.3,116.3L471.3,116.3l0.5-0.4l0.7,0.4l0.3-0.1l-1.4-0.8l-1.1,0.7h0.1c0,0,0.1,0,0.1,0.1l0.1,0.1 l0.1,0.1v0.1l-0.1,0.1c-0.1,0-0.1,0.1-0.3,0.1c-0.1,0-0.1,0-0.3,0s-0.1,0-0.1,0H470c-0.1,0-0.1-0.1-0.1-0.1 c0-0.1-0.1-0.1-0.1-0.3h-0.3c0,0.1,0.1,0.3,0.1,0.3c0.1,0.1,0.1,0.1,0.4,0.3c0.3,0.1,0.5,0.3,0.8,0.3s0.5,0,0.8-0.3 c0.3-0.1,0.4-0.3,0.4-0.4C471.7,116.6,471.6,116.5,471.3,116.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M470.1,114.6l-3.1,0.8l0.3,0.1l0.4-0.1l0.8,0.4l-0.1,0.3l0.8,0.4l1.4-1.9H470.1z M468.5,115.6l-0.5-0.3 l1.1-0.3L468.5,115.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M481.2,121.6c0.1-0.1,0.1-0.3,0.1-0.3c0-0.1,0-0.1-0.1-0.3c-0.1-0.1-0.1-0.1-0.3-0.3s-0.3-0.1-0.4-0.1 c-0.1,0-0.3,0-0.4,0c-0.1,0-0.4,0-0.5,0.1c-0.1,0-0.4,0.1-0.7,0.3c-0.3,0.1-0.4,0.3-0.5,0.4c-0.1,0.1-0.1,0.3-0.1,0.3 c0,0.1,0,0.1,0.1,0.3c0.1,0.1,0.1,0.1,0.3,0.3c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0.3,0,0.5,0c0.1,0,0.4,0,0.5-0.1 c0.1,0,0.4-0.1,0.7-0.3C480.9,121.9,481.1,121.7,481.2,121.6z M480,121.6c-0.1,0.1-0.4,0.1-0.5,0.3c-0.1,0-0.3,0.1-0.3,0.1 c-0.1,0-0.1,0-0.1,0h-0.1l0,0c0,0,0,0,0-0.1c0,0,0.1-0.1,0.3-0.1c0.1-0.1,0.3-0.1,0.4-0.3c0.1-0.1,0.4-0.3,0.5-0.3 s0.3-0.1,0.3-0.1c0.1,0,0.1,0,0.1,0h0.1l0,0c0,0,0,0,0,0.1c0,0-0.1,0.1-0.3,0.1C480.4,121.3,480.1,121.5,480,121.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M478.5,119.7v-0.1l-0.1-0.1c-0.1,0-0.1-0.1-0.3-0.1s-0.1-0.1-0.3-0.1s-0.3,0-0.3-0.1c-0.1,0-0.3,0-0.3,0 c-0.1,0-0.3,0-0.3,0.1c-0.1,0.1-0.3,0.1-0.3,0.3c0,0.1,0,0.1,0.1,0.3c-0.3,0-0.4-0.1-0.5-0.1s-0.4,0.1-0.5,0.1 c-0.1,0.1-0.3,0.1-0.3,0.3c0,0.1,0,0.1,0,0.3c0,0.1,0.1,0.1,0.1,0.3c0.1,0.1,0.1,0.1,0.3,0.3c0.3,0.1,0.5,0.3,0.8,0.3 s0.5,0,0.8-0.1c0.1-0.1,0.3-0.3,0.3-0.3c0-0.1,0-0.3-0.1-0.3c0.1,0,0.1,0,0.3,0s0.1,0,0.3,0h0.1c0,0,0.1,0,0.1-0.1 C478.3,119.8,478.5,119.8,478.5,119.7z M476.7,120.2l-0.1,0.1c0,0-0.1,0-0.1,0.1h-0.1h-0.1v-0.1c0,0,0.1-0.1,0.4-0.3 c0.1-0.1,0.3-0.1,0.4-0.1c0.1,0,0.1,0,0.3,0c0,0,0.1,0.1,0,0.1C477,120,476.9,120.1,476.7,120.2z M477.7,119.6 c-0.1,0.1-0.3,0.1-0.4,0.1c-0.1,0,0-0.1,0.1-0.3c0.1-0.1,0.3-0.1,0.3-0.1h0.1c0,0,0,0,0,0.1 C477.8,119.4,477.8,119.6,477.7,119.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M491.3,128.2c0.3-0.1,0.4-0.3,0.5-0.4c0.1-0.1,0.1-0.3,0.1-0.3c0-0.1,0-0.1-0.1-0.3 c-0.1-0.1-0.1-0.1-0.3-0.3c-0.1-0.1-0.3-0.1-0.4-0.1c-0.1,0-0.3,0-0.4,0c-0.1,0-0.4,0-0.5,0.1c-0.1,0-0.4,0.1-0.7,0.3 c-0.3,0.1-0.4,0.3-0.5,0.4c-0.1,0.1-0.1,0.3-0.1,0.3c0,0.1,0,0.1,0.1,0.3c0.1,0.1,0.1,0.1,0.3,0.3c0.1,0.1,0.3,0.1,0.4,0.1 c0.1,0,0.3,0,0.5,0c0.1,0,0.4,0,0.5-0.1C490.9,128.4,491.2,128.4,491.3,128.2z M490.3,128.1c-0.1,0-0.3,0.1-0.3,0.1 c-0.1,0-0.1,0-0.1,0h-0.1l0,0c0,0,0,0,0-0.1c0,0,0.1-0.1,0.3-0.1c0.1-0.1,0.3-0.1,0.4-0.3c0.1-0.1,0.4-0.3,0.5-0.3 c0.1,0,0.3-0.1,0.3-0.1c0.1,0,0.1,0,0.1,0h0.1l0,0c0,0,0,0,0,0.1c0,0-0.1,0.1-0.3,0.1c-0.1,0.1-0.3,0.1-0.4,0.3 C490.5,128,490.4,128,490.3,128.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M494.3,128.5l-1.4-0.8l-0.3,0.1l0.9,0.5h-1.5l-0.1,0.1c0.1,0,0.1,0.1,0.1,0.1v0.1c0,0,0,0.1-0.1,0.1 l-0.1,0.1c0,0-0.1,0.1-0.3,0.1s-0.1,0-0.3,0s-0.1,0-0.3,0s-0.1,0-0.3-0.1c-0.1,0-0.1-0.1-0.1-0.1c0-0.1,0-0.1,0-0.1h-0.3v0.1 c0,0,0,0.1,0.1,0.1l0.1,0.1c0,0,0.1,0.1,0.3,0.1c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0.3,0,0.5,0c0.1,0,0.3,0,0.5,0 c0.1,0,0.3-0.1,0.4-0.1c0.1,0,0.1-0.1,0.3-0.1l0.1-0.1v-0.1c0,0,0-0.1,0-0.3h0.7L494.3,128.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M489.9,126.7c0.1-0.1,0.1-0.3,0.1-0.3c0-0.1,0-0.1-0.1-0.3c-0.1-0.1-0.1-0.1-0.3-0.3 c-0.1-0.1-0.3-0.1-0.4-0.1c-0.1,0-0.3,0-0.4,0c-0.1,0-0.4,0-0.5,0.1c-0.1,0-0.4,0.1-0.7,0.3c-0.3,0.1-0.4,0.3-0.5,0.4 s-0.1,0.3-0.1,0.3c0,0.1,0,0.1,0.1,0.3c0.1,0.1,0.1,0.1,0.3,0.3c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0.3,0,0.5,0 c0.1,0,0.4,0,0.5-0.1c0.1,0,0.4-0.1,0.7-0.3C489.6,126.9,489.9,126.7,489.9,126.7z M488.8,126.6c-0.1,0.1-0.4,0.1-0.5,0.3 c-0.1,0-0.3,0.1-0.3,0.1c-0.1,0-0.1,0-0.1,0h-0.1l0,0c0,0,0,0,0-0.1c0,0,0.1-0.1,0.3-0.1c0.1-0.1,0.3-0.1,0.4-0.3 c0.1-0.1,0.4-0.3,0.5-0.3s0.3-0.1,0.3-0.1c0.1,0,0.1,0,0.1,0h0.1l0,0c0,0,0,0,0,0.1c0,0-0.1,0.1-0.3,0.1 C489,126.5,488.9,126.6,488.8,126.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M487.3,124.9l0.3-0.1l-1.4-0.8l-1.1,0.7h0.1c0,0,0.1,0,0.1,0.1l0.1,0.1l0.1,0.1v0.1l-0.1,0.1 c-0.1,0-0.1,0.1-0.3,0.1s-0.1,0-0.3,0h-0.1h-0.1c-0.1,0-0.1-0.1-0.1-0.1c0-0.1-0.1-0.1-0.1-0.3h-0.3c0,0.1,0.1,0.3,0.1,0.3 c0.1,0.1,0.1,0.1,0.4,0.3c0.3,0.1,0.5,0.3,0.8,0.3s0.5,0,0.8-0.3c0.3-0.1,0.4-0.3,0.4-0.4c0-0.1-0.1-0.3-0.4-0.4h-0.1l0.5-0.4 L487.3,124.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M483.1,122.8c0.1-0.1,0.1-0.3,0.1-0.3c0-0.1,0-0.1-0.1-0.3c-0.1-0.1-0.1-0.1-0.3-0.3 c-0.1-0.1-0.3-0.1-0.4-0.1c-0.1,0-0.3,0-0.4,0c-0.1,0-0.4,0-0.5,0.1c-0.1,0-0.4,0.1-0.7,0.3c-0.3,0.1-0.4,0.3-0.5,0.4 c-0.1,0.1-0.1,0.3-0.1,0.3c0,0.1,0,0.1,0.1,0.3c0.1,0.1,0.1,0.1,0.3,0.3c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0.3,0,0.5,0 c0.1,0,0.4,0,0.5-0.1c0.1,0,0.4-0.1,0.7-0.3C482.8,123,483,122.8,483.1,122.8z M482,122.7c-0.1,0.1-0.4,0.1-0.5,0.3 c-0.1,0-0.3,0.1-0.3,0.1c-0.1,0-0.1,0-0.1,0h-0.1l0,0c0,0,0,0,0-0.1c0,0,0.1-0.1,0.3-0.1c0.1-0.1,0.3-0.1,0.4-0.3 c0.1-0.1,0.4-0.3,0.5-0.3s0.3-0.1,0.3-0.1c0.1,0,0.1,0,0.1,0h0.1l0,0c0,0,0,0,0,0.1c0,0-0.1,0.1-0.3,0.1 C482.3,122.5,482.1,122.7,482,122.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M484.6,124.3c0.3-0.1,0.4-0.3,0.5-0.4c0.1-0.1,0.1-0.3,0.1-0.3c0-0.1,0-0.1-0.1-0.3 c-0.1-0.1-0.1-0.1-0.3-0.3c-0.1-0.1-0.3-0.1-0.4-0.1c-0.1,0-0.3,0-0.4,0c-0.1,0-0.4,0-0.5,0.1c-0.1,0-0.4,0.1-0.7,0.3 c-0.3,0.1-0.4,0.3-0.5,0.4c-0.1,0.1-0.1,0.3-0.1,0.3c0,0.1,0,0.1,0.1,0.3c0.1,0.1,0.1,0.1,0.3,0.3c0.1,0.1,0.3,0.1,0.4,0.1 c0.1,0,0.3,0,0.5,0c0.1,0,0.4,0,0.5-0.1C484.2,124.4,484.4,124.4,484.6,124.3z M483.5,124.2c-0.1,0-0.3,0.1-0.3,0.1 c-0.1,0-0.1,0-0.1,0H483l0,0c0,0,0,0,0-0.1c0,0,0.1-0.1,0.3-0.1c0.1-0.1,0.3-0.1,0.4-0.3c0.1-0.1,0.4-0.3,0.5-0.3 s0.3-0.1,0.3-0.1c0.1,0,0.1,0,0.1,0h0.1l0,0c0,0,0,0,0,0.1c0,0-0.1,0.1-0.3,0.1c-0.1,0.1-0.3,0.1-0.4,0.3 C483.8,124,483.6,124,483.5,124.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M468.9,120.7l1.5-0.9l-0.7-0.4l-2.4,0.4l-0.1,0.1l0.8,0.4l-0.5,0.3l0.7,0.4l0.5-0.3l0.3,0.1l0.3-0.1 L468.9,120.7z M468.2,120.2l-0.7-0.4l1.8-0.3L468.2,120.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M471.3,121.5c0-0.1-0.1-0.3-0.4-0.4h-0.1l0.5-0.4l0.7,0.4l0.3-0.1l-1.4-0.8l-1.1,0.7h0.1 c0,0,0.1,0,0.1,0.1l0.1,0.1l0.1,0.1v0.1l-0.1,0.1c-0.1,0-0.1,0.1-0.3,0.1s-0.1,0-0.3,0s-0.1,0-0.1,0h-0.1 c-0.1,0-0.1-0.1-0.1-0.1c0-0.1-0.1-0.1-0.1-0.3h-0.3c0,0.1,0.1,0.3,0.1,0.3c0.1,0.1,0.1,0.1,0.4,0.3c0.3,0.1,0.5,0.3,0.8,0.3 s0.5,0,0.8-0.3C471.3,121.7,471.3,121.6,471.3,121.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M467,118.8L467,118.8l0.5-0.4l0.7,0.4l0.3-0.1l-1.4-0.8l-1.1,0.7h0.1c0,0,0.1,0,0.1,0.1l0.1,0.1l0.1,0.1 v0.1l-0.1,0.1c-0.1,0-0.1,0.1-0.3,0.1s-0.1,0-0.3,0s-0.1,0-0.1,0h-0.1c-0.1,0-0.1-0.1-0.1-0.1c0-0.1-0.1-0.1-0.1-0.3h-0.3 c0,0.1,0.1,0.3,0.1,0.3c0.1,0.1,0.1,0.1,0.4,0.3c0.3,0.1,0.5,0.3,0.8,0.3s0.5,0,0.8-0.3c0.3-0.1,0.4-0.3,0.4-0.4 C467.4,119,467.2,118.9,467,118.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M465.8,117l-3.1,0.8l0.3,0.1l0.4-0.1l0.8,0.4l-0.1,0.3l0.8,0.4l1.4-1.9H465.8z M464.1,118.1l-0.5-0.3 l1.1-0.3L464.1,118.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M476.9,124.2c0.1-0.1,0.1-0.3,0.1-0.3c0-0.1,0-0.1-0.1-0.3c-0.1-0.1-0.1-0.1-0.3-0.3 c-0.1-0.1-0.3-0.1-0.4-0.1c-0.1,0-0.3,0-0.4,0c-0.1,0-0.4,0-0.5,0.1c-0.1,0-0.4,0.1-0.7,0.3c-0.3,0.1-0.4,0.3-0.5,0.4 c-0.1,0.1-0.1,0.3-0.1,0.3c0,0.1,0,0.1,0.1,0.3c0.1,0.1,0.1,0.1,0.3,0.3c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0.3,0,0.5,0 c0.1,0,0.4,0,0.5-0.1c0.1,0,0.4-0.1,0.7-0.3C476.6,124.3,476.7,124.2,476.9,124.2z M475.6,124c-0.1,0.1-0.4,0.1-0.5,0.3 c-0.1,0-0.3,0.1-0.3,0.1c-0.1,0-0.1,0-0.1,0h-0.1l0,0c0,0,0,0,0-0.1c0,0,0.1-0.1,0.3-0.1c0.1-0.1,0.3-0.1,0.4-0.3 c0.1-0.1,0.4-0.3,0.5-0.3s0.3-0.1,0.3-0.1c0.1,0,0.1,0,0.1,0h0.1l0,0c0,0,0,0,0,0.1c0,0-0.1,0.1-0.3,0.1 C476,123.9,475.8,124,475.6,124z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M474.2,122.3v-0.1L474,122c-0.1,0-0.1-0.1-0.3-0.1s-0.1-0.1-0.3-0.1s-0.3,0-0.3-0.1c-0.1,0-0.3,0-0.3,0 c-0.1,0-0.3,0-0.3,0.1c-0.1,0.1-0.3,0.1-0.3,0.3c0,0.1,0,0.1,0.1,0.3c-0.3,0-0.4-0.1-0.5-0.1s-0.4,0.1-0.5,0.1 c-0.1,0.1-0.3,0.1-0.3,0.3c0,0.1,0,0.1,0,0.3c0,0.1,0.1,0.1,0.1,0.3c0.1,0.1,0.1,0.1,0.3,0.3c0.3,0.1,0.5,0.3,0.8,0.3 s0.5,0,0.8-0.1c0.1-0.1,0.3-0.3,0.3-0.3c0-0.1,0-0.3-0.1-0.3c0.1,0,0.1,0,0.3,0s0.1,0,0.3,0h0.1c0,0,0.1,0,0.1-0.1 C474,122.3,474.2,122.3,474.2,122.3z M472.4,122.7l-0.1,0.1c0,0-0.1,0-0.1,0.1H472h-0.1v-0.1c0,0,0.1-0.1,0.4-0.3 c0.1-0.1,0.3-0.1,0.4-0.1c0.1,0,0.1,0,0.3,0c0,0,0.1,0.1,0,0.1C472.7,122.5,472.5,122.5,472.4,122.7z M473.3,122.1 c-0.1,0.1-0.3,0.1-0.4,0.1c-0.1,0,0-0.1,0.1-0.3c0.1-0.1,0.3-0.1,0.3-0.1c0.1,0,0.1,0,0.1,0s0,0,0,0.1 C473.5,122,473.5,122,473.3,122.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M487,130.7c0.3-0.1,0.4-0.3,0.5-0.4s0.1-0.3,0.1-0.3c0-0.1,0-0.1-0.1-0.3c-0.1-0.1-0.1-0.1-0.3-0.3 c-0.1-0.1-0.3-0.1-0.4-0.1c-0.1,0-0.3,0-0.4,0c-0.1,0-0.4,0-0.5,0.1c-0.1,0-0.4,0.1-0.7,0.3c-0.3,0.1-0.4,0.3-0.5,0.4 s-0.1,0.3-0.1,0.3c0,0.1,0,0.1,0.1,0.3c0.1,0.1,0.1,0.1,0.3,0.3c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0.3,0,0.5,0 c0.1,0,0.4,0,0.5-0.1C486.6,130.9,486.9,130.8,487,130.7z M485.9,130.5c-0.1,0-0.3,0.1-0.3,0.1c-0.1,0-0.1,0-0.1,0h-0.1l0,0 c0,0,0,0,0-0.1c0,0,0.1-0.1,0.3-0.1c0.1-0.1,0.3-0.1,0.4-0.3c0.1-0.1,0.4-0.3,0.5-0.3s0.3-0.1,0.3-0.1c0.1,0,0.1,0,0.1,0h0.1 l0,0c0,0,0,0,0,0.1c0,0-0.1,0.1-0.3,0.1c-0.1,0.1-0.3,0.1-0.4,0.3C486.2,130.4,486.1,130.5,485.9,130.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M490,131.1l-1.4-0.8l-0.3,0.1l0.9,0.5h-1.5l-0.1,0.1c0.1,0,0.1,0.1,0.1,0.1v0.1c0,0,0,0.1-0.1,0.1 l-0.1,0.1c0,0-0.1,0.1-0.3,0.1s-0.1,0-0.3,0s-0.1,0-0.3,0s-0.1,0-0.3-0.1c-0.1,0-0.1-0.1-0.1-0.1c0-0.1,0-0.1,0-0.1h-0.3v0.1 c0,0,0,0.1,0.1,0.1l0.1,0.1c0,0,0.1,0.1,0.3,0.1c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0.3,0,0.5,0c0.1,0,0.3,0,0.5,0 c0.1,0,0.3-0.1,0.4-0.1c0.1,0,0.1-0.1,0.3-0.1l0.1-0.1v-0.1c0,0,0-0.1,0-0.3h0.7L490,131.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M485.5,129.2c0.1-0.1,0.1-0.3,0.1-0.3c0-0.1,0-0.1-0.1-0.3c-0.1-0.1-0.1-0.1-0.3-0.3 c-0.1-0.1-0.3-0.1-0.4-0.1c-0.1,0-0.3,0-0.4,0c-0.1,0-0.4,0-0.5,0.1c-0.1,0-0.4,0.1-0.7,0.3c-0.3,0.1-0.4,0.3-0.5,0.4 s-0.1,0.3-0.1,0.3c0,0.1,0,0.1,0.1,0.3c0.1,0.1,0.1,0.1,0.3,0.3c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0.3,0,0.5,0 c0.1,0,0.4,0,0.5-0.1c0.1,0,0.4-0.1,0.7-0.3C485.3,129.5,485.5,129.3,485.5,129.2z M484.4,129.2c-0.1,0.1-0.4,0.1-0.5,0.3 c-0.1,0-0.3,0.1-0.3,0.1c-0.1,0-0.1,0-0.1,0h-0.1l0,0c0,0,0,0,0-0.1c0,0,0.1-0.1,0.3-0.1c0.1-0.1,0.3-0.1,0.4-0.3 c0.1-0.1,0.4-0.3,0.5-0.3s0.3-0.1,0.3-0.1c0.1,0,0.1,0,0.1,0h0.1l0,0c0,0,0,0,0,0.1c0,0-0.1,0.1-0.3,0.1 C484.7,128.9,484.6,129,484.4,129.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M483,127.3l0.3-0.1l-1.4-0.8l-1.1,0.7h0.1c0,0,0.1,0,0.1,0.1l0.1,0.1l0.1,0.1v0.1l-0.1,0.1 c-0.1,0-0.1,0.1-0.3,0.1s-0.1,0-0.3,0h-0.1h-0.1c-0.1,0-0.1-0.1-0.1-0.1c0-0.1-0.1-0.1-0.1-0.3h-0.3c0,0.1,0.1,0.3,0.1,0.3 c0.1,0.1,0.1,0.1,0.4,0.3c0.3,0.1,0.5,0.3,0.8,0.3s0.5,0,0.8-0.3c0.3-0.1,0.4-0.3,0.4-0.4c0-0.1-0.1-0.3-0.4-0.4h-0.1l0.5-0.4 L483,127.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M478.8,125.3c0.1-0.1,0.1-0.3,0.1-0.3c0-0.1,0-0.1-0.1-0.3c-0.1-0.1-0.1-0.1-0.3-0.3 c-0.1-0.1-0.3-0.1-0.4-0.1c-0.1,0-0.3,0-0.4,0c-0.1,0-0.4,0-0.5,0.1c-0.1,0-0.4,0.1-0.7,0.3c-0.3,0.1-0.4,0.3-0.5,0.4 c-0.1,0.1-0.1,0.3-0.1,0.3c0,0.1,0,0.1,0.1,0.3c0.1,0.1,0.1,0.1,0.3,0.3c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0.3,0,0.5,0 c0.1,0,0.4,0,0.5-0.1c0.1,0,0.4-0.1,0.7-0.3C478.5,125.5,478.6,125.4,478.8,125.3z M477.7,125.3c-0.1,0.1-0.4,0.1-0.5,0.3 c-0.1,0-0.3,0.1-0.3,0.1c-0.1,0-0.1,0-0.1,0h-0.1l0,0c0,0,0,0,0-0.1c0,0,0.1-0.1,0.3-0.1c0.1-0.1,0.3-0.1,0.4-0.3 c0.1-0.1,0.4-0.3,0.5-0.3s0.3-0.1,0.3-0.1c0.1,0,0.1,0,0.1,0h0.1l0,0c0,0,0,0,0,0.1c0,0-0.1,0.1-0.3,0.1 C477.9,125,477.8,125.1,477.7,125.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M480.2,126.7c0.3-0.1,0.4-0.3,0.5-0.4c0.1-0.1,0.1-0.3,0.1-0.3c0-0.1,0-0.1-0.1-0.3 c-0.1-0.1-0.1-0.1-0.3-0.3c-0.1-0.1-0.3-0.1-0.4-0.1c-0.1,0-0.3,0-0.4,0c-0.1,0-0.4,0-0.5,0.1c-0.1,0-0.4,0.1-0.7,0.3 c-0.3,0.1-0.4,0.3-0.5,0.4c-0.1,0.1-0.1,0.3-0.1,0.3c0,0.1,0,0.1,0.1,0.3c0.1,0.1,0.1,0.1,0.3,0.3c0.1,0.1,0.3,0.1,0.4,0.1 c0.1,0,0.3,0,0.5,0c0.1,0,0.4,0,0.5-0.1C479.8,127,480.1,126.9,480.2,126.7z M479.2,126.6c-0.1,0-0.3,0.1-0.3,0.1 c-0.1,0-0.1,0-0.1,0h-0.1l0,0c0,0,0,0,0-0.1c0,0,0.1-0.1,0.3-0.1c0.1-0.1,0.3-0.1,0.4-0.3c0.1-0.1,0.4-0.3,0.5-0.3 s0.3-0.1,0.3-0.1c0.1,0,0.1,0,0.1,0h0.1l0,0c0,0,0,0,0,0.1c0,0-0.1,0.1-0.3,0.1c-0.1,0.1-0.3,0.1-0.4,0.3 C479.4,126.5,479.3,126.6,479.2,126.6z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "436.5,85.3 470.6,104.9 409.4,140.2 375.4,120.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st192",
    points: "375.4,151.9 409.4,171.7 409.4,140.2 375.4,120.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "379.6,123 440.8,87.7 436.5,85.3 375.4,120.5 375.4,151.9 379.6,154.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "409.4,140.2 470.5,104.9 466.3,102.4 405.1,137.7 405.1,169.1 409.4,171.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.6,123 375.4,120.5 375.4,151.9 379.6,154.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.4,140.2 405.1,137.7 405.1,169.1 409.4,171.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M505,132.8c-2.8-1.6-7.4-1.6-10.3,0c-2.8,1.6-2.8,4.3,0,6c2.8,1.6,7.4,1.6,10.3,0 C508,137.2,507.9,134.5,505,132.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_x37__2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110444322893810655930000004354077282131329668_",
    gradientUnits: "userSpaceOnUse",
    x1: 345.9013,
    y1: 527.4578,
    x2: 417.813,
    y2: 527.4578,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000110444322893810655930000004354077282131329668_)"
    },
    d: "M417.8,190l-71.9,0.3 c0,2.7,0,5.6,0,8.3c0.1,7.4,7.2,14.8,21,18.6c9.8,2.7,20.2,2.7,29.9-0.1c13.8-3.9,20.7-11.4,20.7-18.8L417.8,190z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093872493781168933500000017569382211907204488_",
    gradientUnits: "userSpaceOnUse",
    x1: 346.8,
    y1: 525.1472,
    x2: 417.1013,
    y2: 525.1472,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000093872493781168933500000017569382211907204488_)",
      enableBackground: "new"
    },
    d: " M349.3,199.2v7.9c-1.2-1.5-2-3-2.6-4.5v-7.7C347.4,196.4,348.2,197.8,349.3,199.2z M367.7,209.5v7.9c0.8,0.3,1.6,0.4,2.6,0.7 v-8C369.3,209.9,368.5,209.8,367.7,209.5z M378.1,211v8.1c0.8,0,1.6,0,2.6,0.1v-8.1C379.8,211.1,378.9,211.1,378.1,211z  M373,210.4v8c0.8,0.1,1.6,0.3,2.6,0.4v-8C374.6,210.8,373.8,210.6,373,210.4z M352,202v7.7c0.8,0.7,1.6,1.4,2.6,1.9v-7.9 C353.8,203.3,352.8,202.7,352,202z M362.4,208v7.9c0.8,0.3,1.6,0.5,2.6,0.8v-7.9C364.2,208.4,363.2,208.3,362.4,208z  M357.3,205.6v7.9c0.8,0.4,1.6,0.8,2.6,1.2v-7.9C358.9,206.4,358.1,206,357.3,205.6z M383.3,211.1v8.1c0.8,0,1.6,0,2.6-0.1 V211C385,211,384.2,211.1,383.3,211.1z M409.4,203.5v7.9c0.9-0.7,1.8-1.4,2.6-2v-7.7C411.2,202.5,410.2,203,409.4,203.5z  M388.6,210.8v8c0.8-0.1,1.6-0.3,2.6-0.4v-8C390.2,210.6,389.4,210.7,388.6,210.8z M414.6,198.8v7.9c1.2-1.5,2-3.1,2.6-4.6 v-7.6C416.6,196,415.6,197.4,414.6,198.8z M404.1,206.5v7.9c0.8-0.4,1.8-0.8,2.6-1.2v-7.7 C405.9,205.8,405.1,206.1,404.1,206.5z M399,208.5v7.9c0.8-0.3,1.8-0.5,2.6-0.8v-7.9C400.7,208.1,399.8,208.3,399,208.5z  M393.7,209.9v8c0.8-0.1,1.6-0.4,2.6-0.7v-7.9C395.5,209.6,394.7,209.8,393.7,209.9z"
  }), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "M407.2,175.6c14.1,8,14.1,21.1,0.1,29.4c-13.9,8.3-36.7,8.3-50.8,0.3c-14.1-8-14.1-21.1-0.1-29.4 C370.4,167.8,393.2,167.6,407.2,175.6z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M406.2,176c-6.5-3.7-15-5.7-24.1-5.7c-9.3,0-18,2.2-24.6,6c-6.6,3.8-10.2,8.9-10.2,14.4 c0,5.4,3.7,10.4,10.3,14.2c6.5,3.7,15,5.7,24.1,5.7c9.3,0,18-2.2,24.6-6c6.6-3.8,10.2-8.9,10.2-14.4 C416.5,184.8,412.8,179.8,406.2,176z M406,204.1c-6.5,3.8-15,5.8-24.2,5.8c-8.9,0-17.5-2-23.8-5.7s-9.9-8.5-9.9-13.7 s3.5-10,9.8-13.7c6.5-3.8,15-5.8,24.2-5.8c8.9,0,17.5,2,23.8,5.7s9.9,8.5,9.9,13.7C415.8,195.4,412.3,200.3,406,204.1z"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M404.8,177.4c12.7,7.2,12.7,18.8,0.1,26c-12.6,7.2-33.2,7.2-45.9,0c-12.7-7.2-12.7-18.8-0.1-26 C371.5,170.4,392.1,170.4,404.8,177.4z M374.6,185.3c1.2,0.7,1.4,1.8,0.5,2.6l28.2,15.8c0.4-0.1,0.7-0.4,1.1-0.5 c0.5-0.3,1.1-0.7,1.6-0.9l-35.6-20c-1.4,0.5-3.3,0.4-4.5-0.3c-1.4-0.8-1.5-2,0-2.8c1.4-0.8,3.7-0.8,5.1,0 c1.2,0.7,1.4,1.8,0.5,2.6l35.5,20c0.8-0.5,1.6-1.2,2.3-1.9l-14.1-8l-1.8-2.8c-1.1,0.1-2.2-0.1-3.1-0.5c-1.4-0.8-1.4-2.2,0-2.8 c1.4-0.8,3.7-0.8,5.1,0c1.4,0.8,1.5,2,0,2.8c-0.1,0.1-0.3,0.1-0.5,0.3l1.6,2.6l13.4,7.6c6.1-6.8,4.1-15.2-5.8-20.9 c-12.3-7-32.4-6.9-44.7,0c-12.3,7-12.2,18.3,0.1,25.3c10.3,5.8,25.9,6.8,37.8,3l-13.7-7.7l-6.9-1.4c-0.1,0.1-0.3,0.3-0.4,0.3 c-1.4,0.8-3.7,0.8-5.1,0c-1.4-0.8-1.4-2.2,0-2.8c1.4-0.8,3.7-0.8,5.1,0c0.8,0.4,1.1,1.1,1.1,1.6l7.3,1.5l14.2,8 c1.1-0.4,2-0.8,3-1.2l-28-15.8c-1.4,0.5-3.3,0.4-4.5-0.3c-1.4-0.8-1.5-2,0-2.8C371,184.4,373.3,184.4,374.6,185.3L374.6,185.3 z M373.4,187.6c0.8-0.4,0.8-1.1,0-1.5c-0.8-0.4-2-0.4-2.7,0c-0.8,0.4-0.8,1.1,0,1.5C371.5,188,372.7,188,373.4,187.6 L373.4,187.6z M375.3,196.6c0.8-0.4,0.8-1.1,0-1.5c-0.8-0.4-2-0.4-2.7,0c-0.8,0.4-0.8,1.1,0,1.5 C373.3,197,374.5,197,375.3,196.6L375.3,196.6z M369.9,181.1c0.8-0.4,0.7-1.1,0-1.5c-0.8-0.4-2-0.4-2.7,0 c-0.8,0.4-0.8,1.1,0,1.5C367.8,181.5,369.1,181.5,369.9,181.1L369.9,181.1z M394.2,187.6c0.8-0.4,0.8-1.1,0-1.5 c-0.8-0.4-2-0.4-2.7,0c-0.8,0.4-0.7,1.1,0,1.5C392.4,188,393.6,188,394.2,187.6L394.2,187.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106136099501311418830000004050446936746650039_",
    gradientUnits: "userSpaceOnUse",
    x1: 348.1402,
    y1: 536.1251,
    x2: 420.052,
    y2: 536.1251,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106136099501311418830000004050446936746650039_)"
    },
    d: "M420,181.3l-71.9,0.3 c0,2.7,0,5.6,0,8.3c0.1,7.4,7.2,14.8,21,18.6c9.8,2.7,20.2,2.7,29.9-0.1c13.8-3.9,20.7-11.4,20.7-18.8L420,181.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000128484156264690167680000006711857905527227528_",
    gradientUnits: "userSpaceOnUse",
    x1: 349.0162,
    y1: 533.95,
    x2: 419.3028,
    y2: 533.95,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000128484156264690167680000006711857905527227528_)",
      enableBackground: "new"
    },
    d: " M351.6,190.4v7.9c-1.2-1.5-2-3-2.6-4.5v-7.7C349.6,187.7,350.5,189,351.6,190.4z M369.9,200.7v7.9c0.8,0.3,1.6,0.4,2.6,0.7 v-8C371.6,201.1,370.8,201,369.9,200.7z M380.3,202.2v8.1c0.8,0,1.6,0,2.6,0.1v-8.1C382.1,202.3,381.2,202.3,380.3,202.2z  M375.2,201.8v8c0.8,0.1,1.6,0.3,2.6,0.4v-8C376.8,202,376,201.8,375.2,201.8z M354.3,193.4v7.7c0.8,0.7,1.6,1.4,2.6,1.9 v-7.9C355.9,194.5,355,193.9,354.3,193.4z M364.7,199.2v7.9c0.8,0.3,1.6,0.5,2.6,0.8V200 C366.4,199.7,365.5,199.5,364.7,199.2z M359.4,196.8v7.9c0.8,0.4,1.6,0.8,2.6,1.2V198C361.2,197.6,360.3,197.3,359.4,196.8z  M385.6,202.3v8.1c0.8,0,1.6,0,2.6-0.1v-8.1C387.2,202.2,386.4,202.3,385.6,202.3z M411.6,194.7v7.9c0.9-0.7,1.8-1.4,2.6-2 v-7.7C413.3,193.6,412.4,194.2,411.6,194.7z M390.7,202v8c0.8-0.1,1.6-0.3,2.6-0.4v-8C392.5,201.8,391.7,201.9,390.7,202z  M416.7,190v7.9c1.2-1.5,2-3.1,2.6-4.6v-7.6C418.8,187.1,417.9,188.6,416.7,190z M406.4,197.7v7.9c0.8-0.4,1.8-0.8,2.6-1.2 v-7.7C408.1,197,407.2,197.3,406.4,197.7z M401.2,199.7v7.9c0.8-0.3,1.8-0.5,2.6-0.8v-7.9C402.9,199.3,402,199.5,401.2,199.7 z M396,201.1v8c0.8-0.1,1.6-0.4,2.6-0.7v-7.9C397.6,200.8,396.8,201,396,201.1z"
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1 -4.190579e-03 4.190579e-03 1 -0.7582 1.6112)",
    className: "st189",
    cx: 384.1,
    cy: 181.7,
    rx: 35.9,
    ry: 20.7
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M408.5,167.2c-6.5-3.7-15-5.7-24.1-5.7c-9.3,0-18,2.2-24.6,6c-6.6,3.8-10.2,8.9-10.2,14.4 c0,5.4,3.7,10.4,10.3,14.2c6.5,3.7,15,5.7,24.1,5.7c9.3,0,18-2.2,24.6-6c6.6-3.8,10.2-8.9,10.2-14.4 C418.6,176.2,415.1,171,408.5,167.2z M408.2,195.3c-6.5,3.8-15,5.8-24.2,5.8c-8.9,0-17.5-2-23.8-5.7s-9.9-8.5-9.9-13.7 c0-5.1,3.5-10,9.8-13.7c6.5-3.8,15-5.8,24.2-5.8c8.9,0,17.5,2,23.8,5.7c6.4,3.7,9.9,8.5,9.9,13.7 C417.9,186.7,414.6,191.6,408.2,195.3z"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M407,168.7c12.7,7.2,12.7,18.8,0.1,26c-12.6,7.2-33.2,7.2-45.9,0c-12.7-7.2-12.7-18.8-0.1-26 C373.8,161.6,394.4,161.6,407,168.7z M376.8,176.4c1.2,0.7,1.4,1.8,0.5,2.6l28.2,15.8c0.4-0.1,0.7-0.4,1.1-0.5 c0.5-0.3,1.1-0.7,1.6-0.9l-35.6-20c-1.4,0.5-3.3,0.4-4.5-0.3c-1.4-0.8-1.5-2,0-2.8c1.4-0.8,3.7-0.8,5.1,0 c1.2,0.7,1.4,1.8,0.5,2.6l35.5,20c0.8-0.5,1.6-1.2,2.3-1.9l-14.1-8l-1.8-2.8c-1.1,0.1-2.2-0.1-3.1-0.5c-1.4-0.8-1.4-2.2,0-2.8 c1.4-0.8,3.7-0.8,5.1,0c1.4,0.8,1.5,2,0,2.8c-0.1,0.1-0.3,0.1-0.5,0.3l1.6,2.6l13.4,7.6c6.1-6.8,4.1-15.2-5.8-20.9 c-12.3-7-32.4-6.9-44.7,0c-12.3,7-12.2,18.3,0.1,25.3c10.3,5.8,25.9,6.8,37.8,3l-13.7-7.7l-6.9-1.4c-0.1,0.1-0.3,0.3-0.4,0.3 c-1.4,0.8-3.7,0.8-5.1,0c-1.4-0.8-1.4-2.2,0-2.8c1.4-0.8,3.7-0.8,5.1,0c0.8,0.4,1.1,1.1,1.1,1.6l7.3,1.5l14.2,8 c1.1-0.4,2-0.8,3-1.2l-28-15.8c-1.4,0.5-3.3,0.4-4.5-0.3c-1.4-0.8-1.5-2,0-2.8C373.1,175.6,375.4,175.6,376.8,176.4 L376.8,176.4z M375.7,178.8c0.8-0.4,0.8-1.1,0-1.5c-0.8-0.4-2-0.4-2.7,0c-0.8,0.4-0.8,1.1,0,1.5 C373.7,179.2,374.9,179.2,375.7,178.8L375.7,178.8z M377.5,187.8c0.8-0.4,0.8-1.1,0-1.5c-0.8-0.4-2-0.4-2.7,0 c-0.8,0.4-0.8,1.1,0,1.5S376.8,188.2,377.5,187.8L377.5,187.8z M372,172.3c0.8-0.4,0.7-1.1,0-1.5c-0.8-0.4-2-0.4-2.7,0 c-0.8,0.4-0.8,1.1,0,1.5C370,172.7,371.2,172.7,372,172.3L372,172.3z M396.6,178.8c0.8-0.4,0.8-1.1,0-1.5 c-0.8-0.4-2-0.4-2.7,0c-0.8,0.4-0.7,1.1,0,1.5C394.5,179.2,395.7,179.2,396.6,178.8L396.6,178.8z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019672340382803283310000009382935643114649476_",
    gradientUnits: "userSpaceOnUse",
    x1: 344.9533,
    y1: 544.7925,
    x2: 416.8651,
    y2: 544.7925,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000019672340382803283310000009382935643114649476_)"
    },
    d: "M416.9,172.7l-71.9,0.3 c0,2.7,0,5.6,0,8.3c0.1,7.4,7.2,14.8,21,18.6c9.8,2.7,20.2,2.7,29.9-0.1c13.8-3.9,20.7-11.4,20.7-18.8L416.9,172.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084528998990765252640000013289361706564826517_",
    gradientUnits: "userSpaceOnUse",
    x1: 345.7659,
    y1: 542.5496,
    x2: 416.067,
    y2: 542.5496,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000084528998990765252640000013289361706564826517_)",
      enableBackground: "new"
    },
    d: " M348.3,181.7v7.9c-1.2-1.5-2-3-2.6-4.5v-7.7C346.4,179,347.3,180.4,348.3,181.7z M366.8,192.2v7.9c0.8,0.3,1.6,0.4,2.6,0.7 v-8C368.4,192.4,367.6,192.3,366.8,192.2z M377.2,193.5v8.1c0.8,0,1.6,0,2.6,0.1v-8.1C378.8,193.6,378,193.6,377.2,193.5z  M371.9,193.1v8c0.8,0.1,1.6,0.3,2.6,0.4v-8C373.7,193.4,372.9,193.2,371.9,193.1z M351,184.7v7.7c0.8,0.7,1.6,1.4,2.6,1.9 v-7.9C352.8,185.8,351.9,185.3,351,184.7z M361.5,190.5v7.9c0.8,0.3,1.6,0.5,2.6,0.8v-7.9 C363.2,191.1,362.3,190.8,361.5,190.5z M356.3,188.1v7.9c0.8,0.4,1.6,0.8,2.6,1.2v-7.9C358,188.9,357.1,188.6,356.3,188.1z  M382.3,193.6v8.1c0.8,0,1.6,0,2.6-0.1v-8.1C384.1,193.6,383.3,193.6,382.3,193.6z M408.5,186.2v7.9c0.9-0.7,1.8-1.4,2.6-2 v-7.7C410.2,185,409.3,185.5,408.5,186.2z M387.6,193.4v8c0.8-0.1,1.6-0.3,2.6-0.4v-8C389.2,193.1,388.4,193.2,387.6,193.4z  M413.6,181.5v7.9c1.2-1.5,2-3.1,2.6-4.6v-7.6C415.6,178.5,414.7,180,413.6,181.5z M403.2,189v7.9c0.8-0.4,1.8-0.8,2.6-1.2 V188C404.9,188.4,404,188.8,403.2,189z M398,191.1v7.9c0.8-0.3,1.8-0.5,2.6-0.8v-7.9C399.7,190.7,398.9,190.8,398,191.1z  M392.8,192.4v8c0.8-0.1,1.6-0.4,2.6-0.7v-7.9C394.5,192.2,393.7,192.3,392.8,192.4z"
  }), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "M406.3,158.3c14.1,8,14.1,21.1,0.1,29.4c-13.9,8.1-36.7,8.3-50.8,0.3c-14.1-8-14.1-21.1-0.1-29.4 C369.5,150.3,392.2,150.2,406.3,158.3z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M405.2,158.6c-6.5-3.7-15-5.7-24.1-5.7c-9.3,0-18,2.2-24.6,6c-6.6,3.8-10.2,8.9-10.2,14.4 s3.7,10.4,10.3,14.2c6.5,3.7,15,5.7,24.1,5.7c9.3,0,18-2.2,24.6-6c6.6-3.8,10.2-8.9,10.2-14.4 C415.5,167.5,411.9,162.4,405.2,158.6z M404.9,186.6c-6.5,3.8-15,5.8-24.2,5.8c-8.9,0-17.5-2-23.8-5.7s-9.9-8.5-9.9-13.7 s3.5-10,9.8-13.7c6.5-3.8,15-5.8,24.2-5.8c8.9,0,17.5,2,23.8,5.7s9.9,8.5,9.9,13.7C414.8,178.1,411.3,182.9,404.9,186.6z"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M403.9,160.1c12.7,7.2,12.7,18.8,0.1,26c-12.6,7.2-33.2,7.2-45.9,0c-12.7-7.2-12.7-18.8-0.1-26 C370.5,152.9,391.1,152.9,403.9,160.1z M373.7,167.8c1.2,0.7,1.4,1.8,0.5,2.6l28.2,15.8c0.4-0.1,0.7-0.4,1.1-0.5 c0.5-0.3,1.1-0.7,1.6-0.9l-35.8-20.2c-1.4,0.5-3.3,0.4-4.5-0.3c-1.4-0.8-1.5-2,0-2.8c1.4-0.8,3.7-0.8,5.1,0 c1.2,0.7,1.4,1.8,0.5,2.6l35.5,20c0.8-0.5,1.6-1.2,2.3-1.9l-14.1-8l-1.8-2.8c-1.1,0.1-2.2-0.1-3.1-0.5c-1.4-0.8-1.4-2.2,0-2.8 c1.4-0.8,3.7-0.8,5.1,0c1.4,0.8,1.5,2,0,2.8c-0.1,0.1-0.3,0.1-0.5,0.3l1.6,2.6l13.4,7.6c6.1-6.8,4.1-15.2-5.8-20.9 c-12.3-7-32.4-6.9-44.7,0c-12.3,7-12.2,18.3,0.1,25.3c10.3,5.8,25.9,6.8,37.8,3l-13.7-7.7l-6.9-1.4c-0.1,0.1-0.3,0.3-0.4,0.3 c-1.4,0.8-3.7,0.8-5.1,0c-1.4-0.8-1.4-2.2,0-2.8c1.4-0.8,3.7-0.8,5.1,0c0.8,0.4,1.1,1.1,1.1,1.6l7.3,1.5l14.2,8 c1.1-0.4,2-0.8,3-1.2L373,171c-1.4,0.5-3.3,0.4-4.5-0.3c-1.4-0.8-1.5-2,0-2.8C369.9,167,372.2,167,373.7,167.8L373.7,167.8z  M372.4,170.1c0.8-0.4,0.8-1.1,0-1.5c-0.8-0.4-2-0.4-2.7,0c-0.8,0.4-0.8,1.1,0,1.5C370.5,170.5,371.8,170.5,372.4,170.1 L372.4,170.1z M374.3,179.2c0.8-0.4,0.8-1.1,0-1.5c-0.8-0.4-2-0.4-2.7,0c-0.8,0.4-0.8,1.1,0,1.5 C372.3,179.6,373.5,179.6,374.3,179.2L374.3,179.2z M368.8,163.6c0.8-0.4,0.7-1.1,0-1.5c-0.8-0.4-2-0.4-2.7,0 c-0.8,0.4-0.8,1.1,0,1.5C366.9,164,368.1,164,368.8,163.6L368.8,163.6z M393.3,170.1c0.8-0.4,0.8-1.1,0-1.5 c-0.8-0.4-2-0.4-2.7,0c-0.8,0.4-0.7,1.1,0,1.5C391.4,170.5,392.6,170.5,393.3,170.1L393.3,170.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160154269504055483360000005258162260323141283_",
    gradientUnits: "userSpaceOnUse",
    x1: 346.7999,
    y1: 552.9181,
    x2: 418.7116,
    y2: 552.9181,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160154269504055483360000005258162260323141283_)"
    },
    d: "M418.6,164.5l-71.9,0.3 c0,2.7,0,5.6,0,8.3c0.1,7.4,7.2,14.8,21,18.6c9.8,2.7,20.2,2.7,29.9-0.1c13.8-3.9,20.7-11.4,20.7-18.8L418.6,164.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070811586593384157030000009321740879179088805_",
    gradientUnits: "userSpaceOnUse",
    x1: 347.6619,
    y1: 550.6075,
    x2: 417.963,
    y2: 550.6075,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDA349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBCC34"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000070811586593384157030000009321740879179088805_)",
      enableBackground: "new"
    },
    d: " M350.2,173.7v7.9c-1.2-1.5-2-3-2.6-4.5v-7.7C348.2,170.9,349.2,172.4,350.2,173.7z M368.7,184v7.9c0.8,0.3,1.6,0.4,2.6,0.7 v-8C370.3,184.4,369.5,184.3,368.7,184z M379.1,185.5v8.1c0.8,0,1.6,0,2.6,0.1v-8.1C380.7,185.7,379.9,185.5,379.1,185.5z  M373.8,185v8c0.8,0.1,1.6,0.3,2.6,0.4v-8C375.4,185.3,374.6,185.1,373.8,185z M352.9,176.6v7.7c0.8,0.7,1.6,1.4,2.6,1.9 v-7.9C354.6,177.8,353.6,177.3,352.9,176.6z M363.4,182.5v7.9c0.8,0.3,1.6,0.5,2.6,0.8v-7.9 C365.1,182.9,364.2,182.8,363.4,182.5z M358.1,180.1v7.9c0.8,0.4,1.6,0.8,2.6,1.2v-7.9C359.9,180.9,358.9,180.5,358.1,180.1z  M384.2,185.7v8.1c0.8,0,1.6,0,2.6-0.1v-8.1C385.9,185.5,385,185.7,384.2,185.7z M410.2,178.1v7.9c0.9-0.7,1.8-1.4,2.6-2 v-7.7C412,177,411.2,177.5,410.2,178.1z M389.5,185.4v8c0.8-0.1,1.6-0.3,2.6-0.4v-8C391.1,185.1,390.3,185.3,389.5,185.4z  M415.5,173.3v7.9c1.2-1.5,2-3.1,2.6-4.6V169C417.4,170.5,416.6,172,415.5,173.3z M405.1,181.1v7.9c0.8-0.4,1.8-0.8,2.6-1.2 V180C406.8,180.2,405.9,180.6,405.1,181.1z M399.8,183.1v7.9c0.8-0.3,1.8-0.5,2.6-0.8v-7.9 C401.6,182.5,400.7,182.8,399.8,183.1z M394.7,184.4v8c0.8-0.1,1.6-0.4,2.6-0.7v-7.9C396.3,184.2,395.5,184.3,394.7,184.4z"
  }), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M408.1,150.2c14.1,8,14.1,21.1,0.1,29.4c-13.9,8.1-36.7,8.3-50.8,0.3c-14.1-8-14.1-21.1-0.1-29.4 C371.2,142.3,394,142.2,408.1,150.2z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M407.1,150.6c-6.5-3.7-15-5.7-24.1-5.7c-9.3,0-18,2.2-24.6,6c-6.6,3.8-10.2,8.9-10.2,14.4 s3.7,10.4,10.3,14.2c6.5,3.7,15,5.7,24.1,5.7c9.3,0,18-2.2,24.6-6c6.6-3.8,10.2-8.9,10.2-14.4 C417.4,159.4,413.8,154.4,407.1,150.6z M406.8,178.6c-6.5,3.8-15,5.8-24.2,5.8c-8.9,0-17.5-2-23.8-5.7 c-6.4-3.7-9.9-8.5-9.9-13.7s3.5-10,9.8-13.7c6.5-3.8,15-5.8,24.2-5.8c8.9,0,17.5,2,23.8,5.7s9.9,8.5,9.9,13.7 C416.7,169.9,413.2,174.8,406.8,178.6z"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M405.6,151.9c12.7,7.2,12.7,18.8,0.1,26c-12.6,7.2-33.2,7.2-45.9,0c-12.7-7.2-12.7-18.8-0.1-26 C372.4,144.8,393,144.8,405.6,151.9z M375.6,159.8c1.2,0.7,1.4,1.8,0.5,2.6l28.2,15.8c0.4-0.1,0.7-0.4,1.1-0.5 c0.5-0.3,1.1-0.7,1.6-0.9l-35.6-20c-1.4,0.5-3.3,0.4-4.5-0.3c-1.4-0.8-1.5-2,0-2.8c1.4-0.8,3.7-0.8,5.1,0 c1.2,0.7,1.4,1.8,0.5,2.6l35.5,20c0.8-0.5,1.6-1.2,2.3-1.9l-14.1-8l-1.8-2.8c-1.1,0.1-2.2-0.1-3.1-0.5c-1.4-0.8-1.4-2.2,0-2.8 c1.4-0.8,3.7-0.8,5.1,0c1.4,0.8,1.5,2,0,2.8c-0.1,0.1-0.3,0.1-0.5,0.3l1.6,2.6l13.4,7.6c6.1-6.8,4.1-15.2-5.8-20.9 c-12.3-7-32.4-6.9-44.7,0c-12.3,7-12.2,18.3,0.1,25.3c10.3,5.8,25.9,6.8,37.8,3l-13.7-7.7l-6.9-1.4c-0.1,0.1-0.3,0.3-0.4,0.3 c-1.4,0.8-3.7,0.8-5.1,0c-1.4-0.8-1.4-2.2,0-2.8c1.4-0.8,3.7-0.8,5.1,0c0.8,0.4,1.1,1.1,1.1,1.6l7.3,1.5l14.2,8 c1.1-0.4,2-0.8,3-1.2l-28-15.8c-1.4,0.5-3.3,0.4-4.5-0.3c-1.4-0.8-1.5-2,0-2.8C371.8,159,374.1,159,375.6,159.8L375.6,159.8z  M374.3,162c0.8-0.4,0.8-1.1,0-1.5c-0.8-0.4-2-0.4-2.7,0c-0.8,0.4-0.8,1.1,0,1.5C372.3,162.5,373.5,162.5,374.3,162L374.3,162 z M376.1,171.2c0.8-0.4,0.8-1.1,0-1.5c-0.8-0.4-2-0.4-2.7,0c-0.8,0.4-0.8,1.1,0,1.5C374.2,171.6,375.4,171.6,376.1,171.2 L376.1,171.2z M370.7,155.6c0.8-0.4,0.7-1.1,0-1.5c-0.8-0.4-2-0.4-2.7,0c-0.8,0.4-0.8,1.1,0,1.5 C368.8,156,370,156,370.7,155.6L370.7,155.6z M395.2,162.1c0.8-0.4,0.8-1.1,0-1.5c-0.8-0.4-2-0.4-2.7,0 c-0.8,0.4-0.7,1.1,0,1.5C393.2,162.5,394.4,162.5,395.2,162.1L395.2,162.1z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065036693426980595730000003017245259435258773_",
    gradientUnits: "userSpaceOnUse",
    x1: 344.9533,
    y1: 539.4431,
    x2: 420.029,
    y2: 539.4431,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3922E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000065036693426980595730000003017245259435258773_)",
      enableBackground: "new"
    },
    d: " M416.7,181.3c0-0.1,0-0.3,0-0.4v-1.6c1.2-2,1.8-4.2,1.9-6.4v-7.6c-0.1,5.1-3.7,10.3-10.4,14.4c-13.9,8.1-36.7,8.3-50.8,0.3 c-7-3.9-10.6-9.2-10.6-14.5c0,0.4,0,0.8,0,1.4c-1.2,2-1.8,4.2-1.9,6.4l0,0c0,0,0,0,0,0.1c0,0.1,0,0.1,0,0.3c0,2.7,0,5.3,0,8 c0,1.9,0.5,3.8,1.5,5.7c-0.4,1.2-0.5,2.3-0.5,3.5l0,0c0,0,0,0,0,0.1s0,0.1,0,0.3c0,2.7,0,5.3,0,8c0.1,7.4,7.2,14.8,21,18.6 c9.8,2.7,20.2,2.7,29.9-0.1c13.8-3.9,20.7-11.4,20.7-18.8V197c1.5-2.3,2.2-4.6,2.2-7v-8.3L416.7,181.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098213216830380786880000003218098172958971013_",
    gradientUnits: "userSpaceOnUse",
    x1: 464.0365,
    y1: 43.9713,
    x2: 535.9888,
    y2: 43.9713,
    gradientTransform: "matrix(-0.5 0.866 0.866 0.5 624.9716 -266.4071)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBCC34"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CDA349"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098213216830380786880000003218098172958971013_)"
    },
    d: "M407.8,227l35.6-62.4 c-2.4-1.5-4.7-2.8-7.2-4.1c-6.5-3.5-16.4-1.1-26.7,8.9c-7.2,7-12.5,16.1-14.9,26c-3.5,13.9-0.5,23.6,5.8,27.4L407.8,227z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141451679996100262560000017085545571521544348_",
    gradientUnits: "userSpaceOnUse",
    x1: 464.9395,
    y1: 41.7492,
    x2: 535.2045,
    y2: 41.7492,
    gradientTransform: "matrix(-0.5 0.866 0.866 0.5 624.9716 -266.4071)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBCC34"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CDA349"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000141451679996100262560000017085545571521544348_)",
      enableBackground: "new"
    },
    d: " M434.1,163.2l-6.9-3.9c1.8-0.3,3.5-0.3,5.1,0l6.6,3.8C437.4,162.8,435.8,162.9,434.1,163.2z M415.9,173.9l-6.9-3.9 c-0.7,0.7-1.2,1.2-1.8,1.9l6.9,3.9C414.8,175.2,415.4,174.6,415.9,173.9z M409.4,182.1l-7-4.1c-0.4,0.7-0.9,1.5-1.4,2.2 l7,4.1C408.5,183.6,409,182.9,409.4,182.1z M412.5,177.9l-6.9-3.9c-0.5,0.7-1.1,1.4-1.6,2l6.9,3.9 C411.4,179.3,412,178.6,412.5,177.9z M430.3,164l-6.8-3.8c-0.9,0.4-1.9,0.7-3,1.2l6.9,3.9C428.4,164.9,429.3,164.4,430.3,164 z M420,170.2l-6.8-3.9c-0.7,0.5-1.4,1.2-2,1.8l6.8,3.9C418.6,171.4,419.3,170.8,420,170.2z M424.6,166.8l-6.8-3.9 c-0.8,0.4-1.5,1.1-2.3,1.6l6.8,3.9C423.1,167.9,423.8,167.4,424.6,166.8z M406.7,186.6l-7-4.1c-0.4,0.7-0.8,1.5-1.2,2.3 l7,4.1C406,188.1,406.3,187.4,406.7,186.6z M400.3,213l-6.9-3.9c0.1,1.1,0.3,2.2,0.4,3.1l6.6,3.8 C400.3,215,400.3,214,400.3,213z M404.4,191.3l-6.9-3.9c-0.3,0.8-0.7,1.6-0.9,2.4l6.9,3.9C403.9,193,404.1,192.2,404.4,191.3 z M401.8,219.8l-6.9-3.9c0.7,1.8,1.6,3.3,2.7,4.5l6.6,3.8C403.3,223,402.5,221.5,401.8,219.8z M400.3,206.9l-6.8-3.9 c-0.1,0.9-0.1,1.9-0.1,2.8l6.8,3.9C400.1,208.8,400.2,207.9,400.3,206.9z M401.2,201.5l-6.8-3.9c-0.1,0.8-0.4,1.8-0.5,2.6 l6.8,3.9C400.7,203.1,401,202.3,401.2,201.5z M402.6,196.2l-6.9-3.9c-0.3,0.8-0.5,1.6-0.7,2.4l6.9,3.9 C402,197.8,402.4,197,402.6,196.2z"
  }), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4964 -0.8681 0.8681 0.4964 44.3365 467.8392)",
    className: "st11",
    cx: 425.4,
    cy: 195.7,
    rx: 35.9,
    ry: 20.7
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M425.7,224c6.5-3.8,12.5-10.2,17.1-18c4.6-8.1,7.2-16.7,7.2-24.2c0-7.6-2.6-13.3-7.3-16 c-4.7-2.7-11-2-17.5,1.8c-6.5,3.8-12.5,10.2-17.1,18c-4.6,8.1-7.2,16.7-7.2,24.2c0,7.6,2.6,13.3,7.3,16 C412.9,228.5,419.2,227.8,425.7,224z M401.6,209.8c0-7.4,2.4-16,7-24c4.5-7.9,10.4-14.1,16.8-17.7c6.4-3.7,12.3-4.3,16.8-1.8 s6.9,8,7,15.3c0,7.4-2.4,16-7,24c-4.5,7.9-10.4,14.1-16.8,17.7c-6.4,3.7-12.3,4.3-16.8,1.8S401.6,217.1,401.6,209.8z"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    className: "st234"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M425.3,222.1c-12.6,7.4-22.6,1.6-22.6-12.9c0.1-14.5,10.4-32.4,22.9-39.7c12.6-7.4,22.6-1.6,22.6,12.9 C448,196.8,437.7,214.6,425.3,222.1z M433.5,192c-1.2,0.7-2.2,0.3-2.4-0.8l-27.8,16.4c0,0.4,0,0.8,0,1.2c0,0.7,0,1.2,0,1.9 l35.2-20.7c0.3-1.5,1.2-3,2.4-3.7c1.4-0.8,2.6-0.1,2.6,1.5c0,1.6-1.2,3.7-2.6,4.5c-1.2,0.7-2.2,0.3-2.4-0.8l-35.1,20.7 c0.1,0.9,0.3,2,0.5,2.8l13.9-8.3l3.3-0.1c0.4-0.9,1.2-1.9,2-2.3c1.4-0.8,2.6-0.1,2.6,1.5c0,1.6-1.2,3.7-2.6,4.5 c-1.4,0.8-2.6,0.1-2.6-1.5c0-0.1,0-0.4,0-0.5l-3.1,0.1l-13.3,7.9c2.8,8.7,11.1,11.1,21,5.3c12.2-7.2,22.2-24.6,22.3-38.7 s-9.8-19.8-21.9-12.6c-10.2,6-18.8,19-21.5,31.3l13.5-8l4.6-5.3c0-0.1,0-0.4,0-0.5c0-1.6,1.2-3.7,2.6-4.5 c1.4-0.8,2.6-0.1,2.6,1.5c0,1.6-1.2,3.7-2.6,4.5c-0.8,0.5-1.5,0.4-2,0l-4.9,5.6l-14.1,8.3c-0.1,1.1-0.4,2.2-0.4,3.3l27.8-16.4 c0.3-1.5,1.2-3,2.4-3.7c1.4-0.8,2.6-0.1,2.6,1.5C436.1,189.2,434.9,191.2,433.5,192L433.5,192z M432.2,189.9 c0,0.8,0.5,1.2,1.4,0.8c0.8-0.4,1.4-1.5,1.4-2.3c0-0.8-0.5-1.2-1.4-0.8C432.8,188,432.2,189,432.2,189.9L432.2,189.9z  M423.4,186.9c0,0.8,0.5,1.2,1.4,0.8c0.8-0.4,1.4-1.5,1.4-2.3c0-0.8-0.5-1.2-1.4-0.8C424,185,423.4,186.1,423.4,186.9 L423.4,186.9z M439.6,190c0,0.8,0.5,1.2,1.4,0.8c0.8-0.4,1.4-1.5,1.4-2.3c0-0.8-0.5-1.2-1.4-0.8 C440.2,188.1,439.6,189,439.6,190L439.6,190z M421.7,208c0,0.8,0.5,1.2,1.4,0.8c0.8-0.4,1.4-1.5,1.4-2.3 c0-0.8-0.5-1.2-1.4-0.8C422.4,206,421.7,207.1,421.7,208L421.7,208z"
  })))))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "_x34__3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31__7_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M725.7,649.5c0,0.8,0.5,1.6,1.8,2.3l72.3,41.8c2,1.2,5.3,1.4,7,0.3l43.3-24.9c0.9-0.5,1.2-1.2,1.2-1.9 c0-0.4,0-0.8-0.1-1.2c-0.1-0.7-0.7-1.5-1.6-2L777.3,622c-2-1.2-5.3-1.4-7-0.3l-43.3,24.9c-0.8,0.4-1.2,1.1-1.2,1.6 C725.6,648.5,725.7,649.1,725.7,649.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st212",
    d: "M777.2,621.8l72.3,41.8c2,1.2,2.3,3,0.5,4.1l-43.3,24.9c-1.8,1.1-5,0.9-7-0.3l-72.3-41.8 c-2-1.2-2.3-3-0.5-4.1l43.3-24.9C771.9,620.5,775,620.6,777.2,621.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M843.3,663c0.8,0.4,1.2,1.1,1.4,1.6c0.1,0.5-0.3,1.2-0.9,1.6l-4.7,2.7c-1.5,0.8-3.9,0.7-5.6-0.3 l-14.8-8.5c-0.8-0.4-1.2-1.1-1.4-1.6s0.3-1.2,0.9-1.6l4.7-2.7c1.5-0.8,3.9-0.7,5.6,0.3L843.3,663z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st235",
    d: "M828.1,655l14.8,8.5c1.4,0.8,1.5,2,0.3,2.7l-4.7,2.7c-1.2,0.7-3.3,0.5-4.6-0.1l-14.8-8.5 c-1.4-0.8-1.5-2-0.3-2.7l4.7-2.7C824.7,654.2,826.7,654.3,828.1,655z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M754.3,650.5c0.5,0.4,0.9,0.8,1.1,1.2c0,0.4-0.1,0.9-0.7,1.2l-5.3,3.1c-1.1,0.7-3,0.5-4.2-0.1l-11-6.4 c-0.5-0.4-0.9-0.8-1.1-1.2c0-0.4,0.1-0.9,0.7-1.2l5.3-3.1c1.1-0.7,3-0.5,4.2,0.1L754.3,650.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "M734.5,649.6l11,6.4c1.1,0.5,2.6,0.7,3.5,0.1l5.3-3.1c0.9-0.5,0.8-1.4-0.3-2l-11-6.4 c-1.1-0.5-2.6-0.7-3.5-0.1l-5.3,3.1C733.3,648.1,733.4,649.1,734.5,649.6z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st234"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M742.6,644.5c-0.1,0-0.3-0.1-0.4-0.1l-8.4,4.9c0.1,0.1,0.1,0.1,0.3,0.3l2-1.2l3.5,2 c-0.7,0.7-0.5,1.6,0.5,2.2c1.1,0.7,2.7,0.8,3.8,0.4l3.7,2.2l-2,1.2c0.1,0,0.3,0.1,0.4,0.1l8.4-4.9c-0.1-0.1-0.1-0.1-0.3-0.3 l-2.3,1.4l-3.7-2.2c0.8-0.7,0.5-1.6-0.5-2.3c-1.1-0.7-2.8-0.8-3.9-0.3l-3.5-2L742.6,644.5z M744.5,652.6l3.5-2l3.7,2l-3.5,2 L744.5,652.6C744.4,652.6,744.5,652.6,744.5,652.6z M740.6,652.3c-0.9-0.5-1.1-1.4-0.5-1.9l3.8,2.2 C742.9,652.8,741.6,652.8,740.6,652.3z M747.5,648.2c0.9,0.5,1.1,1.4,0.5,1.9l-3.8-2.2C745.1,647.7,746.6,647.7,747.5,648.2z  M743.9,648.1l3.8,2.2l-3.5,2l0,0l-3.8-2.2l0,0L743.9,648.1z M743.6,648l-3.5,2l0,0l-3.4-2l3.5-2L743.6,648z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st235",
    d: "M776.1,626.6c0,0.3-0.1,0.4-0.5,0.7l-0.4,0.3H775l-0.3-0.1c0,0,0,0,0-0.1l0.4-0.3 c0.3-0.1,0.4-0.3,0.4-0.4s-0.1-0.3-0.4-0.4l-0.8-0.5c-0.3-0.1-0.4-0.1-0.7-0.1s-0.5,0.1-0.7,0.3l-2.7,1.5 c-0.3,0.1-0.4,0.3-0.4,0.4s0.1,0.3,0.3,0.4l0.9,0.5c0.3,0.1,0.4,0.1,0.7,0.1s0.5-0.1,0.7-0.3l0.4-0.3h0.1l0.3,0.1c0,0,0,0,0,0.1 l-0.4,0.3c-0.3,0.1-0.7,0.3-1.1,0.3s-0.7-0.1-1.1-0.3l-0.9-0.5c-0.3-0.1-0.5-0.4-0.5-0.7s0.1-0.4,0.5-0.7l2.7-1.6 c0.3-0.1,0.7-0.3,1.1-0.3c0.4,0,0.7,0.1,1.1,0.3l0.9,0.5C775.9,626,776.1,626.3,776.1,626.6z M775.9,631.6h-0.1l-0.3-0.1 c0,0-0.1-0.1,0-0.1l0.9-1.6l-1.2-0.7h-0.1l-1.9,1.1h-0.1l-0.3-0.1c0,0,0,0,0-0.1l4.7-2.7h0.1l1.8,0.9c0.3,0.1,0.5,0.4,0.5,0.7 s-0.1,0.4-0.5,0.7l-0.7,0.4c-0.3,0.1-0.5,0.3-0.9,0.3c-0.3,0-0.7,0-0.9-0.1l0,0L775.9,631.6z M777,629.7 c0.3,0.1,0.5,0.1,0.7,0.1c0.3,0,0.5-0.1,0.7-0.3l0.7-0.4c0.3-0.1,0.4-0.3,0.4-0.4c0-0.1-0.1-0.3-0.4-0.4l-1.4-0.8h-0.1l-2,1.2 c0,0,0,0,0,0.1L777,629.7z M784.2,630.9l-2.3-1.4h-0.1l-4.7,2.7c0,0,0,0,0,0.1l2.3,1.4h0.1l0.1-0.1c0,0,0,0,0-0.1l-1.9-1.1 c0,0,0,0,0-0.1l1.9-1.1h0.1l1.8,0.9h0.1l0.1-0.1c0,0,0,0,0-0.1l-1.8-0.9c0,0,0,0,0-0.1l1.8-0.9h0.1l1.9,1.1h0.1L784.2,630.9 C784.3,630.9,784.3,630.9,784.2,630.9z M787.9,633.3c0,0.3-0.1,0.4-0.5,0.7l-2.7,1.6c-0.3,0.1-0.7,0.3-1.1,0.3 c-0.4,0-0.7-0.1-1.1-0.3l-1.9-1.1c0,0,0,0,0-0.1l4.7-2.7h0.1l1.9,1.1C787.7,632.9,787.9,633.1,787.9,633.3z M786.9,633.8 c0.3-0.1,0.4-0.3,0.4-0.4c0-0.1-0.1-0.3-0.4-0.4l-1.5-0.8h-0.1l-4.1,2.3c0,0,0,0,0,0.1l1.5,0.8c0.3,0.1,0.5,0.1,0.7,0.1 c0.3,0,0.5-0.1,0.7-0.3L786.9,633.8z M790,634.2l-0.3-0.1h-0.1l-4.7,2.7c0,0,0,0,0,0.1l0.3,0.1h0.1L790,634.2 C790,634.3,790,634.3,790,634.2z M793.7,636.3l-2.7-1.6h-0.1l-0.1,0.1c0,0,0,0,0,0.1l1.1,0.7c0,0,0,0,0,0.1l-4.3,2.6v0.1 l0.3,0.1h0.1l4.3-2.6h0.1l1.1,0.7h0.1L793.7,636.3C793.8,636.5,793.8,636.3,793.7,636.3z M798.6,639.2l-0.9-0.5 c-0.3-0.1-0.7-0.3-1.1-0.3c-0.4,0-0.7,0.1-1.1,0.3l-2.7,1.6c-0.3,0.1-0.5,0.4-0.5,0.7c0,0.3,0.1,0.4,0.5,0.7l0.9,0.5 c0.3,0.1,0.7,0.3,1.1,0.3s0.7-0.1,1.1-0.3l0.4-0.3v-0.1l-0.3-0.1h-0.1l-0.4,0.3c-0.3,0.1-0.5,0.3-0.7,0.3c-0.3,0-0.5,0-0.7-0.1 l-0.9-0.5c-0.3-0.1-0.4-0.3-0.3-0.4c0-0.1,0.1-0.3,0.4-0.4l2.7-1.5c0.3-0.1,0.5-0.3,0.7-0.3c0.3,0,0.5,0,0.7,0.1l0.9,0.5 c0.3,0.1,0.4,0.3,0.4,0.4s-0.1,0.3-0.4,0.4l-0.4,0.3v0.1l0.3,0.1h0.1l0.4-0.3c0.3-0.1,0.5-0.4,0.5-0.7 C799,639.6,798.8,639.3,798.6,639.2z M802.2,641.3l-3.1,3.5H799l-0.3-0.1c0,0,0,0,0-0.1l0.8-0.9l-2-1.1l-1.6,0.4 c-0.1,0-0.1,0-0.1,0l-0.3-0.1c0,0,0,0,0-0.1l6.2-1.9c0.1,0,0.1,0,0.1,0L802.2,641.3C802.2,641.3,802.4,641.3,802.2,641.3z  M799.8,643.5l1.9-2.2l0,0l-3.7,1.1L799.8,643.5z M802.9,647.2h-0.1l-0.3-0.1c0,0-0.1-0.1,0-0.1l0.9-1.6l-1.2-0.7h-0.1l-1.9,1.1 h-0.1l-0.3-0.1c0,0,0,0,0-0.1l4.7-2.7h0.1l1.8,0.9c0.3,0.1,0.5,0.4,0.5,0.7s-0.1,0.4-0.5,0.7l-0.7,0.4c-0.3,0.1-0.5,0.3-0.9,0.3 c-0.3,0-0.7,0-0.9-0.1l0,0L802.9,647.2z M804,645.1c0.3,0.1,0.5,0.1,0.7,0.1c0.3,0,0.5-0.1,0.7-0.3l0.7-0.4 c0.3-0.1,0.4-0.3,0.4-0.4s-0.1-0.3-0.4-0.4l-1.4-0.8h-0.1l-2,1.2c0,0,0,0,0,0.1L804,645.1z M810.6,647.4l-2.7,1.6 c-0.3,0.1-0.7,0.3-1.1,0.3c-0.4,0-0.7-0.1-1.1-0.3l-1.9-1.1c0,0,0,0,0-0.1l4.7-2.7h0.1l1.9,1.1c0.3,0.1,0.5,0.4,0.5,0.7 C811.2,647,811,647.2,810.6,647.4z M810.3,647.2c0.3-0.1,0.4-0.3,0.4-0.4c0-0.1-0.1-0.3-0.4-0.4l-1.5-0.8h-0.1l-4.1,2.3 c0,0,0,0,0,0.1l1.5,0.8c0.3,0.1,0.5,0.1,0.7,0.1c0.3,0,0.5-0.1,0.7-0.3L810.3,647.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st191",
    d: "M798.4,683.3c-2.2,1.2-5.7,1.2-7.9,0s-2.2-3.3,0-4.6c2.2-1.2,5.7-1.2,7.9,0 C800.6,679.9,800.6,682.1,798.4,683.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "M807.5,688.6c-2.2,1.2-5.7,1.2-7.9,0c-2.2-1.2-2.2-3.3,0-4.6c2.2-1.2,5.7-1.2,7.9,0 C809.7,685.4,809.7,687.4,807.5,688.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st235",
    d: "M769.2,644.3l-2.2,1.2c-0.4,0.3-1.2,0.3-1.6,0l-11.1-6.4c-0.4-0.3-0.4-0.7,0-0.9l2.2-1.2 c0.4-0.3,1.2-0.3,1.6,0l11.1,6.4C769.6,643.6,769.6,644,769.2,644.3z M786.6,653.5l-11.1-6.4c-0.4-0.3-1.2-0.3-1.6,0l-2.2,1.2 c-0.4,0.3-0.4,0.7,0,0.9l11.1,6.4c0.4,0.3,1.2,0.3,1.6,0l2.2-1.2C787.1,654.2,787.1,653.7,786.6,653.5z M804.1,663.5l-11.1-6.4 c-0.4-0.3-1.2-0.3-1.6,0l-2.2,1.2c-0.4,0.3-0.4,0.7,0,0.9l11.1,6.4c0.4,0.3,1.2,0.3,1.6,0l2.2-1.2 C804.5,664.2,804.5,663.8,804.1,663.5z M821.6,673.7l-11.1-6.4c-0.4-0.3-1.2-0.3-1.6,0l-2.2,1.2c-0.4,0.3-0.4,0.7,0,0.9l11.1,6.4 c0.4,0.3,1.2,0.3,1.6,0l2.2-1.2C822,674.4,822,673.8,821.6,673.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_x38__1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_x31__3_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "st236",
    d: "M455.3,398V283.8l-5.8-3.4v114.2c0,2.8,0.9,4.9,2.6,5.8l5.8,3.4C456.3,402.7,455.3,400.8,455.3,398z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092430702526241601370000013668777442652291517_",
    gradientUnits: "userSpaceOnUse",
    x1: 515.9949,
    y1: 495.3221,
    x2: 463.7817,
    y2: 465.7997,
    gradientTransform: "matrix(1 0 0 -1 0 732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9E9EA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000092430702526241601370000013668777442652291517_)"
    },
    d: "M514.8,235.5 c-1.6-0.9-3.9-0.8-6.4,0.7l-49.7,28.7l5.8,3.4l49.7-28.7c2.6-1.5,4.7-1.6,6.4-0.7L514.8,235.5z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000099646617770056161390000016018773968617163425_",
    className: "st13",
    d: "M455.3,283.8l-5.8-3.4 c0-5.7,4.1-12.7,8.9-15.6l5.8,3.4C459.4,271.1,455.3,278,455.3,283.8z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000158740846925374422760000010586368457302389160_",
    d: "M455.3,283.8l-5.8-3.4c0-5.7,4.1-12.7,8.9-15.6 l5.8,3.4C459.4,271.1,455.3,278,455.3,283.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000123416238476938700340000004026003201095712159_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158740846925374422760000010586368457302389160_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000123416238476938700340000004026003201095712159_)"
    }
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M455.3,283.8l-5.8-3.4c0-5.7,4.1-12.7,8.9-15.6l5.8,3.4C459.4,271.1,455.3,278,455.3,283.8 L455.3,283.8z"
  }))))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M514.1,239.4c5-2.8,9.1-0.5,9.1,5.1v114.2c0,5.7-4.1,12.7-8.9,15.6L464.5,403c-5,2.8-9.1,0.5-9.1-5.1 V283.7c0-5.7,4.1-12.7,8.9-15.6L514.1,239.4z"
  })))), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st186",
    points: "457.4,283.6 457.4,391.5 520.9,354.8 520.9,246.9  "
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "st239",
    d: "M495.3,372.8c-0.4,0-0.9,0.1-1.5,0.4l-9.5,5.4c-1.5,0.8-2.7,2.7-2.7,4.3v3.1c0,1.1,0.7,1.9,1.8,1.9 c0.4,0,0.9-0.1,1.5-0.4l9.5-5.4c1.5-0.8,2.7-2.7,2.7-4.3v-3.1C496.9,373.5,496.2,372.8,495.3,372.8z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "st236",
    d: "M493.5,381.6c1.5-0.8,2.7-2.7,2.7-4.3v-3c0-0.5-0.1-1.1-0.5-1.4c-0.1,0-0.3-0.1-0.5-0.1 c-0.4,0-0.9,0.1-1.5,0.4l-9.5,5.4c-1.5,0.8-2.7,2.7-2.7,4.3v3.1c0,0.5,0.1,1.1,0.5,1.4c0.1,0,0.3,0.1,0.5,0.1 c0.4,0,0.9-0.1,1.5-0.4L493.5,381.6z"
  }))), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M495.4,258.2l-12.5,7.2c-0.9,0.5-1.8,0.3-1.8-0.7l0,0c0-0.9,0.8-2.2,1.8-2.7l12.5-7.2 c0.9-0.5,1.8-0.3,1.8,0.7l0,0C497.2,256.3,496.4,257.7,495.4,258.2z"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st240",
    points: "457.4,283.6 457.4,293.7 520.9,257 520.9,246.9  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "513.6,255.3 513.6,257.8 518,255.3 518,252.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M512.3,256.8v1.1l-0.4,0.1v-1.1L512.3,256.8z M518.2,252.6v2.7l-5.6,3.3v-2.7L518.2,252.6z M517.9,253 l-5.1,3v2.2l5.1-3V253z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M460.3,287.5l-0.4,0.3v-2l0.4-0.3V287.5z M459.5,286.5l-0.4,0.3v1.5l0.4-0.3V286.5z M461.3,284.4 l-0.4,0.3v2.6l0.4-0.3V284.4z M462.1,283l-0.4,0.3v3.4l0.4-0.3V283z M463,281.9l-0.4,0.3v4.1l0.4-0.3V281.9z"
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M453.2,290.6l-1.1,0.5v9.2c0,0.4-0.1,0.8-0.4,0.9l1.1-0.5c0.3-0.1,0.4-0.4,0.4-0.9V290.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M452.9,289.5c-0.1-0.3-0.3-0.7-0.5-0.8c-0.1-0.3-0.4-0.4-0.7-0.5l-0.4-0.3c-0.4-0.3-0.8-0.3-1.1-0.1 l-1.1,0.5c0.3-0.1,0.7-0.1,1.1,0.1l0.4,0.3c0.3,0.1,0.4,0.3,0.7,0.5s0.4,0.5,0.5,0.8c0.1,0.4,0.3,0.7,0.3,1.1l1.1-0.5 C453.2,290.3,453,289.9,452.9,289.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st236",
    d: "M450.6,288.7c0.8,0.4,1.5,1.6,1.5,2.4v9.2c0,0.9-0.7,1.4-1.5,0.8l-0.4-0.3c-0.8-0.4-1.5-1.6-1.5-2.4 v-9.2c0-0.9,0.7-1.2,1.5-0.8L450.6,288.7z"
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M453.2,309.2l-1.1,0.5v9.2c0,0.4-0.1,0.8-0.4,0.9l1.1-0.5c0.3-0.1,0.4-0.4,0.4-0.9V309.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M452.9,308.1c-0.1-0.3-0.3-0.7-0.5-0.8c-0.1-0.3-0.4-0.4-0.7-0.5l-0.4-0.3c-0.4-0.3-0.8-0.3-1.1-0.1 l-1.1,0.5c0.3-0.1,0.7-0.1,1.1,0.1l0.4,0.3c0.3,0.1,0.4,0.3,0.7,0.5c0.3,0.3,0.4,0.5,0.5,0.8c0.1,0.4,0.3,0.7,0.3,1.1l1.1-0.5 C453.2,308.8,453,308.4,452.9,308.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st236",
    d: "M450.6,307.3c0.8,0.4,1.5,1.6,1.5,2.4v9.2c0,0.9-0.7,1.4-1.5,0.8l-0.4-0.3c-0.8-0.4-1.5-1.6-1.5-2.4 v-9.2c0-0.9,0.7-1.2,1.5-0.8L450.6,307.3z"
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st216",
    d: "M470.4,268.3c-1.1,0.7-2,2.3-2,3.5c0,1.4,0.9,1.9,2,1.2c1.1-0.7,2-2.3,2-3.5 C472.4,268.1,471.4,267.6,470.4,268.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st217",
    d: "M470.2,269.1c-0.7,0.4-1.4,1.5-1.4,2.3s0.5,1.2,1.4,0.8c0.7-0.4,1.4-1.5,1.4-2.3 S471,268.7,470.2,269.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st217",
    d: "M470.4,269.8c-0.4,0.3-0.7,0.8-0.7,1.2c0,0.4,0.3,0.7,0.7,0.4c0.4-0.3,0.7-0.8,0.7-1.2 C471,269.8,470.8,269.6,470.4,269.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st218",
    d: "M470.2,270c-0.1,0.1-0.3,0.3-0.3,0.4c0,0.1,0.1,0.3,0.3,0.1c0.1-0.1,0.3-0.3,0.3-0.4 S470.4,270,470.2,270z"
  }))))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M466.2,305.5c-0.7,0.1-1.5,0.3-1.5-0.5c0-0.5,0.4-1.2,0.9-1.6c0.7-0.4,1.2-0.3,1.5,0.7l0.4-0.1v-1.6 c-0.5,0-1.2,0.3-1.8,0.7c-1.6,0.9-2.4,2.3-2.4,3.4c0,1.2,1.1,1.1,1.9,0.9c0.9-0.1,1.4,0,1.4,0.7c0,0.7-0.5,1.4-1.1,1.8 c-0.7,0.4-1.5,0.1-1.9-0.8l-0.4,0.3l0.1,1.6c0.5,0.1,1.5-0.3,2.2-0.7c1.9-1.1,2.6-2.6,2.6-3.5 C467.9,305.4,467,305.4,466.2,305.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M471.3,306c-0.7,0.4-1.2,0.3-1.2-1.2c0-1.4,0.4-2.2,0.8-2.3c0.4-0.1,0.5,0,0.7,0.5 c0.1,0.1,0.3,0.3,0.4,0.1c0.4-0.1,0.8-0.7,0.8-1.1c0-0.7-0.9-0.5-1.9,0c-0.8,0.4-1.4,0.9-1.8,1.8c-0.4,0.7-0.7,1.5-0.7,2.3 c0,1.6,0.9,1.9,2.3,1.1c0.8-0.4,1.8-1.2,2-2.7h-0.4C472.3,305.2,471.8,305.6,471.3,306z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M478.1,302.3c-0.1,0-0.3,0-0.3-0.5v-2.3c0-0.5-0.1-1.4-1.8-0.3c-1.5,0.8-2.3,1.9-2.3,2.6 c0,0.4,0.7,0.3,0.8,0.1c0.3-0.1,0.3-0.4,0.4-0.7c0.3-0.9,0.5-1.4,0.8-1.5c0.3-0.1,0.5-0.1,0.5,0.4v0.5 c-0.4,0.4-1.2,1.1-1.8,1.8c-0.8,0.7-1.1,1.2-1.1,1.8c0,0.7,0.5,1.1,1.5,0.5c0.7-0.4,1.1-0.9,1.4-1.4c0.1,0.3,0.3,0.4,0.8,0.1 c0.5-0.3,1.1-0.8,1.5-1.1v-0.3C478.3,302.1,478.2,302.3,478.1,302.3z M476.3,302.5c0,0.5-0.4,0.8-0.5,0.9 c-0.4,0.3-0.7,0.1-0.7-0.4c0-0.4,0.1-0.8,0.4-1.1c0.3-0.4,0.7-0.7,0.8-0.9L476.3,302.5L476.3,302.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M483.9,298.6V296c0-0.9-0.4-1.2-1.5-0.7c-0.5,0.3-1.1,0.9-1.6,1.6l-0.1-0.5l-1.9,1.4v0.4l0.4-0.1 c0.1-0.1,0.3,0,0.3,0.4v2.8c0,0.4-0.1,0.5-0.7,0.8v0.4l2.6-1.5v-0.4l-0.3,0.1c-0.3,0.1-0.3,0.1-0.3-0.3v-2.3 c0-0.3,0-0.4,0.1-0.7c0.1-0.3,0.4-0.7,0.8-0.9c0.5-0.3,0.8-0.1,0.8,0.4v2.4c0,0.3-0.1,0.4-0.3,0.5l-0.3,0.1v0.4l2.6-1.5v-0.4 C483.9,299,483.9,299,483.9,298.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M489.6,295.5c-0.4,0.3-0.7,0.1-0.7-0.5v-2.8l0.9-0.5V291l-0.9,0.5v-1.2l-0.5,0.3l-0.8,1.8l-0.7,0.4v0.5 l0.5-0.3v3.1c0,0.9,0.7,0.8,1.2,0.5c0.4-0.3,0.9-0.8,1.5-1.4l-0.1-0.3C490,295.2,489.9,295.3,489.6,295.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M493.1,289.3c-1.8,1.1-2.6,2.4-2.6,3.9c0,1.6,0.8,2,2.6,1.1c1.8-1.1,2.6-2.4,2.6-3.9 C495.7,288.8,494.9,288.2,493.1,289.3z M493.1,293.7c-0.7,0.4-0.9-0.1-0.9-1.5c0-1.4,0.3-2.2,0.9-2.6c0.7-0.4,0.9,0.1,0.9,1.5 C494.1,292.4,493.8,293.3,493.1,293.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M503.3,281.8c-0.5,0-1.1,0.3-1.9,0.7l-3,1.8v0.4c0.7-0.4,0.8-0.4,0.8,0.1v4.9c0,0.5-0.1,0.5-0.8,1.1v0.4 l3.3-1.9v-0.4c-0.8,0.4-0.9,0.4-0.9,0v-1.8l0.5-0.3c0.9-0.5,1.6-1.1,2-1.6c0.5-0.7,0.8-1.4,0.8-2 C504.1,282.2,503.7,281.8,503.3,281.8z M501.2,286.3c-0.4,0.3-0.5,0.3-0.5-0.1v-2.4c0-0.3,0.1-0.4,0.5-0.7 c0.7-0.4,1.2-0.3,1.2,0.8C502.5,284.7,502.2,285.7,501.2,286.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M509,284.4c-0.1,0-0.3,0-0.3-0.5v-2.3c0-0.5-0.1-1.4-1.8-0.3c-1.5,0.8-2.3,1.9-2.3,2.6 c0,0.4,0.7,0.3,0.8,0.1c0.3-0.1,0.3-0.4,0.4-0.7c0.3-0.9,0.5-1.4,0.8-1.5c0.3-0.1,0.5-0.1,0.5,0.4v0.5 c-0.4,0.4-1.2,1.1-1.8,1.8c-0.8,0.7-1.1,1.2-1.1,1.8c0,0.7,0.5,1.1,1.5,0.5c0.7-0.4,1.1-0.9,1.4-1.4c0.1,0.3,0.3,0.4,0.8,0.1 c0.5-0.3,1.1-0.8,1.5-1.1v-0.3C509.2,284.2,509.1,284.4,509,284.4z M507.2,284.7c0,0.5-0.4,0.8-0.5,0.9 c-0.4,0.3-0.7,0.1-0.7-0.4c0-0.4,0.1-0.8,0.4-1.1c0.3-0.4,0.7-0.7,0.8-0.9L507.2,284.7L507.2,284.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M512.7,278v0.4l0.4-0.1c0.1,0,0.1,0,0.1,0.3c-0.3,1.1-0.5,2.2-0.9,3.3l0,0c-0.3-0.7-0.7-1.4-0.9-2.2 c-0.1-0.1,0-0.3,0.1-0.4l0.4-0.3v-0.4l-2.7,1.6v0.4l0.3-0.1c0.1,0,0.3,0,0.4,0.1c0.5,1.1,1.1,2.2,1.6,3.1 c0.1,0.1,0.1,0.4,0,0.7c0,0.3-0.1,0.5-0.4,0.7c-0.1,0-0.3,0.1-0.4,0c-0.1,0-0.3,0-0.4,0c-0.3,0.1-0.7,0.8-0.7,1.1 c0,0.4,0.4,0.4,0.8,0.1c0.7-0.4,1.1-1.1,1.6-2.7c0.5-1.9,1.1-3.7,1.8-5.3c0.1-0.5,0.3-0.8,0.5-0.9l0.3-0.1v-0.4L512.7,278z"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "468.6,320 468.6,365.1 511.3,340.6 511.3,295.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "485,318.4 483.4,319.3 483.4,317.7 485,316.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "486.7,317.4 485,318.4 485,316.6 486.7,315.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "497.2,311.3 495.4,312.3 495.4,310.7 497.2,309.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "483.4,321.1 481.6,322.2 481.6,320.4 483.4,319.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "488.5,318.1 486.7,319 486.7,317.4 488.5,316.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "492,316.1 490.3,317.2 490.3,315.4 492,314.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "493.8,315.1 492,316.1 492,314.3 493.8,313.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "497.2,313.1 495.4,314 495.4,312.3 497.2,311.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "498.9,312 497.2,313.1 497.2,311.3 498.9,310.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "483.4,322.8 481.6,323.8 481.6,322.2 483.4,321.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "488.5,319.9 486.7,320.8 486.7,319 488.5,318.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "495.4,315.8 493.8,316.9 493.8,315.1 495.4,314  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "497.2,314.9 495.4,315.8 495.4,314 497.2,313.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "498.9,313.8 497.2,314.9 497.2,313.1 498.9,312  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "485,323.5 483.4,324.6 483.4,322.8 485,321.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "490.3,320.5 488.5,321.6 488.5,319.9 490.3,318.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "493.8,318.5 492,319.6 492,317.8 493.8,316.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "497.2,316.6 495.4,317.6 495.4,315.8 497.2,314.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "498.9,315.5 497.2,316.6 497.2,314.9 498.9,313.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "485,325.3 483.4,326.4 483.4,324.6 485,323.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "488.5,323.2 486.7,324.3 486.7,322.6 488.5,321.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "490.3,322.3 488.5,323.2 488.5,321.6 490.3,320.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "493.8,320.3 492,321.4 492,319.6 493.8,318.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "495.4,319.3 493.8,320.3 493.8,318.5 495.4,317.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "498.9,317.3 497.2,318.2 497.2,316.6 498.9,315.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "474.6,333.1 472.9,334.1 472.9,332.3 474.6,331.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "476.3,332.1 474.6,333.1 474.6,331.4 476.3,330.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "479.8,330 478.1,331.1 478.1,329.3 479.8,328.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "483.4,328.1 481.6,329.1 481.6,327.3 483.4,326.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "488.5,325 486.7,326.1 486.7,324.3 488.5,323.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "492,323.1 490.3,324.1 490.3,322.3 492,321.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "495.4,321.1 493.8,322 493.8,320.3 495.4,319.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "497.2,320 495.4,321.1 495.4,319.3 497.2,318.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "500.7,318 498.9,319 498.9,317.3 500.7,316.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "506,315 504.2,316.1 504.2,314.3 506,313.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "474.6,334.8 472.9,335.8 472.9,334.1 474.6,333.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "483.4,329.7 481.6,330.8 481.6,329.1 483.4,328.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "485,328.8 483.4,329.7 483.4,328.1 485,327  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "486.7,327.9 485,328.8 485,327 486.7,326.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "492,324.7 490.3,325.8 490.3,324.1 492,323.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "495.4,322.8 493.8,323.8 493.8,322 495.4,321.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "497.2,321.8 495.4,322.8 495.4,321.1 497.2,320  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "502.5,318.8 500.7,319.7 500.7,318 502.5,317  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "478.1,334.5 476.3,335.6 476.3,333.8 478.1,332.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "479.8,333.5 478.1,334.5 478.1,332.9 479.8,331.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "481.6,332.6 479.8,333.5 479.8,331.8 481.6,330.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "488.5,328.5 486.7,329.5 486.7,327.9 488.5,326.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "492,326.5 490.3,327.6 490.3,325.8 492,324.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "497.2,323.5 495.4,324.5 495.4,322.8 497.2,321.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "498.9,322.6 497.2,323.5 497.2,321.8 498.9,320.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "500.7,321.5 498.9,322.6 498.9,320.8 500.7,319.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "502.5,320.5 500.7,321.5 500.7,319.7 502.5,318.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "504.2,319.5 502.5,320.5 502.5,318.8 504.2,317.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "507.6,317.4 506,318.5 506,316.7 507.6,315.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "481.6,334.4 479.8,335.3 479.8,333.5 481.6,332.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "483.4,333.3 481.6,334.4 481.6,332.6 483.4,331.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "486.7,331.2 485,332.3 485,330.6 486.7,329.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "490.3,329.2 488.5,330.3 488.5,328.5 490.3,327.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "492,328.3 490.3,329.2 490.3,327.6 492,326.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "495.4,326.2 493.8,327.3 493.8,325.5 495.4,324.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "497.2,325.3 495.4,326.2 495.4,324.5 497.2,323.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "500.7,323.2 498.9,324.2 498.9,322.6 500.7,321.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "506,320.3 504.2,321.2 504.2,319.5 506,318.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "474.6,340 472.9,341 472.9,339.4 474.6,338.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "476.3,339.1 474.6,340 474.6,338.3 476.3,337.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "478.1,338 476.3,339.1 476.3,337.3 478.1,336.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "479.8,337.1 478.1,338 478.1,336.2 479.8,335.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "483.4,335 481.6,336 481.6,334.4 483.4,333.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "485,334.1 483.4,335 483.4,333.3 485,332.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "486.7,333 485,334.1 485,332.3 486.7,331.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "490.3,331 488.5,332.1 488.5,330.3 490.3,329.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "497.2,327 495.4,328 495.4,326.2 497.2,325.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "504.2,323 502.5,323.9 502.5,322.3 504.2,321.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "474.6,341.8 472.9,342.7 472.9,341 474.6,340  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "479.8,338.8 478.1,339.8 478.1,338 479.8,337.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "483.4,336.8 481.6,337.7 481.6,336 483.4,335  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "485,335.7 483.4,336.8 483.4,335 485,334.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "486.7,334.8 485,335.7 485,334.1 486.7,333  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "490.3,332.7 488.5,333.8 488.5,332.1 490.3,331  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "493.8,330.7 492,331.8 492,330 493.8,328.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "495.4,329.7 493.8,330.7 493.8,328.9 495.4,328  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "500.7,326.8 498.9,327.7 498.9,326 500.7,325  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "502.5,325.7 500.7,326.8 500.7,325 502.5,323.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "504.2,324.7 502.5,325.7 502.5,323.9 504.2,323  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "506,323.7 504.2,324.7 504.2,323 506,322  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "474.6,343.6 472.9,344.5 472.9,342.7 474.6,341.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "479.8,340.4 478.1,341.5 478.1,339.8 479.8,338.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "481.6,339.5 479.8,340.4 479.8,338.8 481.6,337.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "490.3,334.5 488.5,335.4 488.5,333.8 490.3,332.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "492,333.5 490.3,334.5 490.3,332.7 492,331.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "502.5,327.4 500.7,328.4 500.7,326.8 502.5,325.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "506,325.4 504.2,326.5 504.2,324.7 506,323.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "507.6,324.5 506,325.4 506,323.7 507.6,322.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "474.6,345.3 472.9,346.3 472.9,344.5 474.6,343.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "478.1,343.3 476.3,344.2 476.3,342.5 478.1,341.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "479.8,342.2 478.1,343.3 478.1,341.5 479.8,340.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "486.7,338.3 485,339.2 485,337.5 486.7,336.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "495.4,333.3 493.8,334.2 493.8,332.5 495.4,331.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "500.7,330.2 498.9,331.2 498.9,329.5 500.7,328.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "506,327.2 504.2,328.3 504.2,326.5 506,325.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "507.6,326.2 506,327.2 506,325.4 507.6,324.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "474.6,346.9 472.9,348 472.9,346.3 474.6,345.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "488.5,339 486.7,339.9 486.7,338.3 488.5,337.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "490.3,338 488.5,339 488.5,337.2 490.3,336.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "492,336.9 490.3,338 490.3,336.2 492,335.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "497.2,333.9 495.4,334.9 495.4,333.3 497.2,332.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "498.9,333 497.2,333.9 497.2,332.2 498.9,331.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "506,328.9 504.2,329.9 504.2,328.3 506,327.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "485,342.7 483.4,343.7 483.4,341.9 485,341  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "486.7,341.7 485,342.7 485,341 486.7,339.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "492,338.7 490.3,339.6 490.3,338 492,336.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "493.8,337.7 492,338.7 492,336.9 493.8,336  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "495.4,336.7 493.8,337.7 493.8,336 495.4,334.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "498.9,334.6 497.2,335.7 497.2,333.9 498.9,333  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "500.7,333.7 498.9,334.6 498.9,333 500.7,331.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "507.6,329.6 506,330.7 506,328.9 507.6,328  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "485,344.5 483.4,345.5 483.4,343.7 485,342.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "486.7,343.4 485,344.5 485,342.7 486.7,341.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "488.5,342.5 486.7,343.4 486.7,341.7 488.5,340.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "493.8,339.5 492,340.4 492,338.7 493.8,337.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "497.2,337.5 495.4,338.4 495.4,336.7 497.2,335.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "500.7,335.4 498.9,336.4 498.9,334.6 500.7,333.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "502.5,334.4 500.7,335.4 500.7,333.7 502.5,332.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "504.2,333.4 502.5,334.4 502.5,332.7 504.2,331.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "506,332.5 504.2,333.4 504.2,331.6 506,330.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "507.6,331.4 506,332.5 506,330.7 507.6,329.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "488.5,344.2 486.7,345.2 486.7,343.4 488.5,342.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "492,342.2 490.3,343.2 490.3,341.4 492,340.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "493.8,341.1 492,342.2 492,340.4 493.8,339.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "498.9,338.1 497.2,339.2 497.2,337.5 498.9,336.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "502.5,336.1 500.7,337.2 500.7,335.4 502.5,334.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "504.2,335.2 502.5,336.1 502.5,334.4 504.2,333.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "483.4,349 481.6,349.9 481.6,348.2 483.4,347.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "481.6,344.8 479.8,345.7 479.8,344 481.6,343  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "485,347.9 483.4,349 483.4,347.2 485,346.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "488.5,345.9 486.7,346.9 486.7,345.2 488.5,344.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "493.8,342.9 492,344 492,342.2 493.8,341.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "498.9,339.9 497.2,340.9 497.2,339.2 498.9,338.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "502.5,337.9 500.7,339 500.7,337.2 502.5,336.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "483.4,350.7 481.6,351.7 481.6,349.9 483.4,349  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "485,349.7 483.4,350.7 483.4,349 485,347.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "488.5,347.6 486.7,348.7 486.7,346.9 488.5,345.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "490.3,346.7 488.5,347.6 488.5,345.9 490.3,344.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "492,345.6 490.3,346.7 490.3,344.9 492,344  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "495.4,343.7 493.8,344.6 493.8,342.9 495.4,341.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "498.9,341.7 497.2,342.6 497.2,340.9 498.9,339.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "502.5,339.6 500.7,340.6 500.7,339 502.5,337.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M472.9,349.8v6.9l6.9-4.1v-6.9L472.9,349.8z M478.6,352.2l-4.6,2.7v-4.6l4.6-2.7V352.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "475,350.6 475,353.4 477.8,351.8 477.8,349  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M472.9,323.7v6.9l6.9-4.1v-6.9L472.9,323.7z M478.6,326.1l-4.6,2.7v-4.6l4.6-2.7V326.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "475,324.5 475,327.4 477.8,325.7 477.8,322.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M500.7,307.5v6.9l6.9-4.1v-6.9L500.7,307.5z M506.5,310.1l-4.6,2.7v-4.6l4.6-2.7V310.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "502.7,308.5 502.7,311.3 505.6,309.7 505.6,306.7  "
  })))))))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "493.2,366.9 493.2,401.5 579.6,351.6 579.6,316.9  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "505.8,367.5 504.6,368.2 504.6,367 505.8,366.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "507.1,366.7 505.8,367.5 505.8,366.3 507.1,365.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "514.4,362.5 513.2,363.2 513.2,362 514.4,361.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "504.6,369.4 503.4,370.1 503.4,368.9 504.6,368.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "508.3,367.3 507.1,367.9 507.1,366.7 508.3,366  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "510.7,365.9 509.5,366.6 509.5,365.4 510.7,364.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "511.9,365.2 510.7,365.9 510.7,364.7 511.9,364  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "514.4,363.7 513.2,364.4 513.2,363.2 514.4,362.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "515.6,363.1 514.4,363.7 514.4,362.5 515.6,361.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "504.6,370.6 503.4,371.3 503.4,370.1 504.6,369.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "508.3,368.5 507.1,369.2 507.1,367.9 508.3,367.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "513.2,365.6 511.9,366.4 511.9,365.2 513.2,364.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "514.4,365 513.2,365.6 513.2,364.4 514.4,363.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "515.6,364.3 514.4,365 514.4,363.7 515.6,363.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "505.8,371.2 504.6,371.9 504.6,370.6 505.8,370  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "509.5,369 508.3,369.7 508.3,368.5 509.5,367.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "511.9,367.7 510.7,368.3 510.7,367.1 511.9,366.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "514.4,366.2 513.2,366.9 513.2,365.6 514.4,365  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "515.6,365.5 514.4,366.2 514.4,365 515.6,364.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "505.8,372.4 504.6,373.1 504.6,371.9 505.8,371.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "508.3,370.9 507.1,371.6 507.1,370.4 508.3,369.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "509.5,370.2 508.3,370.9 508.3,369.7 509.5,369  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "511.9,368.9 510.7,369.6 510.7,368.3 511.9,367.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "513.2,368.1 511.9,368.9 511.9,367.7 513.2,366.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "515.6,366.7 514.4,367.4 514.4,366.2 515.6,365.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "498.5,377.8 497.3,378.5 497.3,377.3 498.5,376.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "499.7,377.1 498.5,377.8 498.5,376.6 499.7,375.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "502.2,375.7 501,376.3 501,375.1 502.2,374.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "504.6,374.3 503.4,375 503.4,373.8 504.6,373.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "508.3,372.1 507.1,372.8 507.1,371.6 508.3,370.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "510.7,370.8 509.5,371.5 509.5,370.2 510.7,369.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "513.2,369.3 511.9,370.1 511.9,368.9 513.2,368.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "514.4,368.6 513.2,369.3 513.2,368.1 514.4,367.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "516.8,367.3 515.6,367.9 515.6,366.7 516.8,366  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "520.5,365.1 519.2,365.8 519.2,364.6 520.5,363.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "498.5,379 497.3,379.7 497.3,378.5 498.5,377.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "504.6,375.5 503.4,376.2 503.4,375 504.6,374.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "505.8,374.8 504.6,375.5 504.6,374.3 505.8,373.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "507.1,374 505.8,374.8 505.8,373.6 507.1,372.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "510.7,372 509.5,372.7 509.5,371.5 510.7,370.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "513.2,370.5 511.9,371.3 511.9,370.1 513.2,369.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "514.4,369.8 513.2,370.5 513.2,369.3 514.4,368.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "518,367.8 516.8,368.5 516.8,367.3 518,366.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "501,378.8 499.7,379.6 499.7,378.4 501,377.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "502.2,378.1 501,378.8 501,377.6 502.2,376.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "503.4,377.4 502.2,378.1 502.2,376.9 503.4,376.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "508.3,374.6 507.1,375.3 507.1,374 508.3,373.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "510.7,373.2 509.5,373.9 509.5,372.7 510.7,372  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "514.4,371.1 513.2,371.7 513.2,370.5 514.4,369.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "515.6,370.4 514.4,371.1 514.4,369.8 515.6,369.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "516.8,369.7 515.6,370.4 515.6,369.2 516.8,368.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "518,369 516.8,369.7 516.8,368.5 518,367.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "519.2,368.2 518,369 518,367.8 519.2,367  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "521.7,366.9 520.5,367.5 520.5,366.3 521.7,365.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "503.4,378.6 502.2,379.3 502.2,378.1 503.4,377.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "504.6,378 503.4,378.6 503.4,377.4 504.6,376.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "507.1,376.5 505.8,377.3 505.8,376.1 507.1,375.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "509.5,375.1 508.3,375.8 508.3,374.6 509.5,373.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "510.7,374.4 509.5,375.1 509.5,373.9 510.7,373.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "513.2,372.9 511.9,373.8 511.9,372.5 513.2,371.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "514.4,372.3 513.2,372.9 513.2,371.7 514.4,371.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "516.8,370.9 515.6,371.6 515.6,370.4 516.8,369.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "520.5,368.8 519.2,369.4 519.2,368.2 520.5,367.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "498.5,382.7 497.3,383.4 497.3,382.2 498.5,381.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "499.7,382 498.5,382.7 498.5,381.5 499.7,380.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "501,381.2 499.7,382 499.7,380.8 501,380  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "502.2,380.5 501,381.2 501,380 502.2,379.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "504.6,379.2 503.4,379.9 503.4,378.6 504.6,378  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "505.8,378.5 504.6,379.2 504.6,378 505.8,377.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "507.1,377.7 505.8,378.5 505.8,377.3 507.1,376.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "509.5,376.3 508.3,377 508.3,375.8 509.5,375.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "514.4,373.5 513.2,374.2 513.2,372.9 514.4,372.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "519.2,370.6 518,371.5 518,370.2 519.2,369.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "498.5,383.9 497.3,384.6 497.3,383.4 498.5,382.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "502.2,381.8 501,382.4 501,381.2 502.2,380.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "504.6,380.4 503.4,381.1 503.4,379.9 504.6,379.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "505.8,379.7 504.6,380.4 504.6,379.2 505.8,378.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "507.1,378.9 505.8,379.7 505.8,378.5 507.1,377.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "509.5,377.6 508.3,378.2 508.3,377 509.5,376.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "511.9,376.2 510.7,376.9 510.7,375.7 511.9,375  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "513.2,375.4 511.9,376.2 511.9,375 513.2,374.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "516.8,373.4 515.6,374 515.6,372.8 516.8,372.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "518,372.7 516.8,373.4 516.8,372.1 518,371.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "519.2,371.9 518,372.7 518,371.5 519.2,370.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "520.5,371.2 519.2,371.9 519.2,370.6 520.5,370  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "498.5,385.1 497.3,385.8 497.3,384.6 498.5,383.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "502.2,383 501,383.6 501,382.4 502.2,381.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "503.4,382.3 502.2,383 502.2,381.8 503.4,381.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "509.5,378.8 508.3,379.4 508.3,378.2 509.5,377.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "510.7,378.1 509.5,378.8 509.5,377.6 510.7,376.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "518,373.9 516.8,374.6 516.8,373.4 518,372.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "520.5,372.4 519.2,373.1 519.2,371.9 520.5,371.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "521.7,371.7 520.5,372.4 520.5,371.2 521.7,370.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "498.5,386.4 497.3,387 497.3,385.8 498.5,385.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "501,384.9 499.7,385.7 499.7,384.5 501,383.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "502.2,384.2 501,384.9 501,383.6 502.2,383  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "507.1,381.3 505.8,382.2 505.8,380.9 507.1,380.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "513.2,377.8 511.9,378.6 511.9,377.4 513.2,376.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "516.8,375.8 515.6,376.5 515.6,375.3 516.8,374.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "520.5,373.6 519.2,374.3 519.2,373.1 520.5,372.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "521.7,372.9 520.5,373.6 520.5,372.4 521.7,371.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "498.5,387.6 497.3,388.3 497.3,387 498.5,386.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "508.3,381.9 507.1,382.6 507.1,381.3 508.3,380.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "509.5,381.2 508.3,381.9 508.3,380.7 509.5,380  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "510.7,380.5 509.5,381.2 509.5,380 510.7,379.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "514.4,378.4 513.2,379 513.2,377.8 514.4,377.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "515.6,377.7 514.4,378.4 514.4,377.1 515.6,376.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "520.5,374.8 519.2,375.5 519.2,374.3 520.5,373.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "505.8,384.6 504.6,385.3 504.6,384.1 505.8,383.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "507.1,383.8 505.8,384.6 505.8,383.4 507.1,382.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "510.7,381.8 509.5,382.4 509.5,381.2 510.7,380.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "511.9,381.1 510.7,381.8 510.7,380.5 511.9,379.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "513.2,380.3 511.9,381.1 511.9,379.9 513.2,379  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "515.6,378.9 514.4,379.6 514.4,378.4 515.6,377.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "516.8,378.2 515.6,378.9 515.6,377.7 516.8,377  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "521.7,375.4 520.5,376.1 520.5,374.8 521.7,374.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "505.8,385.8 504.6,386.5 504.6,385.3 505.8,384.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "507.1,385 505.8,385.8 505.8,384.6 507.1,383.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "508.3,384.3 507.1,385 507.1,383.8 508.3,383.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "511.9,382.3 510.7,383 510.7,381.8 511.9,381.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "514.4,380.8 513.2,381.5 513.2,380.3 514.4,379.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "516.8,379.4 515.6,380.1 515.6,378.9 516.8,378.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "518,378.8 516.8,379.4 516.8,378.2 518,377.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "519.2,378 518,378.8 518,377.6 519.2,376.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "520.5,377.3 519.2,378 519.2,376.7 520.5,376.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "521.7,376.6 520.5,377.3 520.5,376.1 521.7,375.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "508.3,385.5 507.1,386.2 507.1,385 508.3,384.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "510.7,384.2 509.5,384.9 509.5,383.6 510.7,383  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "511.9,383.5 510.7,384.2 510.7,383 511.9,382.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "515.6,381.3 514.4,382 514.4,380.8 515.6,380.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "518,380 516.8,380.7 516.8,379.4 518,378.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "519.2,379.2 518,380 518,378.8 519.2,378  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "504.6,388.9 503.4,389.6 503.4,388.4 504.6,387.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "503.4,386 502.2,386.6 502.2,385.4 503.4,384.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "505.8,388.3 504.6,388.9 504.6,387.7 505.8,387  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "508.3,386.8 507.1,387.4 507.1,386.2 508.3,385.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "511.9,384.7 510.7,385.4 510.7,384.2 511.9,383.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "515.6,382.6 514.4,383.2 514.4,382 515.6,381.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "518,381.2 516.8,381.9 516.8,380.7 518,380  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "504.6,390.1 503.4,390.8 503.4,389.6 504.6,388.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "505.8,389.5 504.6,390.1 504.6,388.9 505.8,388.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "508.3,388 507.1,388.7 507.1,387.4 508.3,386.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "509.5,387.3 508.3,388 508.3,386.8 509.5,386.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "510.7,386.6 509.5,387.3 509.5,386.1 510.7,385.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "513.2,385.1 511.9,386 511.9,384.7 513.2,383.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "515.6,383.8 514.4,384.5 514.4,383.2 515.6,382.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "518,382.4 516.8,383.1 516.8,381.9 518,381.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M497.3,389.5v4.9l4.9-2.8v-4.9L497.3,389.5z M501.4,391.2l-3.3,1.9v-3.3l3.3-1.9V391.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "498.7,390 498.7,392 500.7,391 500.7,388.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M497.3,371.2v4.9l4.9-2.8v-4.9L497.3,371.2z M501.4,372.9l-3.3,1.9v-3.3l3.3-1.9V372.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "498.7,371.7 498.7,373.8 500.7,372.7 500.7,370.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M516.8,359.9v4.9l4.9-2.8v-4.9L516.8,359.9z M520.9,361.7l-3.3,1.9v-3.3l3.3-1.9V361.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "518.2,360.5 518.2,362.5 520.2,361.4 520.2,359.4  "
  }))))), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M554.3,354.3c0,2.2-1.4,4.6-4.2,6.4c-2.3,1.4-3.4,0.8-3.4,0c0-0.5,0.5-1.2,0.9-1.5c0.3-0.1,0.4-0.1,0.5,0.1 c0.4,0.8,0.9,1.4,2.2,0.5c1.5-0.8,2.2-2.6,2.2-4.5c0-2.3-1.2-2.4-2.3-1.8c-0.9,0.5-1.6,1.4-2.3,2.6h-0.4l0.4-6l0.1-0.3l5.8-3.4 l0.1,0.1l-0.4,1.4l-4.3,2.4c-0.3,0.1-0.4,0.3-0.5,0.8l-0.4,3.5l0,0c0.5-0.8,1.6-1.8,2.6-2.3C552.8,351.6,554.3,352,554.3,354.3z  M563.5,346.9c0,3.4-1.1,6.5-3.9,8.3c-2.8,1.6-3.9-0.3-3.9-3.8c0-3.4,1.1-6.5,3.9-8.3C562.6,341.5,563.5,343.4,563.5,346.9z  M561.8,347.9c0-2.8-0.4-5.1-2.2-4.2c-1.6,0.9-2.2,3.8-2.2,6.6c0,2.8,0.4,5.1,2.2,4.2C561.4,353.6,561.8,350.7,561.8,347.9z  M572.7,344.2c0,2.8-2.8,4.7-3.5,5.1v1.8l-0.7,0.4v-1.8c-2.6,1.5-3.4,0.7-3.4,0.1c0-0.5,0.4-1.1,0.8-1.4 c0.3-0.1,0.4-0.1,0.5,0.1c0.7,1.1,1.6,0.8,2.2,0.5v-4.7c-2.4,0.7-3.3,0-3.3-1.4c0-2,1.6-3.9,3.3-4.9v-1.4l0.7-0.4v1.4 c2-1.1,3-0.7,3,0c0,0.5-0.5,0.9-0.8,1.2c-0.3,0.1-0.4,0.1-0.4-0.1c-0.4-0.8-1.1-0.8-1.8-0.5v4.2 C571.5,342.1,572.7,342.3,572.7,344.2z M568.5,339c-0.7,0.4-1.9,1.6-1.9,3c0,1.2,0.9,1.2,1.9,0.9V339z M571.3,345.6 c0-1.5-0.8-1.6-2-1.4v4.6C570,348.3,571.3,347.2,571.3,345.6z M526.7,374.2l2-1.2v-0.1c-0.7,0.4-0.7,0.4-0.7,0v-1.4l0.4-0.3 c0.3-0.1,0.7-0.4,0.9-0.5c0.5-0.4,1.2-1.2,1.2-2c0-0.5-0.3-0.8-0.5-0.8s-0.8,0.1-1.2,0.4l-1.9,1.1v0.1c0.7-0.3,0.7-0.3,0.7,0.1 v3.5c0,0.4,0,0.4-0.7,0.8v0.3H526.7z M528.1,370.9v-1.8c0-0.1,0.1-0.3,0.5-0.5c0.7-0.4,1.2-0.3,1.2,0.5s-0.5,1.5-1.2,1.9 C528.1,371.2,528.1,371.2,528.1,370.9z M530.8,371.9l1.9-1.1v-0.1c-0.7,0.3-0.7,0.3-0.7,0v-1.8c0-0.5,0.3-0.8,0.4-0.9 c0.1,0,0.3-0.1,0.4-0.1h0.1c0.1-0.1,0.3-0.4,0.3-0.5c0-0.1-0.1-0.3-0.4-0.1c-0.3,0.1-0.4,0.4-0.9,1.1l-0.1-0.5l-1.1,0.8v0.1 l0.3-0.1c0.1-0.1,0.3,0,0.3,0.1v2.2c0,0.4,0,0.4-0.5,0.7v0.4H530.8z M533.6,370.2l1.8-0.9v-0.1c-0.5,0.3-0.5,0.3-0.5-0.1v-2.8 l0,0l-1.1,0.8v0.1l0.3-0.1c0.1-0.1,0.3,0,0.3,0.1v2.2c0,0.4,0,0.4-0.5,0.7v0.3H533.6z M534,365.5c0,0.3,0.1,0.3,0.4,0.1 c0.3-0.1,0.4-0.4,0.4-0.7c0-0.3-0.1-0.3-0.4-0.1C534.1,365,534,365.2,534,365.5z M535.6,367.3c0,1.2,0.5,1.5,1.6,0.8 c0.5-0.3,1.1-0.9,1.4-1.8h-0.1c-0.3,0.7-0.5,1.1-0.9,1.4c-0.8,0.5-1.1-0.3-1.1-0.9c0-1.1,0.4-1.8,0.9-2c0.3-0.1,0.5-0.1,0.7,0.3 c0,0.1,0.1,0.1,0.3,0c0.1-0.1,0.4-0.3,0.4-0.5s-0.4-0.4-1.2,0C536.2,365.2,535.6,366.4,535.6,367.3z M539.2,365.4 c0,1.1,0.5,1.5,1.6,0.8c0.8-0.4,1.2-1.1,1.4-1.8h-0.3c-0.1,0.5-0.4,0.9-0.9,1.4c-0.8,0.5-1.1-0.3-1.1-0.9l2-1.2 c0.1-0.1,0.3-0.1,0.3-0.4c0-0.4-0.1-1.4-1.4-0.5C539.7,363.2,539.2,364.3,539.2,365.4z M539.8,364.4c0-0.3,0.1-1.2,0.8-1.6 c0.7-0.4,0.7,0.3,0.7,0.5c0,0.1,0,0.3-0.3,0.4L539.8,364.4z M526.4,377.3v0.4l50.4-29.1v-0.4L526.4,377.3z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMethodsLeft);
export default __webpack_public_path__ + "static/media/payment-methods-left.3349e5f31d2c73dd26f41bd5bba90d71.svg";
export { ForwardRef as ReactComponent };